'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var require$$0 = require('react');
var reactDom = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var require$$0__default = /*#__PURE__*/_interopDefaultLegacy(require$$0);
var require$$0__namespace = /*#__PURE__*/_interopNamespace(require$$0);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray: isArray$1} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction$1(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString$1 = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction$1 = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction$1(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction$1(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction$1(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$1(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray$1(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction$1(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray$1 = (thing) => {
  if (!thing) return null;
  if (isArray$1(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty$1 = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction$1(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction$1(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray$1(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop = () => {};

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
};

const ALPHA = 'abcdefghijklmnopqrstuvwxyz';

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0];
  }

  return str;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction$1(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray$1(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction$1(thing)) && isFunction$1(thing.then) && isFunction$1(thing.catch);

var utils$1 = {
  isArray: isArray$1,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString: isString$1,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray: toArray$1,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: hasOwnProperty$1,
  hasOwnProp: hasOwnProperty$1, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils$1.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
var httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils$1.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils$1.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);

  if (!utils$1.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils$1.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils$1.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils$1.isArray(value) && isFlatArray(value)) ||
        ((utils$1.isFileList(value) || utils$1.endsWith(key, '[]')) && (arr = utils$1.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils$1.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils$1.forEach(value, function each(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils$1.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var InterceptorManager$1 = InterceptorManager;

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

var platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = (
  (product) => {
    return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0
  })(typeof navigator !== 'undefined' && navigator.product);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

var utils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    hasBrowserEnv: hasBrowserEnv,
    hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv,
    hasStandardBrowserEnv: hasStandardBrowserEnv
});

var platform = {
  ...utils,
  ...platform$1
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};

    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils$1.isObject(data);

    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils$1.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils$1.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils$1.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils$1.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

var defaults$1 = defaults;

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils$1.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils$1.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils$1.isString(value)) return;

  if (utils$1.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils$1.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils$1.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils$1.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils$1.freezeMethods(AxiosHeaders);

var AxiosHeaders$1 = AxiosHeaders;

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;

  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

var cookies = platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils$1.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils$1.isString(path) && cookie.push('path=' + path);

      utils$1.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  };

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

var isURLSameOrigin = platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils$1.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })();

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = AxiosHeaders$1.from(config.headers).normalize();
    let {responseType, withXSRFToken} = config;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let contentType;

    if (utils$1.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        // fix semicolon duplication issue for ReactNative FormData implementation
        const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders$1.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if(platform.hasStandardBrowserEnv) {
      withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));

      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};

utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;

var adapters = {
  getAdapter: (adapters) => {
    adapters = utils$1.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders$1.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders$1.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({caseless}, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils$1.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

const VERSION = "1.6.8";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator$3 = {
  assertOptions,
  validators: validators$1
};

const validators = validator$3.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';

        if (!err.stack) {
          err.stack = stack;
          // match without the 2 top stack lines
        } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
          err.stack += '\n' + stack;
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator$3.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator$3.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils$1.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios$1 = Axios;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

var CancelToken$1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

var HttpStatusCode$1 = HttpStatusCode;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios$1.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils$1.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults$1);

// Expose Axios class to allow class inheritance
axios.Axios = Axios$1;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = AxiosHeaders$1;

axios.formToJSON = thing => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = HttpStatusCode$1;

axios.default = axios;

// this module should only have a default export
var axios$1 = axios;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var validator$2 = {};

var util$5 = {};

(function (exports) {

const nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const nameChar = nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const nameRegexp = '[' + nameStartChar + '][' + nameChar + ']*';
const regexName = new RegExp('^' + nameRegexp + '$');

const getAllMatches = function(string, regex) {
  const matches = [];
  let match = regex.exec(string);
  while (match) {
    const allmatches = [];
    allmatches.startIndex = regex.lastIndex - match[0].length;
    const len = match.length;
    for (let index = 0; index < len; index++) {
      allmatches.push(match[index]);
    }
    matches.push(allmatches);
    match = regex.exec(string);
  }
  return matches;
};

const isName = function(string) {
  const match = regexName.exec(string);
  return !(match === null || typeof match === 'undefined');
};

exports.isExist = function(v) {
  return typeof v !== 'undefined';
};

exports.isEmptyObject = function(obj) {
  return Object.keys(obj).length === 0;
};

/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */
exports.merge = function(target, a, arrayMode) {
  if (a) {
    const keys = Object.keys(a); // will return an array of own properties
    const len = keys.length; //don't make it inline
    for (let i = 0; i < len; i++) {
      if (arrayMode === 'strict') {
        target[keys[i]] = [ a[keys[i]] ];
      } else {
        target[keys[i]] = a[keys[i]];
      }
    }
  }
};
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */

exports.getValue = function(v) {
  if (exports.isExist(v)) {
    return v;
  } else {
    return '';
  }
};

// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};

exports.isName = isName;
exports.getAllMatches = getAllMatches;
exports.nameRegexp = nameRegexp;
}(util$5));

const util$4 = util$5;

const defaultOptions$3 = {
  allowBooleanAttributes: false, //A tag can have attributes without any value
  unpairedTags: []
};

//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
validator$2.validate = function (xmlData, options) {
  options = Object.assign({}, defaultOptions$3, options);

  //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
  //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
  //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
  const tags = [];
  let tagFound = false;

  //indicates that the root tag has been closed (aka. depth 0 has been reached)
  let reachedRoot = false;

  if (xmlData[0] === '\ufeff') {
    // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
  }
  
  for (let i = 0; i < xmlData.length; i++) {

    if (xmlData[i] === '<' && xmlData[i+1] === '?') {
      i+=2;
      i = readPI(xmlData,i);
      if (i.err) return i;
    }else if (xmlData[i] === '<') {
      //starting of tag
      //read until you reach to '>' avoiding any '>' in attribute value
      let tagStartPos = i;
      i++;
      
      if (xmlData[i] === '!') {
        i = readCommentAndCDATA(xmlData, i);
        continue;
      } else {
        let closingTag = false;
        if (xmlData[i] === '/') {
          //closing tag
          closingTag = true;
          i++;
        }
        //read tagname
        let tagName = '';
        for (; i < xmlData.length &&
          xmlData[i] !== '>' &&
          xmlData[i] !== ' ' &&
          xmlData[i] !== '\t' &&
          xmlData[i] !== '\n' &&
          xmlData[i] !== '\r'; i++
        ) {
          tagName += xmlData[i];
        }
        tagName = tagName.trim();
        //console.log(tagName);

        if (tagName[tagName.length - 1] === '/') {
          //self closing tag without attributes
          tagName = tagName.substring(0, tagName.length - 1);
          //continue;
          i--;
        }
        if (!validateTagName(tagName)) {
          let msg;
          if (tagName.trim().length === 0) {
            msg = "Invalid space after '<'.";
          } else {
            msg = "Tag '"+tagName+"' is an invalid name.";
          }
          return getErrorObject('InvalidTag', msg, getLineNumberForPosition(xmlData, i));
        }

        const result = readAttributeStr(xmlData, i);
        if (result === false) {
          return getErrorObject('InvalidAttr', "Attributes for '"+tagName+"' have open quote.", getLineNumberForPosition(xmlData, i));
        }
        let attrStr = result.value;
        i = result.index;

        if (attrStr[attrStr.length - 1] === '/') {
          //self closing tag
          const attrStrStart = i - attrStr.length;
          attrStr = attrStr.substring(0, attrStr.length - 1);
          const isValid = validateAttributeString(attrStr, options);
          if (isValid === true) {
            tagFound = true;
            //continue; //text may presents after self closing tag
          } else {
            //the result from the nested function returns the position of the error within the attribute
            //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
            //this gives us the absolute index in the entire xml, which we can use to find the line at last
            return getErrorObject(isValid.err.code, isValid.err.msg, getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
          }
        } else if (closingTag) {
          if (!result.tagClosed) {
            return getErrorObject('InvalidTag', "Closing tag '"+tagName+"' doesn't have proper closing.", getLineNumberForPosition(xmlData, i));
          } else if (attrStr.trim().length > 0) {
            return getErrorObject('InvalidTag', "Closing tag '"+tagName+"' can't have attributes or invalid starting.", getLineNumberForPosition(xmlData, tagStartPos));
          } else {
            const otg = tags.pop();
            if (tagName !== otg.tagName) {
              let openPos = getLineNumberForPosition(xmlData, otg.tagStartPos);
              return getErrorObject('InvalidTag',
                "Expected closing tag '"+otg.tagName+"' (opened in line "+openPos.line+", col "+openPos.col+") instead of closing tag '"+tagName+"'.",
                getLineNumberForPosition(xmlData, tagStartPos));
            }

            //when there are no more tags, we reached the root level.
            if (tags.length == 0) {
              reachedRoot = true;
            }
          }
        } else {
          const isValid = validateAttributeString(attrStr, options);
          if (isValid !== true) {
            //the result from the nested function returns the position of the error within the attribute
            //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
            //this gives us the absolute index in the entire xml, which we can use to find the line at last
            return getErrorObject(isValid.err.code, isValid.err.msg, getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
          }

          //if the root level has been reached before ...
          if (reachedRoot === true) {
            return getErrorObject('InvalidXml', 'Multiple possible root nodes found.', getLineNumberForPosition(xmlData, i));
          } else if(options.unpairedTags.indexOf(tagName) !== -1); else {
            tags.push({tagName, tagStartPos});
          }
          tagFound = true;
        }

        //skip tag text value
        //It may include comments and CDATA value
        for (i++; i < xmlData.length; i++) {
          if (xmlData[i] === '<') {
            if (xmlData[i + 1] === '!') {
              //comment or CADATA
              i++;
              i = readCommentAndCDATA(xmlData, i);
              continue;
            } else if (xmlData[i+1] === '?') {
              i = readPI(xmlData, ++i);
              if (i.err) return i;
            } else {
              break;
            }
          } else if (xmlData[i] === '&') {
            const afterAmp = validateAmpersand(xmlData, i);
            if (afterAmp == -1)
              return getErrorObject('InvalidChar', "char '&' is not expected.", getLineNumberForPosition(xmlData, i));
            i = afterAmp;
          }else {
            if (reachedRoot === true && !isWhiteSpace(xmlData[i])) {
              return getErrorObject('InvalidXml', "Extra text at the end", getLineNumberForPosition(xmlData, i));
            }
          }
        } //end of reading tag text value
        if (xmlData[i] === '<') {
          i--;
        }
      }
    } else {
      if ( isWhiteSpace(xmlData[i])) {
        continue;
      }
      return getErrorObject('InvalidChar', "char '"+xmlData[i]+"' is not expected.", getLineNumberForPosition(xmlData, i));
    }
  }

  if (!tagFound) {
    return getErrorObject('InvalidXml', 'Start tag expected.', 1);
  }else if (tags.length == 1) {
      return getErrorObject('InvalidTag', "Unclosed tag '"+tags[0].tagName+"'.", getLineNumberForPosition(xmlData, tags[0].tagStartPos));
  }else if (tags.length > 0) {
      return getErrorObject('InvalidXml', "Invalid '"+
          JSON.stringify(tags.map(t => t.tagName), null, 4).replace(/\r?\n/g, '')+
          "' found.", {line: 1, col: 1});
  }

  return true;
};

function isWhiteSpace(char){
  return char === ' ' || char === '\t' || char === '\n'  || char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */
function readPI(xmlData, i) {
  const start = i;
  for (; i < xmlData.length; i++) {
    if (xmlData[i] == '?' || xmlData[i] == ' ') {
      //tagname
      const tagname = xmlData.substr(start, i - start);
      if (i > 5 && tagname === 'xml') {
        return getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', getLineNumberForPosition(xmlData, i));
      } else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
        //check if valid attribut string
        i++;
        break;
      } else {
        continue;
      }
    }
  }
  return i;
}

function readCommentAndCDATA(xmlData, i) {
  if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
    //comment
    for (i += 3; i < xmlData.length; i++) {
      if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
        i += 2;
        break;
      }
    }
  } else if (
    xmlData.length > i + 8 &&
    xmlData[i + 1] === 'D' &&
    xmlData[i + 2] === 'O' &&
    xmlData[i + 3] === 'C' &&
    xmlData[i + 4] === 'T' &&
    xmlData[i + 5] === 'Y' &&
    xmlData[i + 6] === 'P' &&
    xmlData[i + 7] === 'E'
  ) {
    let angleBracketsCount = 1;
    for (i += 8; i < xmlData.length; i++) {
      if (xmlData[i] === '<') {
        angleBracketsCount++;
      } else if (xmlData[i] === '>') {
        angleBracketsCount--;
        if (angleBracketsCount === 0) {
          break;
        }
      }
    }
  } else if (
    xmlData.length > i + 9 &&
    xmlData[i + 1] === '[' &&
    xmlData[i + 2] === 'C' &&
    xmlData[i + 3] === 'D' &&
    xmlData[i + 4] === 'A' &&
    xmlData[i + 5] === 'T' &&
    xmlData[i + 6] === 'A' &&
    xmlData[i + 7] === '['
  ) {
    for (i += 8; i < xmlData.length; i++) {
      if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
        i += 2;
        break;
      }
    }
  }

  return i;
}

const doubleQuote = '"';
const singleQuote = "'";

/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */
function readAttributeStr(xmlData, i) {
  let attrStr = '';
  let startChar = '';
  let tagClosed = false;
  for (; i < xmlData.length; i++) {
    if (xmlData[i] === doubleQuote || xmlData[i] === singleQuote) {
      if (startChar === '') {
        startChar = xmlData[i];
      } else if (startChar !== xmlData[i]) ; else {
        startChar = '';
      }
    } else if (xmlData[i] === '>') {
      if (startChar === '') {
        tagClosed = true;
        break;
      }
    }
    attrStr += xmlData[i];
  }
  if (startChar !== '') {
    return false;
  }

  return {
    value: attrStr,
    index: i,
    tagClosed: tagClosed
  };
}

/**
 * Select all the attributes whether valid or invalid.
 */
const validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');

//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""

function validateAttributeString(attrStr, options) {
  //console.log("start:"+attrStr+":end");

  //if(attrStr.trim().length === 0) return true; //empty string

  const matches = util$4.getAllMatches(attrStr, validAttrStrRegxp);
  const attrNames = {};

  for (let i = 0; i < matches.length; i++) {
    if (matches[i][1].length === 0) {
      //nospace before attribute name: a="sd"b="saf"
      return getErrorObject('InvalidAttr', "Attribute '"+matches[i][2]+"' has no space in starting.", getPositionFromMatch(matches[i]))
    } else if (matches[i][3] !== undefined && matches[i][4] === undefined) {
      return getErrorObject('InvalidAttr', "Attribute '"+matches[i][2]+"' is without value.", getPositionFromMatch(matches[i]));
    } else if (matches[i][3] === undefined && !options.allowBooleanAttributes) {
      //independent attribute: ab
      return getErrorObject('InvalidAttr', "boolean attribute '"+matches[i][2]+"' is not allowed.", getPositionFromMatch(matches[i]));
    }
    /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */
    const attrName = matches[i][2];
    if (!validateAttrName(attrName)) {
      return getErrorObject('InvalidAttr', "Attribute '"+attrName+"' is an invalid name.", getPositionFromMatch(matches[i]));
    }
    if (!attrNames.hasOwnProperty(attrName)) {
      //check for duplicate attribute.
      attrNames[attrName] = 1;
    } else {
      return getErrorObject('InvalidAttr', "Attribute '"+attrName+"' is repeated.", getPositionFromMatch(matches[i]));
    }
  }

  return true;
}

function validateNumberAmpersand(xmlData, i) {
  let re = /\d/;
  if (xmlData[i] === 'x') {
    i++;
    re = /[\da-fA-F]/;
  }
  for (; i < xmlData.length; i++) {
    if (xmlData[i] === ';')
      return i;
    if (!xmlData[i].match(re))
      break;
  }
  return -1;
}

function validateAmpersand(xmlData, i) {
  // https://www.w3.org/TR/xml/#dt-charref
  i++;
  if (xmlData[i] === ';')
    return -1;
  if (xmlData[i] === '#') {
    i++;
    return validateNumberAmpersand(xmlData, i);
  }
  let count = 0;
  for (; i < xmlData.length; i++, count++) {
    if (xmlData[i].match(/\w/) && count < 20)
      continue;
    if (xmlData[i] === ';')
      break;
    return -1;
  }
  return i;
}

function getErrorObject(code, message, lineNumber) {
  return {
    err: {
      code: code,
      msg: message,
      line: lineNumber.line || lineNumber,
      col: lineNumber.col,
    },
  };
}

function validateAttrName(attrName) {
  return util$4.isName(attrName);
}

// const startsWithXML = /^xml/i;

function validateTagName(tagname) {
  return util$4.isName(tagname) /* && !tagname.match(startsWithXML) */;
}

//this function returns the line number for the character at the given index
function getLineNumberForPosition(xmlData, index) {
  const lines = xmlData.substring(0, index).split(/\r?\n/);
  return {
    line: lines.length,

    // column number is last line's length + 1, because column numbering starts at 1:
    col: lines[lines.length - 1].length + 1
  };
}

//this function returns the position of the first character of match within attrStr
function getPositionFromMatch(match) {
  return match.startIndex + match[1].length;
}

var OptionsBuilder = {};

const defaultOptions$2 = {
    preserveOrder: false,
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    removeNSPrefix: false, // remove NS from tag name or attribute name if true
    allowBooleanAttributes: false, //a tag can have attributes without any value
    //ignoreRootElement : false,
    parseTagValue: true,
    parseAttributeValue: false,
    trimValues: true, //Trim string values of tag and attributes
    cdataPropName: false,
    numberParseOptions: {
      hex: true,
      leadingZeros: true,
      eNotation: true
    },
    tagValueProcessor: function(tagName, val) {
      return val;
    },
    attributeValueProcessor: function(attrName, val) {
      return val;
    },
    stopNodes: [], //nested tags will not be parsed even for errors
    alwaysCreateTextNode: false,
    isArray: () => false,
    commentPropName: false,
    unpairedTags: [],
    processEntities: true,
    htmlEntities: false,
    ignoreDeclaration: false,
    ignorePiTags: false,
    transformTagName: false,
    transformAttributeName: false,
    updateTag: function(tagName, jPath, attrs){
      return tagName
    },
    // skipEmptyListItem: false
};
   
const buildOptions$1 = function(options) {
    return Object.assign({}, defaultOptions$2, options);
};

OptionsBuilder.buildOptions = buildOptions$1;
OptionsBuilder.defaultOptions = defaultOptions$2;

class XmlNode{
  constructor(tagname) {
    this.tagname = tagname;
    this.child = []; //nested tags, text, cdata, comments in order
    this[":@"] = {}; //attributes map
  }
  add(key,val){
    // this.child.push( {name : key, val: val, isCdata: isCdata });
    if(key === "__proto__") key = "#__proto__";
    this.child.push( {[key]: val });
  }
  addChild(node) {
    if(node.tagname === "__proto__") node.tagname = "#__proto__";
    if(node[":@"] && Object.keys(node[":@"]).length > 0){
      this.child.push( { [node.tagname]: node.child, [":@"]: node[":@"] });
    }else {
      this.child.push( { [node.tagname]: node.child });
    }
  };
}

var xmlNode$1 = XmlNode;

const util$3 = util$5;

//TODO: handle comments
function readDocType$1(xmlData, i){
    
    const entities = {};
    if( xmlData[i + 3] === 'O' &&
         xmlData[i + 4] === 'C' &&
         xmlData[i + 5] === 'T' &&
         xmlData[i + 6] === 'Y' &&
         xmlData[i + 7] === 'P' &&
         xmlData[i + 8] === 'E')
    {    
        i = i+9;
        let angleBracketsCount = 1;
        let hasBody = false, comment = false;
        let exp = "";
        for(;i<xmlData.length;i++){
            if (xmlData[i] === '<' && !comment) { //Determine the tag type
                if( hasBody && isEntity(xmlData, i)){
                    i += 7; 
                    [entityName, val,i] = readEntityExp(xmlData,i+1);
                    if(val.indexOf("&") === -1) //Parameter entities are not supported
                        entities[ validateEntityName(entityName) ] = {
                            regx : RegExp( `&${entityName};`,"g"),
                            val: val
                        };
                }
                else if( hasBody && isElement(xmlData, i))  i += 8;//Not supported
                else if( hasBody && isAttlist(xmlData, i))  i += 8;//Not supported
                else if( hasBody && isNotation(xmlData, i)) i += 9;//Not supported
                else if( isComment)                         comment = true;
                else                                        throw new Error("Invalid DOCTYPE");

                angleBracketsCount++;
                exp = "";
            } else if (xmlData[i] === '>') { //Read tag content
                if(comment){
                    if( xmlData[i - 1] === "-" && xmlData[i - 2] === "-"){
                        comment = false;
                        angleBracketsCount--;
                    }
                }else {
                    angleBracketsCount--;
                }
                if (angleBracketsCount === 0) {
                  break;
                }
            }else if( xmlData[i] === '['){
                hasBody = true;
            }else {
                exp += xmlData[i];
            }
        }
        if(angleBracketsCount !== 0){
            throw new Error(`Unclosed DOCTYPE`);
        }
    }else {
        throw new Error(`Invalid Tag instead of DOCTYPE`);
    }
    return {entities, i};
}

function readEntityExp(xmlData,i){
    //External entities are not supported
    //    <!ENTITY ext SYSTEM "http://normal-website.com" >

    //Parameter entities are not supported
    //    <!ENTITY entityname "&anotherElement;">

    //Internal entities are supported
    //    <!ENTITY entityname "replacement text">
    
    //read EntityName
    let entityName = "";
    for (; i < xmlData.length && (xmlData[i] !== "'" && xmlData[i] !== '"' ); i++) {
        // if(xmlData[i] === " ") continue;
        // else 
        entityName += xmlData[i];
    }
    entityName = entityName.trim();
    if(entityName.indexOf(" ") !== -1) throw new Error("External entites are not supported");

    //read Entity Value
    const startChar = xmlData[i++];
    let val = "";
    for (; i < xmlData.length && xmlData[i] !== startChar ; i++) {
        val += xmlData[i];
    }
    return [entityName, val, i];
}

function isComment(xmlData, i){
    if(xmlData[i+1] === '!' &&
    xmlData[i+2] === '-' &&
    xmlData[i+3] === '-') return true
    return false
}
function isEntity(xmlData, i){
    if(xmlData[i+1] === '!' &&
    xmlData[i+2] === 'E' &&
    xmlData[i+3] === 'N' &&
    xmlData[i+4] === 'T' &&
    xmlData[i+5] === 'I' &&
    xmlData[i+6] === 'T' &&
    xmlData[i+7] === 'Y') return true
    return false
}
function isElement(xmlData, i){
    if(xmlData[i+1] === '!' &&
    xmlData[i+2] === 'E' &&
    xmlData[i+3] === 'L' &&
    xmlData[i+4] === 'E' &&
    xmlData[i+5] === 'M' &&
    xmlData[i+6] === 'E' &&
    xmlData[i+7] === 'N' &&
    xmlData[i+8] === 'T') return true
    return false
}

function isAttlist(xmlData, i){
    if(xmlData[i+1] === '!' &&
    xmlData[i+2] === 'A' &&
    xmlData[i+3] === 'T' &&
    xmlData[i+4] === 'T' &&
    xmlData[i+5] === 'L' &&
    xmlData[i+6] === 'I' &&
    xmlData[i+7] === 'S' &&
    xmlData[i+8] === 'T') return true
    return false
}
function isNotation(xmlData, i){
    if(xmlData[i+1] === '!' &&
    xmlData[i+2] === 'N' &&
    xmlData[i+3] === 'O' &&
    xmlData[i+4] === 'T' &&
    xmlData[i+5] === 'A' &&
    xmlData[i+6] === 'T' &&
    xmlData[i+7] === 'I' &&
    xmlData[i+8] === 'O' &&
    xmlData[i+9] === 'N') return true
    return false
}

function validateEntityName(name){
    if (util$3.isName(name))
	return name;
    else
        throw new Error(`Invalid entity name ${name}`);
}

var DocTypeReader = readDocType$1;

const hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
// const octRegex = /0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;


//polyfill
if (!Number.parseInt && window.parseInt) {
    Number.parseInt = window.parseInt;
}
if (!Number.parseFloat && window.parseFloat) {
    Number.parseFloat = window.parseFloat;
}

  
const consider = {
    hex :  true,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
    //skipLike: /regex/
};

function toNumber$1(str, options = {}){
    // const options = Object.assign({}, consider);
    // if(opt.leadingZeros === false){
    //     options.leadingZeros = false;
    // }else if(opt.hex === false){
    //     options.hex = false;
    // }

    options = Object.assign({}, consider, options );
    if(!str || typeof str !== "string" ) return str;
    
    let trimmedStr  = str.trim();
    // if(trimmedStr === "0.0") return 0;
    // else if(trimmedStr === "+0.0") return 0;
    // else if(trimmedStr === "-0.0") return -0;

    if(options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (options.hex && hexRegex.test(trimmedStr)) {
        return Number.parseInt(trimmedStr, 16);
    // } else if (options.parseOct && octRegex.test(str)) {
    //     return Number.parseInt(val, 8);
    // }else if (options.parseBin && binRegex.test(str)) {
    //     return Number.parseInt(val, 2);
    }else {
        //separate negative sign, leading zeros, and rest number
        const match = numRegex.exec(trimmedStr);
        if(match){
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            
            const eNotation = match[4] || match[6];
            if(!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if(!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else {//no leading zeros or leading zeros are allowed
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if(numStr.search(/[eE]/) !== -1){ //given number is long and parsed to eNotation
                    if(options.eNotation) return num;
                    else return str;
                }else if(eNotation){ //given number has enotation
                    if(options.eNotation) return num;
                    else return str;
                }else if(trimmedStr.indexOf(".") !== -1){ //floating number
                    // const decimalPart = match[5].substr(1);
                    // const intPart = trimmedStr.substr(0,trimmedStr.indexOf("."));

                    
                    // const p = numStr.indexOf(".");
                    // const givenIntPart = numStr.substr(0,p);
                    // const givenDecPart = numStr.substr(p+1);
                    if(numStr === "0" && (numTrimmedByZeros === "") ) return num; //0.0
                    else if(numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if( sign && numStr === "-"+numTrimmedByZeros) return num;
                    else return str;
                }
                
                if(leadingZeros){
                    // if(numTrimmedByZeros === numStr){
                    //     if(options.leadingZeros) return num;
                    //     else return str;
                    // }else return str;
                    if(numTrimmedByZeros === numStr) return num;
                    else if(sign+numTrimmedByZeros === numStr) return num;
                    else return str;
                }

                if(trimmedStr === numStr) return num;
                else if(trimmedStr === sign+numStr) return num;
                // else{
                //     //number with +/- sign
                //     trimmedStr.test(/[-+][0-9]);

                // }
                return str;
            }
            // else if(!eNotation && trimmedStr && trimmedStr !== Number(trimmedStr) ) return str;
            
        }else { //non-numeric string
            return str;
        }
    }
}

/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */
function trimZeros(numStr){
    if(numStr && numStr.indexOf(".") !== -1){//float
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if(numStr === ".")  numStr = "0";
        else if(numStr[0] === ".")  numStr = "0"+numStr;
        else if(numStr[numStr.length-1] === ".")  numStr = numStr.substr(0,numStr.length-1);
        return numStr;
    }
    return numStr;
}
var strnum = toNumber$1;

///@ts-check

const util$2 = util$5;
const xmlNode = xmlNode$1;
const readDocType = DocTypeReader;
const toNumber = strnum;

// const regx =
//   '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'
//   .replace(/NAME/g, util.nameRegexp);

//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");

class OrderedObjParser$1{
  constructor(options){
    this.options = options;
    this.currentNode = null;
    this.tagsNodeStack = [];
    this.docTypeEntities = {};
    this.lastEntities = {
      "apos" : { regex: /&(apos|#39|#x27);/g, val : "'"},
      "gt" : { regex: /&(gt|#62|#x3E);/g, val : ">"},
      "lt" : { regex: /&(lt|#60|#x3C);/g, val : "<"},
      "quot" : { regex: /&(quot|#34|#x22);/g, val : "\""},
    };
    this.ampEntity = { regex: /&(amp|#38|#x26);/g, val : "&"};
    this.htmlEntities = {
      "space": { regex: /&(nbsp|#160);/g, val: " " },
      // "lt" : { regex: /&(lt|#60);/g, val: "<" },
      // "gt" : { regex: /&(gt|#62);/g, val: ">" },
      // "amp" : { regex: /&(amp|#38);/g, val: "&" },
      // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
      // "apos" : { regex: /&(apos|#39);/g, val: "'" },
      "cent" : { regex: /&(cent|#162);/g, val: "¢" },
      "pound" : { regex: /&(pound|#163);/g, val: "£" },
      "yen" : { regex: /&(yen|#165);/g, val: "¥" },
      "euro" : { regex: /&(euro|#8364);/g, val: "€" },
      "copyright" : { regex: /&(copy|#169);/g, val: "©" },
      "reg" : { regex: /&(reg|#174);/g, val: "®" },
      "inr" : { regex: /&(inr|#8377);/g, val: "₹" },
      "num_dec": { regex: /&#([0-9]{1,7});/g, val : (_, str) => String.fromCharCode(Number.parseInt(str, 10)) },
      "num_hex": { regex: /&#x([0-9a-fA-F]{1,6});/g, val : (_, str) => String.fromCharCode(Number.parseInt(str, 16)) },
    };
    this.addExternalEntities = addExternalEntities;
    this.parseXml = parseXml;
    this.parseTextData = parseTextData;
    this.resolveNameSpace = resolveNameSpace;
    this.buildAttributesMap = buildAttributesMap;
    this.isItStopNode = isItStopNode;
    this.replaceEntitiesValue = replaceEntitiesValue$1;
    this.readStopNodeData = readStopNodeData;
    this.saveTextToParentTag = saveTextToParentTag;
    this.addChild = addChild;
  }

}

function addExternalEntities(externalEntities){
  const entKeys = Object.keys(externalEntities);
  for (let i = 0; i < entKeys.length; i++) {
    const ent = entKeys[i];
    this.lastEntities[ent] = {
       regex: new RegExp("&"+ent+";","g"),
       val : externalEntities[ent]
    };
  }
}

/**
 * @param {string} val
 * @param {string} tagName
 * @param {string} jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */
function parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
  if (val !== undefined) {
    if (this.options.trimValues && !dontTrim) {
      val = val.trim();
    }
    if(val.length > 0){
      if(!escapeEntities) val = this.replaceEntitiesValue(val);
      
      const newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
      if(newval === null || newval === undefined){
        //don't parse
        return val;
      }else if(typeof newval !== typeof val || newval !== val){
        //overwrite
        return newval;
      }else if(this.options.trimValues){
        return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
      }else {
        const trimmedVal = val.trim();
        if(trimmedVal === val){
          return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
        }else {
          return val;
        }
      }
    }
  }
}

function resolveNameSpace(tagname) {
  if (this.options.removeNSPrefix) {
    const tags = tagname.split(':');
    const prefix = tagname.charAt(0) === '/' ? '/' : '';
    if (tags[0] === 'xmlns') {
      return '';
    }
    if (tags.length === 2) {
      tagname = prefix + tags[1];
    }
  }
  return tagname;
}

//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');

function buildAttributesMap(attrStr, jPath, tagName) {
  if (!this.options.ignoreAttributes && typeof attrStr === 'string') {
    // attrStr = attrStr.replace(/\r?\n/g, ' ');
    //attrStr = attrStr || attrStr.trim();

    const matches = util$2.getAllMatches(attrStr, attrsRegx);
    const len = matches.length; //don't make it inline
    const attrs = {};
    for (let i = 0; i < len; i++) {
      const attrName = this.resolveNameSpace(matches[i][1]);
      let oldVal = matches[i][4];
      let aName = this.options.attributeNamePrefix + attrName;
      if (attrName.length) {
        if (this.options.transformAttributeName) {
          aName = this.options.transformAttributeName(aName);
        }
        if(aName === "__proto__") aName  = "#__proto__";
        if (oldVal !== undefined) {
          if (this.options.trimValues) {
            oldVal = oldVal.trim();
          }
          oldVal = this.replaceEntitiesValue(oldVal);
          const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
          if(newVal === null || newVal === undefined){
            //don't parse
            attrs[aName] = oldVal;
          }else if(typeof newVal !== typeof oldVal || newVal !== oldVal){
            //overwrite
            attrs[aName] = newVal;
          }else {
            //parse
            attrs[aName] = parseValue(
              oldVal,
              this.options.parseAttributeValue,
              this.options.numberParseOptions
            );
          }
        } else if (this.options.allowBooleanAttributes) {
          attrs[aName] = true;
        }
      }
    }
    if (!Object.keys(attrs).length) {
      return;
    }
    if (this.options.attributesGroupName) {
      const attrCollection = {};
      attrCollection[this.options.attributesGroupName] = attrs;
      return attrCollection;
    }
    return attrs
  }
}

const parseXml = function(xmlData) {
  xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
  const xmlObj = new xmlNode('!xml');
  let currentNode = xmlObj;
  let textData = "";
  let jPath = "";
  for(let i=0; i< xmlData.length; i++){//for each char in XML data
    const ch = xmlData[i];
    if(ch === '<'){
      // const nextIndex = i+1;
      // const _2ndChar = xmlData[nextIndex];
      if( xmlData[i+1] === '/') {//Closing Tag
        const closeIndex = findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
        let tagName = xmlData.substring(i+2,closeIndex).trim();

        if(this.options.removeNSPrefix){
          const colonIndex = tagName.indexOf(":");
          if(colonIndex !== -1){
            tagName = tagName.substr(colonIndex+1);
          }
        }

        if(this.options.transformTagName) {
          tagName = this.options.transformTagName(tagName);
        }

        if(currentNode){
          textData = this.saveTextToParentTag(textData, currentNode, jPath);
        }

        //check if last tag of nested tag was unpaired tag
        const lastTagName = jPath.substring(jPath.lastIndexOf(".")+1);
        if(tagName && this.options.unpairedTags.indexOf(tagName) !== -1 ){
          throw new Error(`Unpaired tag can not be used as closing tag: </${tagName}>`);
        }
        let propIndex = 0;
        if(lastTagName && this.options.unpairedTags.indexOf(lastTagName) !== -1 ){
          propIndex = jPath.lastIndexOf('.', jPath.lastIndexOf('.')-1);
          this.tagsNodeStack.pop();
        }else {
          propIndex = jPath.lastIndexOf(".");
        }
        jPath = jPath.substring(0, propIndex);

        currentNode = this.tagsNodeStack.pop();//avoid recursion, set the parent tag scope
        textData = "";
        i = closeIndex;
      } else if( xmlData[i+1] === '?') {

        let tagData = readTagExp(xmlData,i, false, "?>");
        if(!tagData) throw new Error("Pi Tag is not closed.");

        textData = this.saveTextToParentTag(textData, currentNode, jPath);
        if( (this.options.ignoreDeclaration && tagData.tagName === "?xml") || this.options.ignorePiTags);else {
  
          const childNode = new xmlNode(tagData.tagName);
          childNode.add(this.options.textNodeName, "");
          
          if(tagData.tagName !== tagData.tagExp && tagData.attrExpPresent){
            childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath, tagData.tagName);
          }
          this.addChild(currentNode, childNode, jPath);

        }


        i = tagData.closeIndex + 1;
      } else if(xmlData.substr(i + 1, 3) === '!--') {
        const endIndex = findClosingIndex(xmlData, "-->", i+4, "Comment is not closed.");
        if(this.options.commentPropName){
          const comment = xmlData.substring(i + 4, endIndex - 2);

          textData = this.saveTextToParentTag(textData, currentNode, jPath);

          currentNode.add(this.options.commentPropName, [ { [this.options.textNodeName] : comment } ]);
        }
        i = endIndex;
      } else if( xmlData.substr(i + 1, 2) === '!D') {
        const result = readDocType(xmlData, i);
        this.docTypeEntities = result.entities;
        i = result.i;
      }else if(xmlData.substr(i + 1, 2) === '![') {
        const closeIndex = findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
        const tagExp = xmlData.substring(i + 9,closeIndex);

        textData = this.saveTextToParentTag(textData, currentNode, jPath);

        let val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true, true);
        if(val == undefined) val = "";

        //cdata should be set even if it is 0 length string
        if(this.options.cdataPropName){
          currentNode.add(this.options.cdataPropName, [ { [this.options.textNodeName] : tagExp } ]);
        }else {
          currentNode.add(this.options.textNodeName, val);
        }
        
        i = closeIndex + 2;
      }else {//Opening tag
        let result = readTagExp(xmlData,i, this.options.removeNSPrefix);
        let tagName= result.tagName;
        const rawTagName = result.rawTagName;
        let tagExp = result.tagExp;
        let attrExpPresent = result.attrExpPresent;
        let closeIndex = result.closeIndex;

        if (this.options.transformTagName) {
          tagName = this.options.transformTagName(tagName);
        }
        
        //save text as child node
        if (currentNode && textData) {
          if(currentNode.tagname !== '!xml'){
            //when nested tag is found
            textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
          }
        }

        //check if last tag was unpaired tag
        const lastTag = currentNode;
        if(lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1 ){
          currentNode = this.tagsNodeStack.pop();
          jPath = jPath.substring(0, jPath.lastIndexOf("."));
        }
        if(tagName !== xmlObj.tagname){
          jPath += jPath ? "." + tagName : tagName;
        }
        if (this.isItStopNode(this.options.stopNodes, jPath, tagName)) {
          let tagContent = "";
          //self-closing tag
          if(tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1){
            i = result.closeIndex;
          }
          //unpaired tag
          else if(this.options.unpairedTags.indexOf(tagName) !== -1){
            i = result.closeIndex;
          }
          //normal tag
          else {
            //read until closing tag is found
            const result = this.readStopNodeData(xmlData, rawTagName, closeIndex + 1);
            if(!result) throw new Error(`Unexpected end of ${rawTagName}`);
            i = result.i;
            tagContent = result.tagContent;
          }

          const childNode = new xmlNode(tagName);
          if(tagName !== tagExp && attrExpPresent){
            childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
          }
          if(tagContent) {
            tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
          }
          
          jPath = jPath.substr(0, jPath.lastIndexOf("."));
          childNode.add(this.options.textNodeName, tagContent);
          
          this.addChild(currentNode, childNode, jPath);
        }else {
  //selfClosing tag
          if(tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1){
            if(tagName[tagName.length - 1] === "/"){ //remove trailing '/'
              tagName = tagName.substr(0, tagName.length - 1);
              jPath = jPath.substr(0, jPath.length - 1);
              tagExp = tagName;
            }else {
              tagExp = tagExp.substr(0, tagExp.length - 1);
            }
            
            if(this.options.transformTagName) {
              tagName = this.options.transformTagName(tagName);
            }

            const childNode = new xmlNode(tagName);
            if(tagName !== tagExp && attrExpPresent){
              childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
            }
            this.addChild(currentNode, childNode, jPath);
            jPath = jPath.substr(0, jPath.lastIndexOf("."));
          }
    //opening tag
          else {
            const childNode = new xmlNode( tagName);
            this.tagsNodeStack.push(currentNode);
            
            if(tagName !== tagExp && attrExpPresent){
              childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
            }
            this.addChild(currentNode, childNode, jPath);
            currentNode = childNode;
          }
          textData = "";
          i = closeIndex;
        }
      }
    }else {
      textData += xmlData[i];
    }
  }
  return xmlObj.child;
};

function addChild(currentNode, childNode, jPath){
  const result = this.options.updateTag(childNode.tagname, jPath, childNode[":@"]);
  if(result === false);else if(typeof result === "string"){
    childNode.tagname = result;
    currentNode.addChild(childNode);
  }else {
    currentNode.addChild(childNode);
  }
}

const replaceEntitiesValue$1 = function(val){

  if(this.options.processEntities){
    for(let entityName in this.docTypeEntities){
      const entity = this.docTypeEntities[entityName];
      val = val.replace( entity.regx, entity.val);
    }
    for(let entityName in this.lastEntities){
      const entity = this.lastEntities[entityName];
      val = val.replace( entity.regex, entity.val);
    }
    if(this.options.htmlEntities){
      for(let entityName in this.htmlEntities){
        const entity = this.htmlEntities[entityName];
        val = val.replace( entity.regex, entity.val);
      }
    }
    val = val.replace( this.ampEntity.regex, this.ampEntity.val);
  }
  return val;
};
function saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
  if (textData) { //store previously collected data as textNode
    if(isLeafNode === undefined) isLeafNode = Object.keys(currentNode.child).length === 0;
    
    textData = this.parseTextData(textData,
      currentNode.tagname,
      jPath,
      false,
      currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false,
      isLeafNode);

    if (textData !== undefined && textData !== "")
      currentNode.add(this.options.textNodeName, textData);
    textData = "";
  }
  return textData;
}

//TODO: use jPath to simplify the logic
/**
 * 
 * @param {string[]} stopNodes 
 * @param {string} jPath
 * @param {string} currentTagName 
 */
function isItStopNode(stopNodes, jPath, currentTagName){
  const allNodesExp = "*." + currentTagName;
  for (const stopNodePath in stopNodes) {
    const stopNodeExp = stopNodes[stopNodePath];
    if( allNodesExp === stopNodeExp || jPath === stopNodeExp  ) return true;
  }
  return false;
}

/**
 * Returns the tag Expression and where it is ending handling single-double quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */
function tagExpWithClosingIndex(xmlData, i, closingChar = ">"){
  let attrBoundary;
  let tagExp = "";
  for (let index = i; index < xmlData.length; index++) {
    let ch = xmlData[index];
    if (attrBoundary) {
        if (ch === attrBoundary) attrBoundary = "";//reset
    } else if (ch === '"' || ch === "'") {
        attrBoundary = ch;
    } else if (ch === closingChar[0]) {
      if(closingChar[1]){
        if(xmlData[index + 1] === closingChar[1]){
          return {
            data: tagExp,
            index: index
          }
        }
      }else {
        return {
          data: tagExp,
          index: index
        }
      }
    } else if (ch === '\t') {
      ch = " ";
    }
    tagExp += ch;
  }
}

function findClosingIndex(xmlData, str, i, errMsg){
  const closingIndex = xmlData.indexOf(str, i);
  if(closingIndex === -1){
    throw new Error(errMsg)
  }else {
    return closingIndex + str.length - 1;
  }
}

function readTagExp(xmlData,i, removeNSPrefix, closingChar = ">"){
  const result = tagExpWithClosingIndex(xmlData, i+1, closingChar);
  if(!result) return;
  let tagExp = result.data;
  const closeIndex = result.index;
  const separatorIndex = tagExp.search(/\s/);
  let tagName = tagExp;
  let attrExpPresent = true;
  if(separatorIndex !== -1){//separate tag name and attributes expression
    tagName = tagExp.substring(0, separatorIndex);
    tagExp = tagExp.substring(separatorIndex + 1).trimStart();
  }

  const rawTagName = tagName;
  if(removeNSPrefix){
    const colonIndex = tagName.indexOf(":");
    if(colonIndex !== -1){
      tagName = tagName.substr(colonIndex+1);
      attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
    }
  }

  return {
    tagName: tagName,
    tagExp: tagExp,
    closeIndex: closeIndex,
    attrExpPresent: attrExpPresent,
    rawTagName: rawTagName,
  }
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */
function readStopNodeData(xmlData, tagName, i){
  const startIndex = i;
  // Starting at 1 since we already have an open tag
  let openTagCount = 1;

  for (; i < xmlData.length; i++) {
    if( xmlData[i] === "<"){ 
      if (xmlData[i+1] === "/") {//close tag
          const closeIndex = findClosingIndex(xmlData, ">", i, `${tagName} is not closed`);
          let closeTagName = xmlData.substring(i+2,closeIndex).trim();
          if(closeTagName === tagName){
            openTagCount--;
            if (openTagCount === 0) {
              return {
                tagContent: xmlData.substring(startIndex, i),
                i : closeIndex
              }
            }
          }
          i=closeIndex;
        } else if(xmlData[i+1] === '?') { 
          const closeIndex = findClosingIndex(xmlData, "?>", i+1, "StopNode is not closed.");
          i=closeIndex;
        } else if(xmlData.substr(i + 1, 3) === '!--') { 
          const closeIndex = findClosingIndex(xmlData, "-->", i+3, "StopNode is not closed.");
          i=closeIndex;
        } else if(xmlData.substr(i + 1, 2) === '![') { 
          const closeIndex = findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
          i=closeIndex;
        } else {
          const tagData = readTagExp(xmlData, i, '>');

          if (tagData) {
            const openTagName = tagData && tagData.tagName;
            if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length-1] !== "/") {
              openTagCount++;
            }
            i=tagData.closeIndex;
          }
        }
      }
  }//end for loop
}

function parseValue(val, shouldParse, options) {
  if (shouldParse && typeof val === 'string') {
    //console.log(options)
    const newval = val.trim();
    if(newval === 'true' ) return true;
    else if(newval === 'false' ) return false;
    else return toNumber(val, options);
  } else {
    if (util$2.isExist(val)) {
      return val;
    } else {
      return '';
    }
  }
}


var OrderedObjParser_1 = OrderedObjParser$1;

var node2json = {};

/**
 * 
 * @param {array} node 
 * @param {any} options 
 * @returns 
 */
function prettify$1(node, options){
  return compress( node, options);
}

/**
 * 
 * @param {array} arr 
 * @param {object} options 
 * @param {string} jPath 
 * @returns object
 */
function compress(arr, options, jPath){
  let text;
  const compressedObj = {};
  for (let i = 0; i < arr.length; i++) {
    const tagObj = arr[i];
    const property = propName$1(tagObj);
    let newJpath = "";
    if(jPath === undefined) newJpath = property;
    else newJpath = jPath + "." + property;

    if(property === options.textNodeName){
      if(text === undefined) text = tagObj[property];
      else text += "" + tagObj[property];
    }else if(property === undefined){
      continue;
    }else if(tagObj[property]){
      
      let val = compress(tagObj[property], options, newJpath);
      const isLeaf = isLeafTag(val, options);

      if(tagObj[":@"]){
        assignAttributes( val, tagObj[":@"], newJpath, options);
      }else if(Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode){
        val = val[options.textNodeName];
      }else if(Object.keys(val).length === 0){
        if(options.alwaysCreateTextNode) val[options.textNodeName] = "";
        else val = "";
      }

      if(compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
        if(!Array.isArray(compressedObj[property])) {
            compressedObj[property] = [ compressedObj[property] ];
        }
        compressedObj[property].push(val);
      }else {
        //TODO: if a node is not an array, then check if it should be an array
        //also determine if it is a leaf node
        if (options.isArray(property, newJpath, isLeaf )) {
          compressedObj[property] = [val];
        }else {
          compressedObj[property] = val;
        }
      }
    }
    
  }
  // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
  if(typeof text === "string"){
    if(text.length > 0) compressedObj[options.textNodeName] = text;
  }else if(text !== undefined) compressedObj[options.textNodeName] = text;
  return compressedObj;
}

function propName$1(obj){
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if(key !== ":@") return key;
  }
}

function assignAttributes(obj, attrMap, jpath, options){
  if (attrMap) {
    const keys = Object.keys(attrMap);
    const len = keys.length; //don't make it inline
    for (let i = 0; i < len; i++) {
      const atrrName = keys[i];
      if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) {
        obj[atrrName] = [ attrMap[atrrName] ];
      } else {
        obj[atrrName] = attrMap[atrrName];
      }
    }
  }
}

function isLeafTag(obj, options){
  const { textNodeName } = options;
  const propCount = Object.keys(obj).length;
  
  if (propCount === 0) {
    return true;
  }

  if (
    propCount === 1 &&
    (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)
  ) {
    return true;
  }

  return false;
}
node2json.prettify = prettify$1;

const { buildOptions} = OptionsBuilder;
const OrderedObjParser = OrderedObjParser_1;
const { prettify} = node2json;
const validator$1 = validator$2;

class XMLParser$1{
    
    constructor(options){
        this.externalEntities = {};
        this.options = buildOptions(options);
        
    }
    /**
     * Parse XML dats to JS object 
     * @param {string|Buffer} xmlData 
     * @param {boolean|Object} validationOption 
     */
    parse(xmlData,validationOption){
        if(typeof xmlData === "string");else if( xmlData.toString){
            xmlData = xmlData.toString();
        }else {
            throw new Error("XML data is accepted in String or Bytes[] form.")
        }
        if( validationOption){
            if(validationOption === true) validationOption = {}; //validate with default options
            
            const result = validator$1.validate(xmlData, validationOption);
            if (result !== true) {
              throw Error( `${result.err.msg}:${result.err.line}:${result.err.col}` )
            }
          }
        const orderedObjParser = new OrderedObjParser(this.options);
        orderedObjParser.addExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if(this.options.preserveOrder || orderedResult === undefined) return orderedResult;
        else return prettify(orderedResult, this.options);
    }

    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */
    addEntity(key, value){
        if(value.indexOf("&") !== -1){
            throw new Error("Entity value can't have '&'")
        }else if(key.indexOf("&") !== -1 || key.indexOf(";") !== -1){
            throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'")
        }else if(value === "&"){
            throw new Error("An entity with value '&' is not permitted");
        }else {
            this.externalEntities[key] = value;
        }
    }
}

var XMLParser_1 = XMLParser$1;

const EOL = "\n";

/**
 * 
 * @param {array} jArray 
 * @param {any} options 
 * @returns 
 */
function toXml(jArray, options) {
    let indentation = "";
    if (options.format && options.indentBy.length > 0) {
        indentation = EOL;
    }
    return arrToStr(jArray, options, "", indentation);
}

function arrToStr(arr, options, jPath, indentation) {
    let xmlStr = "";
    let isPreviousElementTag = false;

    for (let i = 0; i < arr.length; i++) {
        const tagObj = arr[i];
        const tagName = propName(tagObj);
        if(tagName === undefined) continue;

        let newJPath = "";
        if (jPath.length === 0) newJPath = tagName;
        else newJPath = `${jPath}.${tagName}`;

        if (tagName === options.textNodeName) {
            let tagText = tagObj[tagName];
            if (!isStopNode(newJPath, options)) {
                tagText = options.tagValueProcessor(tagName, tagText);
                tagText = replaceEntitiesValue(tagText, options);
            }
            if (isPreviousElementTag) {
                xmlStr += indentation;
            }
            xmlStr += tagText;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.cdataPropName) {
            if (isPreviousElementTag) {
                xmlStr += indentation;
            }
            xmlStr += `<![CDATA[${tagObj[tagName][0][options.textNodeName]}]]>`;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.commentPropName) {
            xmlStr += indentation + `<!--${tagObj[tagName][0][options.textNodeName]}-->`;
            isPreviousElementTag = true;
            continue;
        } else if (tagName[0] === "?") {
            const attStr = attr_to_str(tagObj[":@"], options);
            const tempInd = tagName === "?xml" ? "" : indentation;
            let piTextNodeName = tagObj[tagName][0][options.textNodeName];
            piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing
            xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr}?>`;
            isPreviousElementTag = true;
            continue;
        }
        let newIdentation = indentation;
        if (newIdentation !== "") {
            newIdentation += options.indentBy;
        }
        const attStr = attr_to_str(tagObj[":@"], options);
        const tagStart = indentation + `<${tagName}${attStr}`;
        const tagValue = arrToStr(tagObj[tagName], options, newJPath, newIdentation);
        if (options.unpairedTags.indexOf(tagName) !== -1) {
            if (options.suppressUnpairedNode) xmlStr += tagStart + ">";
            else xmlStr += tagStart + "/>";
        } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) {
            xmlStr += tagStart + "/>";
        } else if (tagValue && tagValue.endsWith(">")) {
            xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>`;
        } else {
            xmlStr += tagStart + ">";
            if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) {
                xmlStr += indentation + options.indentBy + tagValue + indentation;
            } else {
                xmlStr += tagValue;
            }
            xmlStr += `</${tagName}>`;
        }
        isPreviousElementTag = true;
    }

    return xmlStr;
}

function propName(obj) {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if(!obj.hasOwnProperty(key)) continue;
        if (key !== ":@") return key;
    }
}

function attr_to_str(attrMap, options) {
    let attrStr = "";
    if (attrMap && !options.ignoreAttributes) {
        for (let attr in attrMap) {
            if(!attrMap.hasOwnProperty(attr)) continue;
            let attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
            attrVal = replaceEntitiesValue(attrVal, options);
            if (attrVal === true && options.suppressBooleanAttributes) {
                attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}`;
            } else {
                attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}="${attrVal}"`;
            }
        }
    }
    return attrStr;
}

function isStopNode(jPath, options) {
    jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
    let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
    for (let index in options.stopNodes) {
        if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName) return true;
    }
    return false;
}

function replaceEntitiesValue(textValue, options) {
    if (textValue && textValue.length > 0 && options.processEntities) {
        for (let i = 0; i < options.entities.length; i++) {
            const entity = options.entities[i];
            textValue = textValue.replace(entity.regex, entity.val);
        }
    }
    return textValue;
}
var orderedJs2Xml = toXml;

//parse Empty Node as self closing node
const buildFromOrderedJs = orderedJs2Xml;

const defaultOptions$1 = {
  attributeNamePrefix: '@_',
  attributesGroupName: false,
  textNodeName: '#text',
  ignoreAttributes: true,
  cdataPropName: false,
  format: false,
  indentBy: '  ',
  suppressEmptyNode: false,
  suppressUnpairedNode: true,
  suppressBooleanAttributes: true,
  tagValueProcessor: function(key, a) {
    return a;
  },
  attributeValueProcessor: function(attrName, a) {
    return a;
  },
  preserveOrder: false,
  commentPropName: false,
  unpairedTags: [],
  entities: [
    { regex: new RegExp("&", "g"), val: "&amp;" },//it must be on top
    { regex: new RegExp(">", "g"), val: "&gt;" },
    { regex: new RegExp("<", "g"), val: "&lt;" },
    { regex: new RegExp("\'", "g"), val: "&apos;" },
    { regex: new RegExp("\"", "g"), val: "&quot;" }
  ],
  processEntities: true,
  stopNodes: [],
  // transformTagName: false,
  // transformAttributeName: false,
  oneListGroup: false
};

function Builder(options) {
  this.options = Object.assign({}, defaultOptions$1, options);
  if (this.options.ignoreAttributes || this.options.attributesGroupName) {
    this.isAttribute = function(/*a*/) {
      return false;
    };
  } else {
    this.attrPrefixLen = this.options.attributeNamePrefix.length;
    this.isAttribute = isAttribute;
  }

  this.processTextOrObjNode = processTextOrObjNode;

  if (this.options.format) {
    this.indentate = indentate;
    this.tagEndChar = '>\n';
    this.newLine = '\n';
  } else {
    this.indentate = function() {
      return '';
    };
    this.tagEndChar = '>';
    this.newLine = '';
  }
}

Builder.prototype.build = function(jObj) {
  if(this.options.preserveOrder){
    return buildFromOrderedJs(jObj, this.options);
  }else {
    if(Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1){
      jObj = {
        [this.options.arrayNodeName] : jObj
      };
    }
    return this.j2x(jObj, 0).val;
  }
};

Builder.prototype.j2x = function(jObj, level) {
  let attrStr = '';
  let val = '';
  for (let key in jObj) {
    if(!Object.prototype.hasOwnProperty.call(jObj, key)) continue;
    if (typeof jObj[key] === 'undefined') {
      // supress undefined node only if it is not an attribute
      if (this.isAttribute(key)) {
        val += '';
      }
    } else if (jObj[key] === null) {
      // null attribute should be ignored by the attribute list, but should not cause the tag closing
      if (this.isAttribute(key)) {
        val += '';
      } else if (key[0] === '?') {
        val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
      } else {
        val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
      }
      // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
    } else if (jObj[key] instanceof Date) {
      val += this.buildTextValNode(jObj[key], key, '', level);
    } else if (typeof jObj[key] !== 'object') {
      //premitive type
      const attr = this.isAttribute(key);
      if (attr) {
        attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
      }else {
        //tag value
        if (key === this.options.textNodeName) {
          let newval = this.options.tagValueProcessor(key, '' + jObj[key]);
          val += this.replaceEntitiesValue(newval);
        } else {
          val += this.buildTextValNode(jObj[key], key, '', level);
        }
      }
    } else if (Array.isArray(jObj[key])) {
      //repeated nodes
      const arrLen = jObj[key].length;
      let listTagVal = "";
      for (let j = 0; j < arrLen; j++) {
        const item = jObj[key][j];
        if (typeof item === 'undefined') ; else if (item === null) {
          if(key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
          else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
          // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        } else if (typeof item === 'object') {
          if(this.options.oneListGroup ){
            listTagVal += this.j2x(item, level + 1).val;
          }else {
            listTagVal += this.processTextOrObjNode(item, key, level);
          }
        } else {
          listTagVal += this.buildTextValNode(item, key, '', level);
        }
      }
      if(this.options.oneListGroup){
        listTagVal = this.buildObjectNode(listTagVal, key, '', level);
      }
      val += listTagVal;
    } else {
      //nested node
      if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
        const Ks = Object.keys(jObj[key]);
        const L = Ks.length;
        for (let j = 0; j < L; j++) {
          attrStr += this.buildAttrPairStr(Ks[j], '' + jObj[key][Ks[j]]);
        }
      } else {
        val += this.processTextOrObjNode(jObj[key], key, level);
      }
    }
  }
  return {attrStr: attrStr, val: val};
};

Builder.prototype.buildAttrPairStr = function(attrName, val){
  val = this.options.attributeValueProcessor(attrName, '' + val);
  val = this.replaceEntitiesValue(val);
  if (this.options.suppressBooleanAttributes && val === "true") {
    return ' ' + attrName;
  } else return ' ' + attrName + '="' + val + '"';
};

function processTextOrObjNode (object, key, level) {
  const result = this.j2x(object, level + 1);
  if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) {
    return this.buildTextValNode(object[this.options.textNodeName], key, result.attrStr, level);
  } else {
    return this.buildObjectNode(result.val, key, result.attrStr, level);
  }
}

Builder.prototype.buildObjectNode = function(val, key, attrStr, level) {
  if(val === ""){
    if(key[0] === "?") return  this.indentate(level) + '<' + key + attrStr+ '?' + this.tagEndChar;
    else {
      return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
    }
  }else {

    let tagEndExp = '</' + key + this.tagEndChar;
    let piClosingChar = "";
    
    if(key[0] === "?") {
      piClosingChar = "?";
      tagEndExp = "";
    }
  
    // attrStr is an empty string in case the attribute came as undefined or null
    if ((attrStr || attrStr === '') && val.indexOf('<') === -1) {
      return ( this.indentate(level) + '<' +  key + attrStr + piClosingChar + '>' + val + tagEndExp );
    } else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) {
      return this.indentate(level) + `<!--${val}-->` + this.newLine;
    }else {
      return (
        this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar +
        val +
        this.indentate(level) + tagEndExp    );
    }
  }
};

Builder.prototype.closeTag = function(key){
  let closeTag = "";
  if(this.options.unpairedTags.indexOf(key) !== -1){ //unpaired
    if(!this.options.suppressUnpairedNode) closeTag = "/";
  }else if(this.options.suppressEmptyNode){ //empty
    closeTag = "/";
  }else {
    closeTag = `></${key}`;
  }
  return closeTag;
};

Builder.prototype.buildTextValNode = function(val, key, attrStr, level) {
  if (this.options.cdataPropName !== false && key === this.options.cdataPropName) {
    return this.indentate(level) + `<![CDATA[${val}]]>` +  this.newLine;
  }else if (this.options.commentPropName !== false && key === this.options.commentPropName) {
    return this.indentate(level) + `<!--${val}-->` +  this.newLine;
  }else if(key[0] === "?") {//PI tag
    return  this.indentate(level) + '<' + key + attrStr+ '?' + this.tagEndChar; 
  }else {
    let textValue = this.options.tagValueProcessor(key, val);
    textValue = this.replaceEntitiesValue(textValue);
  
    if( textValue === ''){
      return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
    }else {
      return this.indentate(level) + '<' + key + attrStr + '>' +
         textValue +
        '</' + key + this.tagEndChar;
    }
  }
};

Builder.prototype.replaceEntitiesValue = function(textValue){
  if(textValue && textValue.length > 0 && this.options.processEntities){
    for (let i=0; i<this.options.entities.length; i++) {
      const entity = this.options.entities[i];
      textValue = textValue.replace(entity.regex, entity.val);
    }
  }
  return textValue;
};

function indentate(level) {
  return this.options.indentBy.repeat(level);
}

function isAttribute(name /*, options*/) {
  if (name.startsWith(this.options.attributeNamePrefix) && name !== this.options.textNodeName) {
    return name.substr(this.attrPrefixLen);
  } else {
    return false;
  }
}

var json2xml = Builder;

const validator = validator$2;
const XMLParser = XMLParser_1;
const XMLBuilder = json2xml;

var fxp = {
  XMLParser: XMLParser,
  XMLValidator: validator,
  XMLBuilder: XMLBuilder
};

var cardScanPackageVersion = '3.0.37';

exports.CardState = void 0;
(function (CardState) {
    CardState["pending"] = "pending";
    CardState["frontsideProcessing"] = "frontside_processing";
    CardState["frontsideFailed"] = "frontside_failed";
    CardState["backsideProcessing"] = "backside_processing";
    CardState["backsideFailed"] = "backside_failed";
    CardState["completed"] = "completed";
    CardState["error"] = "error";
    CardState["unknown"] = "unknown";
})(exports.CardState || (exports.CardState = {}));
//TODO: this needs to be implemented or deleted.
var CardFields;
(function (CardFields) {
    CardFields["groupNumber"] = "group_number";
    CardFields["payerName"] = "payer_name";
    CardFields["memberNumber"] = "member_number";
    CardFields["memberName"] = "member_name";
    CardFields["dependentNames"] = "dependent_names";
    CardFields["rxBin"] = "rx_bin";
    CardFields["rxPCN"] = "rx_pcn";
    CardFields["rxGroup"] = "rx_group";
})(CardFields || (CardFields = {}));
var Card = /** @class */ (function () {
    function Card(params) {
        this.cardId = params.card_id;
        this.state = params.state;
        this.createdAt = params.created_at;
        this.message = params.message ? params.message : undefined;
        this.images = params.images;
        this.details = params.details
            ? {
                memberNumber: params === null || params === void 0 ? void 0 : params.details.member_number,
                groupNumber: params.details.group_number,
                payerName: params.details.payer_name,
                rxBin: params.details.rx_bin,
                rxPCN: params.details.rx_pcn,
                rxGroup: params.details.rx_group,
                memberName: params.details.member_name,
                dependentNames: params.details.dependent_names,
                planName: params.details.plan_name,
                planId: params.details.plan_id,
                clientName: params.details.client_name,
                startDate: params.details.start_date,
                cardSpecificId: params.details.card_specific_id,
            }
            : undefined;
        this.payerMatch = params.payer_match
            ? {
                cardscanPayerId: params.payer_match.cardscan_payer_id,
                cardscanPayerName: params.payer_match.cardscan_payer_name,
                score: params.payer_match.score,
                changeHealthcare: params.payer_match.change_healthcare
                    ? formatChangeHealthcare(params.payer_match.change_healthcare)
                    : [],
                custom: params.payer_match.custom
                    ? formatCustomPayer(params.payer_match.custom)
                    : [],
            }
            : {};
    }
    return Card;
}());
function formatChangeHealthcare(changeHealthcare) {
    return changeHealthcare.map(function (data) { return ({
        chcPayerId: data.chc_payer_id,
        chcPayerName: data.chc_payer_name,
        score: data.score,
    }); });
}
function formatCustomPayer(custom) {
    return custom.map(function (data) { return ({
        customPayerId: data.custom_payer_id,
        customPayerName: data.custom_payer_name,
        customPayerNameAlt: data.custom_payer_name_alt,
        score: data.score,
        source: data.source,
    }); });
}

var XMLErrortoCardScanError = function (xmlErrorObj, code) { return ({
    message: xmlErrorObj.Message._text,
    type: xmlErrorObj.Code._text,
    code: code,
    isCardScanError: true,
}); };
var generateError = function (message, type, code) {
    if (type === void 0) { type = "ApiError"; }
    if (code === void 0) { code = 696; }
    return ({
        message: message,
        type: type,
        code: code,
        isCardScanError: true,
    });
};

var GlobalLogger = /** @class */ (function () {
    function GlobalLogger() {
    }
    GlobalLogger.setLogLevel = function (level) {
        GlobalLogger.LogLevel = level;
    };
    GlobalLogger.shouldLog = function (level) {
        if (GlobalLogger.LogLevel === "off") {
            return false;
        }
        if (GlobalLogger.LogLevel === "everything") {
            return true;
        }
        if (GlobalLogger.LogLevel === "detector") {
            return level === "detector";
        }
        if (GlobalLogger.LogLevel === "verbose") {
            return level !== "detector" && level !== "everything";
        }
        return level === "normal";
    };
    GlobalLogger.getLog = function () {
        return window.cardScanDebugLog || [];
    };
    // This is a special log function that is used before the logger is fully initialized
    GlobalLogger.earlyLog = function (message) {
        var timestamp = new Date().toISOString();
        if (!window.cardScanDebugLog) {
            window.cardScanDebugLog = [];
        }
        window.cardScanDebugLog.push("".concat(timestamp, " [CardScan] INFO: ").concat(message));
        console.log("".concat(timestamp, " [CardScan] INFO: ").concat(message));
    };
    GlobalLogger.log = function (message, level) {
        if (level === void 0) { level = "normal"; }
        if (GlobalLogger.shouldLog(level)) {
            var timestamp = new Date().toISOString();
            if (!window.cardScanDebugLog) {
                window.cardScanDebugLog = [];
            }
            window.cardScanDebugLog.push("".concat(timestamp, " [CardScan] INFO: ").concat(message));
            console.log("".concat(timestamp, " [CardScan] INFO: ").concat(message));
        }
    };
    GlobalLogger.debug = function (message, level) {
        if (level === void 0) { level = "verbose"; }
        if (GlobalLogger.shouldLog(level)) {
            var timestamp = new Date().toISOString();
            if (!window.cardScanDebugLog) {
                window.cardScanDebugLog = [];
            }
            window.cardScanDebugLog.push("".concat(timestamp, " [CardScan] DEBUG: ").concat(message));
            console.debug("".concat(timestamp, " [CardScan] DEBUG: ").concat(message));
        }
    };
    GlobalLogger.error = function (message) {
        var timestamp = new Date().toISOString();
        if (!window.cardScanDebugLog) {
            window.cardScanDebugLog = [];
        }
        window.cardScanDebugLog.push("".concat(timestamp, " [CardScan] ERROR: ").concat(message));
        console.error("".concat(timestamp, " [CardScan] ERROR: ").concat(message));
    };
    GlobalLogger.startingLogLevel = "off";
    GlobalLogger.LogLevel = GlobalLogger.startingLogLevel;
    return GlobalLogger;
}());

var LIVE_API_ENDPOINT = "https://api.cardscan.ai/v1/";
var SANDBOX_API_ENDPOINT = "https://sandbox.cardscan.ai/v1/";
var LIVE_WS_ENDPOINT = "wss://ws.cardscan.ai";
var SANDBOX_WS_ENDPOINT = "wss://sandbox-ws.cardscan.ai";
var CardScanApi = /** @class */ (function () {
    function CardScanApi(params) {
        var _this = this;
        this.initializeRequestInterceptor = function () {
            _this.instance.interceptors.request.use(_this.handleRequest);
        };
        this.handleRequest = function (config) {
            if (config && config.headers) {
                config.headers.Authorization = "Bearer ".concat(_this.sessionToken);
                config.headers["x-cardscan-ai-sdk"] = "insurance_cardscan_react  ".concat(cardScanPackageVersion);
            }
            return config;
        };
        this.generateUploadUrl = function (cardId, payload) {
            return _this.instance.post("/cards/".concat(cardId, "/generate-upload-url"), payload);
        };
        this.generateMagicLink = function () {
            return _this.instance.get("/generate-magic-link");
        };
        this.uploadCardImage = function (file) {
            var formData = new FormData();
            return _this.instance
                .get("/generate-upload-url")
                .then(function (response) { return response.data; })
                .then(function (cardUploadRes) {
                var upload_parameters = cardUploadRes.upload_parameters;
                for (var key in upload_parameters) {
                    formData.append(key, upload_parameters[key]);
                }
                formData.append("file", file);
                return {
                    uploadUrl: cardUploadRes.upload_url,
                    cardId: cardUploadRes.card_id,
                };
            })
                .then(function (_a) {
                var uploadUrl = _a.uploadUrl, cardId = _a.cardId;
                // needs to be axios and not this.instance because can't use authorization header.
                return axios$1
                    .post(uploadUrl, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(function () { return cardId; })
                    .catch(function (error) {
                    //errors back from S3 will be in XML.
                    if (error.response && error.response.data) {
                        var parser = new fxp.XMLParser();
                        var errorResponse = parser.parse(error.response.data);
                        var cardError = XMLErrortoCardScanError(errorResponse.Error, error.response.status);
                        GlobalLogger.error("Error uploading file: ".concat(cardError.message));
                        throw cardError;
                    }
                    else {
                        throw error;
                    }
                });
            });
        };
        this.uploadScanImage = function (scanCount, file, cardId, captureType, orientation, metadata) {
            var payload = {
                metadata: metadata || {},
                capture_type: captureType,
                orientation: orientation,
            };
            return _this.uploadScan(cardId, file, orientation, captureType, scanCount)
                .then(function (response) { return response.data; })
                .then(function (data) {
                _this.setScanMetadata(data.scan_id, payload);
                return {
                    scanId: data.scan_id,
                    cardId: data.card_id,
                };
            });
        };
        this.uploadScan = function (cardId, file, orientation, captureType, scanCount) {
            return _this.instance.post("/cards/".concat(cardId, "/upload"), file, {
                params: {
                    orientation: orientation,
                    capture_type: captureType,
                    scanCount: scanCount,
                },
                headers: {
                    "Content-Type": file.type,
                },
            });
        };
        this.setScanMetadata = function (scanId, metadata) {
            return _this.instance.post("/scans/".concat(scanId, "/metadata"), metadata);
        };
        this.listCards = function (params) {
            var config = {
                params: {},
            };
            if (params === null || params === void 0 ? void 0 : params.cursor)
                config.params.cursor = params === null || params === void 0 ? void 0 : params.cursor;
            if (params === null || params === void 0 ? void 0 : params.limit)
                config.params.limit = params === null || params === void 0 ? void 0 : params.limit;
            return _this.instance.get("/cards", config);
        };
        this.getCard = function (cardId) {
            return _this.instance.get("/cards/".concat(cardId));
        };
        this.createEligibility = function (eligibility, card_id) {
            var payload = {
                eligibility: eligibility,
                card_id: card_id,
            };
            return _this.instance.post("/eligibility", payload);
        };
        this.getEligibility = function (eligibilityId) {
            return _this.instance.get("eligibility/".concat(eligibilityId));
        };
        this.getCardImage = function (cardId) {
            return _this.instance.get("/cards/".concat(cardId, "/image"));
        };
        this.createCard = function (backsideSupport, enableLivescan, metadata) {
            var payload = __assign$2({ enable_backside_scan: backsideSupport, enable_livescan: enableLivescan }, (metadata && { metadata: metadata }));
            return _this.instance.post("/cards", payload);
        };
        this.performanceData = function (cardId, data) {
            return _this.instance.post("/cards/".concat(cardId, "/performance"), __assign$2(__assign$2({}, data), { timestamp: new Date().toISOString() }));
        };
        this.subscribe = function (cardId, callback) {
            var inProgress = false;
            var isDifferent = true;
            var lastState = "";
            _this.intervalId = setInterval(function () {
                if (!inProgress) {
                    inProgress = true;
                    _this.getCard(cardId)
                        .then(function (res) {
                        if (lastState !== res.data.state) {
                            isDifferent = true;
                        }
                        if (isDifferent) {
                            lastState = res.data.state;
                            callback(new Card(res.data));
                        }
                        inProgress = false;
                        if (["completed", "error"].includes(res.data.state))
                            _this.cancelSubscription();
                    })
                        .catch(function (err) {
                        GlobalLogger.error("Error getting card: ".concat(cardId));
                        inProgress = false;
                        callback(new Card({
                            state: exports.CardState.error,
                            message: err.response.data.message,
                            card_id: cardId,
                        }));
                        _this.cancelSubscription();
                    });
                }
            }, 1000);
        };
        this.cancelSubscription = function () {
            if (_this.intervalId) {
                clearInterval(_this.intervalId);
                _this.intervalId = null;
            }
        };
        if (!params.sessionToken || params.sessionToken.length === 0) {
            throw new Error("sessionToken is required");
        }
        this.sessionToken = params.sessionToken;
        var apiEndpoint = params.apiEndpoint ||
            (params.live ? LIVE_API_ENDPOINT : SANDBOX_API_ENDPOINT);
        var wsEndpoint = params.wsEndpoint ||
            (params.live ? LIVE_WS_ENDPOINT : SANDBOX_WS_ENDPOINT);
        this.instance = axios$1.create({
            baseURL: apiEndpoint,
        });
        this.initializeRequestInterceptor();
        this.intervalId = null;
        var wsUrl = "".concat(wsEndpoint, "?token=").concat(this.sessionToken);
        // This is a workaround for Cypress live vs stubbed tests
        if (window.Cypress &&
            window.Cypress.env("cardScanWebsocketUrl") &&
            window.Cypress.env("cardScanWebsocketUrl") !== "NONE") {
            wsUrl = window.Cypress.env("cardScanWebsocketUrl");
        }
        this.socket = new WebSocket(wsUrl);
    }
    return CardScanApi;
}());

var propTypes$2 = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e$1=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h$2=b?Symbol.for("react.provider"):60109,k$1=b?Symbol.for("react.context"):60110,l$1=b?Symbol.for("react.async_mode"):60111,m$1=b?Symbol.for("react.concurrent_mode"):60111,n$2=b?Symbol.for("react.forward_ref"):60112,p$2=b?Symbol.for("react.suspense"):60113,q$2=b?
Symbol.for("react.suspense_list"):60120,r$2=b?Symbol.for("react.memo"):60115,t$2=b?Symbol.for("react.lazy"):60116,v$1=b?Symbol.for("react.block"):60121,w$1=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l$1:case m$1:case e$1:case g:case f:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$2:case t$2:case r$2:case h$2:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m$1}reactIs_production_min.AsyncMode=l$1;reactIs_production_min.ConcurrentMode=m$1;reactIs_production_min.ContextConsumer=k$1;reactIs_production_min.ContextProvider=h$2;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n$2;reactIs_production_min.Fragment=e$1;reactIs_production_min.Lazy=t$2;reactIs_production_min.Memo=r$2;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p$2;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l$1};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k$1};reactIs_production_min.isContextProvider=function(a){return z(a)===h$2};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n$2};reactIs_production_min.isFragment=function(a){return z(a)===e$1};reactIs_production_min.isLazy=function(a){return z(a)===t$2};
reactIs_production_min.isMemo=function(a){return z(a)===r$2};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p$2};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$1||a===g||a===f||a===p$2||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$2||a.$$typeof===r$2||a.$$typeof===h$2||a.$$typeof===k$1||a.$$typeof===n$2||a.$$typeof===w$1||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v$1)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$3 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$2 = has$3;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$2(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;
var assign$3 = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has$1 = has$3;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign$3({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$2.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$2.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes$2.exports;

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var spinkitSpinners = {
  circle: { className: 'sk-circle', divCount: 12 },
  'cube-grid': { className: 'sk-cube-grid', divCount: 9 },
  wave: { className: 'sk-wave', divCount: 5 },
  'folding-cube': { className: 'sk-folding-cube', divCount: 4 },
  'three-bounce': { className: 'sk-three-bounce', divCount: 3 },
  'double-bounce': { className: 'sk-double-bounce', divCount: 2 },
  'wandering-cubes': { className: 'sk-wandering-cubes', divCount: 2 },
  'chasing-dots': { className: 'sk-chasing-dots', divCount: 2 },
  'rotating-plane': { className: 'sk-rotating-plane', divCount: 1 },
  pulse: { className: 'sk-pulse', divCount: 1 },
  wordpress: { className: 'sk-wordpress', divCount: 1 }
};

var loadersCssSpinners = {
  'ball-grid-beat': { divCount: 9 },
  'ball-grid-pulse': { divCount: 9 },
  'line-spin-fade-loader': { divCount: 8 },
  'ball-spin-fade-loader': { divCount: 8 },
  'ball-pulse-rise': { divCount: 5 },
  'line-scale': { divCount: 5 },
  'line-scale-pulse-out': { divCount: 5 },
  'line-scale-pulse-out-rapid': { divCount: 5 },
  pacman: { divCount: 5 },
  'line-scale-party': { divCount: 4 },
  'ball-triangle-path': { divCount: 3 },
  'ball-scale-multiple': { divCount: 3 },
  'ball-scale-ripple-multiple': { divCount: 3 },
  'ball-pulse-sync': { divCount: 3 },
  'ball-beat': { divCount: 3 },
  'ball-zig-zag': { divCount: 2 },
  'ball-zig-zag-deflect': { divCount: 2 },
  'ball-clip-rotate-pulse': { divCount: 2 },
  'ball-clip-rotate-multiple': { divCount: 2 },
  'ball-clip-rotate': { divCount: 1 },
  'ball-scale-ripple': { divCount: 1 },
  'triangle-skew-spin': { divCount: 1 }
};

var spinners = {
  spinkitSpinners: spinkitSpinners,
  loadersCssSpinners: loadersCssSpinners,
  allSpinners: _extends$4({}, spinkitSpinners, loadersCssSpinners)
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$p = "@-webkit-keyframes scale{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}45%{opacity:.7;-webkit-transform:scale(.1);transform:scale(.1)}80%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.ball-pulse>div:nth-child(0){-webkit-animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.36s infinite;animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.36s infinite}.ball-pulse>div:first-child{-webkit-animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.24s infinite;animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.24s infinite}.ball-pulse>div:nth-child(2){-webkit-animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.12s infinite;animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.12s infinite}.ball-pulse>div:nth-child(3){-webkit-animation:scale .75s cubic-bezier(.2,.68,.18,1.08) 0s infinite;animation:scale .75s cubic-bezier(.2,.68,.18,1.08) 0s infinite}.ball-pulse>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;display:inline-block;height:15px;margin:2px;width:15px}@-webkit-keyframes ball-pulse-sync{33%{-webkit-transform:translateY(10px);transform:translateY(10px)}66%{-webkit-transform:translateY(-10px);transform:translateY(-10px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes ball-pulse-sync{33%{-webkit-transform:translateY(10px);transform:translateY(10px)}66%{-webkit-transform:translateY(-10px);transform:translateY(-10px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.ball-pulse-sync>div:nth-child(0){-webkit-animation:ball-pulse-sync .6s ease-in-out -.21s infinite;animation:ball-pulse-sync .6s ease-in-out -.21s infinite}.ball-pulse-sync>div:first-child{-webkit-animation:ball-pulse-sync .6s ease-in-out -.14s infinite;animation:ball-pulse-sync .6s ease-in-out -.14s infinite}.ball-pulse-sync>div:nth-child(2){-webkit-animation:ball-pulse-sync .6s ease-in-out -.07s infinite;animation:ball-pulse-sync .6s ease-in-out -.07s infinite}.ball-pulse-sync>div:nth-child(3){-webkit-animation:ball-pulse-sync .6s ease-in-out 0s infinite;animation:ball-pulse-sync .6s ease-in-out 0s infinite}.ball-pulse-sync>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;display:inline-block;height:15px;margin:2px;width:15px}@-webkit-keyframes ball-scale{0%{-webkit-transform:scale(0);transform:scale(0)}to{opacity:0;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-scale{0%{-webkit-transform:scale(0);transform:scale(0)}to{opacity:0;-webkit-transform:scale(1);transform:scale(1)}}.ball-scale>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-scale 1s ease-in-out 0s infinite;animation:ball-scale 1s ease-in-out 0s infinite;background-color:#fff;border-radius:100%;display:inline-block;height:15px;height:60px;margin:2px;width:15px;width:60px}.ball-scale-random{height:40px;width:37px}.ball-scale-random>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-scale 1s ease-in-out 0s infinite;animation:ball-scale 1s ease-in-out 0s infinite;background-color:#fff;border-radius:100%;display:inline-block;height:15px;height:30px;margin:2px;position:absolute;width:15px;width:30px}.ball-scale-random>div:first-child{-webkit-animation:ball-scale 1s ease-in-out .2s infinite;animation:ball-scale 1s ease-in-out .2s infinite;margin-left:-7px}.ball-scale-random>div:nth-child(3){-webkit-animation:ball-scale 1s ease-in-out .5s infinite;animation:ball-scale 1s ease-in-out .5s infinite;margin-left:-2px;margin-top:9px}@-webkit-keyframes rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ball-rotate,.ball-rotate>div{position:relative}.ball-rotate>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;height:15px;margin:2px;width:15px}.ball-rotate>div:first-child{-webkit-animation:rotate 1s cubic-bezier(.7,-.13,.22,.86) 0s infinite;animation:rotate 1s cubic-bezier(.7,-.13,.22,.86) 0s infinite}.ball-rotate>div:after,.ball-rotate>div:before{background-color:#fff;border-radius:100%;content:\"\";height:15px;margin:2px;opacity:.8;position:absolute;width:15px}.ball-rotate>div:before{left:-28px;top:0}.ball-rotate>div:after{left:25px;top:0}.ball-clip-rotate>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:rotate .75s linear 0s infinite;animation:rotate .75s linear 0s infinite;background-color:#fff;background:transparent!important;border:2px solid;border-color:#fff #fff transparent;border-radius:100%;display:inline-block;height:15px;height:25px;margin:2px;width:15px;width:25px}@keyframes scale{30%{-webkit-transform:scale(.3);transform:scale(.3)}to{-webkit-transform:scale(1);transform:scale(1)}}.ball-clip-rotate-pulse{position:relative;-webkit-transform:translateY(-15px);-ms-transform:translateY(-15px);transform:translateY(-15px)}.ball-clip-rotate-pulse>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;border-radius:100%;left:0;position:absolute;top:0}.ball-clip-rotate-pulse>div:first-child{-webkit-animation:scale 1s cubic-bezier(.09,.57,.49,.9) 0s infinite;animation:scale 1s cubic-bezier(.09,.57,.49,.9) 0s infinite;background:#fff;height:16px;left:-7px;top:7px;width:16px}.ball-clip-rotate-pulse>div:last-child{-webkit-animation:rotate 1s cubic-bezier(.09,.57,.49,.9) 0s infinite;animation:rotate 1s cubic-bezier(.09,.57,.49,.9) 0s infinite;-webkit-animation-duration:1s;animation-duration:1s;background:transparent;border:2px solid;border-color:#fff transparent;border-style:solid;border-width:2px;height:30px;left:-16px;position:absolute;top:-2px;width:30px}@keyframes rotate{0%{-webkit-transform:rotate(0deg) scale(1);transform:rotate(0deg) scale(1)}50%{-webkit-transform:rotate(180deg) scale(.6);transform:rotate(180deg) scale(.6)}to{-webkit-transform:rotate(1turn) scale(1);transform:rotate(1turn) scale(1)}}.ball-clip-rotate-multiple{position:relative}.ball-clip-rotate-multiple>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:rotate 1s ease-in-out 0s infinite;animation:rotate 1s ease-in-out 0s infinite;border-color:transparent #fff;border-radius:100%;border-style:solid;border-width:2px;height:35px;left:-20px;position:absolute;top:-20px;width:35px}.ball-clip-rotate-multiple>div:last-child{-webkit-animation-direction:reverse;animation-direction:reverse;-webkit-animation-duration:.5s;animation-duration:.5s;border-color:#fff transparent;display:inline-block;height:15px;left:-10px;top:-10px;width:15px}@-webkit-keyframes ball-scale-ripple{0%{opacity:1;-webkit-transform:scale(.1);transform:scale(.1)}70%{opacity:.7;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0}}@keyframes ball-scale-ripple{0%{opacity:1;-webkit-transform:scale(.1);transform:scale(.1)}70%{opacity:.7;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0}}.ball-scale-ripple>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-scale-ripple 1s cubic-bezier(.21,.53,.56,.8) 0s infinite;animation:ball-scale-ripple 1s cubic-bezier(.21,.53,.56,.8) 0s infinite;border:2px solid #fff;border-radius:100%;height:50px;width:50px}@-webkit-keyframes ball-scale-ripple-multiple{0%{opacity:1;-webkit-transform:scale(.1);transform:scale(.1)}70%{opacity:.7;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0}}@keyframes ball-scale-ripple-multiple{0%{opacity:1;-webkit-transform:scale(.1);transform:scale(.1)}70%{opacity:.7;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0}}.ball-scale-ripple-multiple{position:relative;-webkit-transform:translateY(-25px);-ms-transform:translateY(-25px);transform:translateY(-25px)}.ball-scale-ripple-multiple>div:nth-child(0){-webkit-animation-delay:-.8s;animation-delay:-.8s}.ball-scale-ripple-multiple>div:first-child{-webkit-animation-delay:-.6s;animation-delay:-.6s}.ball-scale-ripple-multiple>div:nth-child(2){-webkit-animation-delay:-.4s;animation-delay:-.4s}.ball-scale-ripple-multiple>div:nth-child(3){-webkit-animation-delay:-.2s;animation-delay:-.2s}.ball-scale-ripple-multiple>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-scale-ripple-multiple 1.25s cubic-bezier(.21,.53,.56,.8) 0s infinite;animation:ball-scale-ripple-multiple 1.25s cubic-bezier(.21,.53,.56,.8) 0s infinite;border:2px solid #fff;border-radius:100%;height:50px;left:-26px;position:absolute;top:-2px;width:50px}@-webkit-keyframes ball-beat{50%{opacity:.2;-webkit-transform:scale(.75);transform:scale(.75)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-beat{50%{opacity:.2;-webkit-transform:scale(.75);transform:scale(.75)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.ball-beat>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-beat .7s linear 0s infinite;animation:ball-beat .7s linear 0s infinite;background-color:#fff;border-radius:100%;display:inline-block;height:15px;margin:2px;width:15px}.ball-beat>div:nth-child(2n-1){-webkit-animation-delay:-.35s!important;animation-delay:-.35s!important}@-webkit-keyframes ball-scale-multiple{0%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}5%{opacity:1}to{opacity:0;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-scale-multiple{0%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}5%{opacity:1}to{opacity:0;-webkit-transform:scale(1);transform:scale(1)}}.ball-scale-multiple{position:relative;-webkit-transform:translateY(-30px);-ms-transform:translateY(-30px);transform:translateY(-30px)}.ball-scale-multiple>div:nth-child(2){-webkit-animation-delay:-.4s;animation-delay:-.4s}.ball-scale-multiple>div:nth-child(3){-webkit-animation-delay:-.2s;animation-delay:-.2s}.ball-scale-multiple>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-scale-multiple 1s linear 0s infinite;animation:ball-scale-multiple 1s linear 0s infinite;background-color:#fff;border-radius:100%;height:15px;height:60px;left:-30px;margin:0;opacity:0;position:absolute;top:0;width:15px;width:60px}@-webkit-keyframes ball-triangle-path-1{33%{-webkit-transform:translate(25px,-50px);transform:translate(25px,-50px)}66%{-webkit-transform:translate(50px);transform:translate(50px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-triangle-path-1{33%{-webkit-transform:translate(25px,-50px);transform:translate(25px,-50px)}66%{-webkit-transform:translate(50px);transform:translate(50px)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes ball-triangle-path-2{33%{-webkit-transform:translate(25px,50px);transform:translate(25px,50px)}66%{-webkit-transform:translate(-25px,50px);transform:translate(-25px,50px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-triangle-path-2{33%{-webkit-transform:translate(25px,50px);transform:translate(25px,50px)}66%{-webkit-transform:translate(-25px,50px);transform:translate(-25px,50px)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes ball-triangle-path-3{33%{-webkit-transform:translate(-50px);transform:translate(-50px)}66%{-webkit-transform:translate(-25px,-50px);transform:translate(-25px,-50px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-triangle-path-3{33%{-webkit-transform:translate(-50px);transform:translate(-50px)}66%{-webkit-transform:translate(-25px,-50px);transform:translate(-25px,-50px)}to{-webkit-transform:translate(0);transform:translate(0)}}.ball-triangle-path{position:relative;-webkit-transform:translate(-29.994px,-37.50938px);-ms-transform:translate(-29.994px,-37.50938px);transform:translate(-29.994px,-37.50938px)}.ball-triangle-path>div:first-child{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ball-triangle-path-1;animation-name:ball-triangle-path-1;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.ball-triangle-path>div:first-child,.ball-triangle-path>div:nth-child(2){-webkit-animation-delay:0;animation-delay:0;-webkit-animation-duration:2s;animation-duration:2s}.ball-triangle-path>div:nth-child(2){-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ball-triangle-path-2;animation-name:ball-triangle-path-2;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.ball-triangle-path>div:nth-child(3){-webkit-animation-delay:0;animation-delay:0;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ball-triangle-path-3;animation-name:ball-triangle-path-3;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.ball-triangle-path>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;border:1px solid #fff;border-radius:100%;height:10px;position:absolute;width:10px}.ball-triangle-path>div:first-of-type{top:50px}.ball-triangle-path>div:nth-of-type(2){left:25px}.ball-triangle-path>div:nth-of-type(3){left:50px;top:50px}@-webkit-keyframes ball-pulse-rise-even{0%{-webkit-transform:scale(1.1);transform:scale(1.1)}25%{-webkit-transform:translateY(-30px);transform:translateY(-30px)}50%{-webkit-transform:scale(.4);transform:scale(.4)}75%{-webkit-transform:translateY(30px);transform:translateY(30px)}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-pulse-rise-even{0%{-webkit-transform:scale(1.1);transform:scale(1.1)}25%{-webkit-transform:translateY(-30px);transform:translateY(-30px)}50%{-webkit-transform:scale(.4);transform:scale(.4)}75%{-webkit-transform:translateY(30px);transform:translateY(30px)}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes ball-pulse-rise-odd{0%{-webkit-transform:scale(.4);transform:scale(.4)}25%{-webkit-transform:translateY(30px);transform:translateY(30px)}50%{-webkit-transform:scale(1.1);transform:scale(1.1)}75%{-webkit-transform:translateY(-30px);transform:translateY(-30px)}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform:scale(.75);transform:scale(.75)}}@keyframes ball-pulse-rise-odd{0%{-webkit-transform:scale(.4);transform:scale(.4)}25%{-webkit-transform:translateY(30px);transform:translateY(30px)}50%{-webkit-transform:scale(1.1);transform:scale(1.1)}75%{-webkit-transform:translateY(-30px);transform:translateY(-30px)}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform:scale(.75);transform:scale(.75)}}.ball-pulse-rise>div{-webkit-animation-delay:0;animation-delay:0;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:cubic-bezier(.15,.46,.9,.6);animation-timing-function:cubic-bezier(.15,.46,.9,.6);background-color:#fff;border-radius:100%;display:inline-block;height:15px;margin:2px;width:15px}.ball-pulse-rise>div:nth-child(2n){-webkit-animation-name:ball-pulse-rise-even;animation-name:ball-pulse-rise-even}.ball-pulse-rise>div:nth-child(2n-1){-webkit-animation-name:ball-pulse-rise-odd;animation-name:ball-pulse-rise-odd}@-webkit-keyframes ball-grid-beat{50%{opacity:.7}to{opacity:1}}@keyframes ball-grid-beat{50%{opacity:.7}to{opacity:1}}.ball-grid-beat{width:57px}.ball-grid-beat>div:first-child{-webkit-animation-delay:.44s;animation-delay:.44s;-webkit-animation-duration:1.27s;animation-duration:1.27s}.ball-grid-beat>div:nth-child(2){-webkit-animation-delay:.2s;animation-delay:.2s;-webkit-animation-duration:1.52s;animation-duration:1.52s}.ball-grid-beat>div:nth-child(3){-webkit-animation-delay:.14s;animation-delay:.14s;-webkit-animation-duration:.61s;animation-duration:.61s}.ball-grid-beat>div:nth-child(4){-webkit-animation-delay:.15s;animation-delay:.15s;-webkit-animation-duration:.82s;animation-duration:.82s}.ball-grid-beat>div:nth-child(5){-webkit-animation-delay:-.01s;animation-delay:-.01s;-webkit-animation-duration:1.24s;animation-duration:1.24s}.ball-grid-beat>div:nth-child(6){-webkit-animation-delay:-.07s;animation-delay:-.07s;-webkit-animation-duration:1.35s;animation-duration:1.35s}.ball-grid-beat>div:nth-child(7){-webkit-animation-delay:.29s;animation-delay:.29s;-webkit-animation-duration:1.44s;animation-duration:1.44s}.ball-grid-beat>div:nth-child(8){-webkit-animation-delay:.63s;animation-delay:.63s;-webkit-animation-duration:1.19s;animation-duration:1.19s}.ball-grid-beat>div:nth-child(9){-webkit-animation-delay:-.18s;animation-delay:-.18s;-webkit-animation-duration:1.48s;animation-duration:1.48s}.ball-grid-beat>div{-webkit-animation-delay:0;animation-delay:0;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ball-grid-beat;animation-name:ball-grid-beat;background-color:#fff;border-radius:100%;display:inline-block;float:left;height:15px;margin:2px;width:15px}@-webkit-keyframes ball-grid-pulse{0%{-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.7;-webkit-transform:scale(.5);transform:scale(.5)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-grid-pulse{0%{-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.7;-webkit-transform:scale(.5);transform:scale(.5)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.ball-grid-pulse{width:57px}.ball-grid-pulse>div:first-child{-webkit-animation-delay:.58s;animation-delay:.58s;-webkit-animation-duration:.9s;animation-duration:.9s}.ball-grid-pulse>div:nth-child(2){-webkit-animation-delay:.01s;animation-delay:.01s;-webkit-animation-duration:.94s;animation-duration:.94s}.ball-grid-pulse>div:nth-child(3){-webkit-animation-delay:.25s;animation-delay:.25s;-webkit-animation-duration:1.43s;animation-duration:1.43s}.ball-grid-pulse>div:nth-child(4){-webkit-animation-delay:-.03s;animation-delay:-.03s;-webkit-animation-duration:.74s;animation-duration:.74s}.ball-grid-pulse>div:nth-child(5){-webkit-animation-delay:.21s;animation-delay:.21s;-webkit-animation-duration:.68s;animation-duration:.68s}.ball-grid-pulse>div:nth-child(6){-webkit-animation-delay:.25s;animation-delay:.25s;-webkit-animation-duration:1.17s;animation-duration:1.17s}.ball-grid-pulse>div:nth-child(7){-webkit-animation-delay:.46s;animation-delay:.46s;-webkit-animation-duration:1.41s;animation-duration:1.41s}.ball-grid-pulse>div:nth-child(8){-webkit-animation-delay:.02s;animation-delay:.02s;-webkit-animation-duration:1.56s;animation-duration:1.56s}.ball-grid-pulse>div:nth-child(9){-webkit-animation-delay:.13s;animation-delay:.13s;-webkit-animation-duration:.78s;animation-duration:.78s}.ball-grid-pulse>div{-webkit-animation-delay:0;animation-delay:0;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ball-grid-pulse;animation-name:ball-grid-pulse;background-color:#fff;border-radius:100%;display:inline-block;float:left;height:15px;margin:2px;width:15px}@-webkit-keyframes ball-spin-fade-loader{50%{opacity:.3;-webkit-transform:scale(.4);transform:scale(.4)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-spin-fade-loader{50%{opacity:.3;-webkit-transform:scale(.4);transform:scale(.4)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.ball-spin-fade-loader{left:-10px;position:relative;top:-10px}.ball-spin-fade-loader>div:first-child{-webkit-animation:ball-spin-fade-loader 1s linear -.96s infinite;animation:ball-spin-fade-loader 1s linear -.96s infinite;left:0;top:25px}.ball-spin-fade-loader>div:nth-child(2){-webkit-animation:ball-spin-fade-loader 1s linear -.84s infinite;animation:ball-spin-fade-loader 1s linear -.84s infinite;left:17.04545px;top:17.04545px}.ball-spin-fade-loader>div:nth-child(3){-webkit-animation:ball-spin-fade-loader 1s linear -.72s infinite;animation:ball-spin-fade-loader 1s linear -.72s infinite;left:25px;top:0}.ball-spin-fade-loader>div:nth-child(4){-webkit-animation:ball-spin-fade-loader 1s linear -.6s infinite;animation:ball-spin-fade-loader 1s linear -.6s infinite;left:17.04545px;top:-17.04545px}.ball-spin-fade-loader>div:nth-child(5){-webkit-animation:ball-spin-fade-loader 1s linear -.48s infinite;animation:ball-spin-fade-loader 1s linear -.48s infinite;left:0;top:-25px}.ball-spin-fade-loader>div:nth-child(6){-webkit-animation:ball-spin-fade-loader 1s linear -.36s infinite;animation:ball-spin-fade-loader 1s linear -.36s infinite;left:-17.04545px;top:-17.04545px}.ball-spin-fade-loader>div:nth-child(7){-webkit-animation:ball-spin-fade-loader 1s linear -.24s infinite;animation:ball-spin-fade-loader 1s linear -.24s infinite;left:-25px;top:0}.ball-spin-fade-loader>div:nth-child(8){-webkit-animation:ball-spin-fade-loader 1s linear -.12s infinite;animation:ball-spin-fade-loader 1s linear -.12s infinite;left:-17.04545px;top:17.04545px}.ball-spin-fade-loader>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;height:15px;margin:2px;position:absolute;width:15px}@-webkit-keyframes ball-spin-loader{75%{opacity:.2}to{opacity:1}}@keyframes ball-spin-loader{75%{opacity:.2}to{opacity:1}}.ball-spin-loader{position:relative}.ball-spin-loader>span:first-child{-webkit-animation:ball-spin-loader 2s linear .9s infinite;animation:ball-spin-loader 2s linear .9s infinite;left:0;top:45px}.ball-spin-loader>span:nth-child(2){-webkit-animation:ball-spin-loader 2s linear 1.8s infinite;animation:ball-spin-loader 2s linear 1.8s infinite;left:30.68182px;top:30.68182px}.ball-spin-loader>span:nth-child(3){-webkit-animation:ball-spin-loader 2s linear 2.7s infinite;animation:ball-spin-loader 2s linear 2.7s infinite;left:45px;top:0}.ball-spin-loader>span:nth-child(4){-webkit-animation:ball-spin-loader 2s linear 3.6s infinite;animation:ball-spin-loader 2s linear 3.6s infinite;left:30.68182px;top:-30.68182px}.ball-spin-loader>span:nth-child(5){-webkit-animation:ball-spin-loader 2s linear 4.5s infinite;animation:ball-spin-loader 2s linear 4.5s infinite;left:0;top:-45px}.ball-spin-loader>span:nth-child(6){-webkit-animation:ball-spin-loader 2s linear 5.4s infinite;animation:ball-spin-loader 2s linear 5.4s infinite;left:-30.68182px;top:-30.68182px}.ball-spin-loader>span:nth-child(7){-webkit-animation:ball-spin-loader 2s linear 6.3s infinite;animation:ball-spin-loader 2s linear 6.3s infinite;left:-45px;top:0}.ball-spin-loader>span:nth-child(8){-webkit-animation:ball-spin-loader 2s linear 7.2s infinite;animation:ball-spin-loader 2s linear 7.2s infinite;left:-30.68182px;top:30.68182px}.ball-spin-loader>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background:green;border-radius:100%;height:15px;position:absolute;width:15px}@-webkit-keyframes ball-zig{33%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}66%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-zig{33%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}66%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes ball-zag{33%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}66%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-zag{33%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}66%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}to{-webkit-transform:translate(0);transform:translate(0)}}.ball-zig-zag{position:relative;-webkit-transform:translate(-15px,-15px);-ms-transform:translate(-15px,-15px);transform:translate(-15px,-15px)}.ball-zig-zag>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;height:15px;left:-7px;margin:2px 2px 2px 15px;position:absolute;top:4px;width:15px}.ball-zig-zag>div:first-child{-webkit-animation:ball-zig .7s linear 0s infinite;animation:ball-zig .7s linear 0s infinite}.ball-zig-zag>div:last-child{-webkit-animation:ball-zag .7s linear 0s infinite;animation:ball-zag .7s linear 0s infinite}@-webkit-keyframes ball-zig-deflect{17%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}34%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}50%{-webkit-transform:translate(0);transform:translate(0)}67%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}84%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-zig-deflect{17%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}34%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}50%{-webkit-transform:translate(0);transform:translate(0)}67%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}84%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes ball-zag-deflect{17%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}34%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}50%{-webkit-transform:translate(0);transform:translate(0)}67%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}84%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-zag-deflect{17%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}34%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}50%{-webkit-transform:translate(0);transform:translate(0)}67%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}84%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}to{-webkit-transform:translate(0);transform:translate(0)}}.ball-zig-zag-deflect{position:relative;-webkit-transform:translate(-15px,-15px);-ms-transform:translate(-15px,-15px);transform:translate(-15px,-15px)}.ball-zig-zag-deflect>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;height:15px;left:-7px;margin:2px 2px 2px 15px;position:absolute;top:4px;width:15px}.ball-zig-zag-deflect>div:first-child{-webkit-animation:ball-zig-deflect 1.5s linear 0s infinite;animation:ball-zig-deflect 1.5s linear 0s infinite}.ball-zig-zag-deflect>div:last-child{-webkit-animation:ball-zag-deflect 1.5s linear 0s infinite;animation:ball-zag-deflect 1.5s linear 0s infinite}@-webkit-keyframes line-scale{0%{-webkit-transform:scaley(1);transform:scaley(1)}50%{-webkit-transform:scaley(.4);transform:scaley(.4)}to{-webkit-transform:scaley(1);transform:scaley(1)}}@keyframes line-scale{0%{-webkit-transform:scaley(1);transform:scaley(1)}50%{-webkit-transform:scaley(.4);transform:scaley(.4)}to{-webkit-transform:scaley(1);transform:scaley(1)}}.line-scale>div:first-child{-webkit-animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.4s infinite;animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.4s infinite}.line-scale>div:nth-child(2){-webkit-animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.3s infinite;animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.3s infinite}.line-scale>div:nth-child(3){-webkit-animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.2s infinite;animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.2s infinite}.line-scale>div:nth-child(4){-webkit-animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.1s infinite;animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.1s infinite}.line-scale>div:nth-child(5){-webkit-animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) 0s infinite;animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) 0s infinite}.line-scale>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:2px;display:inline-block;height:35px;margin:2px;width:4px}@-webkit-keyframes line-scale-party{0%{-webkit-transform:scale(1);transform:scale(1)}50%{-webkit-transform:scale(.5);transform:scale(.5)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes line-scale-party{0%{-webkit-transform:scale(1);transform:scale(1)}50%{-webkit-transform:scale(.5);transform:scale(.5)}to{-webkit-transform:scale(1);transform:scale(1)}}.line-scale-party>div:first-child{-webkit-animation-delay:-.09s;animation-delay:-.09s;-webkit-animation-duration:.83s;animation-duration:.83s}.line-scale-party>div:nth-child(2){-webkit-animation-delay:.33s;animation-delay:.33s;-webkit-animation-duration:.64s;animation-duration:.64s}.line-scale-party>div:nth-child(3){-webkit-animation-delay:.32s;animation-delay:.32s;-webkit-animation-duration:.39s;animation-duration:.39s}.line-scale-party>div:nth-child(4){-webkit-animation-delay:.47s;animation-delay:.47s;-webkit-animation-duration:.52s;animation-duration:.52s}.line-scale-party>div{-webkit-animation-delay:0;animation-delay:0;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:line-scale-party;animation-name:line-scale-party;background-color:#fff;border-radius:2px;display:inline-block;height:35px;margin:2px;width:4px}@-webkit-keyframes line-scale-pulse-out{0%{-webkit-transform:scaley(1);transform:scaley(1)}50%{-webkit-transform:scaley(.4);transform:scaley(.4)}to{-webkit-transform:scaley(1);transform:scaley(1)}}@keyframes line-scale-pulse-out{0%{-webkit-transform:scaley(1);transform:scaley(1)}50%{-webkit-transform:scaley(.4);transform:scaley(.4)}to{-webkit-transform:scaley(1);transform:scaley(1)}}.line-scale-pulse-out>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:line-scale-pulse-out .9s cubic-bezier(.85,.25,.37,.85) -.6s infinite;animation:line-scale-pulse-out .9s cubic-bezier(.85,.25,.37,.85) -.6s infinite;background-color:#fff;border-radius:2px;display:inline-block;height:35px;margin:2px;width:4px}.line-scale-pulse-out>div:nth-child(2),.line-scale-pulse-out>div:nth-child(4){-webkit-animation-delay:-.4s!important;animation-delay:-.4s!important}.line-scale-pulse-out>div:first-child,.line-scale-pulse-out>div:nth-child(5){-webkit-animation-delay:-.2s!important;animation-delay:-.2s!important}@-webkit-keyframes line-scale-pulse-out-rapid{0%{-webkit-transform:scaley(1);transform:scaley(1)}80%{-webkit-transform:scaley(.3);transform:scaley(.3)}90%{-webkit-transform:scaley(1);transform:scaley(1)}}@keyframes line-scale-pulse-out-rapid{0%{-webkit-transform:scaley(1);transform:scaley(1)}80%{-webkit-transform:scaley(.3);transform:scaley(.3)}90%{-webkit-transform:scaley(1);transform:scaley(1)}}.line-scale-pulse-out-rapid>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:line-scale-pulse-out-rapid .9s cubic-bezier(.11,.49,.38,.78) -.5s infinite;animation:line-scale-pulse-out-rapid .9s cubic-bezier(.11,.49,.38,.78) -.5s infinite;background-color:#fff;border-radius:2px;display:inline-block;height:35px;margin:2px;width:4px}.line-scale-pulse-out-rapid>div:nth-child(2),.line-scale-pulse-out-rapid>div:nth-child(4){-webkit-animation-delay:-.25s!important;animation-delay:-.25s!important}.line-scale-pulse-out-rapid>div:first-child,.line-scale-pulse-out-rapid>div:nth-child(5){-webkit-animation-delay:0s!important;animation-delay:0s!important}@-webkit-keyframes line-spin-fade-loader{50%{opacity:.3}to{opacity:1}}@keyframes line-spin-fade-loader{50%{opacity:.3}to{opacity:1}}.line-spin-fade-loader{left:-4px;position:relative;top:-10px}.line-spin-fade-loader>div:first-child{-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.84s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.84s infinite;left:0;top:20px}.line-spin-fade-loader>div:nth-child(2){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.72s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.72s infinite;left:13.63636px;top:13.63636px;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.line-spin-fade-loader>div:nth-child(3){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.6s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.6s infinite;left:20px;top:0;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.line-spin-fade-loader>div:nth-child(4){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.48s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.48s infinite;left:13.63636px;top:-13.63636px;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.line-spin-fade-loader>div:nth-child(5){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.36s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.36s infinite;left:0;top:-20px}.line-spin-fade-loader>div:nth-child(6){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.24s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.24s infinite;left:-13.63636px;top:-13.63636px;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.line-spin-fade-loader>div:nth-child(7){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.12s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.12s infinite;left:-20px;top:0;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.line-spin-fade-loader>div:nth-child(8){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out 0s infinite;animation:line-spin-fade-loader 1.2s ease-in-out 0s infinite;left:-13.63636px;top:13.63636px;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.line-spin-fade-loader>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:2px;height:35px;height:15px;margin:2px;position:absolute;width:4px;width:5px}@-webkit-keyframes triangle-skew-spin{25%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(0);transform:perspective(100px) rotateX(180deg) rotateY(0)}50%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(180deg);transform:perspective(100px) rotateX(180deg) rotateY(180deg)}75%{-webkit-transform:perspective(100px) rotateX(0) rotateY(180deg);transform:perspective(100px) rotateX(0) rotateY(180deg)}to{-webkit-transform:perspective(100px) rotateX(0) rotateY(0);transform:perspective(100px) rotateX(0) rotateY(0)}}@keyframes triangle-skew-spin{25%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(0);transform:perspective(100px) rotateX(180deg) rotateY(0)}50%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(180deg);transform:perspective(100px) rotateX(180deg) rotateY(180deg)}75%{-webkit-transform:perspective(100px) rotateX(0) rotateY(180deg);transform:perspective(100px) rotateX(0) rotateY(180deg)}to{-webkit-transform:perspective(100px) rotateX(0) rotateY(0);transform:perspective(100px) rotateX(0) rotateY(0)}}.triangle-skew-spin>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:triangle-skew-spin 3s cubic-bezier(.09,.57,.49,.9) 0s infinite;animation:triangle-skew-spin 3s cubic-bezier(.09,.57,.49,.9) 0s infinite;border-bottom:20px solid #fff;border-left:20px solid transparent;border-right:20px solid transparent;height:0;width:0}@-webkit-keyframes square-spin{25%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(0);transform:perspective(100px) rotateX(180deg) rotateY(0)}50%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(180deg);transform:perspective(100px) rotateX(180deg) rotateY(180deg)}75%{-webkit-transform:perspective(100px) rotateX(0) rotateY(180deg);transform:perspective(100px) rotateX(0) rotateY(180deg)}to{-webkit-transform:perspective(100px) rotateX(0) rotateY(0);transform:perspective(100px) rotateX(0) rotateY(0)}}@keyframes square-spin{25%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(0);transform:perspective(100px) rotateX(180deg) rotateY(0)}50%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(180deg);transform:perspective(100px) rotateX(180deg) rotateY(180deg)}75%{-webkit-transform:perspective(100px) rotateX(0) rotateY(180deg);transform:perspective(100px) rotateX(0) rotateY(180deg)}to{-webkit-transform:perspective(100px) rotateX(0) rotateY(0);transform:perspective(100px) rotateX(0) rotateY(0)}}.square-spin>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:square-spin 3s cubic-bezier(.09,.57,.49,.9) 0s infinite;animation:square-spin 3s cubic-bezier(.09,.57,.49,.9) 0s infinite;background:#fff;border:1px solid red;height:50px;width:50px}@-webkit-keyframes rotate_pacman_half_up{0%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}50%{-webkit-transform:rotate(1turn);transform:rotate(1turn)}to{-webkit-transform:rotate(270deg);transform:rotate(270deg)}}@keyframes rotate_pacman_half_up{0%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}50%{-webkit-transform:rotate(1turn);transform:rotate(1turn)}to{-webkit-transform:rotate(270deg);transform:rotate(270deg)}}@-webkit-keyframes rotate_pacman_half_down{0%{-webkit-transform:rotate(90deg);transform:rotate(90deg)}50%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(90deg);transform:rotate(90deg)}}@keyframes rotate_pacman_half_down{0%{-webkit-transform:rotate(90deg);transform:rotate(90deg)}50%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(90deg);transform:rotate(90deg)}}@-webkit-keyframes pacman-balls{75%{opacity:.7}to{-webkit-transform:translate(-100px,-6.25px);transform:translate(-100px,-6.25px)}}@keyframes pacman-balls{75%{opacity:.7}to{-webkit-transform:translate(-100px,-6.25px);transform:translate(-100px,-6.25px)}}.pacman{position:relative}.pacman>div:nth-child(2){-webkit-animation:pacman-balls 1s linear -.99s infinite;animation:pacman-balls 1s linear -.99s infinite}.pacman>div:nth-child(3){-webkit-animation:pacman-balls 1s linear -.66s infinite;animation:pacman-balls 1s linear -.66s infinite}.pacman>div:nth-child(4){-webkit-animation:pacman-balls 1s linear -.33s infinite;animation:pacman-balls 1s linear -.33s infinite}.pacman>div:nth-child(5){-webkit-animation:pacman-balls 1s linear 0s infinite;animation:pacman-balls 1s linear 0s infinite}.pacman>div:first-of-type{-webkit-animation:rotate_pacman_half_up .5s 0s infinite;animation:rotate_pacman_half_up .5s 0s infinite}.pacman>div:first-of-type,.pacman>div:nth-child(2){border:25px solid #fff;border-radius:25px;border-right-color:transparent;height:0;left:-30px;position:relative;width:0}.pacman>div:nth-child(2){-webkit-animation:rotate_pacman_half_down .5s 0s infinite;animation:rotate_pacman_half_down .5s 0s infinite;margin-top:-50px}.pacman>div:nth-child(3),.pacman>div:nth-child(4),.pacman>div:nth-child(5),.pacman>div:nth-child(6){background-color:#fff;border-radius:100%;height:15px;height:10px;left:70px;margin:2px;position:absolute;top:25px;-webkit-transform:translateY(-6.25px);-ms-transform:translateY(-6.25px);transform:translateY(-6.25px);width:15px;width:10px}@-webkit-keyframes cube-transition{25%{-webkit-transform:translateX(50px) scale(.5) rotate(-90deg);transform:translateX(50px) scale(.5) rotate(-90deg)}50%{-webkit-transform:translate(50px,50px) rotate(-180deg);transform:translate(50px,50px) rotate(-180deg)}75%{-webkit-transform:translateY(50px) scale(.5) rotate(-270deg);transform:translateY(50px) scale(.5) rotate(-270deg)}to{-webkit-transform:rotate(-1turn);transform:rotate(-1turn)}}@keyframes cube-transition{25%{-webkit-transform:translateX(50px) scale(.5) rotate(-90deg);transform:translateX(50px) scale(.5) rotate(-90deg)}50%{-webkit-transform:translate(50px,50px) rotate(-180deg);transform:translate(50px,50px) rotate(-180deg)}75%{-webkit-transform:translateY(50px) scale(.5) rotate(-270deg);transform:translateY(50px) scale(.5) rotate(-270deg)}to{-webkit-transform:rotate(-1turn);transform:rotate(-1turn)}}.cube-transition{position:relative;-webkit-transform:translate(-25px,-25px);-ms-transform:translate(-25px,-25px);transform:translate(-25px,-25px)}.cube-transition>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:cube-transition 1.6s ease-in-out 0s infinite;animation:cube-transition 1.6s ease-in-out 0s infinite;background-color:#fff;height:10px;left:-5px;position:absolute;top:-5px;width:10px}.cube-transition>div:last-child{-webkit-animation-delay:-.8s;animation-delay:-.8s}@-webkit-keyframes spin-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.semi-circle-spin{height:35px;overflow:hidden;position:relative;width:35px}.semi-circle-spin>div{-webkit-animation:spin-rotate .6s linear 0s infinite;animation:spin-rotate .6s linear 0s infinite;background-image:-webkit-linear-gradient(transparent,transparent 70%,#fff 0,#fff);background-image:linear-gradient(transparent,transparent 70%,#fff 0,#fff);border-radius:100%;border-width:0;height:100%;position:absolute;width:100%}@-webkit-keyframes bar-progress{0%{opacity:1;-webkit-transform:scaleY(20%);transform:scaleY(20%)}25%{opacity:.7;-webkit-transform:translateX(6%) scaleY(10%);transform:translateX(6%) scaleY(10%)}50%{opacity:1;-webkit-transform:translateX(20%) scaleY(20%);transform:translateX(20%) scaleY(20%)}75%{opacity:.7;-webkit-transform:translateX(6%) scaleY(10%);transform:translateX(6%) scaleY(10%)}to{opacity:1;-webkit-transform:scaleY(20%);transform:scaleY(20%)}}@keyframes bar-progress{0%{opacity:1;-webkit-transform:scaleY(20%);transform:scaleY(20%)}25%{opacity:.7;-webkit-transform:translateX(6%) scaleY(10%);transform:translateX(6%) scaleY(10%)}50%{opacity:1;-webkit-transform:translateX(20%) scaleY(20%);transform:translateX(20%) scaleY(20%)}75%{opacity:.7;-webkit-transform:translateX(6%) scaleY(10%);transform:translateX(6%) scaleY(10%)}to{opacity:1;-webkit-transform:scaleY(20%);transform:scaleY(20%)}}.bar-progress{height:12px;width:30%}.bar-progress>div{-webkit-animation:bar-progress 3s cubic-bezier(.57,.1,.44,.93) infinite;animation:bar-progress 3s cubic-bezier(.57,.1,.44,.93) infinite;background-color:#fff;border-radius:10px;height:12px;opacity:1;position:relative;width:20%}@-webkit-keyframes bar-swing{0%{left:0}50%{left:70%}to{left:0}}@keyframes bar-swing{0%{left:0}50%{left:70%}to{left:0}}.bar-swing,.bar-swing>div{height:8px;width:30%}.bar-swing>div{-webkit-animation:bar-swing 1.5s infinite;animation:bar-swing 1.5s infinite;background-color:#fff;border-radius:10px;position:relative}@-webkit-keyframes bar-swing-container{0%{left:0;-webkit-transform:translateX(0);transform:translateX(0)}50%{left:70%;-webkit-transform:translateX(-4px);transform:translateX(-4px)}to{left:0;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes bar-swing-container{0%{left:0;-webkit-transform:translateX(0);transform:translateX(0)}50%{left:70%;-webkit-transform:translateX(-4px);transform:translateX(-4px)}to{left:0;-webkit-transform:translateX(0);transform:translateX(0)}}.bar-swing-container{height:8px;position:relative;width:20%}.bar-swing-container div:first-child{background-color:hsla(0,0%,100%,.2);border-radius:10px;height:12px;position:absolute;width:100%}.bar-swing-container div:nth-child(2){-webkit-animation:bar-swing-container 2s cubic-bezier(.91,.35,.12,.6) infinite;animation:bar-swing-container 2s cubic-bezier(.91,.35,.12,.6) infinite;background-color:#fff;border-radius:10px;height:8px;margin:2px 2px 0;position:absolute;width:30%}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$p);

var css_248z$o = ".sk-spinner{color:#333}.sk-spinner>div{background-color:currentColor}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJhc2UuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLFlBQ0UsVUFDRixDQUVBLGdCQUNFLDZCQUNGIiwiZmlsZSI6ImJhc2UuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNrLXNwaW5uZXIge1xuICBjb2xvcjogIzMzMztcbn1cblxuLnNrLXNwaW5uZXIgPiBkaXYge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiBjdXJyZW50Q29sb3I7XG59XG4iXX0= */";
styleInject(css_248z$o);

var css_248z$n = ".ball-scale-ripple-multiple>div,.ball-scale-ripple>div,.ball-triangle-path>div{background-color:initial;border-color:currentColor}.ball-clip-rotate>div{background-color:initial;border-left-color:currentColor;border-right-color:currentColor;border-top-color:currentColor}.ball-clip-rotate-pulse>div:first-child{background-color:currentColor}.ball-clip-rotate-pulse>div:last-child{background-color:initial;border-bottom-color:currentColor;border-top-color:currentColor}.ball-clip-rotate-multiple>div:first-child{background-color:initial;border-left-color:currentColor;border-right-color:currentColor}.ball-clip-rotate-multiple>div:last-child{border-top-color:currentColor}.ball-clip-rotate-multiple>div:last-child,.triangle-skew-spin>div{background-color:initial;border-bottom-color:currentColor}.pacman>div:first-child,.pacman>div:nth-child(2){background-color:initial;border-bottom-color:currentColor;border-left-color:currentColor;border-top-color:currentColor}.pacman>div:nth-child(3),.pacman>div:nth-child(4),.pacman>div:nth-child(5){background-color:currentColor}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$n);

var css_248z$m = "@-webkit-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@-moz-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@-ms-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}.sk-fade-in{-webkit-animation:sk-fade-in 2s;-moz-animation:sk-fade-in 2s;-o-animation:sk-fade-in 2s;-ms-animation:sk-fade-in 2s;animation:sk-fade-in 2s}.sk-fade-in-half-second{-webkit-animation:sk-fade-in 1s;-moz-animation:sk-fade-in 1s;-o-animation:sk-fade-in 1s;-ms-animation:sk-fade-in 1s;animation:sk-fade-in 1s}.sk-fade-in-quarter-second{-webkit-animation:sk-fade-in .5s;-moz-animation:sk-fade-in .5s;-o-animation:sk-fade-in .5s;-ms-animation:sk-fade-in .5s;animation:sk-fade-in .5s}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$m);

var css_248z$l = ".sk-chasing-dots{-webkit-animation:sk-rotate 2s linear infinite;animation:sk-rotate 2s linear infinite;height:27px;position:relative;width:27px}.sk-chasing-dots>div{-webkit-animation:sk-bounce 2s ease-in-out infinite;animation:sk-bounce 2s ease-in-out infinite;background-color:currentColor;border-radius:100%;display:inline-block;height:60%;position:absolute;top:0;width:60%}.sk-chasing-dots>div:last-child{-webkit-animation-delay:-1s;animation-delay:-1s;bottom:0;top:auto}@-webkit-keyframes sk-rotate{to{-webkit-transform:rotate(1turn)}}@keyframes sk-rotate{to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}@-webkit-keyframes sk-bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes sk-bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$l);

var css_248z$k = ".sk-circle{height:22px;position:relative;width:22px}.sk-circle>div{background-color:initial;height:100%;left:0;position:absolute;top:0;width:100%}.sk-circle>div:before{-webkit-animation:sk-bouncedelay 1.2s ease-in-out infinite;animation:sk-bouncedelay 1.2s ease-in-out infinite;-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:currentColor;border-radius:100%;content:\"\";display:block;height:20%;margin:0 auto;width:20%}.sk-circle>div:nth-child(2){-webkit-transform:rotate(30deg);transform:rotate(30deg)}.sk-circle>div:nth-child(3){-webkit-transform:rotate(60deg);transform:rotate(60deg)}.sk-circle>div:nth-child(4){-webkit-transform:rotate(90deg);transform:rotate(90deg)}.sk-circle>div:nth-child(5){-webkit-transform:rotate(120deg);transform:rotate(120deg)}.sk-circle>div:nth-child(6){-webkit-transform:rotate(150deg);transform:rotate(150deg)}.sk-circle>div:nth-child(7){-webkit-transform:rotate(180deg);transform:rotate(180deg)}.sk-circle>div:nth-child(8){-webkit-transform:rotate(210deg);transform:rotate(210deg)}.sk-circle>div:nth-child(9){-webkit-transform:rotate(240deg);transform:rotate(240deg)}.sk-circle>div:nth-child(10){-webkit-transform:rotate(270deg);transform:rotate(270deg)}.sk-circle>div:nth-child(11){-webkit-transform:rotate(300deg);transform:rotate(300deg)}.sk-circle>div:nth-child(12){-webkit-transform:rotate(330deg);transform:rotate(330deg)}.sk-circle>div:nth-child(2):before{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-circle>div:nth-child(3):before{-webkit-animation-delay:-1s;animation-delay:-1s}.sk-circle>div:nth-child(4):before{-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-circle>div:nth-child(5):before{-webkit-animation-delay:-.8s;animation-delay:-.8s}.sk-circle>div:nth-child(6):before{-webkit-animation-delay:-.7s;animation-delay:-.7s}.sk-circle>div:nth-child(7):before{-webkit-animation-delay:-.6s;animation-delay:-.6s}.sk-circle>div:nth-child(8):before{-webkit-animation-delay:-.5s;animation-delay:-.5s}.sk-circle>div:nth-child(9):before{-webkit-animation-delay:-.4s;animation-delay:-.4s}.sk-circle>div:nth-child(10):before{-webkit-animation-delay:-.3s;animation-delay:-.3s}.sk-circle>div:nth-child(11):before{-webkit-animation-delay:-.2s;animation-delay:-.2s}.sk-circle>div:nth-child(12):before{-webkit-animation-delay:-.1s;animation-delay:-.1s}@-webkit-keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNpcmNsZS5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsV0FFRSxXQUFZLENBQ1osaUJBQWtCLENBRmxCLFVBR0YsQ0FFQSxlQUNFLHdCQUF5QixDQUV6QixXQUFZLENBRVosTUFBTyxDQURQLGlCQUFrQixDQUVsQixLQUFNLENBSk4sVUFLRixDQUVBLHNCQVNFLDBEQUEyRCxDQUMzRCxrREFBbUQsQ0FFbkQsZ0NBQWlDLENBQ2pDLHdCQUF5QixDQVB6Qiw2QkFBOEIsQ0FDOUIsa0JBQW1CLENBTm5CLFVBQVcsQ0FDWCxhQUFjLENBR2QsVUFBVyxDQUZYLGFBQWMsQ0FDZCxTQVVGLENBRUEsNEJBQWlDLCtCQUFnQyxDQUFHLHVCQUEwQixDQUM5Riw0QkFBaUMsK0JBQWdDLENBQUcsdUJBQTBCLENBQzlGLDRCQUFpQywrQkFBZ0MsQ0FBRyx1QkFBMEIsQ0FDOUYsNEJBQWlDLGdDQUFpQyxDQUFFLHdCQUEwQixDQUM5Riw0QkFBaUMsZ0NBQWlDLENBQUUsd0JBQTBCLENBQzlGLDRCQUFpQyxnQ0FBaUMsQ0FBRSx3QkFBMEIsQ0FDOUYsNEJBQWlDLGdDQUFpQyxDQUFFLHdCQUEwQixDQUM5Riw0QkFBaUMsZ0NBQWlDLENBQUUsd0JBQTBCLENBQzlGLDZCQUFpQyxnQ0FBaUMsQ0FBRSx3QkFBMEIsQ0FDOUYsNkJBQWlDLGdDQUFpQyxDQUFFLHdCQUEwQixDQUM5Riw2QkFBaUMsZ0NBQWlDLENBQUUsd0JBQTBCLENBRTlGLG1DQUF5Qyw2QkFBOEIsQ0FBRSxxQkFBdUIsQ0FDaEcsbUNBQXlDLDJCQUE4QixDQUFFLG1CQUF1QixDQUNoRyxtQ0FBeUMsNEJBQThCLENBQUUsb0JBQXVCLENBQ2hHLG1DQUF5Qyw0QkFBOEIsQ0FBRSxvQkFBdUIsQ0FDaEcsbUNBQXlDLDRCQUE4QixDQUFFLG9CQUF1QixDQUNoRyxtQ0FBeUMsNEJBQThCLENBQUUsb0JBQXVCLENBQ2hHLG1DQUF5Qyw0QkFBOEIsQ0FBRSxvQkFBdUIsQ0FDaEcsbUNBQXlDLDRCQUE4QixDQUFFLG9CQUF1QixDQUNoRyxvQ0FBeUMsNEJBQThCLENBQUUsb0JBQXVCLENBQ2hHLG9DQUF5Qyw0QkFBOEIsQ0FBRSxvQkFBdUIsQ0FDaEcsb0NBQXlDLDRCQUE4QixDQUFFLG9CQUF1QixDQUVoRyxrQ0FDRSxVQUFnQiwwQkFBOEIsQ0FDOUMsSUFBTSwwQkFBOEIsQ0FDdEMsQ0FFQSwwQkFDRSxVQUNFLDBCQUE2QixDQUM3QixrQkFDRixDQUFFLElBQ0EsMEJBQTZCLENBQzdCLGtCQUNGLENBQ0YiLCJmaWxlIjoiY2lyY2xlLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zay1jaXJjbGUge1xuICB3aWR0aDogMjJweDtcbiAgaGVpZ2h0OiAyMnB4O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG59XG5cbi5zay1jaXJjbGUgPiBkaXYge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiBpbml0aWFsO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGxlZnQ6IDA7XG4gIHRvcDogMDtcbn1cblxuLnNrLWNpcmNsZSA+IGRpdjo6YmVmb3JlIHtcbiAgY29udGVudDogJyc7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBtYXJnaW46IDAgYXV0bztcbiAgd2lkdGg6IDIwJTtcbiAgaGVpZ2h0OiAyMCU7XG4gIGJhY2tncm91bmQtY29sb3I6IGN1cnJlbnRDb2xvcjtcbiAgYm9yZGVyLXJhZGl1czogMTAwJTtcblxuICAtd2Via2l0LWFuaW1hdGlvbjogc2stYm91bmNlZGVsYXkgMS4ycyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbiAgYW5pbWF0aW9uOiBzay1ib3VuY2VkZWxheSAxLjJzIGluZmluaXRlIGVhc2UtaW4tb3V0O1xuICAvKiBQcmV2ZW50IGZpcnN0IGZyYW1lIGZyb20gZmxpY2tlcmluZyB3aGVuIGFuaW1hdGlvbiBzdGFydHMgKi9cbiAgLXdlYmtpdC1hbmltYXRpb24tZmlsbC1tb2RlOiBib3RoO1xuICBhbmltYXRpb24tZmlsbC1tb2RlOiBib3RoO1xufVxuXG4uc2stY2lyY2xlID4gZGl2Om50aC1jaGlsZCgyKSAgeyAtd2Via2l0LXRyYW5zZm9ybTogcm90YXRlKDMwZGVnKTsgIHRyYW5zZm9ybTogcm90YXRlKDMwZGVnKSAgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoMykgIHsgLXdlYmtpdC10cmFuc2Zvcm06IHJvdGF0ZSg2MGRlZyk7ICB0cmFuc2Zvcm06IHJvdGF0ZSg2MGRlZykgIH1cbi5zay1jaXJjbGUgPiBkaXY6bnRoLWNoaWxkKDQpICB7IC13ZWJraXQtdHJhbnNmb3JtOiByb3RhdGUoOTBkZWcpOyAgdHJhbnNmb3JtOiByb3RhdGUoOTBkZWcpICB9XG4uc2stY2lyY2xlID4gZGl2Om50aC1jaGlsZCg1KSAgeyAtd2Via2l0LXRyYW5zZm9ybTogcm90YXRlKDEyMGRlZyk7IHRyYW5zZm9ybTogcm90YXRlKDEyMGRlZykgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoNikgIHsgLXdlYmtpdC10cmFuc2Zvcm06IHJvdGF0ZSgxNTBkZWcpOyB0cmFuc2Zvcm06IHJvdGF0ZSgxNTBkZWcpIH1cbi5zay1jaXJjbGUgPiBkaXY6bnRoLWNoaWxkKDcpICB7IC13ZWJraXQtdHJhbnNmb3JtOiByb3RhdGUoMTgwZGVnKTsgdHJhbnNmb3JtOiByb3RhdGUoMTgwZGVnKSB9XG4uc2stY2lyY2xlID4gZGl2Om50aC1jaGlsZCg4KSAgeyAtd2Via2l0LXRyYW5zZm9ybTogcm90YXRlKDIxMGRlZyk7IHRyYW5zZm9ybTogcm90YXRlKDIxMGRlZykgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoOSkgIHsgLXdlYmtpdC10cmFuc2Zvcm06IHJvdGF0ZSgyNDBkZWcpOyB0cmFuc2Zvcm06IHJvdGF0ZSgyNDBkZWcpIH1cbi5zay1jaXJjbGUgPiBkaXY6bnRoLWNoaWxkKDEwKSB7IC13ZWJraXQtdHJhbnNmb3JtOiByb3RhdGUoMjcwZGVnKTsgdHJhbnNmb3JtOiByb3RhdGUoMjcwZGVnKSB9XG4uc2stY2lyY2xlID4gZGl2Om50aC1jaGlsZCgxMSkgeyAtd2Via2l0LXRyYW5zZm9ybTogcm90YXRlKDMwMGRlZyk7IHRyYW5zZm9ybTogcm90YXRlKDMwMGRlZykgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoMTIpIHsgLXdlYmtpdC10cmFuc2Zvcm06IHJvdGF0ZSgzMzBkZWcpOyB0cmFuc2Zvcm06IHJvdGF0ZSgzMzBkZWcpIH1cblxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoMik6OmJlZm9yZSAgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTEuMXM7IGFuaW1hdGlvbi1kZWxheTogLTEuMXMgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoMyk6OmJlZm9yZSAgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTEuMHM7IGFuaW1hdGlvbi1kZWxheTogLTEuMHMgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoNCk6OmJlZm9yZSAgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuOXM7IGFuaW1hdGlvbi1kZWxheTogLTAuOXMgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoNSk6OmJlZm9yZSAgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuOHM7IGFuaW1hdGlvbi1kZWxheTogLTAuOHMgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoNik6OmJlZm9yZSAgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuN3M7IGFuaW1hdGlvbi1kZWxheTogLTAuN3MgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoNyk6OmJlZm9yZSAgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuNnM7IGFuaW1hdGlvbi1kZWxheTogLTAuNnMgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoOCk6OmJlZm9yZSAgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuNXM7IGFuaW1hdGlvbi1kZWxheTogLTAuNXMgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoOSk6OmJlZm9yZSAgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuNHM7IGFuaW1hdGlvbi1kZWxheTogLTAuNHMgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoMTApOjpiZWZvcmUgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuM3M7IGFuaW1hdGlvbi1kZWxheTogLTAuM3MgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoMTEpOjpiZWZvcmUgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuMnM7IGFuaW1hdGlvbi1kZWxheTogLTAuMnMgfVxuLnNrLWNpcmNsZSA+IGRpdjpudGgtY2hpbGQoMTIpOjpiZWZvcmUgeyAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuMXM7IGFuaW1hdGlvbi1kZWxheTogLTAuMXMgfVxuXG5ALXdlYmtpdC1rZXlmcmFtZXMgc2stYm91bmNlZGVsYXkge1xuICAwJSwgODAlLCAxMDAlIHsgLXdlYmtpdC10cmFuc2Zvcm06IHNjYWxlKDAuMCkgfVxuICA0MCUgeyAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMS4wKSB9XG59XG5cbkBrZXlmcmFtZXMgc2stYm91bmNlZGVsYXkge1xuICAwJSwgODAlLCAxMDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMC4wKTtcbiAgICB0cmFuc2Zvcm06IHNjYWxlKDAuMCk7XG4gIH0gNDAlIHtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMS4wKTtcbiAgICB0cmFuc2Zvcm06IHNjYWxlKDEuMCk7XG4gIH1cbn1cbiJdfQ== */";
styleInject(css_248z$k);

var css_248z$j = ".sk-cube-grid{height:27px;width:27px}.sk-cube-grid>div{-webkit-animation:sk-scaleDelay 1.3s ease-in-out infinite;animation:sk-scaleDelay 1.3s ease-in-out infinite;background-color:currentColor;float:left;height:33%;width:33%}.sk-cube-grid>div:first-child{-webkit-animation-delay:.2s;animation-delay:.2s}.sk-cube-grid>div:nth-child(2){-webkit-animation-delay:.3s;animation-delay:.3s}.sk-cube-grid>div:nth-child(3){-webkit-animation-delay:.4s;animation-delay:.4s}.sk-cube-grid>div:nth-child(4){-webkit-animation-delay:.1s;animation-delay:.1s}.sk-cube-grid>div:nth-child(5){-webkit-animation-delay:.2s;animation-delay:.2s}.sk-cube-grid>div:nth-child(6){-webkit-animation-delay:.3s;animation-delay:.3s}.sk-cube-grid>div:nth-child(7){-webkit-animation-delay:0s;animation-delay:0s}.sk-cube-grid>div:nth-child(8){-webkit-animation-delay:.1s;animation-delay:.1s}.sk-cube-grid>div:nth-child(9){-webkit-animation-delay:.2s;animation-delay:.2s}@-webkit-keyframes sk-scaleDelay{0%,70%,to{-webkit-transform:scaleX(1)}35%{-webkit-transform:scale3D(0,0,1)}}@keyframes sk-scaleDelay{0%,70%,to{-webkit-transform:scaleX(1);transform:scaleX(1)}35%{-webkit-transform:scaleX(1);transform:scale3D(0,0,1)}}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$j);

var css_248z$i = ".sk-double-bounce{height:27px;position:relative;width:27px}.sk-double-bounce>div{-webkit-animation:sk-bounce 2s ease-in-out infinite;animation:sk-bounce 2s ease-in-out infinite;background-color:currentColor;border-radius:50%;height:100%;left:0;opacity:.6;position:absolute;top:0;width:100%}.sk-double-bounce>div:last-child{-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes sk-bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes sk-bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRvdWJsZS1ib3VuY2UuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGtCQUVFLFdBQVksQ0FDWixpQkFBa0IsQ0FGbEIsVUFHRixDQUVBLHNCQVVFLG1EQUFzRCxDQUN0RCwyQ0FBOEMsQ0FQOUMsNkJBQThCLENBRDlCLGlCQUFrQixDQURsQixXQUFZLENBTVosTUFBTyxDQUhQLFVBQVksQ0FDWixpQkFBa0IsQ0FDbEIsS0FBTSxDQU5OLFVBV0YsQ0FFQSxpQ0FDRSwyQkFBOEIsQ0FDOUIsbUJBQ0YsQ0FFQSw2QkFDRSxNQUFXLDBCQUE4QixDQUN6QyxJQUFNLDBCQUE4QixDQUN0QyxDQUVBLHFCQUNFLE1BQ0Usa0JBQXFCLENBQ3JCLDBCQUNGLENBQUUsSUFDQSxrQkFBcUIsQ0FDckIsMEJBQ0YsQ0FDRiIsImZpbGUiOiJkb3VibGUtYm91bmNlLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zay1kb3VibGUtYm91bmNlIHtcbiAgd2lkdGg6IDI3cHg7XG4gIGhlaWdodDogMjdweDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xufVxuXG4uc2stZG91YmxlLWJvdW5jZSA+IGRpdiB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgYmFja2dyb3VuZC1jb2xvcjogY3VycmVudENvbG9yO1xuICBvcGFjaXR5OiAwLjY7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuXG4gIC13ZWJraXQtYW5pbWF0aW9uOiBzay1ib3VuY2UgMi4wcyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbiAgYW5pbWF0aW9uOiBzay1ib3VuY2UgMi4wcyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbn1cblxuLnNrLWRvdWJsZS1ib3VuY2UgPiBkaXY6bGFzdC1jaGlsZCB7XG4gIC13ZWJraXQtYW5pbWF0aW9uLWRlbGF5OiAtMS4wcztcbiAgYW5pbWF0aW9uLWRlbGF5OiAtMS4wcztcbn1cblxuQC13ZWJraXQta2V5ZnJhbWVzIHNrLWJvdW5jZSB7XG4gIDAlLCAxMDAlIHsgLXdlYmtpdC10cmFuc2Zvcm06IHNjYWxlKDAuMCkgfVxuICA1MCUgeyAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMS4wKSB9XG59XG5cbkBrZXlmcmFtZXMgc2stYm91bmNlIHtcbiAgMCUsIDEwMCUge1xuICAgIHRyYW5zZm9ybTogc2NhbGUoMC4wKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMC4wKTtcbiAgfSA1MCUge1xuICAgIHRyYW5zZm9ybTogc2NhbGUoMS4wKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMS4wKTtcbiAgfVxufVxuIl19 */";
styleInject(css_248z$i);

var css_248z$h = ".sk-folding-cube{height:27px;position:relative;-webkit-transform:rotate(45deg);transform:rotate(45deg);width:27px}.sk-folding-cube>div{background-color:initial;float:left;height:50%;position:relative;-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1);width:50%}.sk-folding-cube>div:before{-webkit-animation:sk-foldCubeAngle 2.4s linear infinite both;animation:sk-foldCubeAngle 2.4s linear infinite both;background-color:currentColor;content:\"\";height:100%;left:0;position:absolute;top:0;-webkit-transform-origin:100% 100%;-ms-transform-origin:100% 100%;transform-origin:100% 100%;width:100%}.sk-folding-cube>div:nth-child(2){-webkit-transform:scale(1.1) rotate(90deg);transform:scale(1.1) rotate(90deg)}.sk-folding-cube>div:nth-child(4){-webkit-transform:scale(1.1) rotate(180deg);transform:scale(1.1) rotate(180deg)}.sk-folding-cube>div:nth-child(3){-webkit-transform:scale(1.1) rotate(270deg);transform:scale(1.1) rotate(270deg)}.sk-folding-cube>div:nth-child(2):before{-webkit-animation-delay:.3s;animation-delay:.3s}.sk-folding-cube>div:nth-child(4):before{-webkit-animation-delay:.6s;animation-delay:.6s}.sk-folding-cube>div:nth-child(3):before{-webkit-animation-delay:.9s;animation-delay:.9s}@-webkit-keyframes sk-foldCubeAngle{0%,10%{opacity:0;-webkit-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg)}25%,75%{opacity:1;-webkit-transform:perspective(140px) rotateX(0deg);transform:perspective(140px) rotateX(0deg)}90%,to{opacity:0;-webkit-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg)}}@keyframes sk-foldCubeAngle{0%,10%{opacity:0;-webkit-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg)}25%,75%{opacity:1;-webkit-transform:perspective(140px) rotateX(0deg);transform:perspective(140px) rotateX(0deg)}90%,to{opacity:0;-webkit-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg)}}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$h);

var css_248z$g = ".sk-pulse>div{-webkit-animation:sk-scaleout 1s ease-in-out infinite;animation:sk-scaleout 1s ease-in-out infinite;background-color:currentColor;border-radius:100%;height:27px;width:27px}@-webkit-keyframes sk-scaleout{0%{-webkit-transform:scale(0)}to{opacity:0;-webkit-transform:scale(1)}}@keyframes sk-scaleout{0%{transform:scale(0);-webkit-transform:scale(0)}to{opacity:0;transform:scale(1);-webkit-transform:scale(1)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInB1bHNlLmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxjQU1FLHFEQUF3RCxDQUN4RCw2Q0FBZ0QsQ0FKaEQsNkJBQThCLENBQzlCLGtCQUFtQixDQUZuQixXQUFZLENBRFosVUFPRixDQUVBLCtCQUNFLEdBQUssMEJBQThCLENBQ25DLEdBRUUsU0FBVSxDQURWLDBCQUVGLENBQ0YsQ0FFQSx1QkFDRSxHQUNFLGtCQUFxQixDQUNyQiwwQkFDRixDQUFFLEdBR0EsU0FBVSxDQUZWLGtCQUFxQixDQUNyQiwwQkFFRixDQUNGIiwiZmlsZSI6InB1bHNlLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zay1wdWxzZSA+IGRpdiB7XG4gIHdpZHRoOiAyN3B4O1xuICBoZWlnaHQ6IDI3cHg7XG4gIGJhY2tncm91bmQtY29sb3I6IGN1cnJlbnRDb2xvcjtcbiAgYm9yZGVyLXJhZGl1czogMTAwJTtcblxuICAtd2Via2l0LWFuaW1hdGlvbjogc2stc2NhbGVvdXQgMS4wcyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbiAgYW5pbWF0aW9uOiBzay1zY2FsZW91dCAxLjBzIGluZmluaXRlIGVhc2UtaW4tb3V0O1xufVxuXG5ALXdlYmtpdC1rZXlmcmFtZXMgc2stc2NhbGVvdXQge1xuICAwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZSgwLjApIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHNjYWxlKDEuMCk7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxufVxuXG5Aa2V5ZnJhbWVzIHNrLXNjYWxlb3V0IHtcbiAgMCUge1xuICAgIHRyYW5zZm9ybTogc2NhbGUoMC4wKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMC4wKTtcbiAgfSAxMDAlIHtcbiAgICB0cmFuc2Zvcm06IHNjYWxlKDEuMCk7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHNjYWxlKDEuMCk7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxufVxuIl19 */";
styleInject(css_248z$g);

var css_248z$f = ".sk-rotating-plane>div{-webkit-animation:sk-rotateplane 1.2s ease-in-out infinite;animation:sk-rotateplane 1.2s ease-in-out infinite;background-color:currentColor;height:27px;width:27px}@-webkit-keyframes sk-rotateplane{0%{-webkit-transform:perspective(120px)}50%{-webkit-transform:perspective(120px) rotateY(180deg)}to{-webkit-transform:perspective(120px) rotateY(180deg) rotateX(180deg)}}@keyframes sk-rotateplane{0%{transform:perspective(120px) rotateX(0deg) rotateY(0deg);-webkit-transform:perspective(120px) rotateX(0deg) rotateY(0deg)}50%{transform:perspective(120px) rotateX(-180.1deg) rotateY(0deg);-webkit-transform:perspective(120px) rotateX(-180.1deg) rotateY(0deg)}to{transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg);-webkit-transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJvdGF0aW5nLXBsYW5lLmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSx1QkFLRSwwREFBMkQsQ0FDM0Qsa0RBQW1ELENBSG5ELDZCQUE4QixDQUQ5QixXQUFZLENBRFosVUFNRixDQUVBLGtDQUNFLEdBQUssb0NBQXNDLENBQzNDLElBQU0sb0RBQXNELENBQzVELEdBQU8sb0VBQXVFLENBQ2hGLENBRUEsMEJBQ0UsR0FDRSx3REFBeUQsQ0FDekQsZ0VBQ0YsQ0FBRSxJQUNBLDZEQUE4RCxDQUM5RCxxRUFDRixDQUFFLEdBQ0EsZ0VBQWlFLENBQ2pFLHdFQUNGLENBQ0YiLCJmaWxlIjoicm90YXRpbmctcGxhbmUuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNrLXJvdGF0aW5nLXBsYW5lID4gZGl2IHtcbiAgd2lkdGg6IDI3cHg7XG4gIGhlaWdodDogMjdweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogY3VycmVudENvbG9yO1xuXG4gIC13ZWJraXQtYW5pbWF0aW9uOiBzay1yb3RhdGVwbGFuZSAxLjJzIGluZmluaXRlIGVhc2UtaW4tb3V0O1xuICBhbmltYXRpb246IHNrLXJvdGF0ZXBsYW5lIDEuMnMgaW5maW5pdGUgZWFzZS1pbi1vdXQ7XG59XG5cbkAtd2Via2l0LWtleWZyYW1lcyBzay1yb3RhdGVwbGFuZSB7XG4gIDAlIHsgLXdlYmtpdC10cmFuc2Zvcm06IHBlcnNwZWN0aXZlKDEyMHB4KSB9XG4gIDUwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBwZXJzcGVjdGl2ZSgxMjBweCkgcm90YXRlWSgxODBkZWcpIH1cbiAgMTAwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBwZXJzcGVjdGl2ZSgxMjBweCkgcm90YXRlWSgxODBkZWcpICByb3RhdGVYKDE4MGRlZykgfVxufVxuXG5Aa2V5ZnJhbWVzIHNrLXJvdGF0ZXBsYW5lIHtcbiAgMCUge1xuICAgIHRyYW5zZm9ybTogcGVyc3BlY3RpdmUoMTIwcHgpIHJvdGF0ZVgoMGRlZykgcm90YXRlWSgwZGVnKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogcGVyc3BlY3RpdmUoMTIwcHgpIHJvdGF0ZVgoMGRlZykgcm90YXRlWSgwZGVnKTtcbiAgfSA1MCUge1xuICAgIHRyYW5zZm9ybTogcGVyc3BlY3RpdmUoMTIwcHgpIHJvdGF0ZVgoLTE4MC4xZGVnKSByb3RhdGVZKDBkZWcpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiBwZXJzcGVjdGl2ZSgxMjBweCkgcm90YXRlWCgtMTgwLjFkZWcpIHJvdGF0ZVkoMGRlZyk7XG4gIH0gMTAwJSB7XG4gICAgdHJhbnNmb3JtOiBwZXJzcGVjdGl2ZSgxMjBweCkgcm90YXRlWCgtMTgwZGVnKSByb3RhdGVZKC0xNzkuOWRlZyk7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHBlcnNwZWN0aXZlKDEyMHB4KSByb3RhdGVYKC0xODBkZWcpIHJvdGF0ZVkoLTE3OS45ZGVnKTtcbiAgfVxufVxuIl19 */";
styleInject(css_248z$f);

var css_248z$e = ".sk-three-bounce{height:18px}.sk-three-bounce>div{-webkit-animation:sk-bouncedelay 1.4s ease-in-out infinite;animation:sk-bouncedelay 1.4s ease-in-out infinite;-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:currentColor;border-radius:100%;display:inline-block;height:18px;width:18px}.sk-three-bounce>div:first-child{-webkit-animation-delay:-.32s;animation-delay:-.32s}.sk-three-bounce>div:nth-child(2){-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes sk-bouncedelay{0%,80%,to{transform:scale(0);-webkit-transform:scale(0)}40%{transform:scale(1);-webkit-transform:scale(1)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRocmVlLWJvdW5jZS5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsaUJBQ0UsV0FDRixDQUVBLHFCQU9FLDBEQUEyRCxDQUMzRCxrREFBbUQsQ0FFbkQsZ0NBQWlDLENBQ2pDLHdCQUF5QixDQVJ6Qiw2QkFBOEIsQ0FDOUIsa0JBQW1CLENBQ25CLG9CQUFxQixDQUhyQixXQUFZLENBRFosVUFXRixDQUVBLGlDQUNFLDZCQUErQixDQUMvQixxQkFDRixDQUVBLGtDQUNFLDZCQUErQixDQUMvQixxQkFDRixDQUVBLGtDQUNFLFVBQWdCLDBCQUE4QixDQUM5QyxJQUFNLDBCQUE4QixDQUN0QyxDQUVBLDBCQUNFLFVBQ0Usa0JBQXFCLENBQ3JCLDBCQUNGLENBQUUsSUFDQSxrQkFBcUIsQ0FDckIsMEJBQ0YsQ0FDRiIsImZpbGUiOiJ0aHJlZS1ib3VuY2UuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNrLXRocmVlLWJvdW5jZSB7XG4gIGhlaWdodDogMThweDtcbn1cblxuLnNrLXRocmVlLWJvdW5jZSA+IGRpdiB7XG4gIHdpZHRoOiAxOHB4O1xuICBoZWlnaHQ6IDE4cHg7XG4gIGJhY2tncm91bmQtY29sb3I6IGN1cnJlbnRDb2xvcjtcbiAgYm9yZGVyLXJhZGl1czogMTAwJTtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuXG4gIC13ZWJraXQtYW5pbWF0aW9uOiBzay1ib3VuY2VkZWxheSAxLjRzIGluZmluaXRlIGVhc2UtaW4tb3V0O1xuICBhbmltYXRpb246IHNrLWJvdW5jZWRlbGF5IDEuNHMgaW5maW5pdGUgZWFzZS1pbi1vdXQ7XG4gIC8qIFByZXZlbnQgZmlyc3QgZnJhbWUgZnJvbSBmbGlja2VyaW5nIHdoZW4gYW5pbWF0aW9uIHN0YXJ0cyAqL1xuICAtd2Via2l0LWFuaW1hdGlvbi1maWxsLW1vZGU6IGJvdGg7XG4gIGFuaW1hdGlvbi1maWxsLW1vZGU6IGJvdGg7XG59XG5cbi5zay10aHJlZS1ib3VuY2UgPiBkaXY6Zmlyc3QtY2hpbGQge1xuICAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuMzJzO1xuICBhbmltYXRpb24tZGVsYXk6IC0wLjMycztcbn1cblxuLnNrLXRocmVlLWJvdW5jZSA+IGRpdjpudGgtY2hpbGQoMikge1xuICAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuMTZzO1xuICBhbmltYXRpb24tZGVsYXk6IC0wLjE2cztcbn1cblxuQC13ZWJraXQta2V5ZnJhbWVzIHNrLWJvdW5jZWRlbGF5IHtcbiAgMCUsIDgwJSwgMTAwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZSgwLjApIH1cbiAgNDAlIHsgLXdlYmtpdC10cmFuc2Zvcm06IHNjYWxlKDEuMCkgfVxufVxuXG5Aa2V5ZnJhbWVzIHNrLWJvdW5jZWRlbGF5IHtcbiAgMCUsIDgwJSwgMTAwJSB7XG4gICAgdHJhbnNmb3JtOiBzY2FsZSgwLjApO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZSgwLjApO1xuICB9IDQwJSB7XG4gICAgdHJhbnNmb3JtOiBzY2FsZSgxLjApO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZSgxLjApO1xuICB9XG59XG4iXX0= */";
styleInject(css_248z$e);

var css_248z$d = ".sk-wandering-cubes{height:52px;position:relative;width:52px}.sk-wandering-cubes>div{-webkit-animation:sk-cubemove 1.8s ease-in-out infinite;animation:sk-cubemove 1.8s ease-in-out infinite;background-color:currentColor;height:10px;left:0;position:absolute;top:0;width:10px}.sk-wandering-cubes>div:last-child{-webkit-animation-delay:-.9s;animation-delay:-.9s}@-webkit-keyframes sk-cubemove{25%{-webkit-transform:translateX(42px) rotate(-90deg) scale(.5)}50%{-webkit-transform:translateX(42px) translateY(42px) rotate(-180deg)}75%{-webkit-transform:translateX(0) translateY(42px) rotate(-270deg) scale(.5)}to{-webkit-transform:rotate(-1turn)}}@keyframes sk-cubemove{25%{transform:translateX(42px) rotate(-90deg) scale(.5);-webkit-transform:translateX(42px) rotate(-90deg) scale(.5)}50%{transform:translateX(42px) translateY(42px) rotate(-179deg);-webkit-transform:translateX(42px) translateY(42px) rotate(-179deg)}50.1%{transform:translateX(42px) translateY(42px) rotate(-180deg);-webkit-transform:translateX(42px) translateY(42px) rotate(-180deg)}75%{transform:translateX(0) translateY(42px) rotate(-270deg) scale(.5);-webkit-transform:translateX(0) translateY(42px) rotate(-270deg) scale(.5)}to{transform:rotate(-1turn);-webkit-transform:rotate(-1turn)}}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$d);

var css_248z$c = ".sk-wave{height:27px;width:30px}.sk-wave>div{-webkit-animation:sk-stretchdelay 1.2s ease-in-out infinite;animation:sk-stretchdelay 1.2s ease-in-out infinite;background-color:currentColor;display:inline-block;height:100%;width:6px}.sk-wave>div:nth-child(2){-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-wave>div:nth-child(3){-webkit-animation-delay:-1s;animation-delay:-1s}.sk-wave>div:nth-child(4){-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-wave>div:nth-child(5){-webkit-animation-delay:-.8s;animation-delay:-.8s}@-webkit-keyframes sk-stretchdelay{0%,40%,to{-webkit-transform:scaleY(.4)}20%{-webkit-transform:scaleY(1)}}@keyframes sk-stretchdelay{0%,40%,to{transform:scaleY(.4);-webkit-transform:scaleY(.4)}20%{transform:scaleY(1);-webkit-transform:scaleY(1)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndhdmUuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLFNBRUUsV0FBWSxDQURaLFVBRUYsQ0FFQSxhQU1FLDJEQUE0RCxDQUM1RCxtREFBb0QsQ0FOcEQsNkJBQThCLENBRzlCLG9CQUFxQixDQUZyQixXQUFZLENBQ1osU0FLRixDQUVBLDBCQUNFLDZCQUE4QixDQUM5QixxQkFDRixDQUVBLDBCQUNFLDJCQUE4QixDQUM5QixtQkFDRixDQUVBLDBCQUNFLDRCQUE4QixDQUM5QixvQkFDRixDQUVBLDBCQUNFLDRCQUE4QixDQUM5QixvQkFDRixDQUVBLG1DQUNFLFVBQWdCLDRCQUErQixDQUMvQyxJQUFNLDJCQUErQixDQUN2QyxDQUVBLDJCQUNFLFVBQ0Usb0JBQXNCLENBQ3RCLDRCQUNGLENBQUUsSUFDQSxtQkFBc0IsQ0FDdEIsMkJBQ0YsQ0FDRiIsImZpbGUiOiJ3YXZlLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zay13YXZlIHtcbiAgd2lkdGg6IDMwcHg7XG4gIGhlaWdodDogMjdweDtcbn1cblxuLnNrLXdhdmUgPiBkaXYge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiBjdXJyZW50Q29sb3I7XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDZweDtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuXG4gIC13ZWJraXQtYW5pbWF0aW9uOiBzay1zdHJldGNoZGVsYXkgMS4ycyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbiAgYW5pbWF0aW9uOiBzay1zdHJldGNoZGVsYXkgMS4ycyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbn1cblxuLnNrLXdhdmUgPiBkaXY6bnRoLWNoaWxkKDIpIHtcbiAgLXdlYmtpdC1hbmltYXRpb24tZGVsYXk6IC0xLjFzO1xuICBhbmltYXRpb24tZGVsYXk6IC0xLjFzO1xufVxuXG4uc2std2F2ZSA+IGRpdjpudGgtY2hpbGQoMykge1xuICAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTEuMHM7XG4gIGFuaW1hdGlvbi1kZWxheTogLTEuMHM7XG59XG5cbi5zay13YXZlID4gZGl2Om50aC1jaGlsZCg0KSB7XG4gIC13ZWJraXQtYW5pbWF0aW9uLWRlbGF5OiAtMC45cztcbiAgYW5pbWF0aW9uLWRlbGF5OiAtMC45cztcbn1cblxuLnNrLXdhdmUgPiBkaXY6bnRoLWNoaWxkKDUpIHtcbiAgLXdlYmtpdC1hbmltYXRpb24tZGVsYXk6IC0wLjhzO1xuICBhbmltYXRpb24tZGVsYXk6IC0wLjhzO1xufVxuXG5ALXdlYmtpdC1rZXlmcmFtZXMgc2stc3RyZXRjaGRlbGF5IHtcbiAgMCUsIDQwJSwgMTAwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZVkoMC40KSB9XG4gIDIwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZVkoMS4wKSB9XG59XG5cbkBrZXlmcmFtZXMgc2stc3RyZXRjaGRlbGF5IHtcbiAgMCUsIDQwJSwgMTAwJSB7XG4gICAgdHJhbnNmb3JtOiBzY2FsZVkoMC40KTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGVZKDAuNCk7XG4gIH0gMjAlIHtcbiAgICB0cmFuc2Zvcm06IHNjYWxlWSgxLjApO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZVkoMS4wKTtcbiAgfVxufVxuIl19 */";
styleInject(css_248z$c);

var css_248z$b = ".sk-wordpress>div{-webkit-animation:sk-inner-circle 1s linear infinite;animation:sk-inner-circle 1s linear infinite;background-color:currentColor;border-radius:27px;display:inline-block;height:27px;position:relative;width:27px}.sk-wordpress>div:after{background-color:#fff;border-radius:8px;content:\"\";display:block;height:8px;left:5px;position:absolute;top:5px;width:8px}@-webkit-keyframes sk-inner-circle{0%{-webkit-transform:rotate(0)}to{-webkit-transform:rotate(1turn)}}@keyframes sk-inner-circle{0%{transform:rotate(0);-webkit-transform:rotate(0)}to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndvcmRwcmVzcy5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsa0JBUUUsb0RBQXFELENBQ3JELDRDQUE2QyxDQU43Qyw2QkFBOEIsQ0FFOUIsa0JBQW1CLENBRG5CLG9CQUFxQixDQUZyQixXQUFZLENBSVosaUJBQWtCLENBTGxCLFVBU0YsQ0FFQSx3QkFHRSxxQkFBc0IsQ0FJdEIsaUJBQWtCLENBTmxCLFVBQVcsQ0FDWCxhQUFjLENBR2QsVUFBVyxDQUlYLFFBQVMsQ0FIVCxpQkFBa0IsQ0FFbEIsT0FBUSxDQUpSLFNBTUYsQ0FFQSxtQ0FDRSxHQUFLLDJCQUE4QixDQUNuQyxHQUFPLCtCQUFtQyxDQUM1QyxDQUVBLDJCQUNFLEdBQUssbUJBQW9CLENBQUUsMkJBQTZCLENBQ3hELEdBQU8sdUJBQXlCLENBQUUsK0JBQWtDLENBQ3RFIiwiZmlsZSI6IndvcmRwcmVzcy5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuc2std29yZHByZXNzID4gZGl2IHtcbiAgd2lkdGg6IDI3cHg7XG4gIGhlaWdodDogMjdweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogY3VycmVudENvbG9yO1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIGJvcmRlci1yYWRpdXM6IDI3cHg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcblxuICAtd2Via2l0LWFuaW1hdGlvbjogc2staW5uZXItY2lyY2xlIDFzIGxpbmVhciBpbmZpbml0ZTtcbiAgYW5pbWF0aW9uOiBzay1pbm5lci1jaXJjbGUgMXMgbGluZWFyIGluZmluaXRlO1xufVxuXG4uc2std29yZHByZXNzID4gZGl2OjphZnRlciB7XG4gIGNvbnRlbnQ6ICcnO1xuICBkaXNwbGF5OiBibG9jaztcbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZjtcbiAgd2lkdGg6IDhweDtcbiAgaGVpZ2h0OiA4cHg7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgYm9yZGVyLXJhZGl1czogOHB4O1xuICB0b3A6IDVweDtcbiAgbGVmdDogNXB4O1xufVxuXG5ALXdlYmtpdC1rZXlmcmFtZXMgc2staW5uZXItY2lyY2xlIHtcbiAgMCUgeyAtd2Via2l0LXRyYW5zZm9ybTogcm90YXRlKDApOyB9XG4gIDEwMCUgeyAtd2Via2l0LXRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7IH1cbn1cblxuQGtleWZyYW1lcyBzay1pbm5lci1jaXJjbGUge1xuICAwJSB7IHRyYW5zZm9ybTogcm90YXRlKDApOyAtd2Via2l0LXRyYW5zZm9ybTpyb3RhdGUoMCk7IH1cbiAgMTAwJSB7IHRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7IC13ZWJraXQtdHJhbnNmb3JtOnJvdGF0ZSgzNjBkZWcpOyB9XG59XG4iXX0= */";
styleInject(css_248z$b);

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes$2 = propTypes$2.exports;

var _propTypes2$2 = _interopRequireDefault$2(_propTypes$2);

var _react$2 = require$$0__default["default"];

var _react2$2 = _interopRequireDefault$2(_react$2);

var _classnames = classnames.exports;

var _classnames2 = _interopRequireDefault$2(_classnames);

var _objectAssign = objectAssign;

var _objectAssign2 = _interopRequireDefault$2(_objectAssign);

var _spinners = spinners;

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-extraneous-dependencies


if (!process.env.REACT_SPINKIT_NO_STYLES) ;

var noFadeInWarning = "Deprecation Warning (react-spinkit): noFadeIn prop should be replaced with fadeIn='none'";

var Spinner = function (_React$Component) {
  _inherits$1(Spinner, _React$Component);

  function Spinner(props) {
    _classCallCheck$1(this, Spinner);

    if (props.noFadeIn) {
      console.warn(noFadeInWarning); // eslint-disable-line no-console
    }

    var _this = _possibleConstructorReturn$1(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call(this, props));

    _this.displayName = 'SpinKit';
    return _this;
  }

  _createClass$1(Spinner, [{
    key: 'render',
    value: function render() {
      var _cx;

      var spinnerInfo = _spinners.allSpinners[this.props.name] || _spinners.allSpinners['three-bounce'];
      var classes = (0, _classnames2.default)((_cx = {
        'sk-fade-in': this.props.fadeIn === 'full' && !this.props.noFadeIn,
        'sk-fade-in-half-second': this.props.fadeIn === 'half' && !this.props.noFadeIn,
        'sk-fade-in-quarter-second': this.props.fadeIn === 'quarter' && !this.props.noFadeIn,
        'sk-spinner': !this.props.overrideSpinnerClassName
      }, _defineProperty$1(_cx, this.props.overrideSpinnerClassName, !!this.props.overrideSpinnerClassName), _defineProperty$1(_cx, this.props.className, !!this.props.className), _defineProperty$1(_cx, spinnerInfo.className || this.props.name, true), _cx));

      var props = (0, _objectAssign2.default)({}, this.props);
      delete props.name;
      delete props.fadeIn;
      delete props.noFadeIn;
      delete props.overrideSpinnerClassName;
      delete props.className;

      if (this.props.color) {
        props.style = props.style ? _extends$3({}, props.style, { color: this.props.color }) : { color: this.props.color };
      }

      return _react2$2.default.createElement(
        'div',
        _extends$3({}, props, { className: classes }),
        [].concat(_toConsumableArray(Array(spinnerInfo.divCount))).map(function (_, idx) {
          return _react2$2.default.createElement('div', { key: idx });
        })
      );
    }
  }]);

  return Spinner;
}(_react2$2.default.Component);

Spinner.propTypes = {
  name: _propTypes2$2.default.string.isRequired,
  noFadeIn: _propTypes2$2.default.bool,
  fadeIn: _propTypes2$2.default.oneOf(['full', 'half', 'quarter', 'none']),
  overrideSpinnerClassName: _propTypes2$2.default.string,
  className: _propTypes2$2.default.string,
  color: _propTypes2$2.default.string
};

Spinner.defaultProps = {
  name: 'three-bounce',
  noFadeIn: false,
  fadeIn: 'full',
  overrideSpinnerClassName: ''
};

var dist = Spinner;

var css_248z$a = "html{--cardscan-video-width:0px;--cardscan-video-height:0px;--cardscan-app-height:100vh;--cardscan-app-width:100vw;--cardscan-buffer-size:0;--cardscan-buffer-max-size:1;--cardscan-video-background-height:0;--cardscan-corner-width:20%;--cardscan-corner-height:20%;--cardscan-auto-switch-active-color:#6fcf97;--cardscan-auto-switch-inactive-color:#545454;--cardscan-progress-bar-color:#6fcf97;--cardscan-widget-background-color:rgba(29,29,29,.9);--cardscan-message-font-size:18px;--cardscan-message-text-color:#fff;--cardscan-message-background-color:rgba(0,0,0,.45)}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLEtBQ0UsMEJBQTJCLENBQzNCLDJCQUE0QixDQUM1QiwyQkFBNEIsQ0FDNUIsMEJBQTJCLENBQzNCLHdCQUF5QixDQUN6Qiw0QkFBNkIsQ0FDN0Isb0NBQXFDLENBQ3JDLDJCQUE0QixDQUM1Qiw0QkFBNkIsQ0FDN0IsMkNBQTRDLENBQzVDLDZDQUE4QyxDQUM5QyxxQ0FBc0MsQ0FDdEMsb0RBQXlELENBQ3pELGlDQUFrQyxDQUNsQyxrQ0FBb0MsQ0FDcEMsbURBQ0YiLCJmaWxlIjoic3R5bGVzLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJodG1sIHtcbiAgLS1jYXJkc2Nhbi12aWRlby13aWR0aDogMHB4O1xuICAtLWNhcmRzY2FuLXZpZGVvLWhlaWdodDogMHB4O1xuICAtLWNhcmRzY2FuLWFwcC1oZWlnaHQ6IDEwMHZoO1xuICAtLWNhcmRzY2FuLWFwcC13aWR0aDogMTAwdnc7XG4gIC0tY2FyZHNjYW4tYnVmZmVyLXNpemU6IDA7XG4gIC0tY2FyZHNjYW4tYnVmZmVyLW1heC1zaXplOiAxO1xuICAtLWNhcmRzY2FuLXZpZGVvLWJhY2tncm91bmQtaGVpZ2h0OiAwO1xuICAtLWNhcmRzY2FuLWNvcm5lci13aWR0aDogMjAlO1xuICAtLWNhcmRzY2FuLWNvcm5lci1oZWlnaHQ6IDIwJTtcbiAgLS1jYXJkc2Nhbi1hdXRvLXN3aXRjaC1hY3RpdmUtY29sb3I6ICM2ZmNmOTc7XG4gIC0tY2FyZHNjYW4tYXV0by1zd2l0Y2gtaW5hY3RpdmUtY29sb3I6ICM1NDU0NTQ7XG4gIC0tY2FyZHNjYW4tcHJvZ3Jlc3MtYmFyLWNvbG9yOiAjNmZjZjk3O1xuICAtLWNhcmRzY2FuLXdpZGdldC1iYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDI5LCAyOSwgMjksIDAuOSk7XG4gIC0tY2FyZHNjYW4tbWVzc2FnZS1mb250LXNpemU6IDE4cHg7XG4gIC0tY2FyZHNjYW4tbWVzc2FnZS10ZXh0LWNvbG9yOiB3aGl0ZTtcbiAgLS1jYXJkc2Nhbi1tZXNzYWdlLWJhY2tncm91bmQtY29sb3I6IHJnYmEoMCwgMCwgMCwgMC40NSk7XG59Il19 */";
styleInject(css_248z$a);

var defaultMessages = {
    manualCaptureTitle: "Use camera button to scan card",
    frontsideCompletedTitle: "Front side scan is complete\nRotate card to scan back",
    autoCaptureTitle: "Hold Card in Frame\nIt Will Scan Automatically",
    processingTitle: "Keep Card Still While Scanning",
    postProcessing: "Validating Insurance Card...",
    completedTitle: "Card Scanned Successfully",
    errorTitle: "Setup Failure - Please Reload the Page",
    retryTitle: "Scanning Failed - Please Try Again",
    cameraErrorTitle: "Unable to Setup Camera for Capture",
    eligibilityProcessing: "Checking eligibility",
};
var defaultIndicatorOptions = {
    name: "ball-spin-fade-loader",
    fadeIn: "none",
    color: "#FFF",
};

/* eslint-disable @typescript-eslint/no-var-requires */
var tf = require("@tensorflow/tfjs");
var loadGraphModel = require("@tensorflow/tfjs-converter").loadGraphModel;
var CardDetector = /** @class */ (function () {
    function CardDetector(modelPath) {
        var _this = this;
        this.modelPath = "https://cardscan-models.s3-accelerate.amazonaws.com/card-detection-ft-class/model-v2-tfjs/model.json";
        this.statusCallback = null;
        this.laplaceFilter = tf
            .tensor2d([
            [0, 1, 0],
            [1, -4, 1],
            [0, 1, 0],
        ])
            .expandDims(-1)
            .expandDims(-1);
        GlobalLogger.earlyLog("Detector -- init");
        this._modelState = "loading";
        this.modelPath = modelPath || this.modelPath;
        this.load_model().then(function (model) {
            _this.model = model;
            _this.setModelState("loaded");
            _this.warm_model();
        });
        //TODO: catch error loading model....
    }
    CardDetector.prototype.setModelStatusCallback = function (callback) {
        this.statusCallback = callback;
    };
    CardDetector.prototype.setModelState = function (state) {
        this._modelState = state;
        if (this.statusCallback) {
            this.statusCallback(state);
        }
    };
    Object.defineProperty(CardDetector.prototype, "modelState", {
        get: function () {
            return this._modelState;
        },
        enumerable: false,
        configurable: true
    });
    CardDetector.prototype.load_model = function () {
        return __awaiter(this, void 0, void 0, function () {
            var model, t0, t1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        t0 = performance.now();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, loadGraphModel("indexeddb://cardscan-class-model")];
                    case 2:
                        model = _b.sent();
                        GlobalLogger.earlyLog("Detector -- model loaded from cache");
                        return [3 /*break*/, 5];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, loadGraphModel(this.modelPath)];
                    case 4:
                        model = _b.sent();
                        GlobalLogger.earlyLog("Detector -- model loaded from CDN");
                        return [3 /*break*/, 5];
                    case 5:
                        t1 = performance.now();
                        GlobalLogger.earlyLog("Detector -- model loaded in ".concat(t1 - t0, " ms"));
                        return [2 /*return*/, model];
                }
            });
        });
    };
    CardDetector.prototype.warm_model = function () {
        var _this = this;
        if (this.model == null) {
            GlobalLogger.error("Detector -- Unable to warm unloaded model");
            return;
        }
        //TOOD: check https, check IP isn't HOME.
        var expression = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
        //trying to stop other devs from wasting time.
        if (expression.test(window.location.hostname) &&
            window.location.hostname != "127.0.0.1") {
            GlobalLogger.earlyLog("many browsers do not allow camera access on IP addresses. Please use localhost (web) or a tunnel like ngrox (mobile)");
            //TODO: if dev/sandbox and on mobile and on ip... then show alert...
        }
        if (window.location.protocol != "https:" &&
            window.location.hostname != "localhost" &&
            window.location.hostname != "127.0.0.1") {
            GlobalLogger.earlyLog("CardScanView: many browsers do not allow camera access on insecure connections. Please use localhost or https");
        }
        tf.tidy(function () {
            var t0 = performance.now();
            var results = _this.model.predict(tf
                .zeros([CardDetector.IMG_SIZE, CardDetector.IMG_SIZE, 3], "float32")
                .expandDims(0));
            results.data().then(function () {
                _this.setModelState("warmed");
                //save model on successful warm
                _this.model.save("indexeddb://cardscan-class-model");
            });
            var t1 = performance.now();
            GlobalLogger.earlyLog("Detector -- model warmed in ".concat(t1 - t0, " ms"));
            GlobalLogger.earlyLog(_this.tf_mem_log(tf.memory()));
        });
    };
    CardDetector.prototype.tf_mem_log = function (memory) {
        return "TF Memory Usage - t:".concat(memory.numTensors, ", gpu:").concat(memory.numBytesInGPU, ", gpufree:").concat(memory.numBytesInGPUFree, " buf:").concat(memory.numDataBuffers, ", mem:").concat(memory.numBytes);
    };
    CardDetector.prototype.prepare_results = function (modelResult, laplaceResult) {
        var response = {};
        var predictions = tf.sigmoid(modelResult);
        var score = predictions.dataSync()[0];
        response["modelClass"] = score < 0.5 ? "card" : "notcard";
        response["modelScore"] = score;
        response["modelProbability"] = score < 0.5 ? 1 - score : score;
        laplaceResult = laplaceResult.squeeze();
        laplaceResult = laplaceResult.div(tf.scalar(255)); //need to workaround #2475
        response["laplaceVariance"] = tf
            .moments(laplaceResult)
            .variance.dataSync()[0];
        response["laplaceMax"] = laplaceResult.max(1).dataSync()[0];
        //cleanup memory
        laplaceResult.dispose();
        modelResult.dispose();
        predictions.dispose();
        return response;
    };
    CardDetector.prototype.predict_image = function (canvas, flipHorizontal, flipVertical) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                //on slow systems the model might not be loaded yet.
                if (this.model === undefined) {
                    return [2 /*return*/, null];
                }
                //TODO check canvas matches model image size
                //cleans up all tensors on exit
                return [2 /*return*/, tf.tidy(function () {
                        var t0 = performance.now();
                        var data = tf.browser.fromPixels(canvas, 3);
                        if (flipHorizontal || flipVertical) {
                            var flipAxes = [];
                            if (flipHorizontal)
                                flipAxes.push(1);
                            if (flipVertical)
                                flipAxes.push(0);
                            data = data.reverse(flipAxes);
                        }
                        var grey = data.mean(2);
                        data = tf.cast(data, "float32");
                        //normalize from 0 to 1
                        data = data.div(tf.scalar(255));
                        GlobalLogger.debug("image-prepare: ".concat(performance.now() - t0, " ms"), "detector");
                        t0 = performance.now();
                        var result = _this.model.predict(data.expandDims(0));
                        GlobalLogger.debug("model-predict: ".concat(performance.now() - t0, " ms"), "detector");
                        grey = grey.expandDims(0).expandDims(-1);
                        t0 = performance.now();
                        var lapResult = grey.conv2d(_this.laplaceFilter, 1, "valid");
                        GlobalLogger.debug("laplacian: ".concat(performance.now() - t0, " ms"), "detector");
                        GlobalLogger.debug(_this.tf_mem_log(tf.memory()), "detector");
                        return _this.prepare_results(result, lapResult);
                    })];
            });
        });
    };
    //model is fixed to IMG_SIZE x IMG_SIZE
    CardDetector.IMG_SIZE = 224;
    return CardDetector;
}());
var DetectorWrapper = /** @class */ (function () {
    function DetectorWrapper() {
    }
    DetectorWrapper.get = function () {
        if (window.cardDetector === undefined) {
            window.cardDetector = new CardDetector();
        }
        return window.cardDetector;
    };
    DetectorWrapper.init = function (modelPath) {
        if (window.cardDetector === undefined) {
            window.cardDetector = new CardDetector(modelPath);
        }
    };
    DetectorWrapper.cleanUp = function () {
        delete window.cardDetector;
    };
    DetectorWrapper.image_size = CardDetector.IMG_SIZE;
    return DetectorWrapper;
}());
var CardScanModel = /** @class */ (function () {
    function CardScanModel() {
    }
    CardScanModel.warm = function (modelPath) {
        GlobalLogger.earlyLog("Detector -- warm model");
        DetectorWrapper.init(modelPath);
    };
    return CardScanModel;
}());

/* eslint-disable @typescript-eslint/no-empty-function */
var MyGlobalContext = require$$0.createContext({
    logging: GlobalLogger.startingLogLevel,
    modelState: {},
    scanDebugState: {},
    threshold: {},
    setThreshold: {},
    laplacianThreshold: {},
    setLaplacianThreshold: {},
    scanFreqency: {},
    setScanFreqency: {},
    bufferSize: {},
    setBufferSize: {},
    bufferRef: {},
    debugCanvasBestRef: {},
    bestScore: {},
    bestLaplacian: {},
    debugCanvasLatestRef: {},
    latestScore: {},
    latestLaplacian: {},
    debugMenu: false,
    videoMetadata: {},
    showCurtain: false,
    onCloseBtn: function () { },
    closeButton: null,
    isMobile: false,
    isMobileOnLandscape: false,
    stateMachineState: {},
    stateMachineSend: function () { },
    stateMachineService: {},
    handleRetryButton: function () { },
});
var useGlobalContext = function () { return require$$0.useContext(MyGlobalContext); };

var css_248z$9 = ".debug-module_scanDebugMenu__eCBlE{background-color:#accaf2;left:10px;position:absolute;top:10px;width:200px;z-index:2000}.debug-module_scanDebugMenu__eCBlE *{font-size:14px}.debug-module_scanDebugMenu__eCBlE input{background-color:#d3d3d3;width:60px}.debug-module_scanDebugMenu__eCBlE button{background-color:#656464;border-radius:6px;color:#fff;margin-left:13px;padding:0 3px}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRlYnVnLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLG1DQUNFLHdCQUF5QixDQUd6QixTQUFVLENBRlYsaUJBQWtCLENBQ2xCLFFBQVMsQ0FHVCxXQUFZLENBRFosWUFFRixDQUNBLHFDQUNFLGNBQ0YsQ0FDQSx5Q0FFRSx3QkFBMkIsQ0FEM0IsVUFFRixDQUNBLDBDQUNFLHdCQUF5QixDQUd6QixpQkFBa0IsQ0FGbEIsVUFBWSxDQUNaLGdCQUFpQixDQUVqQixhQUNGIiwiZmlsZSI6ImRlYnVnLm1vZHVsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNjYW5EZWJ1Z01lbnUge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjYWNjYWYyO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMTBweDtcbiAgbGVmdDogMTBweDtcbiAgei1pbmRleDogMjAwMDtcbiAgd2lkdGg6IDIwMHB4O1xufVxuLnNjYW5EZWJ1Z01lbnUgKiB7XG4gIGZvbnQtc2l6ZTogMTRweDtcbn1cbi5zY2FuRGVidWdNZW51IGlucHV0IHtcbiAgd2lkdGg6IDYwcHg7XG4gIGJhY2tncm91bmQtY29sb3I6IGxpZ2h0Z3JheTtcbn1cbi5zY2FuRGVidWdNZW51IGJ1dHRvbiB7XG4gIGJhY2tncm91bmQtY29sb3I6ICM2NTY0NjQ7XG4gIGNvbG9yOiB3aGl0ZTtcbiAgbWFyZ2luLWxlZnQ6IDEzcHg7XG4gIGJvcmRlci1yYWRpdXM6IDZweDtcbiAgcGFkZGluZzogMHB4IDNweDtcbn0iXX0= */";
var styles$9 = {"scanDebugMenu":"debug-module_scanDebugMenu__eCBlE"};
styleInject(css_248z$9);

var DebugMenu = function () {
    var _a = useGlobalContext(), bufferRef = _a.bufferRef, threshold = _a.threshold, setThreshold = _a.setThreshold, modelState = _a.modelState, scanDebugState = _a.scanDebugState, laplacianThreshold = _a.laplacianThreshold, scanFreqency = _a.scanFreqency, debugCanvasBestRef = _a.debugCanvasBestRef, bestScore = _a.bestScore, bestLaplacian = _a.bestLaplacian, setBufferSize = _a.setBufferSize, setScanFreqency = _a.setScanFreqency, latestScore = _a.latestScore, latestLaplacian = _a.latestLaplacian, debugCanvasLatestRef = _a.debugCanvasLatestRef, setLaplacianThreshold = _a.setLaplacianThreshold, bufferSize = _a.bufferSize, debugMenu = _a.debugMenu, videoMetadata = _a.videoMetadata;
    var _b = require$$0.useState(false), showDebugMenu = _b[0], setShowDebugMenu = _b[1];
    var loadDebugLibraries = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            //Load debug libraries in dynamically at runtine so we don't need them in the package.
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    if (debugMenu == false) {
                        return reject();
                    }
                    // @ts-expect-error: Debug libraries loading dynamically.
                    if (window.JSZip != undefined || window.saveAs != undefined) {
                        //already loaded
                        return resolve();
                    }
                    console.log("JSZip & FileSaver are required for this feature");
                    // @ts-expect-error: FileSaver loading dynamically.
                    if (window.FileSaver == undefined) {
                        var script = document.createElement("script");
                        script.src =
                            "https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.0/FileSaver.min.js";
                        script.id = "filesaver-dynamic-load";
                        document.body.appendChild(script);
                    }
                    // @ts-expect-error: JSZip loading dynamically.
                    if (window.JSZip == undefined) {
                        var script = document.createElement("script");
                        script.src =
                            "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.7.1/jszip.min.js";
                        script.id = "jszip-dynamic-load";
                        document.body.appendChild(script);
                        script.onload = function () {
                            console.log("JSZip loaded!");
                            return resolve();
                        };
                    }
                })];
        });
    }); };
    var downloadDebugLog = function (event) {
        if (bufferRef.current.length == 0) {
            GlobalLogger.log("No cards to download");
        }
        loadDebugLibraries().then(function () {
            // @ts-expect-error: Debug libraries loading dynamically.
            var zip = new window.JSZip();
            bufferRef.current.forEach(function (element) {
                var name = element.file.lastModified + ".jpg";
                zip.file(name, element.file);
            });
            var files = bufferRef.current.map(function (element) {
                element["file"] = element.file.lastModified;
                return element;
            });
            var data = {
                package_name: "insurance-cardscan-react",
                package_version: cardScanPackageVersion,
                windowInner: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                },
                files: files,
                debugLog: GlobalLogger.getLog(),
                videoMetadata: videoMetadata,
                scanAttributes: {
                    modelState: modelState,
                    scanDebugState: scanDebugState,
                    threshold: threshold,
                    laplacianThreshold: laplacianThreshold,
                    scanFreqency: scanFreqency,
                    bufferSize: bufferSize,
                    bestScore: bestScore,
                    bestLaplacian: bestLaplacian,
                    latestScore: latestScore,
                    latestLaplacian: latestLaplacian,
                },
            };
            var results = new Blob([JSON.stringify(data, null, 2)], {
                type: "application/json",
            });
            zip.file("debugLog.json", results);
            // Add canvases to the zip file
            if (debugCanvasBestRef.current) {
                var bestCanvasDataUrl = debugCanvasBestRef.current.toDataURL("image/jpeg");
                zip.file("bestCanvas.jpg", bestCanvasDataUrl.split(",")[1], {
                    base64: true,
                });
            }
            if (debugCanvasLatestRef.current) {
                var latestCanvasDataUrl = debugCanvasLatestRef.current.toDataURL("image/jpeg");
                zip.file("latestCanvas.jpg", latestCanvasDataUrl.split(",")[1], {
                    base64: true,
                });
            }
            var filename = "download_" + new Date().getTime() + ".zip";
            zip.generateAsync({ type: "blob" }).then(function (content) {
                // @ts-expect-error: Debug libraries loading dynamically.
                window.saveAs(content, filename);
            });
        });
    };
    if (!debugMenu) {
        return jsxRuntime.jsx("div", {});
    }
    return (jsxRuntime.jsxs("div", __assign$2({ "data-cy": "scanDebugMenu", className: styles$9.scanDebugMenu }, { children: [jsxRuntime.jsx("button", __assign$2({ onClick: function (e) {
                    setShowDebugMenu(!showDebugMenu);
                } }, { children: showDebugMenu ? "Hide" : "Show" })), jsxRuntime.jsxs("div", __assign$2({ className: "scan-debug-wrapper", hidden: !showDebugMenu }, { children: [jsxRuntime.jsxs("div", __assign$2({ "data-cy": "scanDebugModelstate", className: "scan-debug-modelstate" }, { children: ["Model: ", modelState] })), jsxRuntime.jsxs("div", __assign$2({ "data-cy": "scanDebugScanstate", className: "scan-debug-scanstate" }, { children: ["Scanning: ", scanDebugState] })), jsxRuntime.jsxs("div", __assign$2({ className: "scan-debug-threshold" }, { children: ["Model Threshold:", " ", jsxRuntime.jsx("input", { type: "number", value: threshold, onChange: function (event) {
                                    setThreshold(Number(event.target.value));
                                } })] })), jsxRuntime.jsxs("div", __assign$2({ className: "scan-debug-threshold" }, { children: ["Laplacian Threshold:", " ", jsxRuntime.jsx("input", { type: "number", value: laplacianThreshold, onChange: function (event) {
                                    setLaplacianThreshold(Number(event.target.value));
                                } })] })), jsxRuntime.jsxs("div", __assign$2({ className: "scan-debug-frequency" }, { children: ["Scan Frequency:", " ", jsxRuntime.jsx("input", { type: "number", value: scanFreqency, onChange: function (event) {
                                    setScanFreqency(Number(event.target.value));
                                } })] })), jsxRuntime.jsxs("div", __assign$2({ className: "scan-debug-results" }, { children: ["Buffer: ", bufferRef.current.length, " /", " ", jsxRuntime.jsx("input", { type: "number", width: "35px", value: bufferSize, onChange: function (event) {
                                    setBufferSize(Number(event.target.value));
                                } }), jsxRuntime.jsx("button", __assign$2({ onClick: function (event) {
                                    bufferRef.current = [];
                                } }, { children: "Clear" }))] })), jsxRuntime.jsxs("div", __assign$2({ className: "scan-debug-best-score" }, { children: ["Best Score: ", (Math.round(bestScore * 1000) / 1000).toFixed(3), jsxRuntime.jsx("br", {}), "Best Laplacian: ", (Math.round(bestLaplacian * 1000) / 1000).toFixed(3)] })), jsxRuntime.jsx("canvas", { ref: debugCanvasBestRef, width: "200", height: "125" }), jsxRuntime.jsxs("div", __assign$2({ className: "scan-debug-latest-score" }, { children: ["Latest Score: ", (Math.round(latestScore * 1000) / 1000).toFixed(3), " ", jsxRuntime.jsx("br", {}), "Laplacian: ", (Math.round(latestLaplacian * 1000) / 1000).toFixed(3)] })), jsxRuntime.jsx("canvas", { ref: debugCanvasLatestRef, width: "200", height: "125" }), jsxRuntime.jsx("div", __assign$2({ className: "scan-debug-get-debug" }, { children: jsxRuntime.jsx("button", __assign$2({ onClick: downloadDebugLog }, { children: "Download Debug Log" })) }))] }))] })));
};

var img$8 = "data:image/png;base64,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";

var FirefoxVideo = "data:video/mp4;base64,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";

var SafariVideo = "data:video/mp4;base64,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";

var ChromeVideo = "data:video/mp4;base64,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";

var img$7 = "data:image/png;base64,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";

var CardScanLogoURL = img$7;
var getBrowserHelperImage = function (browserName) {
    if (browserName === void 0) { browserName = "Chrome"; }
    return ({
        Firefox: FirefoxVideo,
        Chrome: ChromeVideo,
        Safari: SafariVideo,
        "Mobile Safari": SafariVideo,
        Edge: img$8,
    }[browserName] || ChromeVideo);
};
function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","), mime = arr[0].match(/:(.*?);/)[1], bstr = window.atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}
var calculateGuides = function (videoRefBg, frameDivRef) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var frameDivDimensions = (_a = frameDivRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var videoElementDimensions = (_b = videoRefBg.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
    var heightAspectRatio = (((_c = videoRefBg.current) === null || _c === void 0 ? void 0 : _c.videoHeight) || 1) /
        (((_d = videoRefBg.current) === null || _d === void 0 ? void 0 : _d.videoWidth) || 1);
    var videoElementHeight = videoElementDimensions.width * heightAspectRatio;
    var percentageOfScanFrameWidth = frameDivDimensions.width / videoElementDimensions.width;
    var percentageOfScanFrameHeight = frameDivDimensions.height / videoElementHeight;
    var guideWidth = (((_e = videoRefBg.current) === null || _e === void 0 ? void 0 : _e.videoWidth) || 1) * percentageOfScanFrameWidth;
    var guideHeight = (((_f = videoRefBg.current) === null || _f === void 0 ? void 0 : _f.videoHeight) || 1) * percentageOfScanFrameHeight;
    var videoCenterX = (((_g = videoRefBg.current) === null || _g === void 0 ? void 0 : _g.videoWidth) || 1) / 2;
    var videoCenterY = (((_h = videoRefBg.current) === null || _h === void 0 ? void 0 : _h.videoHeight) || 1) / 2;
    var xPosition = videoCenterX - guideWidth / 2;
    var yPosition = videoCenterY - guideHeight / 2;
    GlobalLogger.debug("Guide: ".concat(xPosition, ", ").concat(yPosition, ", ").concat(guideWidth, ", ").concat(guideHeight), "everything");
    return [xPosition, yPosition, guideWidth, guideHeight];
};
var getHeaderTitle = function (status, messageState, isAuto) {
    return ({
        cameraLoading: messageState.autoCaptureTitle,
        autoCapture: messageState.autoCaptureTitle,
        manualCapture: messageState.manualCaptureTitle,
        frontsideProcessing: messageState.processingTitle,
        backsidePending: messageState.frontsideCompletedTitle,
        frontsideCompleted: messageState.frontsideCompletedTitle,
        backsideProcessing: messageState.processingTitle,
        postProcessing: messageState.postProcessing,
        success: messageState.completedTitle,
        pending: isAuto
            ? messageState.autoCaptureTitle
            : messageState.manualCaptureTitle,
        error: messageState.errorTitle,
        cameraError: messageState.cameraErrorTitle,
        retry: messageState.retryTitle,
        eligibilityProcessing: messageState.eligibilityProcessing,
    }[status]);
};

var lib$1 = {};

var uaParser_min = {exports: {}};

/* UAParser.js v1.0.36
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */

(function (module, exports) {
(function(window,undefined$1){var LIBVERSION="1.0.36",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=350;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i]);}else {mergedRegexes[i]=regexes[i];}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i];}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined$1},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match);}else {this[q[0]]=q[1];}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined$1;}else {this[q[0]]=match?match.replace(q[1],q[2]):undefined$1;}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined$1;}}else {this[q]=match?match:undefined$1;}}}}i+=2;}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined$1:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined$1:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,/(ba?idubrowser)[\/ ]?([\w\.]+)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,/(heytap|ovi)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(metasr)[\/ ]?([\w\.]+)/i,/(lbbrowser)/i,/\[(linkedin)app\]/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i,/panasonic;(viera)/i],[NAME,VERSION],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[12]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mitv-\w{5}) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( 2| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows) nt 6\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,/(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,strMapper,windowsVersionMap]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined$1;}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined$1;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined$1;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined$1;_browser[VERSION]=undefined$1;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave";}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined$1;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined$1;_device[MODEL]=undefined$1;_device[TYPE]=undefined$1;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE;}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET;}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined$1;_engine[VERSION]=undefined$1;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined$1;_os[VERSION]=undefined$1;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS);}return _os};this.getResult=function(){return {ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);{if(module.exports){exports=module.exports=UAParser;}exports.UAParser=UAParser;}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop];}};}})(typeof window==="object"?window:commonjsGlobal);
}(uaParser_min, uaParser_min.exports));

Object.defineProperty(lib$1, '__esModule', { value: true });

function _interopDefault$1 (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require$$0__default["default"];
var React__default = _interopDefault$1(React);

var UAParser = uaParser_min.exports;

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties$2(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties$2(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties$2(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties$2(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties$2(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties$2(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties$2(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children;
      _ref8.viewClassName;
      _ref8.style;
      var props = _objectWithoutProperties$2(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties$2(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties$2(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties$2(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children;
      _ref12.viewClassName;
      _ref12.style;
      var condition = _ref12.condition,
      props = _objectWithoutProperties$2(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends$2({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

lib$1.AndroidView = AndroidView;
lib$1.BrowserTypes = BrowserTypes;
lib$1.BrowserView = BrowserView;
lib$1.ConsoleView = ConsoleView;
lib$1.CustomView = CustomView;
lib$1.IEView = IEView;
lib$1.IOSView = IOSView;
lib$1.MobileOnlyView = MobileOnlyView;
lib$1.MobileView = MobileView;
lib$1.OsTypes = OsTypes;
lib$1.SmartTVView = SmartTVView;
lib$1.TabletView = TabletView;
lib$1.WearableView = WearableView;
lib$1.WinPhoneView = WinPhoneView;
var browserName_1 = lib$1.browserName = browserName;
lib$1.browserVersion = browserVersion;
lib$1.deviceDetect = deviceDetect;
lib$1.deviceType = deviceType;
lib$1.engineName = engineName;
lib$1.engineVersion = engineVersion;
lib$1.fullBrowserVersion = fullBrowserVersion;
lib$1.getSelectorsByUserAgent = getSelectorsByUserAgent;
lib$1.getUA = getUA;
lib$1.isAndroid = isAndroid;
lib$1.isBrowser = isBrowser;
lib$1.isChrome = isChrome;
lib$1.isChromium = isChromium;
lib$1.isConsole = isConsole;
lib$1.isDesktop = isDesktop;
lib$1.isEdge = isEdge;
lib$1.isEdgeChromium = isEdgeChromium;
lib$1.isElectron = isElectron;
lib$1.isEmbedded = isEmbedded;
lib$1.isFirefox = isFirefox;
lib$1.isIE = isIE;
var isIOS_1 = lib$1.isIOS = isIOS;
lib$1.isIOS13 = isIOS13;
lib$1.isIPad13 = isIPad13;
lib$1.isIPhone13 = isIPhone13;
lib$1.isIPod13 = isIPod13;
lib$1.isLegacyEdge = isLegacyEdge;
lib$1.isMIUI = isMIUI;
lib$1.isMacOs = isMacOs;
var isMobile_1 = lib$1.isMobile = isMobile;
lib$1.isMobileOnly = isMobileOnly;
lib$1.isMobileSafari = isMobileSafari;
lib$1.isOpera = isOpera;
lib$1.isSafari = isSafari;
lib$1.isSamsungBrowser = isSamsungBrowser;
lib$1.isSmartTV = isSmartTV;
lib$1.isTablet = isTablet;
lib$1.isWearable = isWearable;
lib$1.isWinPhone = isWinPhone;
lib$1.isWindows = isWindows;
lib$1.isYandex = isYandex;
lib$1.mobileModel = mobileModel;
lib$1.mobileVendor = mobileVendor;
lib$1.osName = osName;
lib$1.osVersion = osVersion;
lib$1.parseUserAgent = parseUserAgent;
lib$1.setUserAgent = setUserAgent;
lib$1.useDeviceData = useDeviceData;
lib$1.useDeviceSelectors = useDeviceSelectors;
var useMobileOrientation_1 = lib$1.useMobileOrientation = useMobileOrientation;
lib$1.withOrientationChange = withOrientationChange;

var css_248z$8 = ".permissionModal-module_scanErrorModal__l1xjO{align-items:center;background-color:#f9fbfd;border-radius:16px;box-shadow:0 8px 36px 0 rgba(0,0,0,.161);display:flex;flex-direction:column;height:630px;left:50%;padding:20px;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%);width:550px;z-index:999999}.permissionModal-module_scanErrorModal__l1xjO>*{margin-bottom:16px}.permissionModal-module_scanErrorTitle__7oc7e{color:#000;font-size:24px;font-weight:700;text-align:center}.permissionModal-module_scanErrorDescription__EgD59{color:rgba(21,25,32,.5);font-size:18px;font-weight:400;text-align:center}.permissionModal-module_scanErrorButton__-Tl-x{border:none;border-radius:8px;font-size:14px;font-weight:600;height:42px;min-width:230px}.permissionModal-module_scanErrorButtonContainer__cKvdH{display:flex;justify-content:space-around;width:100%}.permissionModal-module_scanErrorButtonSecondary__UrV9T{background:#fff;border:1px solid #566789;color:rgba(21,25,32,.5)}.permissionModal-module_scanErrorButtonPrimary__jBcc9{background-color:#2f80ed;color:#fff}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles$8 = {"scanErrorModal":"permissionModal-module_scanErrorModal__l1xjO","scanErrorTitle":"permissionModal-module_scanErrorTitle__7oc7e","scanErrorDescription":"permissionModal-module_scanErrorDescription__EgD59","scanErrorButton":"permissionModal-module_scanErrorButton__-Tl-x","scanErrorButtonContainer":"permissionModal-module_scanErrorButtonContainer__cKvdH","scanErrorButtonSecondary":"permissionModal-module_scanErrorButtonSecondary__UrV9T","scanErrorButtonPrimary":"permissionModal-module_scanErrorButtonPrimary__jBcc9"};
styleInject(css_248z$8);

var CameraPermissionModal = function (_a) {
    var enableModel = _a.enableModel, cameraPermissionModalConfig = _a.cameraPermissionModalConfig;
    var _b = require$$0.useState({
        enabled: true,
        modalTitle: "Camera Permission Needed",
        modalText: "This application needs access to the camera to scan your medical insurance card. Please allow access to the camera.",
        modalButton: "Try Again",
    }), cameraPermissionModalCustom = _b[0], setCameraPermissionModalCustom = _b[1];
    require$$0.useEffect(function () {
        if (cameraPermissionModalConfig) {
            setCameraPermissionModalCustom(function (prev) { return (__assign$2(__assign$2({}, prev), cameraPermissionModalConfig)); });
        }
    }, [cameraPermissionModalConfig]);
    if (!enableModel) {
        return jsxRuntime.jsx("div", {});
    }
    return (jsxRuntime.jsxs("div", __assign$2({ className: styles$8.scanErrorModal }, { children: [jsxRuntime.jsx("h2", __assign$2({ className: styles$8.scanErrorTitle }, { children: cameraPermissionModalCustom.modalTitle })), jsxRuntime.jsx("p", { children: cameraPermissionModalCustom.modalText }), jsxRuntime.jsxs("video", __assign$2({ controls: true, autoPlay: true, loop: true, muted: true, width: "400" }, { children: [jsxRuntime.jsx("source", { src: getBrowserHelperImage(browserName_1), type: "video/mp4" }), "Sorry, your browser doesn't support embedded videos."] })), jsxRuntime.jsx("div", __assign$2({ className: styles$8.scanErrorButtonContainer }, { children: jsxRuntime.jsx("button", __assign$2({ className: "".concat(styles$8.scanErrorButton, " ").concat(styles$8.scanErrorButtonPrimary), onClick: function () { return window.location.reload(); } }, { children: cameraPermissionModalCustom.modalButton })) }))] })));
};

var img$6 = "data:image/png;base64,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";

var img$5 = "data:image/png;base64,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";

var img$4 = "data:image/png;base64,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";

var img$3 = "data:image/png;base64,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";

var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALZSURBVHgBlVXrTRtBEN7ds2Mh5OATAim/cnQAFXCkAaACnArAFRjSAHRgUoFJBYYGgqkA+5elIHFO/L7HTr7Z23Nsg21lpPHsa76d+XbGJ8UKIaISzD7UgzahXVYpZVf8j0RR5Mdx3EiSREMphtq1Z6jmPejZWiBE5MGxEUYRQXUYhmwZrDoajS7Hk4k2Oh4TVI8mkxrWvVkMmQ14A6k0bHqC0k02bQB+xaTBK7xG0y3MpWhFyjlyNzZac4DD8bguSB+TJnPKxiyUVGVE6Wuty/Ye4wdBQpTZNq45cF23azzB0yUivNNEj3McSNkaD4enUqnHN/wASKSA2S03O9vblRzzBoKrhUKBhqPRDTbOs5uVEOUQCwXH8cW7EgPMscM4tSD+fBKGTHbAPL4GwStUB0FQE0sE6Tegml8/scpzBFJVidYniFBizjVXjbX+hmKReMWrZYAAuIKCci3gzxcYG8WxL/v9fgBCSpQxQXTUR6SfdndvxQpBZtcI6YLfnOmxy7/ln16PQ5X/uJb3H4vFI7FGuItA0TMctuyCQeWUu3oadsLp+ODvQqwXDz5XeiZltgq91bYTQg1Skm5WAVpaFR3O11EZTfD/lPnDvanwc88TRCZZcQEDlkBwVSzn7wJnPvOr4mEqCR7V+GrdlJ1Ox3Py+UPDn+O0Zh13XPdhEcz27rPpJuLapgq67BgD31HKN4eAfmvrSWd1FS/MWSFng8GgNhgOCaqtomyD/V8vL9cmKMuJh379iYE7F07a06bFYFv4kzjl9sz6eHpMqcvi5qap21zqJ1uoxy8YNHBqK0uHtyiFpXw+f4Ko7yitO2Ft+s+Dh5mCzwbEoeO2OpdE5oQT/PfzPUqSB7jXUhD0euralbnciVssPrwLyNIJAu+DEGfoqzI8PV4DkQfCceqA8kzx4hOA1O8GvV5lb29v7nPwBnAh4kPwxqBPADqX/E1RqgmgH4tAmfwFCACBSzrNB+sAAAAASUVORK5CYII=";

var css_248z$7 = ".scanSwitch-module_cardScanAutoSwitch__6ONVZ{align-items:center;background-color:var(--cardscan-auto-switch-active-color);border-radius:50px;box-sizing:border-box;color:#fff;cursor:pointer;display:flex;flex-flow:row-reverse;font-size:80%;font-weight:600;justify-content:space-evenly;left:50%;line-height:.5;max-width:80px;padding:2px;position:fixed;text-transform:uppercase;top:-6%;transform:translate(-50%,-50%);transition:all 1s ease;width:100%;z-index:9}.scanSwitch-module_cardScanAutoSwitchMobileLandscape__GYVhq,.scanSwitch-module_cardScanAutoSwitchMobile__Bo8Za{position:absolute;top:10%;transform:translate(-50%)}.scanSwitch-module_cardScanAutoSwitchMobileLandscape__GYVhq{left:50%;right:auto;top:5%}.scanSwitch-module_cardScanSwitchOff__x9Hne{background:var(--cardscan-auto-switch-inactive-color);flex-flow:row}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjYW5Td2l0Y2gubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsNkNBYUUsa0JBQW1CLENBWG5CLHlEQUEwRCxDQUMxRCxrQkFBbUIsQ0FGbkIscUJBQXNCLENBR3RCLFVBQVcsQ0FXWCxjQUFlLENBTGYsWUFBYSxDQUNiLHFCQUFzQixDQVd0QixhQUFjLENBakJkLGVBQWdCLENBT2hCLDRCQUE2QixDQUo3QixRQUFTLENBYVQsY0FBZ0IsQ0FGaEIsY0FBZSxDQUxmLFdBQVksQ0FSWixjQUFlLENBY2Ysd0JBQXlCLENBYnpCLE9BQVEsQ0FFUiw4QkFBZ0MsQ0FPaEMsc0JBQXVCLENBRXZCLFVBQVcsQ0FEWCxTQU1GLENBRUEsK0dBSUUsaUJBQWtCLENBRmxCLE9BQVEsQ0FDUix5QkFFRixDQUVBLDREQUVFLFFBQVMsQ0FEVCxVQUFXLENBRVgsTUFDRixDQUVBLDRDQUNFLHFEQUFzRCxDQUN0RCxhQUNGIiwiZmlsZSI6InNjYW5Td2l0Y2gubW9kdWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY2FyZFNjYW5BdXRvU3dpdGNoIHtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tY2FyZHNjYW4tYXV0by1zd2l0Y2gtYWN0aXZlLWNvbG9yKTtcbiAgYm9yZGVyLXJhZGl1czogNTBweDtcbiAgY29sb3I6ICNmZmY7XG4gIGZvbnQtd2VpZ2h0OiA2MDA7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAtNiU7XG4gIGxlZnQ6IDUwJTtcbiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSk7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZmxvdzogcm93LXJldmVyc2U7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtZXZlbmx5O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBwYWRkaW5nOiAycHg7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgdHJhbnNpdGlvbjogYWxsIDFzIGVhc2U7XG4gIHotaW5kZXg6IDk7XG4gIHdpZHRoOiAxMDAlO1xuICBtYXgtd2lkdGg6IDgwcHg7XG4gIHRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7XG4gIGxpbmUtaGVpZ2h0OiAwLjU7XG4gIGZvbnQtc2l6ZTogODAlO1xufVxuXG4uY2FyZFNjYW5BdXRvU3dpdGNoTW9iaWxlLFxuLmNhcmRTY2FuQXV0b1N3aXRjaE1vYmlsZUxhbmRzY2FwZSB7XG4gIHRvcDogMTAlO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCAwJSk7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbn1cblxuLmNhcmRTY2FuQXV0b1N3aXRjaE1vYmlsZUxhbmRzY2FwZSB7XG4gIHJpZ2h0OiBhdXRvO1xuICBsZWZ0OiA1MCU7XG4gIHRvcDogNSU7XG59XG5cbi5jYXJkU2NhblN3aXRjaE9mZiB7XG4gIGJhY2tncm91bmQ6IHZhcigtLWNhcmRzY2FuLWF1dG8tc3dpdGNoLWluYWN0aXZlLWNvbG9yKTtcbiAgZmxleC1mbG93OiByb3c7XG59Il19 */";
var styles$7 = {"cardScanAutoSwitch":"scanSwitch-module_cardScanAutoSwitch__6ONVZ","cardScanAutoSwitchMobile":"scanSwitch-module_cardScanAutoSwitchMobile__Bo8Za","cardScanAutoSwitchMobileLandscape":"scanSwitch-module_cardScanAutoSwitchMobileLandscape__GYVhq","cardScanSwitchOff":"scanSwitch-module_cardScanSwitchOff__x9Hne"};
styleInject(css_248z$7);

var MobilePortal = function (_a) {
    var children = _a.children, elementId = _a.elementId;
    var isMobile = useGlobalContext().isMobile;
    var element = document.getElementById(elementId);
    if (isMobile && element) {
        return jsxRuntime.jsx(jsxRuntime.Fragment, { children: reactDom.createPortal(children, element) });
    }
    return jsxRuntime.jsx(jsxRuntime.Fragment, { children: children });
};

var ScanSwitch = function (_a) {
    var isMobile = _a.isMobile;
    var _b = useGlobalContext(), isMobileOnLandscape = _b.isMobileOnLandscape, stateMachineState = _b.stateMachineState, stateMachineSend = _b.stateMachineSend;
    return (jsxRuntime.jsx(MobilePortal, __assign$2({ elementId: isMobileOnLandscape ? "mobileBottomCurtain" : "mobileTopCurtain" }, { children: jsxRuntime.jsxs("div", __assign$2({ "data-cy": "cardScanAutoSwitch", className: "".concat(styles$7.cardScanAutoSwitch, " ").concat(stateMachineState.context.autoScan ? "" : styles$7.cardScanSwitchOff, " ").concat(isMobile
                ? isMobileOnLandscape
                    ? styles$7.cardScanAutoSwitchMobileLandscape
                    : styles$7.cardScanAutoSwitchMobile
                : ""), onClick: function () { return stateMachineSend("TOGGLE"); } }, { children: [jsxRuntime.jsx("img", { src: img$2, alt: "switch icon indicating an option between auto scan and manual scan", style: { height: "auto", width: "20%", aspectRatio: "1/1" } }), stateMachineState.context.autoScan ? "Auto" : "Off"] })) })));
};
ScanSwitch.propTypes = {
    isMobile: PropTypes.bool,
};

var css_248z$6 = "#scanFrame-module_cardscanHelperText__BSvel{align-items:center;background:var(--cardscan-message-background-color,#000);border-radius:6px;box-sizing:border-box;color:var(--cardscan-message-text-color);display:flex;font-size:var(--cardscan-message-font-size,1.125rem);font-weight:400;justify-content:center;line-height:1.5;padding:6px;text-align:center;text-transform:none;transition:all 1.5s ease;white-space:pre-line;width:fit-content}#scanFrame-module_cardscanHelperText__BSvel.scanFrame-module_mobile__iGA9A{font-size:var(--cardscan-message-font-size,1.2rem);left:50%;margin:0;position:absolute;top:50%;transform:translate(-50%,-25%);z-index:10}#scanFrame-module_cardscanHelperText__BSvel.scanFrame-module_eligibilityText__WdG-u.scanFrame-module_mobile__iGA9A{top:100%;transform:translate(-50%,25%)}#scanFrame-module_cardscanHelperText__BSvel.scanFrame-module_mobileLandscape__R9O4q{font-size:var(--cardscan-message-font-size,1.125rem);position:relative;top:50%;transform:translate(-50%,-50%);width:auto}.scanFrame-module_cardscanRetryButton__4iwA9{background:#6fcf97;border:none;border-radius:13px;box-shadow:0 2px 4px rgba(0,0,0,.25);color:#dfdedf;cursor:pointer;font-family:Roboto,sans-serif;font-size:14px;font-weight:600;letter-spacing:2px;line-height:22px;outline:none;padding:6px 14px;text-align:center;text-transform:uppercase;transition:all .3s ease 0s}.scanFrame-module_cardscanRetryButton__4iwA9:active,.scanFrame-module_cardscanRetryButton__4iwA9:focus{outline:none;transform:translate(2px,2px)}.scanFrame-module_corner__S6aVE{border-color:var(--cardscan-progress-bar-color);border-radius:5px;border-style:solid;content:\" \";height:20%;position:absolute;transition:border-color .5s ease,width .75s linear,height .75s linear;width:20%}.scanFrame-module_corner__S6aVE.scanFrame-module_cardscanCornerOff__G373s{border-color:#e3eaf4}.scanFrame-module_corner1__ouwk5{border-width:5px 0 0 5px;height:20%;left:-6px;top:-6px;width:var(--cardscan-corner-width)}.scanFrame-module_corner2__LR0Sj{border-width:5px 5px 0 0;height:var(--cardscan-corner-height);right:-6px;top:-6px;width:20%}.scanFrame-module_corner3__SSofi{border-width:0 5px 5px 0;bottom:-6px;height:20%;right:-6px;width:var(--cardscan-corner-width)}.scanFrame-module_corner4__-rkSZ{border-width:0 0 5px 5px;bottom:-6px;height:var(--cardscan-corner-height);left:-6px;width:20%}.scanFrame-module_cardGuide__41-fv{aspect-ratio:16/9;box-shadow:0 0 8px 0 rgba(0,0,0,.55);box-sizing:border-box;height:auto;left:50%;min-width:auto;position:relative;position:absolute;top:50%;transform:translate(-50%,-50%);width:81%;z-index:2}@supports not (aspect-ratio:5/3){.scanFrame-module_cardGuide__41-fv:before{content:\"\";float:left;padding-top:56.25%}.scanFrame-module_cardGuide__41-fv:after{clear:both;content:\"\";display:block}}.scanFrame-module_cardGuide__41-fv.scanFrame-module_mobile__iGA9A{border:none;width:95%}.scanFrame-module_cardGuide__41-fv .scanFrame-module_processStatus__Z-dLU{display:block}.scanFrame-module_cardGuide__41-fv .scanFrame-module_spinnerWrapper__rxkNG{align-items:center;display:flex;flex-direction:column;height:80px;justify-content:center;width:100%}.scanFrame-module_cardGuide__41-fv .scanFrame-module_processStatus__Z-dLU{align-items:center;display:flex;flex-direction:column;justify-content:center;position:absolute;top:50%;transform:translateY(-50%);width:100%}.scanFrame-module_cardGuide__41-fv .scanFrame-module_processStatus__Z-dLU img{max-width:9%}.scanFrame-module_cardGuide__41-fv .scanFrame-module_processStatus__Z-dLU img.scanFrame-module_mobile__iGA9A{max-width:20%}.scanFrame-module_scanCompleted__mi8R3{box-shadow:none}.scanFrame-module_cardGuideLandscape__FZ9pd{height:calc(100% - 40px)}.scanFrame-module_backCard__mpdOR,.scanFrame-module_frontCard__tMSrQ{-webkit-backface-visibility:hidden;backface-visibility:hidden;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);transform-style:preserve-3d;width:100px}.scanFrame-module_frontCard__tMSrQ{animation:scanFrame-module_flipFrontCard__6qcCG 4s infinite}.scanFrame-module_backCard__mpdOR{animation:scanFrame-module_flipBackCard__sY6a4 4s infinite}@keyframes scanFrame-module_flipFrontCard__6qcCG{0%{transform:translate(-50%,-50%) rotateY(0deg)}50%{transform:translate(-50%,-50%) rotateY(180deg)}to{transform:translate(-50%,-50%) rotateY(1turn)}}@keyframes scanFrame-module_flipBackCard__sY6a4{0%{transform:translate(-50%,-50%) rotateY(180deg)}50%{transform:translate(-50%,-50%) rotateY(1turn)}to{transform:translate(-50%,-50%) rotateY(540deg)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjYW5GcmFtZS5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSw0Q0FnQkUsa0JBQW1CLENBWm5CLHdEQUE2RCxDQUM3RCxpQkFBa0IsQ0FRbEIscUJBQXNCLENBVnRCLHdDQUF5QyxDQVd6QyxZQUFhLENBYmIsb0RBQXNELENBQ3RELGVBQWdCLENBYWhCLHNCQUF1QixDQUp2QixlQUFnQixDQUxoQixXQUFZLENBV1osaUJBQWtCLENBUGxCLG1CQUFvQixDQUZwQix3QkFBeUIsQ0FDekIsb0JBQXFCLENBR3JCLGlCQU1GLENBQ0EsMkVBT0Usa0RBQW9ELENBRnBELFFBQVMsQ0FEVCxRQUFTLENBSFQsaUJBQWtCLENBRWxCLE9BQVEsQ0FHUiw4QkFBZ0MsQ0FKaEMsVUFNRixDQUNBLG1IQUNFLFFBQVMsQ0FDVCw2QkFDRixDQUNBLG9GQUlFLG9EQUFzRCxDQUN0RCxpQkFBa0IsQ0FIbEIsT0FBUSxDQUNSLDhCQUFnQyxDQUZoQyxVQUtGLENBRUEsNkNBYUUsa0JBQW1CLENBRG5CLFdBQVksQ0FEWixrQkFBbUIsQ0FGbkIsb0NBQTJDLENBSzNDLGFBQWMsQ0FDZCxjQUFlLENBZGYsNkJBQWlDLENBQ2pDLGNBQWUsQ0FHZixlQUFnQixDQURoQixrQkFBbUIsQ0FJbkIsZ0JBQWlCLENBUWpCLFlBQWEsQ0FOYixnQkFBaUIsQ0FIakIsaUJBQWtCLENBSmxCLHdCQUF5QixDQUd6QiwwQkFXRixDQUVBLHVHQUVFLFlBQWEsQ0FDYiw0QkFDRixDQUVBLGdDQUdFLCtDQUFnRCxDQUloRCxpQkFBa0IsQ0FIbEIsa0JBQW1CLENBRm5CLFdBQVksQ0FJWixVQUFXLENBTFgsaUJBQWtCLENBT2xCLHFFQUEyRSxDQUgzRSxTQUlGLENBQ0EsMEVBQ0Usb0JBQ0YsQ0FFQSxpQ0FHRSx3QkFBeUIsQ0FFekIsVUFBVyxDQUhYLFNBQVUsQ0FEVixRQUFTLENBR1Qsa0NBRUYsQ0FFQSxpQ0FHRSx3QkFBeUIsQ0FDekIsb0NBQXFDLENBRnJDLFVBQVcsQ0FEWCxRQUFTLENBSVQsU0FDRixDQUVBLGlDQUdFLHdCQUF5QixDQUZ6QixXQUFZLENBSVosVUFBVyxDQUhYLFVBQVcsQ0FFWCxrQ0FFRixDQUVBLGlDQUdFLHdCQUF5QixDQUZ6QixXQUFZLENBR1osb0NBQXFDLENBRnJDLFNBQVUsQ0FHVixTQUNGLENBRUEsbUNBWUUsaUJBQWtCLENBUmxCLG9DQUErQyxDQUgvQyxxQkFBc0IsQ0FTdEIsV0FBWSxDQUhaLFFBQVMsQ0FJVCxjQUFlLENBUmYsaUJBQWtCLENBRWxCLGlCQUFrQixDQUNsQixPQUFRLENBRVIsOEJBQWdDLENBQ2hDLFNBQVUsQ0FQVixTQVdGLENBQ0EsaUNBQ0UsMENBR0UsVUFBVyxDQUZYLFVBQVcsQ0FDWCxrQkFFRixDQUNBLHlDQUdFLFVBQVcsQ0FEWCxVQUFXLENBRFgsYUFHRixDQUNGLENBQ0Esa0VBQ0UsV0FBWSxDQUNaLFNBQ0YsQ0FDQSwwRUFDRSxhQUNGLENBQ0EsMkVBRUUsa0JBQW1CLENBRG5CLFlBQWEsQ0FFYixxQkFBc0IsQ0FDdEIsV0FBWSxDQUVaLHNCQUF1QixDQUR2QixVQUVGLENBQ0EsMEVBRUUsa0JBQW1CLENBRG5CLFlBQWEsQ0FFYixxQkFBc0IsQ0FJdEIsc0JBQXVCLENBSHZCLGlCQUFrQixDQUNsQixPQUFRLENBR1IsMEJBQTJCLENBRjNCLFVBR0YsQ0FDQSw4RUFDRSxZQUNGLENBQ0EsNkdBQ0UsYUFDRixDQUVBLHVDQUNFLGVBQ0YsQ0FFQSw0Q0FDRSx3QkFDRixDQUVBLHFFQVFFLGtDQUFtQyxDQUNuQywwQkFBMkIsQ0FOM0IsUUFBUyxDQURULGlCQUFrQixDQUVsQixPQUFRLENBQ1IsOEJBQWdDLENBRWhDLDJCQUE0QixDQUQ1QixXQUlGLENBRUEsbUNBQ0UsMkRBQ0YsQ0FFQSxrQ0FDRSwwREFDRixDQUVBLGlEQUNFLEdBQ0UsNENBQ0YsQ0FDQSxJQUNFLDhDQUNGLENBQ0EsR0FDRSw2Q0FDRixDQUNGLENBQ0EsZ0RBQ0UsR0FDRSw4Q0FDRixDQUNBLElBQ0UsNkNBQ0YsQ0FDQSxHQUNFLDhDQUNGLENBQ0YiLCJmaWxlIjoic2NhbkZyYW1lLm1vZHVsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiI2NhcmRzY2FuSGVscGVyVGV4dCB7XG4gIGZvbnQtc2l6ZTogdmFyKC0tY2FyZHNjYW4tbWVzc2FnZS1mb250LXNpemUsIDEuMTI1cmVtKTtcbiAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgY29sb3I6IHZhcigtLWNhcmRzY2FuLW1lc3NhZ2UtdGV4dC1jb2xvcik7XG4gIGJhY2tncm91bmQ6IHZhcigtLWNhcmRzY2FuLW1lc3NhZ2UtYmFja2dyb3VuZC1jb2xvciwgIzAwMDAwMCk7XG4gIGJvcmRlci1yYWRpdXM6IDZweDtcbiAgcGFkZGluZzogNnB4O1xuICB3aWR0aDogZml0LWNvbnRlbnQ7XG4gIHRyYW5zaXRpb246IGFsbCAxLjVzIGVhc2U7XG4gIHdoaXRlLXNwYWNlOiBwcmUtbGluZTtcbiAgdGV4dC10cmFuc2Zvcm06IG5vbmU7XG4gIGxpbmUtaGVpZ2h0OiAxLjU7XG4gIHdpZHRoOiBmaXQtY29udGVudDtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cbiNjYXJkc2NhbkhlbHBlclRleHQubW9iaWxlIHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB6LWluZGV4OiAxMDtcbiAgdG9wOiA1MCU7XG4gIG1hcmdpbjogMDtcbiAgbGVmdDogNTAlO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCAtMjUlKTtcbiAgZm9udC1zaXplOiB2YXIoLS1jYXJkc2Nhbi1tZXNzYWdlLWZvbnQtc2l6ZSwgMS4ycmVtKTtcbn1cbiNjYXJkc2NhbkhlbHBlclRleHQuZWxpZ2liaWxpdHlUZXh0Lm1vYmlsZSB7XG4gIHRvcDogMTAwJTtcbiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgMjUlKTtcbn1cbiNjYXJkc2NhbkhlbHBlclRleHQubW9iaWxlTGFuZHNjYXBlIHtcbiAgd2lkdGg6IGF1dG87XG4gIHRvcDogNTAlO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCAtNTAlKTtcbiAgZm9udC1zaXplOiB2YXIoLS1jYXJkc2Nhbi1tZXNzYWdlLWZvbnQtc2l6ZSwgMS4xMjVyZW0pO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG59XG5cbi5jYXJkc2NhblJldHJ5QnV0dG9uIHtcbiAgZm9udC1mYW1pbHk6IFwiUm9ib3RvXCIsIHNhbnMtc2VyaWY7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcbiAgbGV0dGVyLXNwYWNpbmc6IDJweDtcbiAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgdHJhbnNpdGlvbjogYWxsIDAuM3MgZWFzZSAwcztcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBsaW5lLWhlaWdodDogMjJweDtcbiAgYm94LXNoYWRvdzogMHB4IDJweCA0cHggcmdiYSgwLCAwLCAwLCAwLjI1KTtcbiAgcGFkZGluZzogNnB4IDE0cHg7XG4gIGJvcmRlci1yYWRpdXM6IDEzcHg7XG4gIGJvcmRlcjogbm9uZTtcbiAgYmFja2dyb3VuZDogIzZmY2Y5NztcbiAgY29sb3I6ICNkZmRlZGY7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgb3V0bGluZTogbm9uZTtcbn1cblxuLmNhcmRzY2FuUmV0cnlCdXR0b246YWN0aXZlLFxuLmNhcmRzY2FuUmV0cnlCdXR0b246Zm9jdXMge1xuICBvdXRsaW5lOiBub25lO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgycHgsIDJweCk7XG59XG5cbi5jb3JuZXIge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGNvbnRlbnQ6IFwiIFwiO1xuICBib3JkZXItY29sb3I6IHZhcigtLWNhcmRzY2FuLXByb2dyZXNzLWJhci1jb2xvcik7XG4gIGJvcmRlci1zdHlsZTogc29saWQ7XG4gIHdpZHRoOiAyMCU7XG4gIGhlaWdodDogMjAlO1xuICBib3JkZXItcmFkaXVzOiA1cHg7XG4gIHRyYW5zaXRpb246IGJvcmRlci1jb2xvciAwLjVzIGVhc2UsIHdpZHRoIGxpbmVhciAwLjc1cywgaGVpZ2h0IGxpbmVhciAwLjc1cztcbn1cbi5jb3JuZXIuY2FyZHNjYW5Db3JuZXJPZmYge1xuICBib3JkZXItY29sb3I6ICNlM2VhZjQ7XG59XG5cbi5jb3JuZXIxIHtcbiAgdG9wOiAtNnB4O1xuICBsZWZ0OiAtNnB4O1xuICBib3JkZXItd2lkdGg6IDVweCAwIDAgNXB4O1xuICB3aWR0aDogdmFyKC0tY2FyZHNjYW4tY29ybmVyLXdpZHRoKTtcbiAgaGVpZ2h0OiAyMCU7XG59XG5cbi5jb3JuZXIyIHtcbiAgdG9wOiAtNnB4O1xuICByaWdodDogLTZweDtcbiAgYm9yZGVyLXdpZHRoOiA1cHggNXB4IDAgMDtcbiAgaGVpZ2h0OiB2YXIoLS1jYXJkc2Nhbi1jb3JuZXItaGVpZ2h0KTtcbiAgd2lkdGg6IDIwJTtcbn1cblxuLmNvcm5lcjMge1xuICBib3R0b206IC02cHg7XG4gIHJpZ2h0OiAtNnB4O1xuICBib3JkZXItd2lkdGg6IDAgNXB4IDVweCAwO1xuICB3aWR0aDogdmFyKC0tY2FyZHNjYW4tY29ybmVyLXdpZHRoKTtcbiAgaGVpZ2h0OiAyMCU7XG59XG5cbi5jb3JuZXI0IHtcbiAgYm90dG9tOiAtNnB4O1xuICBsZWZ0OiAtNnB4O1xuICBib3JkZXItd2lkdGg6IDAgMCA1cHggNXB4O1xuICBoZWlnaHQ6IHZhcigtLWNhcmRzY2FuLWNvcm5lci1oZWlnaHQpO1xuICB3aWR0aDogMjAlO1xufVxuXG4uY2FyZEd1aWRlIHtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgei1pbmRleDogMjtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBib3gtc2hhZG93OiAwcHggMHB4IDhweCAwcHggcmdiYSgwLCAwLCAwLCAwLjU1KTtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDUwJTtcbiAgbGVmdDogNTAlO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCAtNTAlKTtcbiAgd2lkdGg6IDgxJTtcbiAgaGVpZ2h0OiBhdXRvO1xuICBtaW4td2lkdGg6IGF1dG87XG4gIGFzcGVjdC1yYXRpbzogMTYvOTtcbn1cbkBzdXBwb3J0cyBub3QgKGFzcGVjdC1yYXRpbzogNS8zKSB7XG4gIC5jYXJkR3VpZGU6OmJlZm9yZSB7XG4gICAgZmxvYXQ6IGxlZnQ7XG4gICAgcGFkZGluZy10b3A6IDU2LjI1JTtcbiAgICBjb250ZW50OiBcIlwiO1xuICB9XG4gIC5jYXJkR3VpZGU6YWZ0ZXIge1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIGNvbnRlbnQ6IFwiXCI7XG4gICAgY2xlYXI6IGJvdGg7XG4gIH1cbn1cbi5jYXJkR3VpZGUubW9iaWxlIHtcbiAgYm9yZGVyOiBub25lO1xuICB3aWR0aDogOTUlO1xufVxuLmNhcmRHdWlkZSAucHJvY2Vzc1N0YXR1cyB7XG4gIGRpc3BsYXk6IGJsb2NrO1xufVxuLmNhcmRHdWlkZSAuc3Bpbm5lcldyYXBwZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBoZWlnaHQ6IDgwcHg7XG4gIHdpZHRoOiAxMDAlO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbn1cbi5jYXJkR3VpZGUgLnByb2Nlc3NTdGF0dXMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogNTAlO1xuICB3aWR0aDogMTAwJTtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcbn1cbi5jYXJkR3VpZGUgLnByb2Nlc3NTdGF0dXMgaW1nIHtcbiAgbWF4LXdpZHRoOiA5JTtcbn1cbi5jYXJkR3VpZGUgLnByb2Nlc3NTdGF0dXMgaW1nLm1vYmlsZSB7XG4gIG1heC13aWR0aDogMjAlO1xufVxuXG4uc2NhbkNvbXBsZXRlZCB7XG4gIGJveC1zaGFkb3c6IG5vbmU7XG59XG5cbi5jYXJkR3VpZGVMYW5kc2NhcGUge1xuICBoZWlnaHQ6IGNhbGMoMTAwJSAtIDQwcHgpO1xufVxuXG4uZnJvbnRDYXJkLFxuLmJhY2tDYXJkIHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICBsZWZ0OiA1MCU7XG4gIHRvcDogNTAlO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCAtNTAlKTtcbiAgd2lkdGg6IDEwMHB4O1xuICB0cmFuc2Zvcm0tc3R5bGU6IHByZXNlcnZlLTNkO1xuICAtd2Via2l0LWJhY2tmYWNlLXZpc2liaWxpdHk6IGhpZGRlbjsgLyogU2FmYXJpICovXG4gIGJhY2tmYWNlLXZpc2liaWxpdHk6IGhpZGRlbjtcbn1cblxuLmZyb250Q2FyZCB7XG4gIGFuaW1hdGlvbjogZmxpcEZyb250Q2FyZCA0cyBpbmZpbml0ZTtcbn1cblxuLmJhY2tDYXJkIHtcbiAgYW5pbWF0aW9uOiBmbGlwQmFja0NhcmQgNHMgaW5maW5pdGU7XG59XG5cbkBrZXlmcmFtZXMgZmxpcEZyb250Q2FyZCB7XG4gIDAlIHtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCAtNTAlKSByb3RhdGVZKDBkZWcpO1xuICB9XG4gIDUwJSB7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSkgcm90YXRlWSgxODBkZWcpO1xuICB9XG4gIDEwMCUge1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpIHJvdGF0ZVkoMzYwZGVnKTtcbiAgfVxufVxuQGtleWZyYW1lcyBmbGlwQmFja0NhcmQge1xuICAwJSB7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSkgcm90YXRlWSgxODBkZWcpO1xuICB9XG4gIDUwJSB7XG4gICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSkgcm90YXRlWSgzNjBkZWcpO1xuICB9XG4gIDEwMCUge1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpIHJvdGF0ZVkoNTQwZGVnKTtcbiAgfVxufSJdfQ== */";
var styles$6 = {"cardscanHelperText":"scanFrame-module_cardscanHelperText__BSvel","mobile":"scanFrame-module_mobile__iGA9A","eligibilityText":"scanFrame-module_eligibilityText__WdG-u","mobileLandscape":"scanFrame-module_mobileLandscape__R9O4q","cardscanRetryButton":"scanFrame-module_cardscanRetryButton__4iwA9","corner":"scanFrame-module_corner__S6aVE","cardscanCornerOff":"scanFrame-module_cardscanCornerOff__G373s","corner1":"scanFrame-module_corner1__ouwk5","corner2":"scanFrame-module_corner2__LR0Sj","corner3":"scanFrame-module_corner3__SSofi","corner4":"scanFrame-module_corner4__-rkSZ","cardGuide":"scanFrame-module_cardGuide__41-fv","processStatus":"scanFrame-module_processStatus__Z-dLU","spinnerWrapper":"scanFrame-module_spinnerWrapper__rxkNG","scanCompleted":"scanFrame-module_scanCompleted__mi8R3","cardGuideLandscape":"scanFrame-module_cardGuideLandscape__FZ9pd","frontCard":"scanFrame-module_frontCard__tMSrQ","backCard":"scanFrame-module_backCard__mpdOR","flipFrontCard":"scanFrame-module_flipFrontCard__6qcCG","flipBackCard":"scanFrame-module_flipBackCard__sY6a4"};
styleInject(css_248z$6);

var css_248z$5 = ".webToMobileModal-module_scanErrorModal__lMrJJ{align-items:center;background-color:#f9fbfd;border-radius:16px;box-shadow:0 8px 36px 0 rgba(0,0,0,.161);display:flex;flex-direction:column;height:500px;left:50%;padding:20px;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%);width:550px;z-index:999999}.webToMobileModal-module_scanErrorModal__lMrJJ>*{margin-bottom:16px}.webToMobileModal-module_modalText__aebRU{white-space:break-spaces}.webToMobileModal-module_scanErrorTitle__xn1rc{color:#000;font-size:24px;font-weight:700;text-align:center}.webToMobileModal-module_scanErrorDescription__M7bCV{color:rgba(21,25,32,.5);font-size:18px;font-weight:400;text-align:center}.webToMobileModal-module_scanErrorButton__OT-QR{border:none;border-radius:8px;font-size:14px;font-weight:600;height:42px;min-width:230px}.webToMobileModal-module_scanErrorButtonContainer__DImXw{display:flex;justify-content:space-around;width:100%}.webToMobileModal-module_scanErrorButtonSecondary__ObyA-{background:#fff;border:1px solid #566789;color:rgba(21,25,32,.5)}.webToMobileModal-module_scanErrorButtonPrimary__hqs2M{background-color:#2f80ed;color:#fff}.webToMobileModal-module_processStatus__zcTGi,.webToMobileModal-module_spinnerWrapper__lbMCo{display:block}.webToMobileModal-module_spinnerWrapper__lbMCo{display:flex;height:256px}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles$5 = {"scanErrorModal":"webToMobileModal-module_scanErrorModal__lMrJJ","modalText":"webToMobileModal-module_modalText__aebRU","scanErrorTitle":"webToMobileModal-module_scanErrorTitle__xn1rc","scanErrorDescription":"webToMobileModal-module_scanErrorDescription__M7bCV","scanErrorButton":"webToMobileModal-module_scanErrorButton__OT-QR","scanErrorButtonContainer":"webToMobileModal-module_scanErrorButtonContainer__DImXw","scanErrorButtonSecondary":"webToMobileModal-module_scanErrorButtonSecondary__ObyA-","scanErrorButtonPrimary":"webToMobileModal-module_scanErrorButtonPrimary__hqs2M","spinnerWrapper":"webToMobileModal-module_spinnerWrapper__lbMCo","processStatus":"webToMobileModal-module_processStatus__zcTGi"};
styleInject(css_248z$5);

var lib = {};

var mode$1 = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};

var mode = mode$1;

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

var _8BitByte = QR8bitByte;

var ErrorCorrectLevel = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};

// ErrorCorrectLevel
var ECL = ErrorCorrectLevel;

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
};

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
};

var RSBlock$1 = QRRSBlock;

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

var BitBuffer$1 = QRBitBuffer;

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

var math$2 = QRMath;

var math$1 = math$2;

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math$1.gexp(math$1.glog(this.get(i) ) + math$1.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math$1.glog(this.get(0) ) - math$1.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math$1.gexp(math$1.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

var Polynomial$2 = QRPolynomial;

var Mode = mode$1;
var Polynomial$1 = Polynomial$2;
var math = math$2;

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial$1([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial$1([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

var util$1 = QRUtil;

var BitByte = _8BitByte;
var RSBlock = RSBlock$1;
var BitBuffer = BitBuffer$1;
var util = util$1;
var Polynomial = Polynomial$2;

function QRCode$1(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode$1.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode$1.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode$1.PAD0 = 0xEC;
QRCode$1.PAD1 = 0x11;

QRCode$1.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$1.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$1.PAD1, 8);
	}

	return QRCode$1.createBytes(buffer, rsBlocks);
};

QRCode$1.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

var QRCode_1 = QRCode$1;

var QRCodeSvg$1 = {};

Object.defineProperty(QRCodeSvg$1, "__esModule", {
  value: true
});

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes$1 = propTypes$2.exports;

var _propTypes2$1 = _interopRequireDefault$1(_propTypes$1);

var _react$1 = require$$0__default["default"];

var _react2$1 = _interopRequireDefault$1(_react$1);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes$1 = {
  bgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  bgD: _propTypes2$1.default.string.isRequired,
  fgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  fgD: _propTypes2$1.default.string.isRequired,
  size: _propTypes2$1.default.number.isRequired,
  title: _propTypes2$1.default.string,
  viewBoxSize: _propTypes2$1.default.number.isRequired,
  xmlns: _propTypes2$1.default.string
};

var defaultProps$1 = {
  title: undefined,
  xmlns: "http://www.w3.org/2000/svg"
};

var QRCodeSvg = (0, _react$1.forwardRef)(function (_ref, ref) {
  var bgColor = _ref.bgColor,
      bgD = _ref.bgD,
      fgD = _ref.fgD,
      fgColor = _ref.fgColor,
      size = _ref.size,
      title = _ref.title,
      viewBoxSize = _ref.viewBoxSize,
      props = _objectWithoutProperties$1(_ref, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize"]);

  return _react2$1.default.createElement(
    "svg",
    _extends$1({}, props, { height: size, ref: ref, viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize, width: size }),
    title ? _react2$1.default.createElement(
      "title",
      null,
      title
    ) : null,
    _react2$1.default.createElement("path", { d: bgD, fill: bgColor }),
    _react2$1.default.createElement("path", { d: fgD, fill: fgColor })
  );
});

QRCodeSvg.displayName = "QRCodeSvg";
QRCodeSvg.propTypes = propTypes$1;
QRCodeSvg.defaultProps = defaultProps$1;

QRCodeSvg$1.default = QRCodeSvg;

Object.defineProperty(lib, "__esModule", {
  value: true
});
lib.QRCode = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _QRCode = QRCode_1;

var _QRCode2 = _interopRequireDefault(_QRCode);

var _ErrorCorrectLevel = ErrorCorrectLevel;

var _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel);

var _propTypes = propTypes$2.exports;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require$$0__default["default"];

var _react2 = _interopRequireDefault(_react);

var _QRCodeSvg = QRCodeSvg$1;

var _QRCodeSvg2 = _interopRequireDefault(_QRCodeSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.


var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  level: _propTypes2.default.string,
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
};

var defaultProps = {
  bgColor: "#FFFFFF",
  fgColor: "#000000",
  level: "L",
  size: 256
};

var QRCode = (0, _react.forwardRef)(function (_ref, ref) {
  var bgColor = _ref.bgColor,
      fgColor = _ref.fgColor,
      level = _ref.level,
      size = _ref.size,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["bgColor", "fgColor", "level", "size", "value"]);

  // Use type === -1 to automatically pick the best type.
  var qrcode = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[level]);
  qrcode.addData(value);
  qrcode.make();
  var cells = qrcode.modules;
  return _react2.default.createElement(_QRCodeSvg2.default, _extends({}, props, {
    bgColor: bgColor,
    bgD: cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    fgColor: fgColor,
    fgD: cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    ref: ref,
    size: size,
    viewBoxSize: cells.length
  }));
});

lib.QRCode = QRCode;
QRCode.displayName = "QRCode";
QRCode.propTypes = propTypes;
QRCode.defaultProps = defaultProps;

var _default = lib.default = QRCode;

var WebToMobileModal = function (_a) {
    var enableModel = _a.enableModel, cardScanApi = _a.cardScanApi, webToMobileHandoffConfig = _a.webToMobileHandoffConfig, spinnerOptions = _a.spinnerOptions, backsideSupport = _a.backsideSupport;
    var _b = require$$0.useState(""), webToMobileLink = _b[0], setWebToMobileLink = _b[1];
    var _c = require$$0.useState({
        modalTitle: "Scanning Failed",
        modalText: "Please scan this QR Code to continue scanning on your mobile phone.\nReturn here once successful to continue.",
        buttonText: "Try again",
    }), webToMobileTexts = _c[0], setWebToMobileTexts = _c[1];
    var handleRetryButton = useGlobalContext().handleRetryButton;
    require$$0.useEffect(function () {
        var _a;
        if (enableModel &&
            cardScanApi.current.sessionToken &&
            webToMobileHandoffConfig) {
            (_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.generateMagicLink().then(function (res) {
                var backside = !!backsideSupport;
                setWebToMobileLink("".concat(webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.urlBase, "/?token=").concat(res.data.token, "&companyName=").concat(webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.companyName, "&backsideSupport=").concat(backside));
            }).catch(function (error) {
                GlobalLogger.error("Error generating magic link - ".concat(error));
                //_handleError(error, stateMachineSend, onError);
            });
        }
    }, [enableModel, cardScanApi, webToMobileHandoffConfig, backsideSupport]);
    require$$0.useEffect(function () {
        var texts = __assign$2(__assign$2(__assign$2({}, ((webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.modalText)
            ? { modalText: webToMobileHandoffConfig.modalText }
            : {})), ((webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.modalTitle)
            ? { modalTitle: webToMobileHandoffConfig.modalTitle }
            : {})), ((webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.buttonText)
            ? { buttonText: webToMobileHandoffConfig.buttonText }
            : {}));
        if (Object.keys(texts).length) {
            setWebToMobileTexts(function (prev) { return (__assign$2(__assign$2({}, prev), texts)); });
        }
    }, [webToMobileHandoffConfig]);
    if (!enableModel) {
        return jsxRuntime.jsx(jsxRuntime.Fragment, {});
    }
    return (jsxRuntime.jsxs("div", __assign$2({ className: styles$5.scanErrorModal }, { children: [jsxRuntime.jsx("h2", __assign$2({ className: styles$5.scanErrorTitle }, { children: webToMobileTexts.modalTitle })), jsxRuntime.jsx("p", __assign$2({ className: styles$5.modalText }, { children: webToMobileTexts.modalText })), jsxRuntime.jsx("div", __assign$2({ style: { height: "auto", margin: "20px auto", width: "400" } }, { children: webToMobileLink ? (jsxRuntime.jsx(_default, { style: { height: "auto", maxWidth: "100%", width: "100%" }, value: webToMobileLink, viewBox: "0 0 256 256" })) : (jsxRuntime.jsx("div", __assign$2({ className: styles$5.spinnerWrapper }, { children: jsxRuntime.jsx(dist, __assign$2({}, spinnerOptions)) }))) })), jsxRuntime.jsx("div", __assign$2({ className: styles$5.scanErrorButtonContainer }, { children: jsxRuntime.jsx("button", __assign$2({ className: "".concat(styles$5.scanErrorButton, " ").concat(styles$5.scanErrorButtonPrimary), onClick: handleRetryButton }, { children: webToMobileTexts.buttonText })) }))] })));
};

var ScanFrame = function (_a) {
    var successIndicator = _a.successIndicator, handleRetryButton = _a.handleRetryButton, frameDivRef = _a.frameDivRef, spinnerOptions = _a.spinnerOptions, errorIndicator = _a.errorIndicator, webToMobileHandoffConfig = _a.webToMobileHandoffConfig, cardScanApi = _a.cardScanApi, backsideSupport = _a.backsideSupport;
    var _b = useGlobalContext(), stateMachineState = _b.stateMachineState, showCurtain = _b.showCurtain, isMobile = _b.isMobile, isMobileOnLandscape = _b.isMobileOnLandscape;
    var _c = require$$0.useState(false); _c[0]; var setFlipped = _c[1];
    require$$0.useEffect(function () {
        var interval = setInterval(function () {
            setFlipped(function (f) { return !f; });
        }, 3000);
        return function () { return clearInterval(interval); };
    }, []);
    var shouldShowProgress = [
        "frontsideProcessing",
        "backsideProcessing",
        "autoCapture",
        "manualCapture",
        "backsidePending",
        "eligibilityPending",
        "eligibilityProcessing",
    ].some(stateMachineState.matches);
    var shouldShowRotateToScanBack = stateMachineState.matches("backsidePending") ||
        (stateMachineState.matches("backsideProcessing") &&
            !stateMachineState.context.processing);
    var isPending = ["autoCapture", "manualCapture"].some(stateMachineState.matches);
    var isProcessing = ["frontsideProcessing", "backsideProcessing"].some(stateMachineState.matches) && stateMachineState.context.processing;
    var isProcessingAuto = isProcessing;
    isProcessing &&
        !stateMachineState.context.autoScan &&
        stateMachineState.context.scannerRunning;
    var isErrorOrRetry = ["error", "cameraError", "retry"].some(stateMachineState.matches);
    var greyCorner = ["manualCapture", "backsidePending"].some(stateMachineState.matches) &&
        !stateMachineState.context.autoScan;
    return (jsxRuntime.jsx(jsxRuntime.Fragment, { children: jsxRuntime.jsxs("div", __assign$2({ "data-cy": "cardscanCardGuide", className: "".concat(styles$6.cardGuide, " ").concat(isMobile ? styles$6.mobile : "", " active ").concat(stateMachineState.matches("manualCapture")
                ? "cardscan-card-guide-processing"
                : "", " ").concat(isMobileOnLandscape && "card-guide-landscape", " ").concat(stateMachineState.matches("success") ? styles$6.scanCompleted : ""), ref: frameDivRef }, { children: [!showCurtain && !stateMachineState.context.processing && (jsxRuntime.jsx(ScanSwitch, {})), shouldShowProgress && (jsxRuntime.jsx("div", { className: "\n          ".concat(styles$6.corner, " \n          ").concat(styles$6.corner1, " \n          ").concat(greyCorner ? styles$6.cardscanCornerOff : "", "\n          ").concat(shouldShowProgress ? "cardscan-corner-active" : "") })), shouldShowProgress && (jsxRuntime.jsx("div", { className: "\n          ".concat(styles$6.corner, " \n          ").concat(styles$6.corner2, "\n          ").concat(greyCorner ? styles$6.cardscanCornerOff : "", "\n          ").concat(shouldShowProgress ? "cardscan-corner-active" : "") })), shouldShowProgress && (jsxRuntime.jsx("div", { className: "\n          ".concat(styles$6.corner, " \n          ").concat(styles$6.corner3, "\n          ").concat(greyCorner ? styles$6.cardscanCornerOff : "", "\n          ").concat(shouldShowProgress ? "cardscan-corner-active" : "") })), shouldShowProgress && (jsxRuntime.jsx("div", { className: "".concat(styles$6.corner, "  \n          ").concat(styles$6.corner4, "\n          ").concat(greyCorner ? styles$6.cardscanCornerOff : "", "\n          ").concat(shouldShowProgress ? "cardscan-corner-active" : "") })), stateMachineState.matches("success") && (jsxRuntime.jsxs("div", __assign$2({ className: styles$6.processStatus }, { children: [successIndicator != null ? (successIndicator) : (jsxRuntime.jsx("img", { src: img$6, className: "".concat(isMobile ? styles$6.mobile : "", " ").concat(isMobileOnLandscape ? styles$6.mobileLandscape : ""), alt: "checkmark" })), jsxRuntime.jsx(MobilePortal, __assign$2({ elementId: "mobileTopCurtain" }, { children: jsxRuntime.jsx("p", __assign$2({ "data-cy": "cardscanHelperText", id: styles$6.cardscanHelperText, className: "".concat(isMobile ? styles$6.mobile : "", " ").concat(isMobileOnLandscape ? styles$6.mobileLandscape : "") }, { children: stateMachineState.context.headerTitle })) }))] }))), isErrorOrRetry && (!(webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled) || isMobile) && (jsxRuntime.jsxs("div", __assign$2({ className: styles$6.processStatus }, { children: [errorIndicator != null ? (errorIndicator) : (jsxRuntime.jsx("img", { src: img$5, className: "".concat(styles$6.mobile), alt: "" })), jsxRuntime.jsx(MobilePortal, __assign$2({ elementId: "mobileTopCurtain" }, { children: jsxRuntime.jsx("p", __assign$2({ "data-cy": "cardscanHelperText", id: styles$6.cardscanHelperText, className: "".concat(isMobile ? styles$6.mobile : "", " ").concat(isMobileOnLandscape ? styles$6.mobileLandscape : "") }, { children: stateMachineState.context.headerTitle })) })), stateMachineState.matches("retry") && (jsxRuntime.jsx("div", __assign$2({ className: "".concat(styles$6.cardscanRetryButton, " retryScanBtn"), onClick: handleRetryButton }, { children: "Retry Scan" })))] }))), isErrorOrRetry && !isMobile && (webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled) && (jsxRuntime.jsx(WebToMobileModal, { enableModel: true, cardScanApi: cardScanApi, webToMobileHandoffConfig: webToMobileHandoffConfig, spinnerOptions: spinnerOptions, backsideSupport: backsideSupport })), shouldShowRotateToScanBack && (jsxRuntime.jsxs("div", __assign$2({ className: styles$6.processStatus, style: { top: "70%" } }, { children: [jsxRuntime.jsxs("div", __assign$2({ style: {
                                position: "relative",
                                width: "100%",
                                perspective: 300,
                                marginBottom: 25,
                            } }, { children: [jsxRuntime.jsx("img", { src: img$4, className: styles$6.frontCard, style: { maxWidth: "100px" } }), jsxRuntime.jsx("img", { src: img$3, className: styles$6.backCard, style: { maxWidth: "100px" } })] })), jsxRuntime.jsx(MobilePortal, __assign$2({ elementId: "mobileTopCurtain" }, { children: jsxRuntime.jsx("p", __assign$2({ "data-cy": "cardscanHelperText", id: styles$6.cardscanHelperText, className: "".concat(isMobile ? styles$6.mobile : "", " ").concat(isMobileOnLandscape ? styles$6.mobileLandscape : "") }, { children: stateMachineState.context.headerTitle })) }))] }))), (isProcessingAuto || isPending) && (jsxRuntime.jsx("div", __assign$2({ className: styles$6.processStatus }, { children: jsxRuntime.jsx(MobilePortal, __assign$2({ elementId: "mobileTopCurtain" }, { children: jsxRuntime.jsx("p", __assign$2({ "data-cy": "cardscanHelperText", id: styles$6.cardscanHelperText, className: "".concat(isMobile ? styles$6.mobile : "", " ").concat(isMobileOnLandscape ? styles$6.mobileLandscape : "") }, { children: stateMachineState.context.headerTitle })) })) }))), (stateMachineState.matches("eligibilityProcessing") ||
                    stateMachineState.matches("postProcessing")) && (jsxRuntime.jsxs("div", __assign$2({ className: styles$6.processStatus }, { children: [jsxRuntime.jsx("div", __assign$2({ "data-cy": "cardScanCameraLoading", className: styles$6.spinnerWrapper }, { children: jsxRuntime.jsx(dist, __assign$2({}, spinnerOptions)) })), jsxRuntime.jsx("p", __assign$2({ "data-cy": "cardscanHelperText", id: styles$6.cardscanHelperText, className: " ".concat(styles$6.eligibilityText, " ").concat(isMobile ? styles$6.mobile : "", " ").concat(isMobileOnLandscape ? styles$6.mobileLandscape : "") }, { children: stateMachineState.context.headerTitle }))] })))] })) }));
};

var css_248z$4 = ".scanVideoViewer-module_videoBackground__9LiTo{background-color:#708090;height:100%;min-width:300px;transform:var(--cardscan-video-flip-vertical) var(--cardscan-video-flip-horizontal);width:100%;z-index:2}.scanVideoViewer-module_videoBackground__9LiTo.scanVideoViewer-module_heightFrame__q1B2p{height:unset;max-height:var(--cardscan-video-height);max-width:var(--cardscan-video-width);width:var(--cardscan-app-width)}.scanVideoViewer-module_videoBackground__9LiTo.scanVideoViewer-module_mobile__cJg8K{aspect-ratio:16/9;height:100%;object-fit:contain;width:100%}.scanVideoViewer-module_videoBackground__9LiTo.scanVideoViewer-module_portraitView__W-NRl{aspect-ratio:unset;object-fit:cover}.scanVideoViewer-module_fullScreen__BYoQE{max-width:65vw}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjYW5WaWRlb1ZpZXdlci5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSwrQ0FDRSx3QkFBMkIsQ0FJM0IsV0FBWSxDQUhaLGVBQWdCLENBSWhCLG1GQUFvRixDQUZwRixVQUFXLENBRFgsU0FJRixDQUNBLHlGQUNFLFlBQWEsQ0FDYix1Q0FBd0MsQ0FDeEMscUNBQXNDLENBQ3RDLCtCQUNGLENBQ0Esb0ZBRUUsaUJBQWtCLENBQ2xCLFdBQVksQ0FGWixrQkFBbUIsQ0FHbkIsVUFDRixDQUNBLDBGQUVFLGtCQUFtQixDQURuQixnQkFFRixDQUVBLDBDQUNFLGNBQ0YiLCJmaWxlIjoic2NhblZpZGVvVmlld2VyLm1vZHVsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnZpZGVvQmFja2dyb3VuZCB7XG4gIGJhY2tncm91bmQtY29sb3I6IHNsYXRlZ3JleTtcbiAgbWluLXdpZHRoOiAzMDBweDtcbiAgei1pbmRleDogMjtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbiAgdHJhbnNmb3JtOiB2YXIoLS1jYXJkc2Nhbi12aWRlby1mbGlwLXZlcnRpY2FsKSB2YXIoLS1jYXJkc2Nhbi12aWRlby1mbGlwLWhvcml6b250YWwpO1xufVxuLnZpZGVvQmFja2dyb3VuZC5oZWlnaHRGcmFtZSB7XG4gIGhlaWdodDogdW5zZXQ7XG4gIG1heC1oZWlnaHQ6IHZhcigtLWNhcmRzY2FuLXZpZGVvLWhlaWdodCk7XG4gIG1heC13aWR0aDogdmFyKC0tY2FyZHNjYW4tdmlkZW8td2lkdGgpO1xuICB3aWR0aDogdmFyKC0tY2FyZHNjYW4tYXBwLXdpZHRoKTtcbn1cbi52aWRlb0JhY2tncm91bmQubW9iaWxlIHtcbiAgb2JqZWN0LWZpdDogY29udGFpbjtcbiAgYXNwZWN0LXJhdGlvOiAxNi85O1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xufVxuLnZpZGVvQmFja2dyb3VuZC5wb3J0cmFpdFZpZXcge1xuICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgYXNwZWN0LXJhdGlvOiB1bnNldDtcbn1cblxuLmZ1bGxTY3JlZW4ge1xuICBtYXgtd2lkdGg6IDY1dnc7XG59Il19 */";
var styles$4 = {"videoBackground":"scanVideoViewer-module_videoBackground__9LiTo","heightFrame":"scanVideoViewer-module_heightFrame__q1B2p","mobile":"scanVideoViewer-module_mobile__cJg8K","portraitView":"scanVideoViewer-module_portraitView__W-NRl","fullScreen":"scanVideoViewer-module_fullScreen__BYoQE"};
styleInject(css_248z$4);

var ScanVideoViewer = function (_a) {
    var videoRef = _a.videoRef, setShowErrorModal = _a.setShowErrorModal, stateMachineSend = _a.stateMachineSend, setScanDebugState = _a.setScanDebugState, onError = _a.onError, setVideoMetadata = _a.setVideoMetadata, isMobile = _a.isMobile, isVideoPortrait = _a.isVideoPortrait;
    var initialized = require$$0.useRef(false);
    var _b = useGlobalContext(), stateMachineService = _b.stateMachineService, stateMachineState = _b.stateMachineState;
    var srcObject = require$$0.useRef();
    var getVideo = require$$0.useCallback(function (videoBg) {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            GlobalLogger.error("Video Error - mediaDevices or getUserMedia undefined");
            return Promise.resolve(null);
        }
        var webCamPromise = navigator.mediaDevices
            .getUserMedia({
            audio: false,
            video: {
                width: 1920,
                facingMode: "environment",
            },
        })
            .then(function (stream) {
            setShowErrorModal(false);
            srcObject.current = stream;
            var videoTrack = stream.getVideoTracks().pop();
            var settings = (videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.getSettings()) || {};
            var videoMetadata = {
                videoTrack: settings,
            };
            //only works on chrome powered
            navigator.mediaDevices.enumerateDevices().then(function (devices) {
                var device = devices
                    .filter(function (device) { return device["kind"] === "videoinput"; })
                    .pop();
                var currentDevice = devices.find(function (device) { return device.deviceId === settings.deviceId; });
                if (currentDevice) {
                    videoMetadata.cameraDeviceInfo = currentDevice;
                }
                // getCapabilities won't likely be supported by TS
                // https://github.com/microsoft/TypeScript/issues/45660
                if (device && device.getCapabilities != undefined) {
                    var caps = device.getCapabilities();
                    videoMetadata.cameraCapabilities = caps;
                }
            });
            setVideoMetadata(videoMetadata);
            // //1024x768 or less if video is smaller. If canvas is over 1024 we have GPU memory issues.
            // const captureCanvas = captureCanvasRef.current;
            // if (captureCanvas && settings.width && settings.height) {
            //   captureCanvas.width = Math.min(settings.width, 1024);
            //   captureCanvas.height = Math.min(settings.height, 768);
            // }
            return new Promise(function (resolve) {
                videoBg.onloadedmetadata = function () {
                    resolve(stream);
                };
            });
        })
            .catch(function (error) {
            initialized.current = false;
            if (onError) {
                onError(error);
            }
            stateMachineSend("ERROR");
            return Promise.reject(error);
        });
        return webCamPromise;
    }, [
        onError,
        stateMachineSend,
        setScanDebugState,
        setShowErrorModal,
        setVideoMetadata,
        stateMachineState.context.modelState,
    ]);
    var loadVideo = function () {
        var videoBg = videoRef.current;
        if (videoBg) {
            videoBg.srcObject = srcObject.current;
            var videoPromise_1 = videoBg.play();
            if (videoPromise_1 === undefined) {
                GlobalLogger.error("Video Error - videoPromise undefined");
                initialized.current = false;
                return Promise.reject(new Error("Video promise is undefined"));
            }
            videoPromise_1
                .then(function () {
                stateMachineSend("CAMERA_LOADED");
                setScanDebugState("loading");
                GlobalLogger.debug("Camera Loaded");
                GlobalLogger.log("Video Started");
            })
                .catch(function (error) {
                var err = generateError(error.message, "VideoError", 675);
                GlobalLogger.error("Video Error: ".concat(error.message, " - 675"));
                initialized.current = false;
                if (onError) {
                    onError(err);
                }
                stateMachineSend("ERROR");
            });
        }
    };
    require$$0.useEffect(function () {
        var _a;
        var videoBg = videoRef.current;
        if (videoBg && !initialized.current) {
            initialized.current = true;
            (_a = getVideo(videoBg)) === null || _a === void 0 ? void 0 : _a.then(function (media) {
            }).catch(function (error) {
                var err = generateError(error.message, "VideoError", 677);
                GlobalLogger.error("Video Error: ".concat(error.message, " - 677"));
                initialized.current = false;
                if (onError) {
                    onError(err);
                }
                //Only show error modal when error is a permissions error.
                if (error.name === "NotAllowedError") {
                    setShowErrorModal(true);
                    stateMachineSend("CAMERAERROR");
                    GlobalLogger.debug("Camera Error: Not Allowed");
                }
                else if (error.name === "NotFoundError") {
                    setShowErrorModal(true);
                    stateMachineSend("CAMERAERROR");
                    GlobalLogger.debug("Camera Error: Not Found");
                }
                else {
                    setShowErrorModal(false);
                    stateMachineSend("ERROR");
                    GlobalLogger.debug("Camera Error: Unknown");
                }
            });
        }
    }, [videoRef, getVideo, onError, initialized]);
    require$$0.useEffect(function () {
        var subscription = stateMachineService.subscribe(function (state) {
            var _a;
            if (state.matches("eligibilityProcessing")) {
                (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
            }
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [stateMachineService]);
    require$$0.useEffect(function () {
        if (stateMachineState.context.modelState === "warmed" &&
            videoRef.current &&
            srcObject.current) {
            loadVideo();
            return function () {
                var _a;
                (_a = srcObject.current) === null || _a === void 0 ? void 0 : _a.getTracks().forEach(function (track) {
                    track.stop();
                });
            };
        }
    }, [stateMachineState.context.modelState, videoRef, srcObject.current]);
    return (jsxRuntime.jsx("video", { "data-cy": "cardscanVideo", ref: videoRef, className: "".concat(styles$4.videoBackground, " ").concat(isMobile ? styles$4.mobile : styles$4.fullScreen, " ").concat(isVideoPortrait ? styles$4.portraitView : ""), id: "frame", muted: true, playsInline: true, autoPlay: true }));
};

var img$1 = "data:image/png;base64,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";

var css_248z$3 = ".closeButton-module_closeBtn__XDcux{cursor:pointer;height:28px;position:absolute;right:10px;top:10px;width:28px;z-index:3}@media (min-width:680px){.closeButton-module_closeBtn__XDcux{height:38px;width:38px}}.closeButton-module_closeBtnLandscape__aztsu{height:auto;left:3%;position:fixed;right:auto;top:5%;width:auto}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNsb3NlQnV0dG9uLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLG9DQUlFLGNBQWUsQ0FFZixXQUFZLENBTFosaUJBQWtCLENBRWxCLFVBQVcsQ0FEWCxRQUFTLENBS1QsVUFBVyxDQUZYLFNBR0YsQ0FDQSx5QkFDRSxvQ0FFRSxXQUFZLENBRFosVUFFRixDQUNGLENBRUEsNkNBR0UsV0FBWSxDQUVaLE9BQVEsQ0FKUixjQUFlLENBR2YsVUFBVyxDQUVYLE1BQU8sQ0FKUCxVQUtGIiwiZmlsZSI6ImNsb3NlQnV0dG9uLm1vZHVsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNsb3NlQnRuIHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDEwcHg7XG4gIHJpZ2h0OiAxMHB4O1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIHotaW5kZXg6IDM7XG4gIGhlaWdodDogMjhweDtcbiAgd2lkdGg6IDI4cHg7XG59XG5AbWVkaWEgKG1pbi13aWR0aDogNjgwcHgpIHtcbiAgLmNsb3NlQnRuIHtcbiAgICB3aWR0aDogMzhweDtcbiAgICBoZWlnaHQ6IDM4cHg7XG4gIH1cbn1cblxuLmNsb3NlQnRuTGFuZHNjYXBlIHtcbiAgcG9zaXRpb246IGZpeGVkO1xuICB3aWR0aDogYXV0bztcbiAgaGVpZ2h0OiBhdXRvO1xuICByaWdodDogYXV0bztcbiAgbGVmdDogMyU7XG4gIHRvcDogNSU7XG59Il19 */";
var styles$3 = {"closeBtn":"closeButton-module_closeBtn__XDcux","closeBtnLandscape":"closeButton-module_closeBtnLandscape__aztsu"};
styleInject(css_248z$3);

var CloseButton = function (_a) {
    var onCloseBtn = _a.onCloseBtn, closeButton = _a.closeButton;
    var isMobileOnLandscape = useGlobalContext().isMobileOnLandscape;
    return closeButton != null ? (jsxRuntime.jsx("div", __assign$2({ "data-cy": "closeBtn", onClick: onCloseBtn, className: " ".concat(styles$3.closeBtn, " ").concat(isMobileOnLandscape && styles$3.closeBtnLandscape) }, { children: closeButton }))) : (jsxRuntime.jsx("span", __assign$2({ "data-cy": "closeBtn", onClick: onCloseBtn, className: " ".concat(styles$3.closeBtn, " ").concat(isMobileOnLandscape && styles$3.closeBtnLandscape) }, { children: jsxRuntime.jsx("img", { src: img$1, alt: "", style: { height: "28px", width: "28px" } }) })));
};
CloseButton.propTypes = {
    onCloseBtn: PropTypes.func.isRequired,
    closeButton: PropTypes.bool,
};

var img = "data:image/png;base64,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";

var css_248z$2 = ".cardCapture-module_bottomCurtain__psmrF{background:var(--cardscan-widget-background-color,#000);bottom:0;height:12.5%;position:fixed;width:100%;z-index:8}.cardCapture-module_bottomCurtain__psmrF .cardCapture-module_cameraBtn__bH3O4{cursor:pointer;left:50%;min-width:64px;position:absolute;top:50%;transform:translate(-50%,-50%);width:8%;z-index:3}.cardCapture-module_bottomCurtain__psmrF .cardCapture-module_cameraBtn__bH3O4.cardCapture-module_mobile__vbEI-{height:auto;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:64px}.cardCapture-module_bottomCurtainLandscape__jTj1A{height:100%;position:absolute;right:0;top:0;width:17.5%;z-index:10}.cardCapture-module_bottomCurtainLandscape__jTj1A .cardCapture-module_cameraBtn__bH3O4.cardCapture-module_mobile__vbEI-{height:auto;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:64px}.cardCapture-module_topCurtain__caSuL{background:var(--cardscan-widget-background-color,#000);height:20%;position:fixed;top:0;width:100%;z-index:8}.cardCapture-module_topCurtainLandscape__US-NS{background-color:var(--cardscan-widget-background-color,rgba(0,0,0,.502));height:15%;width:fit-content}.cardCapture-module_cardscanLogo__CxQei{bottom:0;box-sizing:border-box;left:4px;left:0;max-width:135px;position:absolute;top:unset;transform:translateY(-100%);transform:translate(0);z-index:300}.cardCapture-module_cardscanLogoLandscape__pAGr7{-webkit-filter:invert(100%);filter:invert(100%);max-width:90px}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles$2 = {"bottomCurtain":"cardCapture-module_bottomCurtain__psmrF","cameraBtn":"cardCapture-module_cameraBtn__bH3O4","mobile":"cardCapture-module_mobile__vbEI-","bottomCurtainLandscape":"cardCapture-module_bottomCurtainLandscape__jTj1A","topCurtain":"cardCapture-module_topCurtain__caSuL","topCurtainLandscape":"cardCapture-module_topCurtainLandscape__US-NS","cardscanLogo":"cardCapture-module_cardscanLogo__CxQei","cardscanLogoLandscape":"cardCapture-module_cardscanLogoLandscape__pAGr7"};
styleInject(css_248z$2);

var CardCapture = function (_a) {
    var children = _a.children;
    var _b = useGlobalContext(), showCurtain = _b.showCurtain, onCloseBtn = _b.onCloseBtn, closeButton = _b.closeButton, isMobileOnLandscape = _b.isMobileOnLandscape, stateMachineState = _b.stateMachineState, stateMachineSend = _b.stateMachineSend, isMobile = _b.isMobile;
    ["cameraLoading", "autoCapture", "manualCapture"].some(stateMachineState.matches);
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [!showCurtain && (jsxRuntime.jsx(CloseButton, { onCloseBtn: onCloseBtn, closeButton: closeButton })), jsxRuntime.jsxs("div", __assign$2({ className: "".concat(styles$2.topCurtain, " ").concat(isMobileOnLandscape && styles$2.topCurtainLandscape), style: {
                    display: showCurtain ? "block" : "none",
                }, id: "mobileTopCurtain" }, { children: [showCurtain && (jsxRuntime.jsx(CloseButton, { onCloseBtn: onCloseBtn, closeButton: closeButton })), showCurtain && !stateMachineState.context.processing && (jsxRuntime.jsx(ScanSwitch, { isMobile: showCurtain }))] })), children, jsxRuntime.jsx("div", __assign$2({ id: "mobileBottomCurtain", className: isMobileOnLandscape
                    ? styles$2.bottomCurtainLandscape
                    : styles$2.bottomCurtain, style: {
                    display: showCurtain ? "block" : "none",
                } }, { children: !stateMachineState.context.autoScan &&
                    !stateMachineState.context.processing && (jsxRuntime.jsx("img", { "data-cy": "cameraBtn", alt: "button to start the scanning", src: img, className: "".concat(styles$2.cameraBtn, " ").concat(isMobile ? styles$2.mobile : ""), id: "camera-btn", onClick: function () { return stateMachineSend("MANUAL_BUTTON_CLICK"); } })) }))] }));
};

var ScanCanvas = function (_a) {
    var detectionCanvasRef = _a.detectionCanvasRef, captureCanvasRef = _a.captureCanvasRef; _a.videoRefBg; _a.frameDivRef; _a.frameDivDimensions; var videoHeight = _a.videoHeight, videoWidth = _a.videoWidth;
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("canvas", { className: "detectionCanvas", width: DetectorWrapper.image_size, height: DetectorWrapper.image_size, ref: detectionCanvasRef, style: { display: "none" } }), jsxRuntime.jsx("canvas", { className: "captureCanvas", width: videoWidth, height: videoHeight, ref: captureCanvasRef, style: { display: "none" } })] }));
};

var useCustomWidget = function (autoSwitchActiveColor, autoSwitchInactiveColor, progressBarColor, widgetBackgroundColor, messageFontSize, messageTextColor, messageBackgroundColor, cameraOptions) {
    require$$0.useEffect(function () {
        if (messageFontSize) {
            document.documentElement.style.setProperty("--cardscan-message-font-size", messageFontSize);
        }
        if (messageTextColor) {
            document.documentElement.style.setProperty("--cardscan-message-text-color", messageTextColor);
        }
        if (messageBackgroundColor) {
            document.documentElement.style.setProperty("--cardscan-message-background-color", messageBackgroundColor);
        }
        if (widgetBackgroundColor) {
            document.documentElement.style.setProperty("--cardscan-widget-background-color", widgetBackgroundColor);
        }
        if (progressBarColor) {
            document.documentElement.style.setProperty("--cardscan-progress-bar-color", progressBarColor);
        }
        if (autoSwitchActiveColor) {
            document.documentElement.style.setProperty("--cardscan-auto-switch-active-color", autoSwitchActiveColor);
        }
        if (autoSwitchInactiveColor) {
            document.documentElement.style.setProperty("--cardscan-auto-switch-inactive-color", autoSwitchInactiveColor);
        }
        document.documentElement.style.setProperty("--cardscan-video-flip-horizontal", (cameraOptions === null || cameraOptions === void 0 ? void 0 : cameraOptions.flipHorizontal) ? "scaleX(-1)" : "scaleX(1)");
        document.documentElement.style.setProperty("--cardscan-video-flip-vertical", (cameraOptions === null || cameraOptions === void 0 ? void 0 : cameraOptions.flipVertical) ? "scaleY(-1)" : "scaleY(1)");
    }, [
        messageFontSize,
        messageTextColor,
        messageBackgroundColor,
        widgetBackgroundColor,
        progressBarColor,
        autoSwitchActiveColor,
        autoSwitchInactiveColor,
    ]);
};

var useLayoutHeight = function (videoRefBg, isVideoLoading, videoLayoutHeight) {
    require$$0.useEffect(function () {
        if (isVideoLoading)
            return;
        document.documentElement.style.setProperty("--cardscan-video-background-height", videoLayoutHeight ? "".concat(videoLayoutHeight, "px") : "0");
        window.addEventListener("resize", function () {
            document.documentElement.style.setProperty("--cardscan-video-background-height", videoLayoutHeight ? "".concat(videoLayoutHeight, "px") : "0");
        });
    }, [videoRefBg, isVideoLoading, videoLayoutHeight]);
};

var useBufferSize = function (bufferSize) {
    require$$0.useEffect(function () {
        document.documentElement.style.setProperty("--cardscan-buffer-max-size", bufferSize.toString());
    }, [bufferSize]);
    //XXX NLS what is this?
    var bufferInfo = require$$0.useState(4);
    return bufferInfo;
};

var useVideoSizes = function (videoRefBg, setShowCurtain, stateMachineState) {
    var _a, _b;
    require$$0.useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (stateMachineState.matches("cameraLoading"))
            return;
        document.documentElement.style.setProperty("--cardscan-video-width", ((_a = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _a === void 0 ? void 0 : _a.videoWidth)
            ? "".concat((_b = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _b === void 0 ? void 0 : _b.videoWidth.toString(), "px")
            : "0");
        document.documentElement.style.setProperty("--cardscan-video-height", ((_c = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _c === void 0 ? void 0 : _c.videoHeight)
            ? "".concat((_d = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _d === void 0 ? void 0 : _d.videoHeight.toString(), "px")
            : "0");
        if ((((_e = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _e === void 0 ? void 0 : _e.videoWidth) &&
            ((_f = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _f === void 0 ? void 0 : _f.videoWidth) > 2 * window.innerWidth) ||
            isMobile_1) {
            setShowCurtain(true);
            var appHeight = function () {
                var doc = document.documentElement;
                doc.style.setProperty("--cardscan-app-height", "".concat(window.innerHeight, "px"));
                doc.style.setProperty("--cardscan-app-width", "".concat(window.innerWidth, "px"));
            };
            window.addEventListener("resize", appHeight);
            appHeight();
            var videoFrame = document.getElementById("frame");
            videoFrame === null || videoFrame === void 0 ? void 0 : videoFrame.classList.add("heightFrame");
            var cameraButton = document.getElementById("camera-btn");
            cameraButton === null || cameraButton === void 0 ? void 0 : cameraButton.classList.add("heightFrame");
        }
    }, [
        (_a = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _a === void 0 ? void 0 : _a.videoWidth,
        (_b = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _b === void 0 ? void 0 : _b.videoHeight,
        setShowCurtain,
        videoRefBg,
        stateMachineState,
    ]);
};

var useRect = function () {
    var ref = require$$0.useRef(null);
    var _a = require$$0.useState(null), rect = _a[0], setRect = _a[1];
    var set = function () {
        return setRect(ref && ref.current ? ref.current.getBoundingClientRect() : null);
    };
    require$$0.useEffect(function () {
        set();
        window.addEventListener("resize", set);
        return function () { return window.removeEventListener("resize", set); };
    }, []);
    return [rect, ref];
};

var useIsomorphicLayoutEffect = typeof window !== "undefined" ? require$$0.useLayoutEffect : require$$0.useEffect;

function useInterval(callback, delay) {
    var savedCallback = require$$0.useRef(callback);
    // Remember the latest callback if it changes.
    useIsomorphicLayoutEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    require$$0.useEffect(function () {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }
        var id = setInterval(function () { return savedCallback.current(); }, delay);
        return function () { return clearInterval(id); };
    }, [delay]);
}

var withSelector = {exports: {}};

var withSelector_production_min = {};

var shim = {exports: {}};

var useSyncExternalStoreShim_production_min = {};

/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=require$$0__default["default"];function h$1(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h$1,l=e.useState,m=e.useEffect,n$1=e.useLayoutEffect,p$1=e.useDebugValue;function q$1(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n$1(function(){c.value=d;c.getSnapshot=b;r$1(c)&&g({inst:c});},[a,d,b]);m(function(){r$1(c)&&g({inst:c});return a(function(){r$1(c)&&g({inst:c});})},[a]);p$1(d);return d}
function r$1(a){var b=a.getSnapshot;a=a.value;try{var d=b();return !k(a,d)}catch(f){return !0}}function t$1(a,b){return b()}var u$1="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t$1:q$1;useSyncExternalStoreShim_production_min.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u$1;

var useSyncExternalStoreShim_development = {};

/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
if (
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ===
    'function'
) {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
}
          var React = require$$0__default["default"];

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      printWarning('error', format, args);
    }
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    } // eslint-disable-next-line react-internal/safe-string-coercion


    var argsWithFormat = args.map(function (item) {
      return String(item);
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
  ;
}

var objectIs = typeof Object.is === 'function' ? Object.is : is;

// dispatch for CommonJS interop named imports.

var useState = React.useState,
    useEffect = React.useEffect,
    useLayoutEffect = React.useLayoutEffect,
    useDebugValue = React.useDebugValue;
var didWarnOld18Alpha = false;
var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.

function useSyncExternalStore(subscribe, getSnapshot, // Note: The shim does not use getServerSnapshot, because pre-18 versions of
// React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
  {
    if (!didWarnOld18Alpha) {
      if (React.startTransition !== undefined) {
        didWarnOld18Alpha = true;

        error('You are using an outdated, pre-release alpha of React 18 that ' + 'does not support useSyncExternalStore. The ' + 'use-sync-external-store shim will not work correctly. Upgrade ' + 'to a newer pre-release.');
      }
    }
  } // Read the current snapshot from the store on every render. Again, this
  // breaks the rules of React, and only works here because of specific
  // implementation details, most importantly that updates are
  // always synchronous.


  var value = getSnapshot();

  {
    if (!didWarnUncachedGetSnapshot) {
      var cachedValue = getSnapshot();

      if (!objectIs(value, cachedValue)) {
        error('The result of getSnapshot should be cached to avoid an infinite loop');

        didWarnUncachedGetSnapshot = true;
      }
    }
  } // Because updates are synchronous, we don't queue them. Instead we force a
  // re-render whenever the subscribed state changes by updating an some
  // arbitrary useState hook. Then, during render, we call getSnapshot to read
  // the current value.
  //
  // Because we don't actually use the state returned by the useState hook, we
  // can save a bit of memory by storing other stuff in that slot.
  //
  // To implement the early bailout, we need to track some things on a mutable
  // object. Usually, we would put that in a useRef hook, but we can stash it in
  // our useState hook instead.
  //
  // To force a re-render, we call forceUpdate({inst}). That works because the
  // new object always fails an equality check.


  var _useState = useState({
    inst: {
      value: value,
      getSnapshot: getSnapshot
    }
  }),
      inst = _useState[0].inst,
      forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
  // in the layout phase so we can access it during the tearing check that
  // happens on subscribe.


  useLayoutEffect(function () {
    inst.value = value;
    inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
    // commit phase if there was an interleaved mutation. In concurrent mode
    // this can happen all the time, but even in synchronous mode, an earlier
    // effect may have mutated the store.

    if (checkIfSnapshotChanged(inst)) {
      // Force a re-render.
      forceUpdate({
        inst: inst
      });
    }
  }, [subscribe, value, getSnapshot]);
  useEffect(function () {
    // Check for changes right before subscribing. Subsequent changes will be
    // detected in the subscription handler.
    if (checkIfSnapshotChanged(inst)) {
      // Force a re-render.
      forceUpdate({
        inst: inst
      });
    }

    var handleStoreChange = function () {
      // TODO: Because there is no cross-renderer API for batching updates, it's
      // up to the consumer of this library to wrap their subscription event
      // with unstable_batchedUpdates. Should we try to detect when this isn't
      // the case and print a warning in development?
      // The store changed. Check if the snapshot changed since the last time we
      // read from the store.
      if (checkIfSnapshotChanged(inst)) {
        // Force a re-render.
        forceUpdate({
          inst: inst
        });
      }
    }; // Subscribe to the store and return a clean-up function.


    return subscribe(handleStoreChange);
  }, [subscribe]);
  useDebugValue(value);
  return value;
}

function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  var prevValue = inst.value;

  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(prevValue, nextValue);
  } catch (error) {
    return true;
  }
}

function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
  // Note: The shim does not use getServerSnapshot, because pre-18 versions of
  // React do not expose a way to check if we're hydrating. So users of the shim
  // will need to track that themselves and return the correct value
  // from `getSnapshot`.
  return getSnapshot();
}

var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');

var isServerEnvironment = !canUseDOM;

var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
var useSyncExternalStore$2 = React.useSyncExternalStore !== undefined ? React.useSyncExternalStore : shim;

useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
          /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
if (
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ===
    'function'
) {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
}
        
  })();
}

if (process.env.NODE_ENV === 'production') {
  shim.exports = useSyncExternalStoreShim_production_min;
} else {
  shim.exports = useSyncExternalStoreShim_development;
}

/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=require$$0__default["default"],n=shim.exports;function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
withSelector_production_min.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f;}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return [function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d;},[d]);w(d);return d};

var withSelector_development = {};

/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
if (
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ===
    'function'
) {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
}
          var React = require$$0__default["default"];
var shim$1 = shim.exports;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
  ;
}

var objectIs = typeof Object.is === 'function' ? Object.is : is;

var useSyncExternalStore = shim$1.useSyncExternalStore;

// for CommonJS interop.

var useRef = React.useRef,
    useEffect = React.useEffect,
    useMemo = React.useMemo,
    useDebugValue = React.useDebugValue; // Same as useSyncExternalStore, but supports selector and isEqual arguments.

function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
  // Use this to track the rendered snapshot.
  var instRef = useRef(null);
  var inst;

  if (instRef.current === null) {
    inst = {
      hasValue: false,
      value: null
    };
    instRef.current = inst;
  } else {
    inst = instRef.current;
  }

  var _useMemo = useMemo(function () {
    // Track the memoized state using closure variables that are local to this
    // memoized instance of a getSnapshot function. Intentionally not using a
    // useRef hook, because that state would be shared across all concurrent
    // copies of the hook/component.
    var hasMemo = false;
    var memoizedSnapshot;
    var memoizedSelection;

    var memoizedSelector = function (nextSnapshot) {
      if (!hasMemo) {
        // The first time the hook is called, there is no memoized result.
        hasMemo = true;
        memoizedSnapshot = nextSnapshot;

        var _nextSelection = selector(nextSnapshot);

        if (isEqual !== undefined) {
          // Even if the selector has changed, the currently rendered selection
          // may be equal to the new selection. We should attempt to reuse the
          // current value if possible, to preserve downstream memoizations.
          if (inst.hasValue) {
            var currentSelection = inst.value;

            if (isEqual(currentSelection, _nextSelection)) {
              memoizedSelection = currentSelection;
              return currentSelection;
            }
          }
        }

        memoizedSelection = _nextSelection;
        return _nextSelection;
      } // We may be able to reuse the previous invocation's result.


      // We may be able to reuse the previous invocation's result.
      var prevSnapshot = memoizedSnapshot;
      var prevSelection = memoizedSelection;

      if (objectIs(prevSnapshot, nextSnapshot)) {
        // The snapshot is the same as last time. Reuse the previous selection.
        return prevSelection;
      } // The snapshot has changed, so we need to compute a new selection.


      // The snapshot has changed, so we need to compute a new selection.
      var nextSelection = selector(nextSnapshot); // If a custom isEqual function is provided, use that to check if the data
      // has changed. If it hasn't, return the previous selection. That signals
      // to React that the selections are conceptually equal, and we can bail
      // out of rendering.

      // If a custom isEqual function is provided, use that to check if the data
      // has changed. If it hasn't, return the previous selection. That signals
      // to React that the selections are conceptually equal, and we can bail
      // out of rendering.
      if (isEqual !== undefined && isEqual(prevSelection, nextSelection)) {
        return prevSelection;
      }

      memoizedSnapshot = nextSnapshot;
      memoizedSelection = nextSelection;
      return nextSelection;
    }; // Assigning this to a constant so that Flow knows it can't change.


    // Assigning this to a constant so that Flow knows it can't change.
    var maybeGetServerSnapshot = getServerSnapshot === undefined ? null : getServerSnapshot;

    var getSnapshotWithSelector = function () {
      return memoizedSelector(getSnapshot());
    };

    var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? undefined : function () {
      return memoizedSelector(maybeGetServerSnapshot());
    };
    return [getSnapshotWithSelector, getServerSnapshotWithSelector];
  }, [getSnapshot, getServerSnapshot, selector, isEqual]),
      getSelection = _useMemo[0],
      getServerSelection = _useMemo[1];

  var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
  useEffect(function () {
    inst.hasValue = true;
    inst.value = value;
  }, [value]);
  useDebugValue(value);
  return value;
}

withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector;
          /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
if (
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ===
    'function'
) {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
}
        
  })();
}

if (process.env.NODE_ENV === 'production') {
  withSelector.exports = withSelector_production_min;
} else {
  withSelector.exports = withSelector_development;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read$2(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var ActionTypes;

(function (ActionTypes) {
  ActionTypes["Start"] = "xstate.start";
  ActionTypes["Stop"] = "xstate.stop";
  ActionTypes["Raise"] = "xstate.raise";
  ActionTypes["Send"] = "xstate.send";
  ActionTypes["Cancel"] = "xstate.cancel";
  ActionTypes["NullEvent"] = "";
  ActionTypes["Assign"] = "xstate.assign";
  ActionTypes["After"] = "xstate.after";
  ActionTypes["DoneState"] = "done.state";
  ActionTypes["DoneInvoke"] = "done.invoke";
  ActionTypes["Log"] = "xstate.log";
  ActionTypes["Init"] = "xstate.init";
  ActionTypes["Invoke"] = "xstate.invoke";
  ActionTypes["ErrorExecution"] = "error.execution";
  ActionTypes["ErrorCommunication"] = "error.communication";
  ActionTypes["ErrorPlatform"] = "error.platform";
  ActionTypes["ErrorCustom"] = "xstate.error";
  ActionTypes["Update"] = "xstate.update";
  ActionTypes["Pure"] = "xstate.pure";
  ActionTypes["Choose"] = "xstate.choose";
})(ActionTypes || (ActionTypes = {}));

var SpecialTargets;

(function (SpecialTargets) {
  SpecialTargets["Parent"] = "#_parent";
  SpecialTargets["Internal"] = "#_internal";
})(SpecialTargets || (SpecialTargets = {}));

var start$1 = ActionTypes.Start;
var stop$1 = ActionTypes.Stop;
var raise$1 = ActionTypes.Raise;
var send$1 = ActionTypes.Send;
var cancel$1 = ActionTypes.Cancel;
var nullEvent = ActionTypes.NullEvent;
var assign$2 = ActionTypes.Assign;
ActionTypes.After;
ActionTypes.DoneState;
var log = ActionTypes.Log;
var init = ActionTypes.Init;
var invoke = ActionTypes.Invoke;
ActionTypes.ErrorExecution;
var errorPlatform = ActionTypes.ErrorPlatform;
var error$1 = ActionTypes.ErrorCustom;
var update = ActionTypes.Update;
var choose = ActionTypes.Choose;
var pure = ActionTypes.Pure;

var STATE_DELIMITER = '.';
var EMPTY_ACTIVITY_MAP = {};
var DEFAULT_GUARD_TYPE = 'xstate.guard';
var TARGETLESS_KEY = '';

var IS_PRODUCTION = process.env.NODE_ENV === 'production';

var _a;
function matchesState(parentStateId, childStateId, delimiter) {
  if (delimiter === void 0) {
    delimiter = STATE_DELIMITER;
  }

  var parentStateValue = toStateValue(parentStateId, delimiter);
  var childStateValue = toStateValue(childStateId, delimiter);

  if (isString(childStateValue)) {
    if (isString(parentStateValue)) {
      return childStateValue === parentStateValue;
    } // Parent more specific than child


    return false;
  }

  if (isString(parentStateValue)) {
    return parentStateValue in childStateValue;
  }

  return Object.keys(parentStateValue).every(function (key) {
    if (!(key in childStateValue)) {
      return false;
    }

    return matchesState(parentStateValue[key], childStateValue[key]);
  });
}
function getEventType(event) {
  try {
    return isString(event) || typeof event === 'number' ? "".concat(event) : event.type;
  } catch (e) {
    throw new Error('Events must be strings or objects with a string event.type property.');
  }
}
function toStatePath(stateId, delimiter) {
  try {
    if (isArray(stateId)) {
      return stateId;
    }

    return stateId.toString().split(delimiter);
  } catch (e) {
    throw new Error("'".concat(stateId, "' is not a valid state path."));
  }
}
function isStateLike(state) {
  return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
}
function toStateValue(stateValue, delimiter) {
  if (isStateLike(stateValue)) {
    return stateValue.value;
  }

  if (isArray(stateValue)) {
    return pathToStateValue(stateValue);
  }

  if (typeof stateValue !== 'string') {
    return stateValue;
  }

  var statePath = toStatePath(stateValue, delimiter);
  return pathToStateValue(statePath);
}
function pathToStateValue(statePath) {
  if (statePath.length === 1) {
    return statePath[0];
  }

  var value = {};
  var marker = value;

  for (var i = 0; i < statePath.length - 1; i++) {
    if (i === statePath.length - 2) {
      marker[statePath[i]] = statePath[i + 1];
    } else {
      marker[statePath[i]] = {};
      marker = marker[statePath[i]];
    }
  }

  return value;
}
function mapValues(collection, iteratee) {
  var result = {};
  var collectionKeys = Object.keys(collection);

  for (var i = 0; i < collectionKeys.length; i++) {
    var key = collectionKeys[i];
    result[key] = iteratee(collection[key], key, collection, i);
  }

  return result;
}
function mapFilterValues(collection, iteratee, predicate) {
  var e_1, _a;

  var result = {};

  try {
    for (var _b = __values(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var item = collection[key];

      if (!predicate(item)) {
        continue;
      }

      result[key] = iteratee(item, key, collection);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */

var path = function (props) {
  return function (object) {
    var e_2, _a;

    var result = object;

    try {
      for (var props_1 = __values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
        var prop = props_1_1.value;
        result = result[prop];
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return result;
  };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */

function nestedPath(props, accessorProp) {
  return function (object) {
    var e_3, _a;

    var result = object;

    try {
      for (var props_2 = __values(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()) {
        var prop = props_2_1.value;
        result = result[accessorProp][prop];
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    return result;
  };
}
function toStatePaths(stateValue) {
  if (!stateValue) {
    return [[]];
  }

  if (isString(stateValue)) {
    return [[stateValue]];
  }

  var result = flatten(Object.keys(stateValue).map(function (key) {
    var subStateValue = stateValue[key];

    if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) {
      return [[key]];
    }

    return toStatePaths(stateValue[key]).map(function (subPath) {
      return [key].concat(subPath);
    });
  }));
  return result;
}
function flatten(array) {
  var _a;

  return (_a = []).concat.apply(_a, __spreadArray([], __read$2(array), false));
}
function toArrayStrict(value) {
  if (isArray(value)) {
    return value;
  }

  return [value];
}
function toArray(value) {
  if (value === undefined) {
    return [];
  }

  return toArrayStrict(value);
}
function mapContext(mapper, context, _event) {
  var e_5, _a;

  if (isFunction(mapper)) {
    return mapper(context, _event.data);
  }

  var result = {};

  try {
    for (var _b = __values(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var subMapper = mapper[key];

      if (isFunction(subMapper)) {
        result[key] = subMapper(context, _event.data);
      } else {
        result[key] = subMapper;
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_5) throw e_5.error;
    }
  }

  return result;
}
function isBuiltInEvent(eventType) {
  return /^(done|error)\./.test(eventType);
}
function isPromiseLike(value) {
  if (value instanceof Promise) {
    return true;
  } // Check if shape matches the Promise/A+ specification for a "thenable".


  if (value !== null && (isFunction(value) || typeof value === 'object') && isFunction(value.then)) {
    return true;
  }

  return false;
}
function isBehavior(value) {
  return value !== null && typeof value === 'object' && 'transition' in value && typeof value.transition === 'function';
}
function partition(items, predicate) {
  var e_6, _a;

  var _b = __read$2([[], []], 2),
      truthy = _b[0],
      falsy = _b[1];

  try {
    for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
      var item = items_1_1.value;

      if (predicate(item)) {
        truthy.push(item);
      } else {
        falsy.push(item);
      }
    }
  } catch (e_6_1) {
    e_6 = {
      error: e_6_1
    };
  } finally {
    try {
      if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
    } finally {
      if (e_6) throw e_6.error;
    }
  }

  return [truthy, falsy];
}
function updateHistoryStates(hist, stateValue) {
  return mapValues(hist.states, function (subHist, key) {
    if (!subHist) {
      return undefined;
    }

    var subStateValue = (isString(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);

    if (!subStateValue) {
      return undefined;
    }

    return {
      current: subStateValue,
      states: updateHistoryStates(subHist, subStateValue)
    };
  });
}
function updateHistoryValue(hist, stateValue) {
  return {
    current: stateValue,
    states: updateHistoryStates(hist, stateValue)
  };
}
function updateContext(context, _event, assignActions, state) {
  if (!IS_PRODUCTION) {
    warn(!!context, 'Attempting to update undefined context');
  }

  var updatedContext = context ? assignActions.reduce(function (acc, assignAction) {
    var e_7, _a;

    var assignment = assignAction.assignment;
    var meta = {
      state: state,
      action: assignAction,
      _event: _event
    };
    var partialUpdate = {};

    if (isFunction(assignment)) {
      partialUpdate = assignment(acc, _event.data, meta);
    } else {
      try {
        for (var _b = __values(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          var propAssignment = assignment[key];
          partialUpdate[key] = isFunction(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_7) throw e_7.error;
        }
      }
    }

    return Object.assign({}, acc, partialUpdate);
  }, context) : context;
  return updatedContext;
} // tslint:disable-next-line:no-empty

var warn = function () {};

if (!IS_PRODUCTION) {
  warn = function (condition, message) {
    var error = condition instanceof Error ? condition : undefined;

    if (!error && condition) {
      return;
    }

    if (console !== undefined) {
      var args = ["Warning: ".concat(message)];

      if (error) {
        args.push(error);
      } // tslint:disable-next-line:no-console


      console.warn.apply(console, args);
    }
  };
}
function isArray(value) {
  return Array.isArray(value);
} // tslint:disable-next-line:ban-types

function isFunction(value) {
  return typeof value === 'function';
}
function isString(value) {
  return typeof value === 'string';
}
function toGuard(condition, guardMap) {
  if (!condition) {
    return undefined;
  }

  if (isString(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition,
      predicate: guardMap ? guardMap[condition] : undefined
    };
  }

  if (isFunction(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition.name,
      predicate: condition
    };
  }

  return condition;
}
function isObservable(value) {
  try {
    return 'subscribe' in value && isFunction(value.subscribe);
  } catch (e) {
    return false;
  }
}
var symbolObservable = /*#__PURE__*/function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages

(_a = {}, _a[symbolObservable] = function () {
  return this;
}, _a[Symbol.observable] = function () {
  return this;
}, _a);
function isMachine(value) {
  return !!value && '__xstatenode' in value;
}
function isActor$1(value) {
  return !!value && typeof value.send === 'function';
}
function toEventObject(event, payload // id?: TEvent['type']
) {
  if (isString(event) || typeof event === 'number') {
    return __assign$1({
      type: event
    }, payload);
  }

  return event;
}
function toSCXMLEvent(event, scxmlEvent) {
  if (!isString(event) && '$$type' in event && event.$$type === 'scxml') {
    return event;
  }

  var eventObject = toEventObject(event);
  return __assign$1({
    name: eventObject.type,
    data: eventObject,
    $$type: 'scxml',
    type: 'external'
  }, scxmlEvent);
}
function toTransitionConfigArray(event, configLike) {
  var transitions = toArrayStrict(configLike).map(function (transitionLike) {
    if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || isMachine(transitionLike)) {
      return {
        target: transitionLike,
        event: event
      };
    }

    return __assign$1(__assign$1({}, transitionLike), {
      event: event
    });
  });
  return transitions;
}
function normalizeTarget(target) {
  if (target === undefined || target === TARGETLESS_KEY) {
    return undefined;
  }

  return toArray(target);
}
function reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
  if (!IS_PRODUCTION) {
    var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : '';

    if (originalError === currentError) {
      // tslint:disable-next-line:no-console
      console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
    } else {
      var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ''; // tslint:disable-next-line:no-console

      console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
    }
  }
}
function evaluateGuard(machine, guard, context, _event, state) {
  var guards = machine.options.guards;
  var guardMeta = {
    state: state,
    cond: guard,
    _event: _event
  }; // TODO: do not hardcode!

  if (guard.type === DEFAULT_GUARD_TYPE) {
    return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
  }

  var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];

  if (!condFn) {
    throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
  }

  return condFn(context, _event.data, guardMeta);
}
function toInvokeSource$1(src) {
  if (typeof src === 'string') {
    return {
      type: src
    };
  }

  return src;
}
function toObserver(nextHandler, errorHandler, completionHandler) {
  var noop = function () {};

  var isObserver = typeof nextHandler === 'object';
  var self = isObserver ? nextHandler : null;
  return {
    next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
    error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
    complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
  };
}
function createInvokeId(stateNodeId, index) {
  return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function isRaisableAction(action) {
  return (action.type === raise$1 || action.type === send$1 && action.to === SpecialTargets.Internal) && typeof action.delay !== 'number';
}

var initEvent = /*#__PURE__*/toSCXMLEvent({
  type: init
});
function getActionFunction(actionType, actionFunctionMap) {
  return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function toActionObject(action, actionFunctionMap) {
  var actionObject;

  if (isString(action) || typeof action === 'number') {
    var exec = getActionFunction(action, actionFunctionMap);

    if (isFunction(exec)) {
      actionObject = {
        type: action,
        exec: exec
      };
    } else if (exec) {
      actionObject = exec;
    } else {
      actionObject = {
        type: action,
        exec: undefined
      };
    }
  } else if (isFunction(action)) {
    actionObject = {
      // Convert action to string if unnamed
      type: action.name || action.toString(),
      exec: action
    };
  } else {
    var exec = getActionFunction(action.type, actionFunctionMap);

    if (isFunction(exec)) {
      actionObject = __assign$1(__assign$1({}, action), {
        exec: exec
      });
    } else if (exec) {
      var actionType = exec.type || action.type;
      actionObject = __assign$1(__assign$1(__assign$1({}, exec), action), {
        type: actionType
      });
    } else {
      actionObject = action;
    }
  }

  return actionObject;
}
var toActionObjects = function (action, actionFunctionMap) {
  if (!action) {
    return [];
  }

  var actions = isArray(action) ? action : [action];
  return actions.map(function (subAction) {
    return toActionObject(subAction, actionFunctionMap);
  });
};
function toActivityDefinition(action) {
  var actionObject = toActionObject(action);
  return __assign$1(__assign$1({
    id: isString(action) ? action : actionObject.id
  }, actionObject), {
    type: actionObject.type
  });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */

function raise(event, options) {
  return {
    type: raise$1,
    event: typeof event === 'function' ? event : toEventObject(event),
    delay: options ? options.delay : undefined,
    id: options === null || options === void 0 ? void 0 : options.id
  };
}
function resolveRaise(action, ctx, _event, delaysMap) {
  var meta = {
    _event: _event
  };
  var resolvedEvent = toSCXMLEvent(isFunction(action.event) ? action.event(ctx, _event.data, meta) : action.event);
  var resolvedDelay;

  if (isString(action.delay)) {
    var configDelay = delaysMap && delaysMap[action.delay];
    resolvedDelay = isFunction(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = isFunction(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
  }

  return __assign$1(__assign$1({}, action), {
    type: raise$1,
    _event: resolvedEvent,
    delay: resolvedDelay
  });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */

function send(event, options) {
  return {
    to: options ? options.to : undefined,
    type: send$1,
    event: isFunction(event) ? event : toEventObject(event),
    delay: options ? options.delay : undefined,
    // TODO: don't auto-generate IDs here like that
    // there is too big chance of the ID collision
    id: options && options.id !== undefined ? options.id : isFunction(event) ? event.name : getEventType(event)
  };
}
function resolveSend(action, ctx, _event, delaysMap) {
  var meta = {
    _event: _event
  }; // TODO: helper function for resolving Expr

  var resolvedEvent = toSCXMLEvent(isFunction(action.event) ? action.event(ctx, _event.data, meta) : action.event);
  var resolvedDelay;

  if (isString(action.delay)) {
    var configDelay = delaysMap && delaysMap[action.delay];
    resolvedDelay = isFunction(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = isFunction(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
  }

  var resolvedTarget = isFunction(action.to) ? action.to(ctx, _event.data, meta) : action.to;
  return __assign$1(__assign$1({}, action), {
    to: resolvedTarget,
    _event: resolvedEvent,
    event: resolvedEvent.data,
    delay: resolvedDelay
  });
}
var resolveLog = function (action, ctx, _event) {
  return __assign$1(__assign$1({}, action), {
    value: isString(action.expr) ? action.expr : action.expr(ctx, _event.data, {
      _event: _event
    })
  });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */

var cancel = function (sendId) {
  return {
    type: cancel$1,
    sendId: sendId
  };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */

function start(activity) {
  var activityDef = toActivityDefinition(activity);
  return {
    type: ActionTypes.Start,
    activity: activityDef,
    exec: undefined
  };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */

function stop(actorRef) {
  var activity = isFunction(actorRef) ? actorRef : toActivityDefinition(actorRef);
  return {
    type: ActionTypes.Stop,
    activity: activity,
    exec: undefined
  };
}
function resolveStop(action, context, _event) {
  var actorRefOrString = isFunction(action.activity) ? action.activity(context, _event.data) : action.activity;
  var resolvedActorRef = typeof actorRefOrString === 'string' ? {
    id: actorRefOrString
  } : actorRefOrString;
  var actionObject = {
    type: ActionTypes.Stop,
    activity: resolvedActorRef
  };
  return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */

var assign$1 = function (assignment) {
  return {
    type: assign$2,
    assignment: assignment
  };
};
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */

function after(delayRef, id) {
  var idSuffix = id ? "#".concat(id) : '';
  return "".concat(ActionTypes.After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */

function done(id, data) {
  var type = "".concat(ActionTypes.DoneState, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */

function doneInvoke(id, data) {
  var type = "".concat(ActionTypes.DoneInvoke, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}
function error(id, data) {
  var type = "".concat(ActionTypes.ErrorPlatform, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}

var pluckAssigns = function (actionBlocks) {
  var e_1, _a;

  var assignActions = [];

  try {
    for (var actionBlocks_1 = __values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
      var block = actionBlocks_1_1.value;
      var i = 0;

      while (i < block.actions.length) {
        if (block.actions[i].type === assign$2) {
          assignActions.push(block.actions[i]);
          block.actions.splice(i, 1);
          continue;
        }

        i++;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return assignActions;
};

function resolveActions(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
  if (preserveActionOrder === void 0) {
    preserveActionOrder = false;
  }

  var assignActions = preserveActionOrder ? [] : pluckAssigns(actionBlocks);
  var updatedContext = assignActions.length ? updateContext(currentContext, _event, assignActions, currentState) : currentContext;
  var preservedContexts = preserveActionOrder ? [currentContext] : undefined;
  var deferredToBlockEnd = [];

  function handleAction(blockType, actionObject) {
    var _a;

    switch (actionObject.type) {
      case raise$1:
        {
          var raisedAction = resolveRaise(actionObject, updatedContext, _event, machine.options.delays);

          if (predictableExec && typeof raisedAction.delay === 'number') {
            predictableExec(raisedAction, updatedContext, _event);
          }

          return raisedAction;
        }

      case send$1:
        var sendAction = resolveSend(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init

        if (!IS_PRODUCTION) {
          var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here

          warn(!isString(configuredDelay) || typeof sendAction.delay === 'number', // tslint:disable-next-line:max-line-length
          "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
        }

        if (predictableExec && sendAction.to !== SpecialTargets.Internal) {
          if (blockType === 'entry') {
            deferredToBlockEnd.push(sendAction);
          } else {
            predictableExec(sendAction, updatedContext, _event);
          }
        }

        return sendAction;

      case log:
        {
          var resolved = resolveLog(actionObject, updatedContext, _event);
          predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, updatedContext, _event);
          return resolved;
        }

      case choose:
        {
          var chooseAction = actionObject;
          var matchedActions = (_a = chooseAction.conds.find(function (condition) {
            var guard = toGuard(condition.cond, machine.options.guards);
            return !guard || evaluateGuard(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
          })) === null || _a === void 0 ? void 0 : _a.actions;

          if (!matchedActions) {
            return [];
          }

          var _b = __read$2(resolveActions(machine, currentState, updatedContext, _event, [{
            type: blockType,
            actions: toActionObjects(toArray(matchedActions), machine.options.actions)
          }], predictableExec, preserveActionOrder), 2),
              resolvedActionsFromChoose = _b[0],
              resolvedContextFromChoose = _b[1];

          updatedContext = resolvedContextFromChoose;
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          return resolvedActionsFromChoose;
        }

      case pure:
        {
          var matchedActions = actionObject.get(updatedContext, _event.data);

          if (!matchedActions) {
            return [];
          }

          var _c = __read$2(resolveActions(machine, currentState, updatedContext, _event, [{
            type: blockType,
            actions: toActionObjects(toArray(matchedActions), machine.options.actions)
          }], predictableExec, preserveActionOrder), 2),
              resolvedActionsFromPure = _c[0],
              resolvedContext = _c[1];

          updatedContext = resolvedContext;
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          return resolvedActionsFromPure;
        }

      case stop$1:
        {
          var resolved = resolveStop(actionObject, updatedContext, _event);
          predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, currentContext, _event);
          return resolved;
        }

      case assign$2:
        {
          updatedContext = updateContext(updatedContext, _event, [actionObject], !predictableExec ? currentState : undefined);
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          break;
        }

      default:
        var resolvedActionObject = toActionObject(actionObject, machine.options.actions);
        var exec_1 = resolvedActionObject.exec;

        if (predictableExec) {
          predictableExec(resolvedActionObject, updatedContext, _event);
        } else if (exec_1 && preservedContexts) {
          var contextIndex_1 = preservedContexts.length - 1;

          var wrapped = __assign$1(__assign$1({}, resolvedActionObject), {
            exec: function (_ctx) {
              var args = [];

              for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
              }

              exec_1.apply(void 0, __spreadArray([preservedContexts[contextIndex_1]], __read$2(args), false));
            }
          });

          resolvedActionObject = wrapped;
        }

        return resolvedActionObject;
    }
  }

  function processBlock(block) {
    var e_2, _a;

    var resolvedActions = [];

    try {
      for (var _b = __values(block.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
        var action = _c.value;
        var resolved = handleAction(block.type, action);

        if (resolved) {
          resolvedActions = resolvedActions.concat(resolved);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    deferredToBlockEnd.forEach(function (action) {
      predictableExec(action, updatedContext, _event);
    });
    deferredToBlockEnd.length = 0;
    return resolvedActions;
  }

  var resolvedActions = flatten(actionBlocks.map(processBlock));
  return [resolvedActions, updatedContext];
}

/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */
var provide = function (service, fn) {
  var result = fn(service);
  return result;
};

function createNullActor(id) {
  var _a;

  return _a = {
    id: id,
    send: function () {
      return void 0;
    },
    subscribe: function () {
      return {
        unsubscribe: function () {
          return void 0;
        }
      };
    },
    getSnapshot: function () {
      return undefined;
    },
    toJSON: function () {
      return {
        id: id
      };
    }
  }, _a[symbolObservable] = function () {
    return this;
  }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */

function createInvocableActor(invokeDefinition, machine, context, _event) {
  var _a;

  var invokeSrc = toInvokeSource$1(invokeDefinition.src);
  var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
  var resolvedData = invokeDefinition.data ? mapContext(invokeDefinition.data, context, _event) : undefined;
  var tempActor = serviceCreator ? createDeferredActor(serviceCreator, invokeDefinition.id, resolvedData) : createNullActor(invokeDefinition.id); // @ts-ignore

  tempActor.meta = invokeDefinition;
  return tempActor;
}
function createDeferredActor(entity, id, data) {
  var tempActor = createNullActor(id); // @ts-ignore

  tempActor.deferred = true;

  if (isMachine(entity)) {
    // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
    var initialState_1 = tempActor.state = provide(undefined, function () {
      return (data ? entity.withContext(data) : entity).initialState;
    });

    tempActor.getSnapshot = function () {
      return initialState_1;
    };
  }

  return tempActor;
}
function isActor(item) {
  try {
    return typeof item.send === 'function';
  } catch (e) {
    return false;
  }
}
function isSpawnedActor(item) {
  return isActor(item) && 'id' in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now

function toActorRef(actorRefLike) {
  var _a;

  return __assign$1((_a = {
    subscribe: function () {
      return {
        unsubscribe: function () {
          return void 0;
        }
      };
    },
    id: 'anonymous',
    getSnapshot: function () {
      return undefined;
    }
  }, _a[symbolObservable] = function () {
    return this;
  }, _a), actorRefLike);
}

var isLeafNode = function (stateNode) {
  return stateNode.type === 'atomic' || stateNode.type === 'final';
};
function getAllChildren(stateNode) {
  return Object.keys(stateNode.states).map(function (key) {
    return stateNode.states[key];
  });
}
function getChildren(stateNode) {
  return getAllChildren(stateNode).filter(function (sn) {
    return sn.type !== 'history';
  });
}
function getAllStateNodes(stateNode) {
  var stateNodes = [stateNode];

  if (isLeafNode(stateNode)) {
    return stateNodes;
  }

  return stateNodes.concat(flatten(getChildren(stateNode).map(getAllStateNodes)));
}
function getConfiguration(prevStateNodes, stateNodes) {
  var e_1, _a, e_2, _b, e_3, _c, e_4, _d;

  var prevConfiguration = new Set(prevStateNodes);
  var prevAdjList = getAdjList(prevConfiguration);
  var configuration = new Set(stateNodes);

  try {
    // add all ancestors
    for (var configuration_1 = __values(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()) {
      var s = configuration_1_1.value;
      var m = s.parent;

      while (m && !configuration.has(m)) {
        configuration.add(m);
        m = m.parent;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  var adjList = getAdjList(configuration);

  try {
    // add descendants
    for (var configuration_2 = __values(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()) {
      var s = configuration_2_1.value; // if previously active, add existing child nodes

      if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) {
        if (prevAdjList.get(s)) {
          prevAdjList.get(s).forEach(function (sn) {
            return configuration.add(sn);
          });
        } else {
          s.initialStateNodes.forEach(function (sn) {
            return configuration.add(sn);
          });
        }
      } else {
        if (s.type === 'parallel') {
          try {
            for (var _e = (e_3 = void 0, __values(getChildren(s))), _f = _e.next(); !_f.done; _f = _e.next()) {
              var child = _f.value;

              if (!configuration.has(child)) {
                configuration.add(child);

                if (prevAdjList.get(child)) {
                  prevAdjList.get(child).forEach(function (sn) {
                    return configuration.add(sn);
                  });
                } else {
                  child.initialStateNodes.forEach(function (sn) {
                    return configuration.add(sn);
                  });
                }
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
        }
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
    } finally {
      if (e_2) throw e_2.error;
    }
  }

  try {
    // add all ancestors
    for (var configuration_3 = __values(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()) {
      var s = configuration_3_1.value;
      var m = s.parent;

      while (m && !configuration.has(m)) {
        configuration.add(m);
        m = m.parent;
      }
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
    } finally {
      if (e_4) throw e_4.error;
    }
  }

  return configuration;
}

function getValueFromAdj(baseNode, adjList) {
  var childStateNodes = adjList.get(baseNode);

  if (!childStateNodes) {
    return {}; // todo: fix?
  }

  if (baseNode.type === 'compound') {
    var childStateNode = childStateNodes[0];

    if (childStateNode) {
      if (isLeafNode(childStateNode)) {
        return childStateNode.key;
      }
    } else {
      return {};
    }
  }

  var stateValue = {};
  childStateNodes.forEach(function (csn) {
    stateValue[csn.key] = getValueFromAdj(csn, adjList);
  });
  return stateValue;
}

function getAdjList(configuration) {
  var e_5, _a;

  var adjList = new Map();

  try {
    for (var configuration_4 = __values(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()) {
      var s = configuration_4_1.value;

      if (!adjList.has(s)) {
        adjList.set(s, []);
      }

      if (s.parent) {
        if (!adjList.has(s.parent)) {
          adjList.set(s.parent, []);
        }

        adjList.get(s.parent).push(s);
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
    } finally {
      if (e_5) throw e_5.error;
    }
  }

  return adjList;
}
function getValue(rootNode, configuration) {
  var config = getConfiguration([rootNode], configuration);
  return getValueFromAdj(rootNode, getAdjList(config));
}
function has(iterable, item) {
  if (Array.isArray(iterable)) {
    return iterable.some(function (member) {
      return member === item;
    });
  }

  if (iterable instanceof Set) {
    return iterable.has(item);
  }

  return false; // TODO: fix
}
function nextEvents(configuration) {
  return __spreadArray([], __read$2(new Set(flatten(__spreadArray([], __read$2(configuration.map(function (sn) {
    return sn.ownEvents;
  })), false)))), false);
}
function isInFinalState(configuration, stateNode) {
  if (stateNode.type === 'compound') {
    return getChildren(stateNode).some(function (s) {
      return s.type === 'final' && has(configuration, s);
    });
  }

  if (stateNode.type === 'parallel') {
    return getChildren(stateNode).every(function (sn) {
      return isInFinalState(configuration, sn);
    });
  }

  return false;
}
function getMeta(configuration) {
  if (configuration === void 0) {
    configuration = [];
  }

  return configuration.reduce(function (acc, stateNode) {
    if (stateNode.meta !== undefined) {
      acc[stateNode.id] = stateNode.meta;
    }

    return acc;
  }, {});
}
function getTagsFromConfiguration(configuration) {
  return new Set(flatten(configuration.map(function (sn) {
    return sn.tags;
  })));
}

function stateValuesEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a === undefined || b === undefined) {
    return false;
  }

  if (isString(a) || isString(b)) {
    return a === b;
  }

  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  return aKeys.length === bKeys.length && aKeys.every(function (key) {
    return stateValuesEqual(a[key], b[key]);
  });
}
function isStateConfig(state) {
  if (typeof state !== 'object' || state === null) {
    return false;
  }

  return 'value' in state && '_event' in state;
}
function bindActionToState(action, state) {
  var exec = action.exec;

  var boundAction = __assign$1(__assign$1({}, action), {
    exec: exec !== undefined ? function () {
      return exec(state.context, state.event, {
        action: action,
        state: state,
        _event: state._event
      });
    } : undefined
  });

  return boundAction;
}

var State =
/*#__PURE__*/

/** @class */
function () {
  /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */
  function State(config) {
    var _this = this;

    var _a;

    this.actions = [];
    this.activities = EMPTY_ACTIVITY_MAP;
    this.meta = {};
    this.events = [];
    this.value = config.value;
    this.context = config.context;
    this._event = config._event;
    this._sessionid = config._sessionid;
    this.event = this._event.data;
    this.historyValue = config.historyValue;
    this.history = config.history;
    this.actions = config.actions || [];
    this.activities = config.activities || EMPTY_ACTIVITY_MAP;
    this.meta = getMeta(config.configuration);
    this.events = config.events || [];
    this.matches = this.matches.bind(this);
    this.toStrings = this.toStrings.bind(this);
    this.configuration = config.configuration;
    this.transitions = config.transitions;
    this.children = config.children;
    this.done = !!config.done;
    this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
    this.machine = config.machine;
    Object.defineProperty(this, 'nextEvents', {
      get: function () {
        return nextEvents(_this.configuration);
      }
    });
  }
  /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */


  State.from = function (stateValue, context) {
    if (stateValue instanceof State) {
      if (stateValue.context !== context) {
        return new State({
          value: stateValue.value,
          context: context,
          _event: stateValue._event,
          _sessionid: null,
          historyValue: stateValue.historyValue,
          history: stateValue.history,
          actions: [],
          activities: stateValue.activities,
          meta: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        });
      }

      return stateValue;
    }

    var _event = initEvent;
    return new State({
      value: stateValue,
      context: context,
      _event: _event,
      _sessionid: null,
      historyValue: undefined,
      history: undefined,
      actions: [],
      activities: undefined,
      meta: undefined,
      events: [],
      configuration: [],
      transitions: [],
      children: {}
    });
  };
  /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */


  State.create = function (config) {
    return new State(config);
  };
  /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */


  State.inert = function (stateValue, context) {
    if (stateValue instanceof State) {
      if (!stateValue.actions.length) {
        return stateValue;
      }

      var _event = initEvent;
      return new State({
        value: stateValue.value,
        context: context,
        _event: _event,
        _sessionid: null,
        historyValue: stateValue.historyValue,
        history: stateValue.history,
        activities: stateValue.activities,
        configuration: stateValue.configuration,
        transitions: [],
        children: {}
      });
    }

    return State.from(stateValue, context);
  };
  /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */


  State.prototype.toStrings = function (stateValue, delimiter) {
    var _this = this;

    if (stateValue === void 0) {
      stateValue = this.value;
    }

    if (delimiter === void 0) {
      delimiter = '.';
    }

    if (isString(stateValue)) {
      return [stateValue];
    }

    var valueKeys = Object.keys(stateValue);
    return valueKeys.concat.apply(valueKeys, __spreadArray([], __read$2(valueKeys.map(function (key) {
      return _this.toStrings(stateValue[key], delimiter).map(function (s) {
        return key + delimiter + s;
      });
    })), false));
  };

  State.prototype.toJSON = function () {
    var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = __rest$1(_a, ["configuration", "transitions", "tags", "machine"]);

    return __assign$1(__assign$1({}, jsonValues), {
      tags: Array.from(tags)
    });
  };

  State.prototype.matches = function (parentStateValue) {
    return matchesState(parentStateValue, this.value);
  };
  /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */


  State.prototype.hasTag = function (tag) {
    return this.tags.has(tag);
  };
  /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */


  State.prototype.can = function (event) {
    var _a;

    if (IS_PRODUCTION) {
      warn(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
    }

    var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
    return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
    transitionData.transitions.some(function (t) {
      return t.target !== undefined || t.actions.length;
    });
  };

  return State;
}();

var defaultOptions = {
  deferEvents: false
};

var Scheduler =
/*#__PURE__*/

/** @class */
function () {
  function Scheduler(options) {
    this.processingEvent = false;
    this.queue = [];
    this.initialized = false;
    this.options = __assign$1(__assign$1({}, defaultOptions), options);
  }

  Scheduler.prototype.initialize = function (callback) {
    this.initialized = true;

    if (callback) {
      if (!this.options.deferEvents) {
        this.schedule(callback);
        return;
      }

      this.process(callback);
    }

    this.flushEvents();
  };

  Scheduler.prototype.schedule = function (task) {
    if (!this.initialized || this.processingEvent) {
      this.queue.push(task);
      return;
    }

    if (this.queue.length !== 0) {
      throw new Error('Event queue should be empty when it is not processing events');
    }

    this.process(task);
    this.flushEvents();
  };

  Scheduler.prototype.clear = function () {
    this.queue = [];
  };

  Scheduler.prototype.flushEvents = function () {
    var nextCallback = this.queue.shift();

    while (nextCallback) {
      this.process(nextCallback);
      nextCallback = this.queue.shift();
    }
  };

  Scheduler.prototype.process = function (callback) {
    this.processingEvent = true;

    try {
      callback();
    } catch (e) {
      // there is no use to keep the future events
      // as the situation is not anymore the same
      this.clear();
      throw e;
    } finally {
      this.processingEvent = false;
    }
  };

  return Scheduler;
}();

var children = /*#__PURE__*/new Map();
var sessionIdIndex = 0;
var registry = {
  bookId: function () {
    return "x:".concat(sessionIdIndex++);
  },
  register: function (id, actor) {
    children.set(id, actor);
    return id;
  },
  get: function (id) {
    return children.get(id);
  },
  free: function (id) {
    children.delete(id);
  }
};

function getGlobal() {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }

  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof global !== 'undefined') {
    return global;
  }

  if (!IS_PRODUCTION) {
    console.warn('XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues');
  }
}

function getDevTools() {
  var global = getGlobal();

  if (global && '__xstate__' in global) {
    return global.__xstate__;
  }

  return undefined;
}

function registerService(service) {
  if (!getGlobal()) {
    return;
  }

  var devTools = getDevTools();

  if (devTools) {
    devTools.register(service);
  }
}

function spawnBehavior(behavior, options) {
  if (options === void 0) {
    options = {};
  }

  var state = behavior.initialState;
  var observers = new Set();
  var mailbox = [];
  var flushing = false;

  var flush = function () {
    if (flushing) {
      return;
    }

    flushing = true;

    while (mailbox.length > 0) {
      var event_1 = mailbox.shift();
      state = behavior.transition(state, event_1, actorCtx);
      observers.forEach(function (observer) {
        return observer.next(state);
      });
    }

    flushing = false;
  };

  var actor = toActorRef({
    id: options.id,
    send: function (event) {
      mailbox.push(event);
      flush();
    },
    getSnapshot: function () {
      return state;
    },
    subscribe: function (next, handleError, complete) {
      var observer = toObserver(next, handleError, complete);
      observers.add(observer);
      observer.next(state);
      return {
        unsubscribe: function () {
          observers.delete(observer);
        }
      };
    }
  });
  var actorCtx = {
    parent: options.parent,
    self: actor,
    id: options.id || 'anonymous',
    observers: observers
  };
  state = behavior.start ? behavior.start(actorCtx) : state;
  return actor;
}

var DEFAULT_SPAWN_OPTIONS = {
  sync: false,
  autoForward: false
};
var InterpreterStatus;

(function (InterpreterStatus) {
  InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
  InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
  InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})(InterpreterStatus || (InterpreterStatus = {}));

var Interpreter =
/*#__PURE__*/

/** @class */
function () {
  /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */
  function Interpreter(machine, options) {
    if (options === void 0) {
      options = Interpreter.defaultOptions;
    }

    var _this = this;

    this.machine = machine;
    this.delayedEventsMap = {};
    this.listeners = new Set();
    this.contextListeners = new Set();
    this.stopListeners = new Set();
    this.doneListeners = new Set();
    this.eventListeners = new Set();
    this.sendListeners = new Set();
    /**
     * Whether the service is started.
     */

    this.initialized = false;
    this.status = InterpreterStatus.NotStarted;
    this.children = new Map();
    this.forwardTo = new Set();
    this._outgoingQueue = [];
    /**
     * Alias for Interpreter.prototype.start
     */

    this.init = this.start;
    /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */

    this.send = function (event, payload) {
      if (isArray(event)) {
        _this.batch(event);

        return _this.state;
      }

      var _event = toSCXMLEvent(toEventObject(event, payload));

      if (_this.status === InterpreterStatus.Stopped) {
        // do nothing
        if (!IS_PRODUCTION) {
          warn(false, "Event \"".concat(_event.name, "\" was sent to stopped service \"").concat(_this.machine.id, "\". This service has already reached its final state, and will not transition.\nEvent: ").concat(JSON.stringify(_event.data)));
        }

        return _this.state;
      }

      if (_this.status !== InterpreterStatus.Running && !_this.options.deferEvents) {
        throw new Error("Event \"".concat(_event.name, "\" was sent to uninitialized service \"").concat(_this.machine.id // tslint:disable-next-line:max-line-length
        , "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ").concat(JSON.stringify(_event.data)));
      }

      _this.scheduler.schedule(function () {
        // Forward copy of event to child actors
        _this.forward(_event);

        var nextState = _this._nextState(_event);

        _this.update(nextState, _event);
      });

      return _this._state; // TODO: deprecate (should return void)
      // tslint:disable-next-line:semicolon
    };

    this.sendTo = function (event, to, immediate) {
      var isParent = _this.parent && (to === SpecialTargets.Parent || _this.parent.id === to);
      var target = isParent ? _this.parent : isString(to) ? to === SpecialTargets.Internal ? _this : _this.children.get(to) || registry.get(to) : isActor$1(to) ? to : undefined;

      if (!target) {
        if (!isParent) {
          throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
        } // tslint:disable-next-line:no-console


        if (!IS_PRODUCTION) {
          warn(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event.type));
        }

        return;
      }

      if ('machine' in target) {
        // perhaps those events should be rejected in the parent
        // but atm it doesn't have easy access to all of the information that is required to do it reliably
        if (_this.status !== InterpreterStatus.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
        _this.state.done) {
          // Send SCXML events to machines
          var scxmlEvent = __assign$1(__assign$1({}, event), {
            name: event.name === error$1 ? "".concat(error(_this.id)) : event.name,
            origin: _this.sessionId
          });

          if (!immediate && _this.machine.config.predictableActionArguments) {
            _this._outgoingQueue.push([target, scxmlEvent]);
          } else {
            target.send(scxmlEvent);
          }
        }
      } else {
        // Send normal events to other targets
        if (!immediate && _this.machine.config.predictableActionArguments) {
          _this._outgoingQueue.push([target, event.data]);
        } else {
          target.send(event.data);
        }
      }
    };

    this._exec = function (action, context, _event, actionFunctionMap) {
      if (actionFunctionMap === void 0) {
        actionFunctionMap = _this.machine.options.actions;
      }

      var actionOrExec = action.exec || getActionFunction(action.type, actionFunctionMap);
      var exec = isFunction(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;

      if (exec) {
        try {
          return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
            action: action,
            state: _this.state,
            _event: _event
          } : {
            action: action,
            _event: _event
          });
        } catch (err) {
          if (_this.parent) {
            _this.parent.send({
              type: 'xstate.error',
              data: err
            });
          }

          throw err;
        }
      }

      switch (action.type) {
        case raise$1:
          {
            // if raise action reached the interpreter then it's a delayed one
            var sendAction_1 = action;

            _this.defer(sendAction_1);

            break;
          }

        case send$1:
          var sendAction = action;

          if (typeof sendAction.delay === 'number') {
            _this.defer(sendAction);

            return;
          } else {
            if (sendAction.to) {
              _this.sendTo(sendAction._event, sendAction.to, _event === initEvent);
            } else {
              _this.send(sendAction._event);
            }
          }

          break;

        case cancel$1:
          _this.cancel(action.sendId);

          break;

        case start$1:
          {
            if (_this.status !== InterpreterStatus.Running) {
              return;
            }

            var activity = action.activity; // If the activity will be stopped right after it's started
            // (such as in transient states)
            // don't bother starting the activity.

            if ( // in v4 with `predictableActionArguments` invokes are called eagerly when the `this.state` still points to the previous state
            !_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) {
              break;
            } // Invoked services


            if (activity.type === ActionTypes.Invoke) {
              var invokeSource = toInvokeSource$1(activity.src);
              var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
              var id = activity.id,
                  data = activity.data;

              if (!IS_PRODUCTION) {
                warn(!('forward' in activity), // tslint:disable-next-line:max-line-length
                "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
              }

              var autoForward = 'autoForward' in activity ? activity.autoForward : !!activity.forward;

              if (!serviceCreator) {
                // tslint:disable-next-line:no-console
                if (!IS_PRODUCTION) {
                  warn(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                }

                return;
              }

              var resolvedData = data ? mapContext(data, context, _event) : undefined;

              if (typeof serviceCreator === 'string') {
                // TODO: warn
                return;
              }

              var source = isFunction(serviceCreator) ? serviceCreator(context, _event.data, {
                data: resolvedData,
                src: invokeSource,
                meta: activity.meta
              }) : serviceCreator;

              if (!source) {
                // TODO: warn?
                return;
              }

              var options = void 0;

              if (isMachine(source)) {
                source = resolvedData ? source.withContext(resolvedData) : source;
                options = {
                  autoForward: autoForward
                };
              }

              _this.spawn(source, id, options);
            } else {
              _this.spawnActivity(activity);
            }

            break;
          }

        case stop$1:
          {
            _this.stopChild(action.activity.id);

            break;
          }

        case log:
          var _a = action,
              label = _a.label,
              value = _a.value;

          if (label) {
            _this.logger(label, value);
          } else {
            _this.logger(value);
          }

          break;

        default:
          if (!IS_PRODUCTION) {
            warn(false, "No implementation found for action type '".concat(action.type, "'"));
          }

          break;
      }
    };

    var resolvedOptions = __assign$1(__assign$1({}, Interpreter.defaultOptions), options);

    var clock = resolvedOptions.clock,
        logger = resolvedOptions.logger,
        parent = resolvedOptions.parent,
        id = resolvedOptions.id;
    var resolvedId = id !== undefined ? id : machine.id;
    this.id = resolvedId;
    this.logger = logger;
    this.clock = clock;
    this.parent = parent;
    this.options = resolvedOptions;
    this.scheduler = new Scheduler({
      deferEvents: this.options.deferEvents
    });
    this.sessionId = registry.bookId();
  }

  Object.defineProperty(Interpreter.prototype, "initialState", {
    get: function () {
      var _this = this;

      if (this._initialState) {
        return this._initialState;
      }

      return provide(this, function () {
        _this._initialState = _this.machine.initialState;
        return _this._initialState;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Interpreter.prototype, "state", {
    /**
     * @deprecated Use `.getSnapshot()` instead.
     */
    get: function () {
      if (!IS_PRODUCTION) {
        warn(this.status !== InterpreterStatus.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
      }

      return this._state;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */

  Interpreter.prototype.execute = function (state, actionsConfig) {
    var e_1, _a;

    try {
      for (var _b = __values(state.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
        var action = _c.value;
        this.exec(action, state, actionsConfig);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };

  Interpreter.prototype.update = function (state, _event) {
    var e_2, _a, e_3, _b, e_4, _c, e_5, _d;

    var _this = this; // Attach session ID to state


    state._sessionid = this.sessionId; // Update state

    this._state = state; // Execute actions

    if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
    // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
    _event === initEvent) && this.options.execute) {
      this.execute(this.state);
    } else {
      var item = void 0;

      while (item = this._outgoingQueue.shift()) {
        item[0].send(item[1]);
      }
    } // Update children


    this.children.forEach(function (child) {
      _this.state.children[child.id] = child;
    }); // Dev tools

    if (this.devTools) {
      this.devTools.send(_event.data, state);
    } // Execute listeners


    if (state.event) {
      try {
        for (var _e = __values(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()) {
          var listener = _f.value;
          listener(state.event);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }

    try {
      for (var _g = __values(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()) {
        var listener = _h.value;
        listener(state, state.event);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    try {
      for (var _j = __values(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()) {
        var contextListener = _k.value;
        contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    if (this.state.done) {
      // get final child state node
      var finalChildStateNode = state.configuration.find(function (sn) {
        return sn.type === 'final' && sn.parent === _this.machine;
      });
      var doneData = finalChildStateNode && finalChildStateNode.doneData ? mapContext(finalChildStateNode.doneData, state.context, _event) : undefined;
      this._doneEvent = doneInvoke(this.id, doneData);

      try {
        for (var _l = __values(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()) {
          var listener = _m.value;
          listener(this._doneEvent);
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
        } finally {
          if (e_5) throw e_5.error;
        }
      }

      this._stop();

      this._stopChildren();

      registry.free(this.sessionId);
    }
  };
  /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */


  Interpreter.prototype.onTransition = function (listener) {
    this.listeners.add(listener); // Send current state to listener

    if (this.status === InterpreterStatus.Running) {
      listener(this.state, this.state.event);
    }

    return this;
  };

  Interpreter.prototype.subscribe = function (nextListenerOrObserver, _, // TODO: error listener
  completeListener) {
    var _this = this;

    var observer = toObserver(nextListenerOrObserver, _, completeListener);
    this.listeners.add(observer.next); // Send current state to listener

    if (this.status !== InterpreterStatus.NotStarted) {
      observer.next(this.state);
    }

    var completeOnce = function () {
      _this.doneListeners.delete(completeOnce);

      _this.stopListeners.delete(completeOnce);

      observer.complete();
    };

    if (this.status === InterpreterStatus.Stopped) {
      observer.complete();
    } else {
      this.onDone(completeOnce);
      this.onStop(completeOnce);
    }

    return {
      unsubscribe: function () {
        _this.listeners.delete(observer.next);

        _this.doneListeners.delete(completeOnce);

        _this.stopListeners.delete(completeOnce);
      }
    };
  };
  /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */


  Interpreter.prototype.onEvent = function (listener) {
    this.eventListeners.add(listener);
    return this;
  };
  /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */


  Interpreter.prototype.onSend = function (listener) {
    this.sendListeners.add(listener);
    return this;
  };
  /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */


  Interpreter.prototype.onChange = function (listener) {
    this.contextListeners.add(listener);
    return this;
  };
  /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */


  Interpreter.prototype.onStop = function (listener) {
    this.stopListeners.add(listener);
    return this;
  };
  /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */


  Interpreter.prototype.onDone = function (listener) {
    if (this.status === InterpreterStatus.Stopped && this._doneEvent) {
      listener(this._doneEvent);
    } else {
      this.doneListeners.add(listener);
    }

    return this;
  };
  /**
   * Removes a listener.
   * @param listener The listener to remove
   */


  Interpreter.prototype.off = function (listener) {
    this.listeners.delete(listener);
    this.eventListeners.delete(listener);
    this.sendListeners.delete(listener);
    this.stopListeners.delete(listener);
    this.doneListeners.delete(listener);
    this.contextListeners.delete(listener);
    return this;
  };
  /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */


  Interpreter.prototype.start = function (initialState) {
    var _this = this;

    if (this.status === InterpreterStatus.Running) {
      // Do not restart the service if it is already started
      return this;
    } // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
    // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
    // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
    // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)


    this.machine._init();

    registry.register(this.sessionId, this);
    this.initialized = true;
    this.status = InterpreterStatus.Running;
    var resolvedState = initialState === undefined ? this.initialState : provide(this, function () {
      return isStateConfig(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState(State.from(initialState, _this.machine.context));
    });

    if (this.options.devTools) {
      this.attachDev();
    }

    this.scheduler.initialize(function () {
      _this.update(resolvedState, initEvent);
    });
    return this;
  };

  Interpreter.prototype._stopChildren = function () {
    // TODO: think about converting those to actions
    this.children.forEach(function (child) {
      if (isFunction(child.stop)) {
        child.stop();
      }
    });
    this.children.clear();
  };

  Interpreter.prototype._stop = function () {
    var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;

    try {
      for (var _f = __values(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()) {
        var listener = _g.value;
        this.listeners.delete(listener);
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
      } finally {
        if (e_6) throw e_6.error;
      }
    }

    try {
      for (var _h = __values(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()) {
        var listener = _j.value; // call listener, then remove

        listener();
        this.stopListeners.delete(listener);
      }
    } catch (e_7_1) {
      e_7 = {
        error: e_7_1
      };
    } finally {
      try {
        if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
      } finally {
        if (e_7) throw e_7.error;
      }
    }

    try {
      for (var _k = __values(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()) {
        var listener = _l.value;
        this.contextListeners.delete(listener);
      }
    } catch (e_8_1) {
      e_8 = {
        error: e_8_1
      };
    } finally {
      try {
        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
      } finally {
        if (e_8) throw e_8.error;
      }
    }

    try {
      for (var _m = __values(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()) {
        var listener = _o.value;
        this.doneListeners.delete(listener);
      }
    } catch (e_9_1) {
      e_9 = {
        error: e_9_1
      };
    } finally {
      try {
        if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
      } finally {
        if (e_9) throw e_9.error;
      }
    }

    if (!this.initialized) {
      // Interpreter already stopped; do nothing
      return this;
    }

    this.initialized = false;
    this.status = InterpreterStatus.Stopped;
    this._initialState = undefined;

    try {
      // we are going to stop within the current sync frame
      // so we can safely just cancel this here as nothing async should be fired anyway
      for (var _p = __values(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()) {
        var key = _q.value;
        this.clock.clearTimeout(this.delayedEventsMap[key]);
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
      } finally {
        if (e_10) throw e_10.error;
      }
    } // clear everything that might be enqueued


    this.scheduler.clear();
    this.scheduler = new Scheduler({
      deferEvents: this.options.deferEvents
    });
  };
  /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */


  Interpreter.prototype.stop = function () {
    // TODO: add warning for stopping non-root interpreters
    var _this = this; // grab the current scheduler as it will be replaced in _stop


    var scheduler = this.scheduler;

    this._stop(); // let what is currently processed to be finished


    scheduler.schedule(function () {
      var _a;

      if ((_a = _this._state) === null || _a === void 0 ? void 0 : _a.done) {
        return;
      } // it feels weird to handle this here but we need to handle this even slightly "out of band"


      var _event = toSCXMLEvent({
        type: 'xstate.stop'
      });

      var nextState = provide(_this, function () {
        var exitActions = flatten(__spreadArray([], __read$2(_this.state.configuration), false).sort(function (a, b) {
          return b.order - a.order;
        }).map(function (stateNode) {
          return toActionObjects(stateNode.onExit, _this.machine.options.actions);
        }));

        var _a = __read$2(resolveActions(_this.machine, _this.state, _this.state.context, _event, [{
          type: 'exit',
          actions: exitActions
        }], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2),
            resolvedActions = _a[0],
            updatedContext = _a[1];

        var newState = new State({
          value: _this.state.value,
          context: updatedContext,
          _event: _event,
          _sessionid: _this.sessionId,
          historyValue: undefined,
          history: _this.state,
          actions: resolvedActions.filter(function (action) {
            return !isRaisableAction(action);
          }),
          activities: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {},
          done: _this.state.done,
          tags: _this.state.tags,
          machine: _this.machine
        });
        newState.changed = true;
        return newState;
      });

      _this.update(nextState, _event);

      _this._stopChildren();

      registry.free(_this.sessionId);
    });
    return this;
  };

  Interpreter.prototype.batch = function (events) {
    var _this = this;

    if (this.status === InterpreterStatus.NotStarted && this.options.deferEvents) {
      // tslint:disable-next-line:no-console
      if (!IS_PRODUCTION) {
        warn(false, "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\" and are deferred. Make sure .start() is called for this service.\nEvent: ").concat(JSON.stringify(event)));
      }
    } else if (this.status !== InterpreterStatus.Running) {
      throw new Error( // tslint:disable-next-line:max-line-length
      "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options."));
    }

    if (!events.length) {
      return;
    }

    var exec = !!this.machine.config.predictableActionArguments && this._exec;
    this.scheduler.schedule(function () {
      var e_11, _a;

      var nextState = _this.state;
      var batchChanged = false;
      var batchedActions = [];

      var _loop_1 = function (event_1) {
        var _event = toSCXMLEvent(event_1);

        _this.forward(_event);

        nextState = provide(_this, function () {
          return _this.machine.transition(nextState, _event, undefined, exec || undefined);
        });
        batchedActions.push.apply(batchedActions, __spreadArray([], __read$2(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function (a) {
          return bindActionToState(a, nextState);
        })), false));
        batchChanged = batchChanged || !!nextState.changed;
      };

      try {
        for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
          var event_1 = events_1_1.value;

          _loop_1(event_1);
        }
      } catch (e_11_1) {
        e_11 = {
          error: e_11_1
        };
      } finally {
        try {
          if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
        } finally {
          if (e_11) throw e_11.error;
        }
      }

      nextState.changed = batchChanged;
      nextState.actions = batchedActions;

      _this.update(nextState, toSCXMLEvent(events[events.length - 1]));
    });
  };
  /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */


  Interpreter.prototype.sender = function (event) {
    return this.send.bind(this, event);
  };

  Interpreter.prototype._nextState = function (event, exec) {
    var _this = this;

    if (exec === void 0) {
      exec = !!this.machine.config.predictableActionArguments && this._exec;
    }

    var _event = toSCXMLEvent(event);

    if (_event.name.indexOf(errorPlatform) === 0 && !this.state.nextEvents.some(function (nextEvent) {
      return nextEvent.indexOf(errorPlatform) === 0;
    })) {
      throw _event.data.data;
    }

    var nextState = provide(this, function () {
      return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
    });
    return nextState;
  };
  /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */


  Interpreter.prototype.nextState = function (event) {
    return this._nextState(event, false);
  };

  Interpreter.prototype.forward = function (event) {
    var e_12, _a;

    try {
      for (var _b = __values(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()) {
        var id = _c.value;
        var child = this.children.get(id);

        if (!child) {
          throw new Error("Unable to forward event '".concat(event, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
        }

        child.send(event);
      }
    } catch (e_12_1) {
      e_12 = {
        error: e_12_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_12) throw e_12.error;
      }
    }
  };

  Interpreter.prototype.defer = function (sendAction) {
    var _this = this;

    var timerId = this.clock.setTimeout(function () {
      if ('to' in sendAction && sendAction.to) {
        _this.sendTo(sendAction._event, sendAction.to, true);
      } else {
        _this.send(sendAction._event);
      }
    }, sendAction.delay);

    if (sendAction.id) {
      this.delayedEventsMap[sendAction.id] = timerId;
    }
  };

  Interpreter.prototype.cancel = function (sendId) {
    this.clock.clearTimeout(this.delayedEventsMap[sendId]);
    delete this.delayedEventsMap[sendId];
  };

  Interpreter.prototype.exec = function (action, state, actionFunctionMap) {
    if (actionFunctionMap === void 0) {
      actionFunctionMap = this.machine.options.actions;
    }

    this._exec(action, state.context, state._event, actionFunctionMap);
  };

  Interpreter.prototype.removeChild = function (childId) {
    var _a;

    this.children.delete(childId);
    this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
    // such as when a child is added then removed while initializing the state

    (_a = this.state) === null || _a === void 0 ? true : delete _a.children[childId];
  };

  Interpreter.prototype.stopChild = function (childId) {
    var child = this.children.get(childId);

    if (!child) {
      return;
    }

    this.removeChild(childId);

    if (isFunction(child.stop)) {
      child.stop();
    }
  };

  Interpreter.prototype.spawn = function (entity, name, options) {
    if (this.status !== InterpreterStatus.Running) {
      return createDeferredActor(entity, name);
    }

    if (isPromiseLike(entity)) {
      return this.spawnPromise(Promise.resolve(entity), name);
    } else if (isFunction(entity)) {
      return this.spawnCallback(entity, name);
    } else if (isSpawnedActor(entity)) {
      return this.spawnActor(entity, name);
    } else if (isObservable(entity)) {
      return this.spawnObservable(entity, name);
    } else if (isMachine(entity)) {
      return this.spawnMachine(entity, __assign$1(__assign$1({}, options), {
        id: name
      }));
    } else if (isBehavior(entity)) {
      return this.spawnBehavior(entity, name);
    } else {
      throw new Error("Unable to spawn entity \"".concat(name, "\" of type \"").concat(typeof entity, "\"."));
    }
  };

  Interpreter.prototype.spawnMachine = function (machine, options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    var childService = new Interpreter(machine, __assign$1(__assign$1({}, this.options), {
      parent: this,
      id: options.id || machine.id
    }));

    var resolvedOptions = __assign$1(__assign$1({}, DEFAULT_SPAWN_OPTIONS), options);

    if (resolvedOptions.sync) {
      childService.onTransition(function (state) {
        _this.send(update, {
          state: state,
          id: childService.id
        });
      });
    }

    var actor = childService;
    this.children.set(childService.id, actor);

    if (resolvedOptions.autoForward) {
      this.forwardTo.add(childService.id);
    }

    childService.onDone(function (doneEvent) {
      _this.removeChild(childService.id);

      _this.send(toSCXMLEvent(doneEvent, {
        origin: childService.id
      }));
    }).start();
    return actor;
  };

  Interpreter.prototype.spawnBehavior = function (behavior, id) {
    var actorRef = spawnBehavior(behavior, {
      id: id,
      parent: this
    });
    this.children.set(id, actorRef);
    return actorRef;
  };

  Interpreter.prototype.spawnPromise = function (promise, id) {
    var _a;

    var _this = this;

    var canceled = false;
    var resolvedData;
    promise.then(function (response) {
      if (!canceled) {
        resolvedData = response;

        _this.removeChild(id);

        _this.send(toSCXMLEvent(doneInvoke(id, response), {
          origin: id
        }));
      }
    }, function (errorData) {
      if (!canceled) {
        _this.removeChild(id);

        var errorEvent = error(id, errorData);

        try {
          // Send "error.platform.id" to this (parent).
          _this.send(toSCXMLEvent(errorEvent, {
            origin: id
          }));
        } catch (error) {
          reportUnhandledExceptionOnInvocation(errorData, error, id);

          if (_this.devTools) {
            _this.devTools.send(errorEvent, _this.state);
          }

          if (_this.machine.strict) {
            // it would be better to always stop the state machine if unhandled
            // exception/promise rejection happens but because we don't want to
            // break existing code so enforce it on strict mode only especially so
            // because documentation says that onError is optional
            _this.stop();
          }
        }
      }
    });
    var actor = (_a = {
      id: id,
      send: function () {
        return void 0;
      },
      subscribe: function (next, handleError, complete) {
        var observer = toObserver(next, handleError, complete);
        var unsubscribed = false;
        promise.then(function (response) {
          if (unsubscribed) {
            return;
          }

          observer.next(response);

          if (unsubscribed) {
            return;
          }

          observer.complete();
        }, function (err) {
          if (unsubscribed) {
            return;
          }

          observer.error(err);
        });
        return {
          unsubscribe: function () {
            return unsubscribed = true;
          }
        };
      },
      stop: function () {
        canceled = true;
      },
      toJSON: function () {
        return {
          id: id
        };
      },
      getSnapshot: function () {
        return resolvedData;
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnCallback = function (callback, id) {
    var _a;

    var _this = this;

    var canceled = false;
    var receivers = new Set();
    var listeners = new Set();
    var emitted;

    var receive = function (e) {
      emitted = e;
      listeners.forEach(function (listener) {
        return listener(e);
      });

      if (canceled) {
        return;
      }

      _this.send(toSCXMLEvent(e, {
        origin: id
      }));
    };

    var callbackStop;

    try {
      callbackStop = callback(receive, function (newListener) {
        receivers.add(newListener);
      });
    } catch (err) {
      this.send(error(id, err));
    }

    if (isPromiseLike(callbackStop)) {
      // it turned out to be an async function, can't reliably check this before calling `callback`
      // because transpiled async functions are not recognizable
      return this.spawnPromise(callbackStop, id);
    }

    var actor = (_a = {
      id: id,
      send: function (event) {
        return receivers.forEach(function (receiver) {
          return receiver(event);
        });
      },
      subscribe: function (next) {
        var observer = toObserver(next);
        listeners.add(observer.next);
        return {
          unsubscribe: function () {
            listeners.delete(observer.next);
          }
        };
      },
      stop: function () {
        canceled = true;

        if (isFunction(callbackStop)) {
          callbackStop();
        }
      },
      toJSON: function () {
        return {
          id: id
        };
      },
      getSnapshot: function () {
        return emitted;
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnObservable = function (source, id) {
    var _a;

    var _this = this;

    var emitted;
    var subscription = source.subscribe(function (value) {
      emitted = value;

      _this.send(toSCXMLEvent(value, {
        origin: id
      }));
    }, function (err) {
      _this.removeChild(id);

      _this.send(toSCXMLEvent(error(id, err), {
        origin: id
      }));
    }, function () {
      _this.removeChild(id);

      _this.send(toSCXMLEvent(doneInvoke(id), {
        origin: id
      }));
    });
    var actor = (_a = {
      id: id,
      send: function () {
        return void 0;
      },
      subscribe: function (next, handleError, complete) {
        return source.subscribe(next, handleError, complete);
      },
      stop: function () {
        return subscription.unsubscribe();
      },
      getSnapshot: function () {
        return emitted;
      },
      toJSON: function () {
        return {
          id: id
        };
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnActor = function (actor, name) {
    this.children.set(name, actor);
    return actor;
  };

  Interpreter.prototype.spawnActivity = function (activity) {
    var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;

    if (!implementation) {
      if (!IS_PRODUCTION) {
        warn(false, "No implementation found for activity '".concat(activity.type, "'"));
      } // tslint:disable-next-line:no-console


      return;
    } // Start implementation


    var dispose = implementation(this.state.context, activity);
    this.spawnEffect(activity.id, dispose);
  };

  Interpreter.prototype.spawnEffect = function (id, dispose) {
    var _a;

    this.children.set(id, (_a = {
      id: id,
      send: function () {
        return void 0;
      },
      subscribe: function () {
        return {
          unsubscribe: function () {
            return void 0;
          }
        };
      },
      stop: dispose || undefined,
      getSnapshot: function () {
        return undefined;
      },
      toJSON: function () {
        return {
          id: id
        };
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a));
  };

  Interpreter.prototype.attachDev = function () {
    var global = getGlobal();

    if (this.options.devTools && global) {
      if (global.__REDUX_DEVTOOLS_EXTENSION__) {
        var devToolsOptions = typeof this.options.devTools === 'object' ? this.options.devTools : undefined;
        this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect(__assign$1(__assign$1({
          name: this.id,
          autoPause: true,
          stateSanitizer: function (state) {
            return {
              value: state.value,
              context: state.context,
              actions: state.actions
            };
          }
        }, devToolsOptions), {
          features: __assign$1({
            jump: false,
            skip: false
          }, devToolsOptions ? devToolsOptions.features : undefined)
        }), this.machine);
        this.devTools.init(this.state);
      } // add XState-specific dev tooling hook


      registerService(this);
    }
  };

  Interpreter.prototype.toJSON = function () {
    return {
      id: this.id
    };
  };

  Interpreter.prototype[symbolObservable] = function () {
    return this;
  };

  Interpreter.prototype.getSnapshot = function () {
    if (this.status === InterpreterStatus.NotStarted) {
      return this.initialState;
    }

    return this._state;
  };
  /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */


  Interpreter.defaultOptions = {
    execute: true,
    deferEvents: true,
    clock: {
      setTimeout: function (fn, ms) {
        return setTimeout(fn, ms);
      },
      clearTimeout: function (id) {
        return clearTimeout(id);
      }
    },
    logger: /*#__PURE__*/console.log.bind(console),
    devTools: false
  };
  Interpreter.interpret = interpret;
  return Interpreter;
}();
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */

function interpret(machine, options) {
  var interpreter = new Interpreter(machine, options);
  return interpreter;
}

function toInvokeSource(src) {
  if (typeof src === 'string') {
    var simpleSrc = {
      type: src
    };

    simpleSrc.toString = function () {
      return src;
    }; // v4 compat - TODO: remove in v5


    return simpleSrc;
  }

  return src;
}
function toInvokeDefinition(invokeConfig) {
  return __assign$1(__assign$1({
    type: invoke
  }, invokeConfig), {
    toJSON: function () {
      invokeConfig.onDone;
          invokeConfig.onError;
          var invokeDef = __rest$1(invokeConfig, ["onDone", "onError"]);

      return __assign$1(__assign$1({}, invokeDef), {
        type: invoke,
        src: toInvokeSource(invokeConfig.src)
      });
    }
  });
}

var NULL_EVENT = '';
var STATE_IDENTIFIER = '#';
var WILDCARD = '*';
var EMPTY_OBJECT = {};

var isStateId = function (str) {
  return str[0] === STATE_IDENTIFIER;
};

var createDefaultOptions = function () {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
};

var validateArrayifiedTransitions = function (stateNode, event, transitions) {
  var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function (transition) {
    return !('cond' in transition) && !('in' in transition) && (isString(transition.target) || isMachine(transition.target));
  });
  var eventText = event === NULL_EVENT ? 'the transient event' : "event '".concat(event, "'");
  warn(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};

var StateNode =
/*#__PURE__*/

/** @class */
function () {
  function StateNode(
  /**
   * The raw config used to create the machine.
   */
  config, options,
  /**
   * The initial extended state
   */
  _context, // TODO: this is unsafe, but we're removing it in v5 anyway
  _stateInfo) {
    if (_context === void 0) {
      _context = 'context' in config ? config.context : undefined;
    }

    var _this = this;

    var _a;

    this.config = config;
    this._context = _context;
    /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */

    this.order = -1;
    this.__xstatenode = true;
    this.__cache = {
      events: undefined,
      relativeValue: new Map(),
      initialStateValue: undefined,
      initialState: undefined,
      on: undefined,
      transitions: undefined,
      candidates: {},
      delayedTransitions: undefined
    };
    this.idMap = {};
    this.tags = [];
    this.options = Object.assign(createDefaultOptions(), options);
    this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
    this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || '(machine)';
    this.machine = this.parent ? this.parent.machine : this;
    this.path = this.parent ? this.parent.path.concat(this.key) : [];
    this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : STATE_DELIMITER);
    this.id = this.config.id || __spreadArray([this.machine.key], __read$2(this.path), false).join(this.delimiter);
    this.version = this.parent ? this.parent.version : this.config.version;
    this.type = this.config.type || (this.config.parallel ? 'parallel' : this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
    this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
    this.description = this.config.description;

    if (!IS_PRODUCTION) {
      warn(!('parallel' in this.config), "The \"parallel\" property is deprecated and will be removed in version 4.1. ".concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
    }

    this.initial = this.config.initial;
    this.states = this.config.states ? mapValues(this.config.states, function (stateConfig, key) {
      var _a;

      var stateNode = new StateNode(stateConfig, {}, undefined, {
        parent: _this,
        key: key
      });
      Object.assign(_this.idMap, __assign$1((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
      return stateNode;
    }) : EMPTY_OBJECT; // Document order

    var order = 0;

    function dfs(stateNode) {
      var e_1, _a;

      stateNode.order = order++;

      try {
        for (var _b = __values(getAllChildren(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          dfs(child);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }

    dfs(this); // History config

    this.history = this.config.history === true ? 'shallow' : this.config.history || false;
    this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function (_a) {
      var event = _a.event;
      return event === NULL_EVENT;
    }) : NULL_EVENT in this.config.on);
    this.strict = !!this.config.strict; // TODO: deprecate (entry)

    this.onEntry = toArray(this.config.entry || this.config.onEntry).map(function (action) {
      return toActionObject(action);
    }); // TODO: deprecate (exit)

    this.onExit = toArray(this.config.exit || this.config.onExit).map(function (action) {
      return toActionObject(action);
    });
    this.meta = this.config.meta;
    this.doneData = this.type === 'final' ? this.config.data : undefined;
    this.invoke = toArray(this.config.invoke).map(function (invokeConfig, i) {
      var _a, _b;

      if (isMachine(invokeConfig)) {
        var invokeId = createInvokeId(_this.id, i);
        _this.machine.options.services = __assign$1((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
        return toInvokeDefinition({
          src: invokeId,
          id: invokeId
        });
      } else if (isString(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i);
        return toInvokeDefinition(__assign$1(__assign$1({}, invokeConfig), {
          id: invokeId,
          src: invokeConfig.src
        }));
      } else if (isMachine(invokeConfig.src) || isFunction(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i);
        _this.machine.options.services = __assign$1((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
        return toInvokeDefinition(__assign$1(__assign$1({
          id: invokeId
        }, invokeConfig), {
          src: invokeId
        }));
      } else {
        var invokeSource = invokeConfig.src;
        return toInvokeDefinition(__assign$1(__assign$1({
          id: createInvokeId(_this.id, i)
        }, invokeConfig), {
          src: invokeSource
        }));
      }
    });
    this.activities = toArray(this.config.activities).concat(this.invoke).map(function (activity) {
      return toActivityDefinition(activity);
    });
    this.transition = this.transition.bind(this);
    this.tags = toArray(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
  }

  StateNode.prototype._init = function () {
    if (this.__cache.transitions) {
      return;
    }

    getAllStateNodes(this).forEach(function (stateNode) {
      return stateNode.on;
    });
  };
  /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */


  StateNode.prototype.withConfig = function (options, context) {
    var _a = this.options,
        actions = _a.actions,
        activities = _a.activities,
        guards = _a.guards,
        services = _a.services,
        delays = _a.delays;
    return new StateNode(this.config, {
      actions: __assign$1(__assign$1({}, actions), options.actions),
      activities: __assign$1(__assign$1({}, activities), options.activities),
      guards: __assign$1(__assign$1({}, guards), options.guards),
      services: __assign$1(__assign$1({}, services), options.services),
      delays: __assign$1(__assign$1({}, delays), options.delays)
    }, context !== null && context !== void 0 ? context : this.context);
  };
  /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */


  StateNode.prototype.withContext = function (context) {
    return new StateNode(this.config, this.options, context);
  };

  Object.defineProperty(StateNode.prototype, "context", {
    get: function () {
      return isFunction(this._context) ? this._context() : this._context;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "definition", {
    /**
     * The well-structured state node definition.
     */
    get: function () {
      return {
        id: this.id,
        key: this.key,
        version: this.version,
        context: this.context,
        type: this.type,
        initial: this.initial,
        history: this.history,
        states: mapValues(this.states, function (state) {
          return state.definition;
        }),
        on: this.on,
        transitions: this.transitions,
        entry: this.onEntry,
        exit: this.onExit,
        activities: this.activities || [],
        meta: this.meta,
        order: this.order || -1,
        data: this.doneData,
        invoke: this.invoke,
        description: this.description,
        tags: this.tags
      };
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.toJSON = function () {
    return this.definition;
  };

  Object.defineProperty(StateNode.prototype, "on", {
    /**
     * The mapping of events to transitions.
     */
    get: function () {
      if (this.__cache.on) {
        return this.__cache.on;
      }

      var transitions = this.transitions;
      return this.__cache.on = transitions.reduce(function (map, transition) {
        map[transition.eventType] = map[transition.eventType] || [];
        map[transition.eventType].push(transition);
        return map;
      }, {});
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "after", {
    get: function () {
      return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "transitions", {
    /**
     * All the transitions that can be taken from this state node.
     */
    get: function () {
      return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.getCandidates = function (eventName) {
    if (this.__cache.candidates[eventName]) {
      return this.__cache.candidates[eventName];
    }

    var transient = eventName === NULL_EVENT;
    var candidates = this.transitions.filter(function (transition) {
      var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions

      return transient ? sameEventType : sameEventType || transition.eventType === WILDCARD;
    });
    this.__cache.candidates[eventName] = candidates;
    return candidates;
  };
  /**
   * All delayed transitions from the config.
   */


  StateNode.prototype.getDelayedTransitions = function () {
    var _this = this;

    var afterConfig = this.config.after;

    if (!afterConfig) {
      return [];
    }

    var mutateEntryExit = function (delay, i) {
      var delayRef = isFunction(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
      var eventType = after(delayRef, _this.id);

      _this.onEntry.push(send(eventType, {
        delay: delay
      }));

      _this.onExit.push(cancel(eventType));

      return eventType;
    };

    var delayedTransitions = isArray(afterConfig) ? afterConfig.map(function (transition, i) {
      var eventType = mutateEntryExit(transition.delay, i);
      return __assign$1(__assign$1({}, transition), {
        event: eventType
      });
    }) : flatten(Object.keys(afterConfig).map(function (delay, i) {
      var configTransition = afterConfig[delay];
      var resolvedTransition = isString(configTransition) ? {
        target: configTransition
      } : configTransition;
      var resolvedDelay = !isNaN(+delay) ? +delay : delay;
      var eventType = mutateEntryExit(resolvedDelay, i);
      return toArray(resolvedTransition).map(function (transition) {
        return __assign$1(__assign$1({}, transition), {
          event: eventType,
          delay: resolvedDelay
        });
      });
    }));
    return delayedTransitions.map(function (delayedTransition) {
      var delay = delayedTransition.delay;
      return __assign$1(__assign$1({}, _this.formatTransition(delayedTransition)), {
        delay: delay
      });
    });
  };
  /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */


  StateNode.prototype.getStateNodes = function (state) {
    var _a;

    var _this = this;

    if (!state) {
      return [];
    }

    var stateValue = state instanceof State ? state.value : toStateValue(state, this.delimiter);

    if (isString(stateValue)) {
      var initialStateValue = this.getStateNode(stateValue).initial;
      return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [this, this.states[stateValue]];
    }

    var subStateKeys = Object.keys(stateValue);
    var subStateNodes = [this];
    subStateNodes.push.apply(subStateNodes, __spreadArray([], __read$2(flatten(subStateKeys.map(function (subStateKey) {
      return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
    }))), false));
    return subStateNodes;
  };
  /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */


  StateNode.prototype.handles = function (event) {
    var eventType = getEventType(event);
    return this.events.includes(eventType);
  };
  /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */


  StateNode.prototype.resolveState = function (state) {
    var stateFromConfig = state instanceof State ? state : State.create(state);
    var configuration = Array.from(getConfiguration([], this.getStateNodes(stateFromConfig.value)));
    return new State(__assign$1(__assign$1({}, stateFromConfig), {
      value: this.resolve(stateFromConfig.value),
      configuration: configuration,
      done: isInFinalState(configuration, this),
      tags: getTagsFromConfiguration(configuration),
      machine: this.machine
    }));
  };

  StateNode.prototype.transitionLeafNode = function (stateValue, state, _event) {
    var stateNode = this.getStateNode(stateValue);
    var next = stateNode.next(state, _event);

    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }

    return next;
  };

  StateNode.prototype.transitionCompoundNode = function (stateValue, state, _event) {
    var subStateKeys = Object.keys(stateValue);
    var stateNode = this.getStateNode(subStateKeys[0]);

    var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);

    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }

    return next;
  };

  StateNode.prototype.transitionParallelNode = function (stateValue, state, _event) {
    var e_2, _a;

    var transitionMap = {};

    try {
      for (var _b = __values(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var subStateKey = _c.value;
        var subStateValue = stateValue[subStateKey];

        if (!subStateValue) {
          continue;
        }

        var subStateNode = this.getStateNode(subStateKey);

        var next = subStateNode._transition(subStateValue, state, _event);

        if (next) {
          transitionMap[subStateKey] = next;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    var stateTransitions = Object.keys(transitionMap).map(function (key) {
      return transitionMap[key];
    });
    var enabledTransitions = flatten(stateTransitions.map(function (st) {
      return st.transitions;
    }));
    var willTransition = stateTransitions.some(function (st) {
      return st.transitions.length > 0;
    });

    if (!willTransition) {
      return this.next(state, _event);
    }

    var configuration = flatten(Object.keys(transitionMap).map(function (key) {
      return transitionMap[key].configuration;
    }));
    return {
      transitions: enabledTransitions,
      exitSet: flatten(stateTransitions.map(function (t) {
        return t.exitSet;
      })),
      configuration: configuration,
      source: state,
      actions: flatten(Object.keys(transitionMap).map(function (key) {
        return transitionMap[key].actions;
      }))
    };
  };

  StateNode.prototype._transition = function (stateValue, state, _event) {
    // leaf node
    if (isString(stateValue)) {
      return this.transitionLeafNode(stateValue, state, _event);
    } // hierarchical node


    if (Object.keys(stateValue).length === 1) {
      return this.transitionCompoundNode(stateValue, state, _event);
    } // orthogonal node


    return this.transitionParallelNode(stateValue, state, _event);
  };

  StateNode.prototype.getTransitionData = function (state, event) {
    return this._transition(state.value, state, toSCXMLEvent(event));
  };

  StateNode.prototype.next = function (state, _event) {
    var e_3, _a;

    var _this = this;

    var eventName = _event.name;
    var actions = [];
    var nextStateNodes = [];
    var selectedTransition;

    try {
      for (var _b = __values(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var candidate = _c.value;
        var cond = candidate.cond,
            stateIn = candidate.in;
        var resolvedContext = state.context;
        var isInState = stateIn ? isString(stateIn) && isStateId(stateIn) ? // Check if in state by ID
        state.matches(toStateValue(this.getStateNodeById(stateIn).path, this.delimiter)) : // Check if in state by relative grandparent
        matchesState(toStateValue(stateIn, this.delimiter), path(this.path.slice(0, -2))(state.value)) : true;
        var guardPassed = false;

        try {
          guardPassed = !cond || evaluateGuard(this.machine, cond, resolvedContext, _event, state);
        } catch (err) {
          throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
        }

        if (guardPassed && isInState) {
          if (candidate.target !== undefined) {
            nextStateNodes = candidate.target;
          }

          actions.push.apply(actions, __spreadArray([], __read$2(candidate.actions), false));
          selectedTransition = candidate;
          break;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    if (!selectedTransition) {
      return undefined;
    }

    if (!nextStateNodes.length) {
      return {
        transitions: [selectedTransition],
        exitSet: [],
        configuration: state.value ? [this] : [],
        source: state,
        actions: actions
      };
    }

    var allNextStateNodes = flatten(nextStateNodes.map(function (stateNode) {
      return _this.getRelativeStateNodes(stateNode, state.historyValue);
    }));
    var isInternal = !!selectedTransition.internal;
    return {
      transitions: [selectedTransition],
      exitSet: isInternal ? [] : flatten(nextStateNodes.map(function (targetNode) {
        return _this.getPotentiallyReenteringNodes(targetNode);
      })),
      configuration: allNextStateNodes,
      source: state,
      actions: actions
    };
  }; // even though the name of this function mentions reentry nodes
  // we are pushing its result into `exitSet`
  // that's because what we exit might be reentered (it's an invariant of reentrancy)


  StateNode.prototype.getPotentiallyReenteringNodes = function (targetNode) {
    if (this.order < targetNode.order) {
      return [this];
    }

    var nodes = [];
    var marker = this;
    var possibleAncestor = targetNode;

    while (marker && marker !== possibleAncestor) {
      nodes.push(marker);
      marker = marker.parent;
    }

    if (marker !== possibleAncestor) {
      // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
      // it's in a different part of the tree so no states will be reentered for such an external transition
      return [];
    }

    nodes.push(possibleAncestor);
    return nodes;
  };

  StateNode.prototype.getActions = function (resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
    var e_4, _a, e_5, _b;

    var _this = this;

    var prevConfig = prevState ? getConfiguration([], this.getStateNodes(prevState.value)) : [];
    var entrySet = new Set();

    try {
      for (var _c = __values(Array.from(resolvedConfig).sort(function (a, b) {
        return a.order - b.order;
      })), _d = _c.next(); !_d.done; _d = _c.next()) {
        var sn = _d.value;

        if (!has(prevConfig, sn) || has(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) {
          entrySet.add(sn);
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    try {
      for (var prevConfig_1 = __values(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()) {
        var sn = prevConfig_1_1.value;

        if (!has(resolvedConfig, sn) || has(transition.exitSet, sn.parent)) {
          transition.exitSet.push(sn);
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
      } finally {
        if (e_5) throw e_5.error;
      }
    }

    transition.exitSet.sort(function (a, b) {
      return b.order - a.order;
    });
    var entryStates = Array.from(entrySet).sort(function (a, b) {
      return a.order - b.order;
    });
    var exitStates = new Set(transition.exitSet);
    var doneEvents = flatten(entryStates.map(function (sn) {
      var events = [];

      if (sn.type !== 'final') {
        return events;
      }

      var parent = sn.parent;

      if (!parent.parent) {
        return events;
      }

      events.push(done(sn.id, sn.doneData), // TODO: deprecate - final states should not emit done events for their own state.
      done(parent.id, sn.doneData ? mapContext(sn.doneData, currentContext, _event) : undefined));
      var grandparent = parent.parent;

      if (grandparent.type === 'parallel') {
        if (getChildren(grandparent).every(function (parentNode) {
          return isInFinalState(transition.configuration, parentNode);
        })) {
          events.push(done(grandparent.id));
        }
      }

      return events;
    }));
    var entryActions = entryStates.map(function (stateNode) {
      var entryActions = stateNode.onEntry;
      var invokeActions = stateNode.activities.map(function (activity) {
        return start(activity);
      });
      return {
        type: 'entry',
        actions: toActionObjects(predictableExec ? __spreadArray(__spreadArray([], __read$2(entryActions), false), __read$2(invokeActions), false) : __spreadArray(__spreadArray([], __read$2(invokeActions), false), __read$2(entryActions), false), _this.machine.options.actions)
      };
    }).concat({
      type: 'state_done',
      actions: doneEvents.map(function (event) {
        return raise(event);
      })
    });
    var exitActions = Array.from(exitStates).map(function (stateNode) {
      return {
        type: 'exit',
        actions: toActionObjects(__spreadArray(__spreadArray([], __read$2(stateNode.onExit), false), __read$2(stateNode.activities.map(function (activity) {
          return stop(activity);
        })), false), _this.machine.options.actions)
      };
    });
    var actions = exitActions.concat({
      type: 'transition',
      actions: toActionObjects(transition.actions, this.machine.options.actions)
    }).concat(entryActions);

    if (isDone) {
      var stopActions = toActionObjects(flatten(__spreadArray([], __read$2(resolvedConfig), false).sort(function (a, b) {
        return b.order - a.order;
      }).map(function (stateNode) {
        return stateNode.onExit;
      })), this.machine.options.actions).filter(function (action) {
        return !isRaisableAction(action);
      });
      return actions.concat({
        type: 'stop',
        actions: stopActions
      });
    }

    return actions;
  };
  /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */


  StateNode.prototype.transition = function (state, event, context, exec) {
    if (state === void 0) {
      state = this.initialState;
    }

    var _event = toSCXMLEvent(event);

    var currentState;

    if (state instanceof State) {
      currentState = context === undefined ? state : this.resolveState(State.from(state, context));
    } else {
      var resolvedStateValue = isString(state) ? this.resolve(pathToStateValue(this.getResolvedPath(state))) : this.resolve(state);
      var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
      currentState = this.resolveState(State.from(resolvedStateValue, resolvedContext));
    }

    if (!IS_PRODUCTION && _event.name === WILDCARD) {
      throw new Error("An event cannot have the wildcard type ('".concat(WILDCARD, "')"));
    }

    if (this.strict) {
      if (!this.events.includes(_event.name) && !isBuiltInEvent(_event.name)) {
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
      }
    }

    var stateTransition = this._transition(currentState.value, currentState, _event) || {
      transitions: [],
      configuration: [],
      exitSet: [],
      source: currentState,
      actions: []
    };
    var prevConfig = getConfiguration([], this.getStateNodes(currentState.value));
    var resolvedConfig = stateTransition.configuration.length ? getConfiguration(prevConfig, stateTransition.configuration) : prevConfig;
    stateTransition.configuration = __spreadArray([], __read$2(resolvedConfig), false);
    return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
  };

  StateNode.prototype.resolveRaisedTransition = function (state, _event, originalEvent, predictableExec) {
    var _a;

    var currentActions = state.actions;
    state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
    // TODO: this should be the raised event! Delete in V5 (breaking)

    state._event = originalEvent;
    state.event = originalEvent.data;

    (_a = state.actions).unshift.apply(_a, __spreadArray([], __read$2(currentActions), false));

    return state;
  };

  StateNode.prototype.resolveTransition = function (stateTransition, currentState, context, predictableExec, _event) {
    var e_6, _a, e_7, _b;

    var _this = this;

    if (_event === void 0) {
      _event = initEvent;
    }

    var configuration = stateTransition.configuration; // Transition will "apply" if:
    // - this is the initial state (there is no current state)
    // - OR there are transitions

    var willTransition = !currentState || stateTransition.transitions.length > 0;
    var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
    var isDone = isInFinalState(resolvedConfiguration, this);
    var resolvedStateValue = willTransition ? getValue(this.machine, configuration) : undefined;
    var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
    var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
    var activities = currentState ? __assign$1({}, currentState.activities) : {};

    try {
      for (var actionBlocks_1 = __values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
        var block = actionBlocks_1_1.value;

        try {
          for (var _c = (e_7 = void 0, __values(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var action = _d.value;

            if (action.type === start$1) {
              activities[action.activity.id || action.activity.type] = action;
            } else if (action.type === stop$1) {
              activities[action.activity.id || action.activity.type] = false;
            }
          }
        } catch (e_7_1) {
          e_7 = {
            error: e_7_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
          } finally {
            if (e_7) throw e_7.error;
          }
        }
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
      } finally {
        if (e_6) throw e_6.error;
      }
    }

    var _e = __read$2(resolveActions(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2),
        resolvedActions = _e[0],
        updatedContext = _e[1];

    var _f = __read$2(partition(resolvedActions, isRaisableAction), 2),
        raisedEvents = _f[0],
        nonRaisedActions = _f[1];

    var invokeActions = resolvedActions.filter(function (action) {
      var _a;

      return action.type === start$1 && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === invoke;
    });
    var children = invokeActions.reduce(function (acc, action) {
      acc[action.activity.id] = createInvocableActor(action.activity, _this.machine, updatedContext, _event);
      return acc;
    }, currentState ? __assign$1({}, currentState.children) : {});
    var nextState = new State({
      value: resolvedStateValue || currentState.value,
      context: updatedContext,
      _event: _event,
      // Persist _sessionid between states
      _sessionid: currentState ? currentState._sessionid : null,
      historyValue: resolvedStateValue ? historyValue ? updateHistoryValue(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
      history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
      actions: resolvedStateValue ? nonRaisedActions : [],
      activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
      events: [],
      configuration: resolvedConfiguration,
      transitions: stateTransition.transitions,
      children: children,
      done: isDone,
      tags: getTagsFromConfiguration(resolvedConfiguration),
      machine: this
    });
    var didUpdateContext = context !== updatedContext;
    nextState.changed = _event.name === update || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks

    var history = nextState.history;

    if (history) {
      delete history.history;
    } // There are transient transitions if the machine is not in a final state
    // and if some of the state nodes have transient ("always") transitions.


    var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function (stateNode) {
      return stateNode._transient;
    })); // If there are no enabled transitions, check if there are transient transitions.
    // If there are transient transitions, continue checking for more transitions
    // because an transient transition should be triggered even if there are no
    // enabled transitions.
    //
    // If we're already working on an transient transition then stop to prevent an infinite loop.
    //
    // Otherwise, if there are no enabled nor transient transitions, we are done.

    if (!willTransition && (!hasAlwaysTransitions || _event.name === NULL_EVENT)) {
      return nextState;
    }

    var maybeNextState = nextState;

    if (!isDone) {
      if (hasAlwaysTransitions) {
        maybeNextState = this.resolveRaisedTransition(maybeNextState, {
          type: nullEvent
        }, _event, predictableExec);
      }

      while (raisedEvents.length) {
        var raisedEvent = raisedEvents.shift();
        maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
      }
    } // Detect if state changed


    var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !stateValuesEqual(maybeNextState.value, history.value) : undefined);
    maybeNextState.changed = changed; // Preserve original history after raised events

    maybeNextState.history = history;
    return maybeNextState;
  };
  /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */


  StateNode.prototype.getStateNode = function (stateKey) {
    if (isStateId(stateKey)) {
      return this.machine.getStateNodeById(stateKey);
    }

    if (!this.states) {
      throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
    }

    var result = this.states[stateKey];

    if (!result) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }

    return result;
  };
  /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */


  StateNode.prototype.getStateNodeById = function (stateId) {
    var resolvedStateId = isStateId(stateId) ? stateId.slice(STATE_IDENTIFIER.length) : stateId;

    if (resolvedStateId === this.id) {
      return this;
    }

    var stateNode = this.machine.idMap[resolvedStateId];

    if (!stateNode) {
      throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
    }

    return stateNode;
  };
  /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */


  StateNode.prototype.getStateNodeByPath = function (statePath) {
    if (typeof statePath === 'string' && isStateId(statePath)) {
      try {
        return this.getStateNodeById(statePath.slice(1));
      } catch (e) {// try individual paths
        // throw e;
      }
    }

    var arrayStatePath = toStatePath(statePath, this.delimiter).slice();
    var currentStateNode = this;

    while (arrayStatePath.length) {
      var key = arrayStatePath.shift();

      if (!key.length) {
        break;
      }

      currentStateNode = currentStateNode.getStateNode(key);
    }

    return currentStateNode;
  };
  /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */


  StateNode.prototype.resolve = function (stateValue) {
    var _a;

    var _this = this;

    if (!stateValue) {
      return this.initialStateValue || EMPTY_OBJECT; // TODO: type-specific properties
    }

    switch (this.type) {
      case 'parallel':
        return mapValues(this.initialStateValue, function (subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : EMPTY_OBJECT;
        });

      case 'compound':
        if (isString(stateValue)) {
          var subStateNode = this.getStateNode(stateValue);

          if (subStateNode.type === 'parallel' || subStateNode.type === 'compound') {
            return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
          }

          return stateValue;
        }

        if (!Object.keys(stateValue).length) {
          return this.initialStateValue || {};
        }

        return mapValues(stateValue, function (subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : EMPTY_OBJECT;
        });

      default:
        return stateValue || EMPTY_OBJECT;
    }
  };

  StateNode.prototype.getResolvedPath = function (stateIdentifier) {
    if (isStateId(stateIdentifier)) {
      var stateNode = this.machine.idMap[stateIdentifier.slice(STATE_IDENTIFIER.length)];

      if (!stateNode) {
        throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
      }

      return stateNode.path;
    }

    return toStatePath(stateIdentifier, this.delimiter);
  };

  Object.defineProperty(StateNode.prototype, "initialStateValue", {
    get: function () {
      var _a;

      if (this.__cache.initialStateValue) {
        return this.__cache.initialStateValue;
      }

      var initialStateValue;

      if (this.type === 'parallel') {
        initialStateValue = mapFilterValues(this.states, function (state) {
          return state.initialStateValue || EMPTY_OBJECT;
        }, function (stateNode) {
          return !(stateNode.type === 'history');
        });
      } else if (this.initial !== undefined) {
        if (!this.states[this.initial]) {
          throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
        }

        initialStateValue = isLeafNode(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
      } else {
        // The finite state value of a machine without child states is just an empty object
        initialStateValue = {};
      }

      this.__cache.initialStateValue = initialStateValue;
      return this.__cache.initialStateValue;
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.getInitialState = function (stateValue, context) {
    this._init(); // TODO: this should be in the constructor (see note in constructor)


    var configuration = this.getStateNodes(stateValue);
    return this.resolveTransition({
      configuration: configuration,
      exitSet: [],
      transitions: [],
      source: undefined,
      actions: []
    }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
  };

  Object.defineProperty(StateNode.prototype, "initialState", {
    /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */
    get: function () {
      var initialStateValue = this.initialStateValue;

      if (!initialStateValue) {
        throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
      }

      return this.getInitialState(initialStateValue);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "target", {
    /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */
    get: function () {
      var target;

      if (this.type === 'history') {
        var historyConfig = this.config;

        if (isString(historyConfig.target)) {
          target = isStateId(historyConfig.target) ? pathToStateValue(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
        } else {
          target = historyConfig.target;
        }
      }

      return target;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */

  StateNode.prototype.getRelativeStateNodes = function (relativeStateId, historyValue, resolve) {
    if (resolve === void 0) {
      resolve = true;
    }

    return resolve ? relativeStateId.type === 'history' ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [relativeStateId];
  };

  Object.defineProperty(StateNode.prototype, "initialStateNodes", {
    get: function () {
      var _this = this;

      if (isLeafNode(this)) {
        return [this];
      } // Case when state node is compound but no initial state is defined


      if (this.type === 'compound' && !this.initial) {
        if (!IS_PRODUCTION) {
          warn(false, "Compound state node '".concat(this.id, "' has no initial state."));
        }

        return [this];
      }

      var initialStateNodePaths = toStatePaths(this.initialStateValue);
      return flatten(initialStateNodePaths.map(function (initialPath) {
        return _this.getFromRelativePath(initialPath);
      }));
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */

  StateNode.prototype.getFromRelativePath = function (relativePath) {
    if (!relativePath.length) {
      return [this];
    }

    var _a = __read$2(relativePath),
        stateKey = _a[0],
        childStatePath = _a.slice(1);

    if (!this.states) {
      throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
    }

    var childStateNode = this.getStateNode(stateKey);

    if (childStateNode.type === 'history') {
      return childStateNode.resolveHistory();
    }

    if (!this.states[stateKey]) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }

    return this.states[stateKey].getFromRelativePath(childStatePath);
  };

  StateNode.prototype.historyValue = function (relativeStateValue) {
    if (!Object.keys(this.states).length) {
      return undefined;
    }

    return {
      current: relativeStateValue || this.initialStateValue,
      states: mapFilterValues(this.states, function (stateNode, key) {
        if (!relativeStateValue) {
          return stateNode.historyValue();
        }

        var subStateValue = isString(relativeStateValue) ? undefined : relativeStateValue[key];
        return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
      }, function (stateNode) {
        return !stateNode.history;
      })
    };
  };
  /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */


  StateNode.prototype.resolveHistory = function (historyValue) {
    var _this = this;

    if (this.type !== 'history') {
      return [this];
    }

    var parent = this.parent;

    if (!historyValue) {
      var historyTarget = this.target;
      return historyTarget ? flatten(toStatePaths(historyTarget).map(function (relativeChildPath) {
        return parent.getFromRelativePath(relativeChildPath);
      })) : parent.initialStateNodes;
    }

    var subHistoryValue = nestedPath(parent.path, 'states')(historyValue).current;

    if (isString(subHistoryValue)) {
      return [parent.getStateNode(subHistoryValue)];
    }

    return flatten(toStatePaths(subHistoryValue).map(function (subStatePath) {
      return _this.history === 'deep' ? parent.getFromRelativePath(subStatePath) : [parent.states[subStatePath[0]]];
    }));
  };

  Object.defineProperty(StateNode.prototype, "stateIds", {
    /**
     * All the state node IDs of this state node and its descendant state nodes.
     */
    get: function () {
      var _this = this;

      var childStateIds = flatten(Object.keys(this.states).map(function (stateKey) {
        return _this.states[stateKey].stateIds;
      }));
      return [this.id].concat(childStateIds);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "events", {
    /**
     * All the event types accepted by this state node and its descendants.
     */
    get: function () {
      var e_8, _a, e_9, _b;

      if (this.__cache.events) {
        return this.__cache.events;
      }

      var states = this.states;
      var events = new Set(this.ownEvents);

      if (states) {
        try {
          for (var _c = __values(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var stateId = _d.value;
            var state = states[stateId];

            if (state.states) {
              try {
                for (var _e = (e_9 = void 0, __values(state.events)), _f = _e.next(); !_f.done; _f = _e.next()) {
                  var event_1 = _f.value;
                  events.add("".concat(event_1));
                }
              } catch (e_9_1) {
                e_9 = {
                  error: e_9_1
                };
              } finally {
                try {
                  if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally {
                  if (e_9) throw e_9.error;
                }
              }
            }
          }
        } catch (e_8_1) {
          e_8 = {
            error: e_8_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
          } finally {
            if (e_8) throw e_8.error;
          }
        }
      }

      return this.__cache.events = Array.from(events);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "ownEvents", {
    /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */
    get: function () {
      var events = new Set(this.transitions.filter(function (transition) {
        return !(!transition.target && !transition.actions.length && transition.internal);
      }).map(function (transition) {
        return transition.eventType;
      }));
      return Array.from(events);
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.resolveTarget = function (_target) {
    var _this = this;

    if (_target === undefined) {
      // an undefined target signals that the state node should not transition from that state when receiving that event
      return undefined;
    }

    return _target.map(function (target) {
      if (!isString(target)) {
        return target;
      }

      var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
      // do not include machine key on target

      if (isInternalTarget && !_this.parent) {
        return _this.getStateNodeByPath(target.slice(1));
      }

      var resolvedTarget = isInternalTarget ? _this.key + target : target;

      if (_this.parent) {
        try {
          var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);

          return targetStateNode;
        } catch (err) {
          throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
        }
      } else {
        return _this.getStateNodeByPath(resolvedTarget);
      }
    });
  };

  StateNode.prototype.formatTransition = function (transitionConfig) {
    var _this = this;

    var normalizedTarget = normalizeTarget(transitionConfig.target);
    var internal = 'internal' in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function (_target) {
      return isString(_target) && _target[0] === _this.delimiter;
    }) : true;
    var guards = this.machine.options.guards;
    var target = this.resolveTarget(normalizedTarget);

    var transition = __assign$1(__assign$1({}, transitionConfig), {
      actions: toActionObjects(toArray(transitionConfig.actions)),
      cond: toGuard(transitionConfig.cond, guards),
      target: target,
      source: this,
      internal: internal,
      eventType: transitionConfig.event,
      toJSON: function () {
        return __assign$1(__assign$1({}, transition), {
          target: transition.target ? transition.target.map(function (t) {
            return "#".concat(t.id);
          }) : undefined,
          source: "#".concat(_this.id)
        });
      }
    });

    return transition;
  };

  StateNode.prototype.formatTransitions = function () {
    var e_10, _a;

    var _this = this;

    var onConfig;

    if (!this.config.on) {
      onConfig = [];
    } else if (Array.isArray(this.config.on)) {
      onConfig = this.config.on;
    } else {
      var _b = this.config.on,
          _c = WILDCARD,
          _d = _b[_c],
          wildcardConfigs = _d === void 0 ? [] : _d,
          strictTransitionConfigs_1 = __rest$1(_b, [typeof _c === "symbol" ? _c : _c + ""]);

      onConfig = flatten(Object.keys(strictTransitionConfigs_1).map(function (key) {
        if (!IS_PRODUCTION && key === NULL_EVENT) {
          warn(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + "Please check the `on` configuration for \"#".concat(_this.id, "\"."));
        }

        var transitionConfigArray = toTransitionConfigArray(key, strictTransitionConfigs_1[key]);

        if (!IS_PRODUCTION) {
          validateArrayifiedTransitions(_this, key, transitionConfigArray);
        }

        return transitionConfigArray;
      }).concat(toTransitionConfigArray(WILDCARD, wildcardConfigs)));
    }

    var eventlessConfig = this.config.always ? toTransitionConfigArray('', this.config.always) : [];
    var doneConfig = this.config.onDone ? toTransitionConfigArray(String(done(this.id)), this.config.onDone) : [];

    if (!IS_PRODUCTION) {
      warn(!(this.config.onDone && !this.parent), "Root nodes cannot have an \".onDone\" transition. Please check the config of \"".concat(this.id, "\"."));
    }

    var invokeConfig = flatten(this.invoke.map(function (invokeDef) {
      var settleTransitions = [];

      if (invokeDef.onDone) {
        settleTransitions.push.apply(settleTransitions, __spreadArray([], __read$2(toTransitionConfigArray(String(doneInvoke(invokeDef.id)), invokeDef.onDone)), false));
      }

      if (invokeDef.onError) {
        settleTransitions.push.apply(settleTransitions, __spreadArray([], __read$2(toTransitionConfigArray(String(error(invokeDef.id)), invokeDef.onError)), false));
      }

      return settleTransitions;
    }));
    var delayedTransitions = this.after;
    var formattedTransitions = flatten(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read$2(doneConfig), false), __read$2(invokeConfig), false), __read$2(onConfig), false), __read$2(eventlessConfig), false).map(function (transitionConfig) {
      return toArray(transitionConfig).map(function (transition) {
        return _this.formatTransition(transition);
      });
    }));

    try {
      for (var delayedTransitions_1 = __values(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()) {
        var delayedTransition = delayedTransitions_1_1.value;
        formattedTransitions.push(delayedTransition);
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
      } finally {
        if (e_10) throw e_10.error;
      }
    }

    return formattedTransitions;
  };

  return StateNode;
}();

var warned = false;
function createMachine(config, options) {
  if (!IS_PRODUCTION && !('predictableActionArguments' in config) && !warned) {
    warned = true;
    console.warn('It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html');
  }

  return new StateNode(config, options);
}

var assign = assign$1;

var index =  require$$0.useLayoutEffect ;

function useConstant(fn) {
    var ref = require$$0__namespace.useRef();
    if (!ref.current) {
        ref.current = { v: fn() };
    }
    return ref.current.v;
}

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$1 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function useIdleInterpreter(getMachine, options) {
    var machine = useConstant(function () {
        return typeof getMachine === 'function' ? getMachine() : getMachine;
    });
    if (process.env.NODE_ENV !== 'production' &&
        typeof getMachine !== 'function') {
        var _a = __read$1(require$$0.useState(machine), 1), initialMachine = _a[0];
        if (getMachine !== initialMachine) {
            console.warn('Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\n' +
                'Please make sure that you pass the same Machine as argument each time.');
        }
    }
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays; options.state; var interpreterOptions = __rest(options, ["context", "guards", "actions", "activities", "services", "delays", "state"]);
    var service = useConstant(function () {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function () { return (__assign(__assign({}, machine.context), context)); });
        return interpret(machineWithConfig, interpreterOptions);
    });
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    index(function () {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [actions, guards, activities, services, delays]);
    return service;
}

(undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
(undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function isInterpreterStateEqual(service, prevState, nextState) {
    if (service.status === InterpreterStatus.NotStarted) {
        return true;
    }
    // Only change the current state if:
    // - the incoming state is the "live" initial state (since it might have new actors)
    // - OR the incoming state actually changed.
    //
    // The "live" initial state will have .changed === undefined.
    var initialStateChanged = nextState.changed === undefined &&
        (Object.keys(nextState.children).length > 0 ||
            typeof prevState.changed === 'boolean');
    return !(nextState.changed || initialStateChanged);
}

var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function identity(a) {
    return a;
}
function useMachine(getMachine) {
    var _a = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        _a[_i - 1] = arguments[_i];
    }
    var _b = __read(_a, 1), _c = _b[0], options = _c === void 0 ? {} : _c;
    // using `useIdleInterpreter` allows us to subscribe to the service *before* we start it
    // so we don't miss any notifications
    var service = useIdleInterpreter(getMachine, options);
    var getSnapshot = require$$0.useCallback(function () {
        if (service.status === InterpreterStatus.NotStarted) {
            return (options.state
                ? State.create(options.state)
                : service.machine.initialState);
        }
        return service.getSnapshot();
    }, [service]);
    var isEqual = require$$0.useCallback(function (prevState, nextState) {
        return isInterpreterStateEqual(service, prevState, nextState);
    }, [service]);
    var subscribe = require$$0.useCallback(function (handleStoreChange) {
        var unsubscribe = service.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [service]);
    var storeSnapshot = withSelector.exports.useSyncExternalStoreWithSelector(subscribe, getSnapshot, getSnapshot, identity, isEqual);
    require$$0.useEffect(function () {
        var rehydratedState = options.state;
        service.start(rehydratedState ? State.create(rehydratedState) : undefined);
        return function () {
            service.stop();
            service.status = InterpreterStatus.NotStarted;
        };
    }, []);
    return [storeSnapshot, service.send, service];
}

var scanViewStateMachine = createMachine({
    id: "scanStatus",
    initial: "cameraLoading",
    predictableActionArguments: true,
    context: {
        card_id: "",
        scan_id: "",
        autoScan: true,
        scannerRunning: false,
        backSideSupport: false,
        eligibilitySupport: false,
        headerTitle: "Hold Card in Frame\nIt Will Scan Automatically",
        messageState: {},
        toggledAutoManual: false,
        processing: false,
        httpCode: 0,
        httpMessage: "",
        session_id: "",
        modelState: "",
    },
    states: {
        cameraLoading: {
            on: {
                CAMERA_LOADED: {
                    target: "autoCapture",
                    cond: function (context) { return context.modelState === "warmed"; },
                    actions: [
                        assign({
                            scannerRunning: true,
                        }),
                    ],
                },
                UPDATE_MODEL_STATE: {
                    actions: [
                        assign({
                            modelState: function (context, event) { return event.modelState; },
                        }),
                    ],
                },
                ERROR: {
                    target: "error",
                    actions: [
                        assign({
                            scannerRunning: true,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                    ],
                },
                CAMERAERROR: {
                    target: "cameraError",
                    actions: [
                        assign({
                            scannerRunning: true,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                    ],
                },
            },
        },
        autoCapture: {
            on: {
                "card.frontside_processing": {
                    target: "frontsideProcessing",
                    actions: [
                        assign({
                            card_id: function (context, event) { return event.card_id; },
                            session_id: function (context, event) { return event.session_id; },
                            scan_id: function (context, event) { return event.scan_id; },
                            backSideSupport: function (context, event) {
                                return event.backSideSupport ? event.backSideSupport : false;
                            },
                            eligibilitySupport: function (context, event) {
                                return event.eligibilitySupport;
                            },
                            processing: true,
                        }),
                    ],
                },
                TOGGLE: {
                    target: "manualCapture",
                    actions: [
                        assign({
                            autoScan: false,
                            scannerRunning: false,
                            toggledAutoManual: true,
                        }),
                    ],
                },
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                    ],
                },
                ERROR: {
                    target: "error",
                    actions: [
                        assign({
                            scannerRunning: true,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                    ],
                },
            },
        },
        manualCapture: {
            on: {
                "card.frontside_processing": {
                    target: "frontsideProcessing",
                    actions: [
                        assign({
                            scannerRunning: true,
                            processing: true,
                        }),
                    ],
                },
                MANUAL_BUTTON_CLICK: {
                    target: "frontsideProcessing",
                    actions: [
                        assign({
                            scannerRunning: true,
                            processing: true,
                        }),
                    ],
                },
                TOGGLE: {
                    target: "autoCapture",
                    actions: [
                        assign({
                            autoScan: true,
                            scannerRunning: true,
                            toggledAutoManual: true,
                        }),
                    ],
                },
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                    ],
                },
                ERROR: {
                    target: "error",
                    actions: [
                        assign({
                            scannerRunning: true,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                    ],
                },
            },
        },
        frontsideProcessing: {
            on: {
                //when frontside only
                "card.completed": [
                    {
                        target: "completed",
                        actions: [
                            assign({
                                scannerRunning: false,
                            }),
                        ],
                    },
                ],
                //when backside supported
                "card.backside_processing": [
                    {
                        target: "backsidePending",
                        actions: [
                            assign({
                                scannerRunning: false,
                                processing: false,
                            }),
                        ],
                    },
                ],
                "card.post_processing": [
                    {
                        target: "postProcessing",
                        actions: [
                            assign({
                                scannerRunning: false,
                                processing: true,
                            }),
                        ],
                    },
                ],
                "card.frontside_failed": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                    ],
                },
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                    ],
                },
                ERROR: {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                    ],
                },
            },
        },
        backsidePending: {
            on: {
                ERROR: {
                    target: "error",
                    actions: [
                        assign({
                            scannerRunning: true,
                            processing: false,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                    ],
                },
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                    ],
                },
                "card.backside_failed": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                    ],
                },
                TOGGLE: [
                    {
                        //when toggled from manual to auto scan, transition immediately
                        target: "backsideProcessing",
                        cond: function (ctx) { return !ctx.autoScan; },
                        actions: [
                            assign({
                                scannerRunning: true,
                                processing: true,
                                autoScan: true,
                                toggledAutoManual: true,
                            }),
                        ],
                    },
                    {
                        //when toggled from auto to manual scan, disable runner and await manual button click
                        cond: function (ctx) { return ctx.autoScan; },
                        actions: [
                            assign({
                                scannerRunning: false,
                                processing: false,
                                autoScan: false,
                                toggledAutoManual: true,
                            }),
                        ],
                    },
                ],
                MANUAL_BUTTON_CLICK: {
                    target: "backsideProcessing",
                    actions: [
                        assign({
                            scannerRunning: true,
                            processing: true,
                        }),
                    ],
                },
            },
            after: {
                // after 5 seconds, transition to backsideProcessing
                5000: {
                    target: "backsideProcessing",
                    cond: function (ctx) { return ctx.autoScan; },
                    actions: [
                        assign({
                            autoScan: true,
                            scannerRunning: true,
                        }),
                    ],
                },
            },
        },
        postProcessing: {
            on: {
                "card.completed": [
                    {
                        target: "completed",
                        actions: [
                            assign({
                                scannerRunning: false,
                            }),
                        ],
                    },
                ],
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                    ],
                },
                ERROR: {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                    ],
                },
            },
        },
        backsideProcessing: {
            on: {
                MANUAL_BUTTON_CLICK: {
                    actions: [
                        assign({
                            scannerRunning: true,
                        }),
                    ],
                },
                "scan.processing": {
                    actions: [
                        assign({
                            scannerRunning: true,
                            processing: true,
                        }),
                    ],
                },
                "card.post_processing": [
                    {
                        target: "postProcessing",
                        actions: [
                            assign({
                                scannerRunning: false,
                                processing: true,
                            }),
                        ],
                    },
                ],
                "card.completed": {
                    target: "completed",
                    actions: [
                        assign({
                            scannerRunning: false, //replaces on cleanUp
                        }),
                    ],
                },
                "card.backside_failed": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                    ],
                },
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                    ],
                },
                ERROR: {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                    ],
                },
            },
        },
        retry: {
            on: {
                retry_scan: {
                    target: "autoCapture",
                    actions: [
                        assign({
                            scannerRunning: true,
                            autoScan: true,
                            processing: false,
                        }),
                    ],
                },
                "card.completed": {
                    target: "completed",
                    actions: [
                        assign({
                            card_id: function (context, event) { return event.card_id; },
                        }),
                    ],
                },
            },
        },
        completed: {
            always: [
                {
                    cond: function (context) { return context.eligibilitySupport === true; },
                    target: "eligibilityPending",
                },
                { target: "success" },
            ],
        },
        eligibilityPending: {
            on: {
                "eligibility.processing": {
                    target: "eligibilityProcessing",
                },
            },
        },
        eligibilityProcessing: {
            on: {
                "eligibility.completed": {
                    target: "success",
                },
                "eligibility.error": {
                    target: "success",
                },
            },
        },
        success: {
            type: "final",
        },
        error: {
            //type: "final",
            on: {
                "card.completed": {
                    target: "completed",
                    actions: [
                        assign({
                            scannerRunning: false,
                            processing: true,
                        }),
                    ],
                },
            },
        },
        cameraError: {
            //type: "final",
            on: {
                "card.completed": {
                    target: "completed",
                    actions: [
                        assign({
                            scannerRunning: false,
                            processing: true,
                        }),
                    ],
                },
            },
        },
    },
}, {
    actions: {
        log: function (context, event, meta) {
            GlobalLogger.debug("backSideSupport: " + context.backSideSupport);
        },
    },
});

var _handleError = function (error, stateMachineSend, onError, stateMachineState) {
    GlobalLogger.error(error);
    if (error.isAxiosError === true && error.response) {
        stateMachineSend("ERROR", {
            httpCode: error.response.status,
            httpMessage: error.message,
        });
        var err = generateError(error.message, "ResponseError", error.response.status);
        if (onError) {
            onError(err);
        }
        GlobalLogger.debug("ResponseError ".concat(error.response.status, " - ").concat(error.message));
    }
    else if (error.isAxiosError === true && error.request) {
        stateMachineSend("ERROR", {
            httpCode: error.request.status,
            httpMessage: error.message,
        });
        var err = generateError(error.message, "RequestError", error.request.status);
        if (onError) {
            onError(err);
        }
        GlobalLogger.debug("RequestError ".concat(error.response.status, " - ").concat(error.message));
    }
    else if (error.isCardScanError == true) {
        var err = error;
        //avoid calling onError on 403 here
        //because it is already handled in AxiosError
        //so we don't get onError being called twice
        //when websocket fails on 403
        if (stateMachineState.context.httpCode == 403) {
            err = generateError(stateMachineState.context.httpMessage, "RequestError", stateMachineState.context.httpCode);
            stateMachineSend("ERROR", {
                httpCode: stateMachineState.context.httpCode,
                httpMessage: stateMachineState.context.httpMessage,
            });
        }
        else {
            stateMachineSend("ERROR");
            if (onError) {
                onError(err);
            }
        }
        GlobalLogger.debug("isCardScanError ".concat(error.message));
    }
    else {
        var err = generateError(error.message, "UnknownError", 606);
        if (onError) {
            onError(err);
        }
        GlobalLogger.debug("UnknownError ".concat(error.message));
        //don't change UI Status as we don't know if this error is fatal or not.
    }
};

var generateImageFromCanvas = function (videoRefBg, frameDivRef, captureCanvasRef, flipHorizontal, flipVertical) {
    var _a = calculateGuides(videoRefBg, frameDivRef), guideX = _a[0], guideY = _a[1], guideWidth = _a[2], guideHeight = _a[3];
    var captureCanvas = captureCanvasRef.current;
    var video = videoRefBg.current;
    if (!captureCanvas || !video) {
        return;
    }
    captureCanvas.width = guideWidth;
    captureCanvas.height = guideHeight;
    //resize image to canvas sizes
    var ctx = captureCanvas === null || captureCanvas === void 0 ? void 0 : captureCanvas.getContext("2d", { alpha: false });
    ctx === null || ctx === void 0 ? void 0 : ctx.clearRect(0, 0, captureCanvas.width, captureCanvas.height);
    var scaleX = flipHorizontal ? -1 : 1;
    var scaleY = flipVertical ? -1 : 1;
    var translateX = flipHorizontal ? -captureCanvas.width : 0;
    var translateY = flipVertical ? -captureCanvas.height : 0;
    ctx === null || ctx === void 0 ? void 0 : ctx.scale(scaleX, scaleY);
    ctx === null || ctx === void 0 ? void 0 : ctx.translate(translateX, translateY);
    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(video, guideX, guideY, guideWidth, guideHeight, 0, 0, captureCanvas.width, captureCanvas.height);
    //The captureCanvas drawImage use a large amount of GPU memory and isn't getting properly garbage collected inside of the loop.
    //To fix this we convert the captured image to a jpeg string, which is stored in RAM.
    //We then clear the canvas context to clear up GPU memory when possible.
    var jpegUrl = captureCanvas.toDataURL("image/jpeg", 0.9);
    ctx === null || ctx === void 0 ? void 0 : ctx.clearRect(0, 0, captureCanvas.width, captureCanvas.height);
    ctx === null || ctx === void 0 ? void 0 : ctx.setTransform(1, 0, 0, 1, 0, 0);
    return jpegUrl;
};
var generateImageMetadata = function (capture, videoRefBg, frameDivRef, captureCanvasRef, threshold, laplacianThreshold, videoMetadata, environmentInfo, videoElementInfo, guideFrameElementInfo, deviceInfo) {
    var video = videoRefBg.current;
    var captureCanvas = captureCanvasRef.current;
    var _a = calculateGuides(videoRefBg, frameDivRef), guideX = _a[0], guideY = _a[1], guideWidth = _a[2], guideHeight = _a[3];
    var metadata = { captureType: capture };
    metadata["guides"] = {
        x: guideX,
        y: guideY,
        width: guideWidth,
        height: guideHeight,
    };
    metadata["captureCanvas"] = {
        width: captureCanvas === null || captureCanvas === void 0 ? void 0 : captureCanvas.width,
        height: captureCanvas === null || captureCanvas === void 0 ? void 0 : captureCanvas.height,
    };
    metadata["videoBackground"] = {
        width: video === null || video === void 0 ? void 0 : video.videoWidth,
        height: video === null || video === void 0 ? void 0 : video.videoHeight,
    };
    metadata["windowInner"] = {
        width: window.innerWidth,
        height: window.innerHeight,
    };
    metadata["environmentInfo"] = environmentInfo;
    metadata["deviceInfo"] = deviceInfo;
    metadata["videoElementInfo"] = videoElementInfo;
    metadata["guideFrameElementInfo"] = guideFrameElementInfo;
    if (capture == "automatic" /* CaptureType.automatic */) {
        metadata["mlThreshold"] = threshold;
        metadata["laplacianThreshold"] = laplacianThreshold;
    }
    metadata["package_name"] = "insurance-cardscan-react";
    metadata["package_version"] = cardScanPackageVersion;
    metadata = Object.assign({}, metadata, videoMetadata);
    return metadata;
};

function getEnvironmentInfo() {
    var _a, _b;
    var userAgent = navigator.userAgent;
    // Mobile detection
    var type = "Desktop";
    if (/Mobi|Android/i.test(userAgent)) {
        type = "Mobile";
    }
    else if (/Tablet|iPad/i.test(userAgent)) {
        type = "Tablet";
    }
    // OS detection and version extraction
    var os = "Unknown";
    var osVersion = "Unknown";
    if (/Windows NT/.test(userAgent)) {
        os = "Windows";
        osVersion = (/Windows NT ([0-9.]+)/.exec(userAgent) || [])[1] || "Unknown";
    }
    else if (/Mac OS X/.test(userAgent)) {
        os = "MacOS";
        osVersion =
            ((_a = (/Mac OS X ([0-9_]+)/.exec(userAgent) || [])[1]) === null || _a === void 0 ? void 0 : _a.replace(/_/g, ".")) ||
                "Unknown";
    }
    else if (/Linux/.test(userAgent)) {
        os = "Linux";
        osVersion =
            (/Linux ([a-zA-Z0-9._-]+)/.exec(userAgent) || [])[1] || "Unknown";
    }
    else if (/Android/.test(userAgent)) {
        os = "Android";
        osVersion = (/Android ([0-9.]+)/.exec(userAgent) || [])[1] || "Unknown";
    }
    else if (/iOS|iPad|iPhone|iPod/.test(userAgent)) {
        os = "iOS";
        osVersion =
            ((_b = (/OS ([0-9_]+)/.exec(userAgent) || [])[1]) === null || _b === void 0 ? void 0 : _b.replace(/_/g, ".")) ||
                "Unknown";
    }
    // Browser detection and version extraction
    var browser = "Unknown";
    var browserVersion = "Unknown";
    if (/Chrome/.test(userAgent) && !/Edg/.test(userAgent)) {
        browser = "Chrome";
        browserVersion =
            (/Chrome\/([0-9.]+)/.exec(userAgent) || [])[1] || "Unknown";
    }
    else if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
        browser = "Safari";
        browserVersion =
            (/Version\/([0-9.]+)/.exec(userAgent) || [])[1] || "Unknown";
    }
    else if (/Firefox/.test(userAgent)) {
        browser = "Firefox";
        browserVersion =
            (/Firefox\/([0-9.]+)/.exec(userAgent) || [])[1] || "Unknown";
    }
    else if (/MSIE|Trident/.test(userAgent)) {
        browser = "Internet Explorer";
        browserVersion =
            (/(?:MSIE |rv:)([0-9.]+)/.exec(userAgent) || [])[1] || "Unknown";
    }
    else if (/Edg/.test(userAgent)) {
        browser = "Edge";
        browserVersion = (/Edg\/([0-9.]+)/.exec(userAgent) || [])[1] || "Unknown";
    }
    else {
        var unknownBrowserMatch = userAgent.match(/(Opera|OPR|YaBrowser|UCBrowser|SamsungBrowser|Vivaldi|Brave|Maxthon|Seamonkey)\/? ?([0-9.]*)/);
        if (unknownBrowserMatch) {
            browser = unknownBrowserMatch[1];
            browserVersion = unknownBrowserMatch[2] || "Unknown";
        }
    }
    return {
        type: type,
        os: os,
        osVersion: osVersion,
        browser: browser,
        browserVersion: browserVersion,
        userAgent: userAgent,
    };
}
function getDeviceInfo() {
    return {
        screenWidth: screen.width,
        screenHeight: screen.height,
    };
}
function getRefSize(ref) {
    var _a, _b;
    return {
        width: ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || "unknown",
        height: ((_b = ref.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) || "unknown",
    };
}

//Main scan processing handler for scans -- called every ~250ms when active.
//Handles: auto & manual scan
//---------------------------------------
// Hot Path
//---------------------------------------
var scanHandler = function (videoRefBg, frameDivRef, captureCanvasRef, detectionCanvasRef, debugCanvasLatestRef, debugCanvasBestRef, scanCountRef, performanceCountRef, setLatestScore, setLatestLaplacian, setBestScore, setBestLaplacian, setModelState, setScanDebugState, setScanProgress, flipHorizontal, flipVertical, scanCaptureBuffer, threshold, laplacianThreshold, onError, scanProgress, softMaxUploads, bufferSize, videoMetadata, cardScanApi, cardIdRef, stateMachineState, stateMachineSend, debugMenu) {
    var _a;
    if (flipHorizontal === void 0) { flipHorizontal = false; }
    if (flipVertical === void 0) { flipVertical = false; }
    var video = videoRefBg.current;
    if (!video || stateMachineState.matches("cameraLoading")) {
        GlobalLogger.error("scanHandler -- no video found");
        return;
    }
    if (!cardIdRef.current) {
        GlobalLogger.log("scanHandler -- no card Id found");
        return;
    }
    var detectionCanvas = detectionCanvasRef.current;
    var captureCanvas = captureCanvasRef.current;
    var _b = calculateGuides(videoRefBg, frameDivRef), guideX = _b[0], guideY = _b[1], guideWidth = _b[2], guideHeight = _b[3];
    GlobalLogger.debug("Canvas: ".concat(captureCanvas === null || captureCanvas === void 0 ? void 0 : captureCanvas.width, ", ").concat(captureCanvas === null || captureCanvas === void 0 ? void 0 : captureCanvas.height), "everything");
    GlobalLogger.debug("Video: ".concat(video.videoWidth, ", ").concat(video.videoHeight), "everything");
    if (!(detectionCanvas && captureCanvas)) {
        GlobalLogger.error("CardScan: no canvas found - critical failure");
        return;
    }
    //resize image to canvas sizes
    (_a = detectionCanvas
        .getContext("2d")) === null || _a === void 0 ? void 0 : _a.drawImage(video, guideX, guideY, guideWidth, guideHeight, 0, 0, detectionCanvas.width, detectionCanvas.height);
    var jpegUrl;
    //work around for iOS GPU memory issue.
    //TODO: check we still need this and remove if not. might have been fixed by useInterval
    if (!isIOS_1) {
        jpegUrl = generateImageFromCanvas(videoRefBg, frameDivRef, captureCanvasRef, flipHorizontal, flipVertical);
    }
    detectCard(videoRefBg, frameDivRef, captureCanvasRef, detectionCanvas, debugCanvasLatestRef, debugCanvasBestRef, scanCountRef, performanceCountRef, setLatestScore, setLatestLaplacian, setBestScore, setBestLaplacian, setModelState, setScanDebugState, flipHorizontal, flipVertical, threshold, laplacianThreshold, onError, scanCaptureBuffer, scanProgress, setScanProgress, softMaxUploads, bufferSize, videoMetadata, cardScanApi, cardIdRef, stateMachineState, stateMachineSend, jpegUrl, debugMenu);
};
var detectCard = function (videoRefBg, frameDivRef, captureCanvasRef, detectionCanvas, debugCanvasLatestRef, debugCanvasBestRef, scanCountRef, performanceCountRef, setLatestScore, setLatestLaplacian, setBestScore, setBestLaplacian, setModelState, setScanDebugState, flipHorizontal, flipVertical, threshold, laplacianThreshold, onError, scanCaptureBuffer, scanProgress, setScanProgress, softMaxUploads, bufferSize, videoMetadata, cardScanApi, cardIdRef, stateMachineState, stateMachineSend, jpegUrl, debugMenu) {
    DetectorWrapper
        .get()
        .predict_image(detectionCanvas, flipHorizontal, flipVertical)
        .then(function (ret) {
        performanceCountRef.current += 1;
        if (ret === null) {
            GlobalLogger.log("cardDetector race condition -- early exit");
            return;
        }
        // Save the performance data approximately every 2.5 seconds
        if (performanceCountRef.current % 10 === 0 && cardIdRef.current) {
            cardScanApi.current
                .performanceData(cardIdRef.current, ret)
                .catch(function (error) {
                GlobalLogger.error(error);
            });
        }
        if (debugMenu) {
            setModelState(DetectorWrapper.get().modelState);
            setScanDebugState("active");
        }
        if (ret["modelClass"] === "card" &&
            ["autoCapture", "frontsideProcessing", "backsideProcessing"].some(stateMachineState.matches)) {
            var score = Number(ret["modelProbability"]);
            var laplacian = Number(ret["laplaceVariance"]);
            GlobalLogger.debug("Score: ".concat(score, " Lap: ").concat(laplacian), "detector");
            if (debugMenu) {
                setLatestScore(score);
                setLatestLaplacian(laplacian);
                renderDebugCanvas(videoRefBg, frameDivRef, debugCanvasLatestRef, debugMenu);
            }
            // Add quality images to the buffer...
            if (score > threshold && laplacian > laplacianThreshold) {
                GlobalLogger.debug("scores above threshold: ".concat(threshold, " lap threshold: ").concat(laplacianThreshold), "detector");
                if (debugMenu) {
                    setBestScore(score);
                    setBestLaplacian(laplacian);
                    renderDebugCanvas(videoRefBg, frameDivRef, debugCanvasBestRef, debugMenu);
                }
                //TODO: see if this is still an issue.
                if (jpegUrl === undefined) {
                    //lazy jpeg capture to workaround iOS GPU memory issue
                    //downside is that we capture the submitted image ~10-15ms after detection but should be Ok
                    var jpeg = generateImageFromCanvas(videoRefBg, frameDivRef, captureCanvasRef, flipHorizontal, flipVertical);
                    addImageToBuffer(scanCountRef, jpeg, score, laplacian, scanCaptureBuffer, scanProgress, setScanProgress, softMaxUploads, bufferSize, videoRefBg, frameDivRef, captureCanvasRef, threshold, laplacianThreshold, videoMetadata, cardScanApi, cardIdRef, stateMachineState, onError);
                }
                else {
                    addImageToBuffer(scanCountRef, jpegUrl, score, laplacian, scanCaptureBuffer, scanProgress, setScanProgress, softMaxUploads, bufferSize, videoRefBg, frameDivRef, captureCanvasRef, threshold, laplacianThreshold, videoMetadata, cardScanApi, cardIdRef, stateMachineState, onError);
                }
            }
        }
    })
        .catch(function (error) {
        _handleError(error, stateMachineSend, onError);
    });
};
var addImageToBuffer = function (scanCountRef, jpegUrl, score, laplacian, scanCaptureBuffer, scanProgress, setScanProgress, softMaxUploads, bufferSize, videoRefBg, frameDivRef, captureCanvasRef, threshold, laplacianThreshold, videoMetadata, cardScanApi, cardIdRef, stateMachineState, onError) {
    var file = dataURLtoFile(jpegUrl, "card.jpeg");
    scanCaptureBuffer.current.push({ file: file, score: score, laplacian: laplacian });
    //TODO: update progress UI -- a little slow to update, we could use the scanCapture buffer.
    GlobalLogger.debug("Adding image to capture buffer: ".concat(scanProgress, " lap: ").concat(laplacian, " score: ").concat(score));
    setScanProgress(function (p) {
        if (p >= (softMaxUploads * bufferSize) / 2) {
            return p + 0.5;
        }
        else {
            return p + 1;
        }
    });
    var numScans = Math.min(Math.ceil(scanProgress), softMaxUploads * bufferSize);
    var totalProgress = 20 + (numScans / (softMaxUploads * bufferSize)) * 100;
    document.documentElement.style.setProperty("--cardscan-corner-height", "".concat(totalProgress >= 100 ? 100 : totalProgress, "%"));
    document.documentElement.style.setProperty("--cardscan-corner-width", "".concat(totalProgress >= 100 ? 100 : totalProgress, "%"));
    document.documentElement.style.setProperty("--cardscan-buffer-size", numScans.toString());
    if (scanCaptureBuffer.current.length === bufferSize) {
        scanCountRef.current += 1;
        GlobalLogger.debug("capture buffer full: ".concat(scanCaptureBuffer.current.length));
        //pull best / least blurry image from buffer
        var lapScores = scanCaptureBuffer.current.map(function (i) {
            return Number(i.laplacian);
        });
        var maxScore = Math.max.apply(null, lapScores);
        var index = lapScores.indexOf(maxScore);
        var bestImage = scanCaptureBuffer.current[index].file;
        GlobalLogger.debug("Best Image picked: ".concat(index, " - lap: ").concat(maxScore));
        var environmentInfo = getEnvironmentInfo();
        var deviceInfo = getDeviceInfo();
        var videoElementInfo = getRefSize(videoRefBg);
        var guideFrameElementInfo = getRefSize(frameDivRef);
        //Note: metadata might have changed between capture and upload.
        var metadata = generateImageMetadata("automatic" /* CaptureType.automatic */, videoRefBg, frameDivRef, captureCanvasRef, threshold, laplacianThreshold, videoMetadata, environmentInfo, videoElementInfo, guideFrameElementInfo, deviceInfo);
        GlobalLogger.debug(JSON.stringify(metadata), "everything");
        var scores = scanCaptureBuffer.current.map(function (i) { return ({
            score: i.score,
            laplacian: i.laplacian,
        }); });
        metadata["capture_score"] = { scores: scores, max_lapScore: maxScore };
        uploadFile(scanCountRef.current, bestImage, "automatic" /* CaptureType.automatic */, metadata, cardScanApi, cardIdRef, stateMachineState, onError, function () {
            GlobalLogger.debug("image upload complete");
        });
        //start capture buffer here so that we start the upload timer right away
        scanCaptureBuffer.current = [];
        GlobalLogger.debug("capture buffer cleared");
    }
};
var uploadFile = function (scanCount, file, captureType, metadata, cardScanApi, cardIdRef, stateMachineState, stateMachineSend, onError, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        (_a = cardScanApi.current) === null || _a === void 0 ? void 0 : _a.uploadScanImage(scanCount, file, cardIdRef.current, captureType, ["backsideProcessing", "backsidePending"].some(stateMachineState.matches)
            ? "back"
            : "front", metadata).then(function () {
            if (cb) {
                cb();
            }
            GlobalLogger.debug("Upload Success");
        }).catch(function (error) {
            _handleError(error, stateMachineSend, onError);
        });
        return [2 /*return*/];
    });
}); };
//---------------------------------------
// Debug Menu
//---------------------------------------
//debug data to be passed in with every scan
var renderDebugCanvas = function (videoRefBg, frameDivRef, debugCanvasRef, debugMenu) {
    var videoBg = videoRefBg.current;
    if (debugMenu && debugCanvasRef && videoBg) {
        var _a = calculateGuides(videoRefBg, frameDivRef), guideX = _a[0], guideY = _a[1], guideWidth = _a[2], guideHeight = _a[3];
        var dCanvas = debugCanvasRef.current;
        if (dCanvas) {
            var destCtx = dCanvas.getContext("2d", { alpha: false });
            destCtx === null || destCtx === void 0 ? void 0 : destCtx.drawImage(videoBg, guideX, guideY, guideWidth, guideHeight, 0, 0, dCanvas.width, dCanvas.height);
        }
    }
};

var resetCorners = function () {
    //reset corners before flipping
    document.documentElement.style.setProperty("--cardscan-corner-width", "62px");
    document.documentElement.style.setProperty("--cardscan-corner-height", "62px");
};

//---------------------------------------
// Exit and Cleanup
//---------------------------------------
var cleanUp = function (scanCaptureBuffer, setScanProgress, videoRefBg, cardScanApi) {
    //kill timer
    var _a;
    //empty both detection buffer and clear progress UI
    scanCaptureBuffer.current = [];
    setScanProgress(0);
    //disable camera on exit
    if (videoRefBg && videoRefBg.current) {
        var videoBackground = videoRefBg.current;
        var stream = videoBackground.srcObject;
        if (stream) {
            var tracks = stream.getTracks();
            tracks.forEach(function (track) { return track.stop(); });
            videoBackground.srcObject = null;
        }
    }
    DetectorWrapper.cleanUp();
    if (cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) {
        (_a = cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket.close();
        cardScanApi.current = null;
    }
    resetCorners();
};

//---------------------------------------
// Websocket message handling
//---------------------------------------
var webSocketHandler = function (cardScanApi, cardIdRef, onError, stateMachineState, stateMachineSend, backSideSupport, eligibilitySupport, onEligibilityError) {
    var _a;
    if ((_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket) {
        cardScanApi.current.socket.onopen = function () {
            var _a;
            GlobalLogger.debug("Socket Successfully Opened");
            //register current card on socket creation -- check card_id length to avoid race condition.
            if (cardIdRef.current && cardIdRef.current.length > 0) {
                var payload = JSON.stringify({
                    card_id: cardIdRef.current,
                    action: "register",
                    source: "onopen",
                });
                (_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket.send(payload);
            }
        };
        cardScanApi.current.socket.onclose = function (event) {
            GlobalLogger.debug("websocket closed ".concat(event.code, " ").concat(event.reason));
            if (event.code == 1005 && event.wasClean) {
                GlobalLogger.debug("websocket closed cleanly");
            }
            else if (event.code == 1000) {
                GlobalLogger.debug("websocket closed cleanly");
            }
            else {
                var error = generateError("The connection was closed abnormally", "WSError", event.code);
                _handleError(error, stateMachineSend, onError, stateMachineState);
            }
        };
        cardScanApi.current.socket.onerror = function (event) {
            var error;
            if (stateMachineState.context.httpCode == 403) {
                error = generateError(stateMachineState.context.httpMessage, "WSError", 403);
            }
            else {
                error = generateError("Unknown error from websocket", "WSError", 642);
            }
            GlobalLogger.debug("websocket error ".concat(error.message));
            _handleError(error, stateMachineSend, onError, stateMachineState);
        };
        cardScanApi.current.socket.onmessage = function (event) {
            //early exit for keepalive
            if (event.data == "pong") {
                return;
            }
            var _type = "";
            try {
                var type = JSON.parse(event.data).type;
                _type = type;
            }
            catch (error) {
                GlobalLogger.error("Unable to parse event received from websocket");
                GlobalLogger.debug("".concat(event));
            }
            if (_type == "card") {
                var _a = JSON.parse(event.data), state = _a.state; _a.details; var error = _a.error, card_id = _a.card_id, session_id = _a.session_id;
                var cardState = state;
                var isCardIdValid = card_id && cardIdRef.current !== card_id;
                var isStateMachineInRetryOrError = stateMachineState.value === "retry" ||
                    stateMachineState.value === "error";
                var isSessionIdMatching = session_id === stateMachineState.context.session_id;
                var isCardPending = cardState === "pending";
                if (isCardIdValid &&
                    isCardPending &&
                    isStateMachineInRetryOrError &&
                    isSessionIdMatching) {
                    GlobalLogger.debug("Card - Overwrite cardIdRef: ".concat(cardIdRef.current, " with ").concat(card_id));
                    cardIdRef.current = card_id;
                }
                GlobalLogger.debug("Card Event Received: cardId: ".concat(card_id, " state:").concat(cardState, " - ui:").concat(stateMachineState.value));
                GlobalLogger.debug("Card Event Payload: ".concat(JSON.stringify(event.data)), "everything");
                stateMachineSend("card.".concat(cardState), {
                    card_id: card_id,
                    backSideSupport: backSideSupport,
                    eligibilitySupport: eligibilitySupport,
                    session_id: session_id,
                });
            }
            else if (_type == "scan") {
                var _b = JSON.parse(event.data), state = _b.state, error = _b.error, scan_id = _b.scan_id, card_id = _b.card_id;
                var scanState = state;
                // If we receive a skipped card error,
                // and we are in an error state or cameraError state
                // and the card is in completed state
                // we need to transition to completed state
                // This is a workaround for when we use web-to-mobile handoff
                // and the user completes the scan on mobile
                // the desktop widget will receive the completed message
                if (error &&
                    error.error === "SkippedCard" &&
                    error.message ===
                        "Skipping scan for card received in completed state" &&
                    ["error", "cameraError"].some(stateMachineState.matches)) {
                    stateMachineSend("card.completed");
                }
                GlobalLogger.debug("Scan Event Received: scanId: ".concat(scan_id, " scan_state:").concat(scanState, " cardId: ").concat(card_id, " - ui:").concat(stateMachineState.value));
                GlobalLogger.debug("Scan Event Payload: ".concat(JSON.stringify(event.data)), "everything");
                stateMachineSend("scan.".concat(scanState), { card_id: card_id, scan_id: scan_id });
            }
            else if (_type == "eligibility") {
                var _c = JSON.parse(event.data), state = _c.state, error = _c.error;
                if (error && onEligibilityError)
                    onEligibilityError(error);
                stateMachineSend("eligibility.".concat(state));
            }
            else {
                GlobalLogger.log("Unknown event received from websocket");
                GlobalLogger.debug("Unknown Payload: ".concat(JSON.stringify(event.data)));
            }
        };
    }
    else {
        var error = generateError("No websocket found - critical failure", "WSError", 640);
        _handleError(error, stateMachineSend, onError, stateMachineState);
    }
};

var css_248z$1 = ".scanview-module_cardscanMain__JjW3i{align-items:center;background-color:var(--cardscan-widget-background-color);box-sizing:border-box;display:flex;font-family:HK Grotesk Pro,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:17px;height:-webkit-fill-available;height:var(--cardscan-app-height);height:100%;justify-content:center;line-height:1.5;max-height:100%;max-width:100%;overflow:hidden;position:relative;width:var(--cardscan-app-width);width:100%}.scanview-module_cardscanMain__JjW3i.scanview-module_isMobile__X92-K{background-color:var(--cardscan-widget-background-color,#000)}.scanview-module_cardscanVideoContainer__PK-Ea{align-items:center;aspect-ratio:16/9;display:flex;height:fit-content;height:auto;justify-content:center;position:relative;width:100%}.scanview-module_cardscanVideoContainer__PK-Ea.scanview-module_mobile__CtroE{aspect-ratio:unset;bottom:12.5%;height:67.5%;position:absolute}.scanview-module_cardscanVideoContainer__PK-Ea.scanview-module_landscapeMobile__CzgKU{aspect-ratio:16/9;bottom:unset;max-height:85%;max-width:82.5%;right:17.5%;top:15%;width:auto}.scanview-module_fullScreenLimit__V6ZU3{max-width:65vw}.scanview-module_cameraBtn__87nOC{cursor:pointer;left:50%;max-width:64px;min-width:24px;position:absolute;top:95.5%;transform:translate(-50%,-50%);width:4%;z-index:3}.scanview-module_cameraBtn__87nOC.scanview-module_heightFrame__k92qj{bottom:40px;transform:translate(-50%)}.scanview-module_spinnerWrapper__NtRr-{align-items:center;display:flex;flex-direction:column;justify-content:center;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:100%;z-index:10}.scanview-module_cardscanLogo__T3S98{box-sizing:border-box;left:4px;left:0;max-width:135px;position:absolute;top:100%;transform:translateY(calc(-100% - 5px));z-index:300}.scanview-module_cardscanLogo__T3S98.scanview-module_cardscanLogoMobile__8lwzv{transform:translate(0)}.scanview-module_cardscanLogoLandscape__LkARY{-webkit-filter:invert(100%);filter:invert(100%);max-width:90px}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles$1 = {"cardscanMain":"scanview-module_cardscanMain__JjW3i","isMobile":"scanview-module_isMobile__X92-K","cardscanVideoContainer":"scanview-module_cardscanVideoContainer__PK-Ea","mobile":"scanview-module_mobile__CtroE","landscapeMobile":"scanview-module_landscapeMobile__CzgKU","fullScreenLimit":"scanview-module_fullScreenLimit__V6ZU3","cameraBtn":"scanview-module_cameraBtn__87nOC","heightFrame":"scanview-module_heightFrame__k92qj","spinnerWrapper":"scanview-module_spinnerWrapper__NtRr-","cardscanLogo":"scanview-module_cardscanLogo__T3S98","cardscanLogoMobile":"scanview-module_cardscanLogoMobile__8lwzv","cardscanLogoLandscape":"scanview-module_cardscanLogoLandscape__LkARY"};
styleInject(css_248z$1);

var Eligibility = /** @class */ (function () {
    function Eligibility(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.eligibilityId = params.eligibility_id;
        this.state = params.state;
        this.cardId = params.card_id;
        this.createdAt = params.created_at;
        this.updateAt = params.update_at;
        this.eligibilityRequest = params.eligibility_request
            ? params.eligibility_request
            : undefined;
        this.eligibilityResponse = params.eligibility_response;
        if (params.eligibility_summarized_response) {
            var esr = params.eligibility_summarized_response; // For brevity
            this.eligibilitySummarizedResponse = {
                eligibilityRequestId: esr.eligibility_request_id,
                subscriberDetails: esr.subscriber_details
                    ? {
                        memberId: esr.subscriber_details.member_id,
                        firstName: esr.subscriber_details.firstname,
                        lastName: esr.subscriber_details.lastname,
                        middleName: esr.subscriber_details.middlename,
                        gender: esr.subscriber_details.gender,
                        dob: esr.subscriber_details.dob,
                        address: esr.subscriber_details.address,
                    }
                    : undefined,
                payerDetails: esr.payer_details
                    ? {
                        payerName: esr.payer_details.payer_name,
                        address: esr.payer_details.address,
                    }
                    : undefined,
                planDetails: esr.plan_details
                    ? {
                        planNumber: esr.plan_details.plan_number,
                        groupName: esr.plan_details.group_name,
                        groupNumber: esr.plan_details.group_number,
                        planStartDate: esr.plan_details.plan_start_date,
                        planEligibilityStartDate: esr.plan_details.plan_eligibility_start_date,
                        planName: esr.plan_details.plan_name,
                        planActive: esr.plan_details.plan_active,
                    }
                    : undefined,
                coverageSummary: esr.coverage_summary
                    ? {
                        individualDeductibleInNetwork: {
                            totalAmount: (_a = esr.coverage_summary.individual_deductible_in_network) === null || _a === void 0 ? void 0 : _a.total_amount,
                            remainingAmount: (_b = esr.coverage_summary.individual_deductible_in_network) === null || _b === void 0 ? void 0 : _b.remaining_amount,
                        },
                        individualOOPInNetwork: {
                            totalAmount: (_c = esr.coverage_summary.individual_oop_in_network) === null || _c === void 0 ? void 0 : _c.total_amount,
                            remainingAmount: (_d = esr.coverage_summary.individual_oop_in_network) === null || _d === void 0 ? void 0 : _d.remaining_amount,
                        },
                        familyDeductibleInNetwork: {
                            totalAmount: (_e = esr.coverage_summary.family_deductible_in_network) === null || _e === void 0 ? void 0 : _e.total_amount,
                            remainingAmount: (_f = esr.coverage_summary.family_deductible_in_network) === null || _f === void 0 ? void 0 : _f.remaining_amount,
                        },
                        familyOOPInNetwork: {
                            totalAmount: (_g = esr.coverage_summary.family_oop_in_network) === null || _g === void 0 ? void 0 : _g.total_amount,
                            remainingAmount: (_h = esr.coverage_summary.family_oop_in_network) === null || _h === void 0 ? void 0 : _h.remaining_amount,
                        },
                    }
                    : undefined,
                chiropractic: this.mapService(esr.chiropractic),
                emergencyRoom: this.mapService(esr.emergency_room),
                officeVisit: this.mapService(esr.office_visit),
                urgentCare: this.mapService(esr.urgent_care),
                hospitalOutpatient: this.mapService(esr.hospital_outpatient),
            };
        }
    }
    // Helper function to map service details
    Eligibility.prototype.mapService = function (service) {
        var _a, _b;
        return service
            ? {
                coInsuranceInNetwork: {
                    amount: (_a = service.co_insurance_in_network) === null || _a === void 0 ? void 0 : _a.amount,
                },
                coPaymentInNetwork: {
                    amount: (_b = service.co_payment_in_network) === null || _b === void 0 ? void 0 : _b.amount,
                },
                serviceCode: service.service_code,
            }
            : undefined;
    };
    return Eligibility;
}());

var HKGroteskProRegularOtf = "data:font/otf;base64,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";

var injectGlobalStyles = function () {
    return "\n    @font-face {\n      font-family: 'HK Grotesk Pro';\n      src: url(".concat(HKGroteskProRegularOtf, ") format('opentype');\n      font-weight: normal;\n      font-style: normal;\n    }\n  ");
};

var styleSheet = document.createElement("style");
styleSheet.innerText = injectGlobalStyles();
document.head.appendChild(styleSheet);
var DEV_SERVER = process.env && "REACT_APP_CARDSCAN_SERVER" in process.env
    ? process.env.REACT_APP_CARDSCAN_SERVER
    : undefined;
var DEV_WEBSOCKET_SERVER = process.env && "REACT_APP_CARDSCAN_WEBSOCKET_SERVER" in process.env
    ? "wss://".concat(process.env.REACT_APP_CARDSCAN_WEBSOCKET_SERVER)
    : undefined;
var CardScanView = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var logging = _a.logging, live = _a.live, sessionToken = _a.sessionToken, onSuccess = _a.onSuccess, onEligibilitySuccess = _a.onEligibilitySuccess, onEligibilityError = _a.onEligibilityError, onProgress = _a.onProgress, onScanStart = _a.onScanStart, onCancel = _a.onCancel, onError = _a.onError, onRetry = _a.onRetry, cameraPermissionModalConfig = _a.cameraPermissionModalConfig, _m = _a.fullScreen, fullScreen = _m === void 0 ? true : _m, backsideSupport = _a.backsideSupport, eligibility = _a.eligibility, _o = _a.messages, messages = _o === void 0 ? {} : _o, closeButton = _a.closeButton, successIndicator = _a.successIndicator, errorIndicator = _a.errorIndicator, indicatorOptions = _a.indicatorOptions, autoSwitchActiveColor = _a.autoSwitchActiveColor, autoSwitchInactiveColor = _a.autoSwitchInactiveColor, progressBarColor = _a.progressBarColor, widgetBackgroundColor = _a.widgetBackgroundColor, messageFontSize = _a.messageFontSize, messageTextColor = _a.messageTextColor, messageBackgroundColor = _a.messageBackgroundColor, webToMobileHandoffConfig = _a.webToMobileHandoffConfig, _internal = _a._internal, _p = _a.cameraOptions, cameraOptions = _p === void 0 ? {} : _p;
    //video, detection and image capture canvas
    var videoRefBg = require$$0.useRef(null);
    var detectionCanvasRef = require$$0.useRef(null);
    var captureCanvasRef = require$$0.useRef(null);
    var isCardCreationInProgress = require$$0.useRef(false);
    var _q = useRect(), frameDivRefRect = _q[0], frameDivRef = _q[1];
    var _r = require$$0.useState(false), isMobileOnLandscape = _r[0], setIsMobileOnLandscape = _r[1];
    var _s = require$$0.useState(false), isVideoPortrait = _s[0], setIsVideoPortrait = _s[1];
    var scanCountRef = require$$0.useRef(0);
    var performanceCountRef = require$$0.useRef(0);
    require$$0.useEffect(function () {
        var checkOrientation = function () { return window.innerWidth > window.innerHeight; };
        var updateOrientation = function () {
            setIsMobileOnLandscape(checkOrientation() && isMobile_1);
        };
        updateOrientation();
        window.addEventListener("resize", updateOrientation);
        return function () {
            window.removeEventListener("resize", updateOrientation);
        };
    }, [isMobile_1]);
    var cardScanApi = require$$0.useRef(null);
    //TODO: remove this and move to state machine?
    var cardIdRef = require$$0.useRef("");
    var eligibilityIdRef = require$$0.useRef("");
    require$$0.useEffect(function () {
        var apiEndpoint = DEV_SERVER;
        var wsEndpoint = DEV_WEBSOCKET_SERVER;
        GlobalLogger.log("Using package v".concat(cardScanPackageVersion));
        if (_internal === null || _internal === void 0 ? void 0 : _internal.devAPIEndpoint) {
            apiEndpoint =
                typeof _internal.devAPIEndpoint === "string"
                    ? _internal.devAPIEndpoint
                    : "https://dev.nop.sh/v1/";
        }
        if (_internal === null || _internal === void 0 ? void 0 : _internal.devWSEndpoint) {
            wsEndpoint =
                typeof _internal.devWSEndpoint === "string"
                    ? _internal.devWSEndpoint
                    : "wss://dev-ws.nop.sh";
        }
        if (sessionToken && !cardScanApi.current) {
            cardScanApi.current = new CardScanApi({
                sessionToken: sessionToken,
                live: live || false,
                apiEndpoint: apiEndpoint,
                wsEndpoint: wsEndpoint,
            });
            GlobalLogger.log("Using API Endpoint: ".concat(apiEndpoint));
            GlobalLogger.log("Using WS Endpoint: ".concat(wsEndpoint));
        }
    }, [sessionToken, live, _internal]);
    // Update user UI
    var _t = require$$0.useState(false), showCurtain = _t[0], setShowCurtain = _t[1];
    var _u = require$$0.useState(false), showErrorModal = _u[0], setShowErrorModal = _u[1];
    var messageState = require$$0.useState(__assign$2(__assign$2({}, defaultMessages), messages))[0];
    var spinnerOptions = require$$0.useState(__assign$2(__assign$2({}, defaultIndicatorOptions), indicatorOptions))[0];
    var _v = useMachine(scanViewStateMachine, {
        context: {
            messageState: messageState,
        },
    }), stateMachineState = _v[0], stateMachineSend = _v[1], stateMachineService = _v[2];
    //updates the header title on every transition
    stateMachineService.subscribe(function (state) {
        stateMachineState.context.headerTitle = getHeaderTitle(String(state.value), messageState, stateMachineState.context.autoScan);
    });
    // % of progress in scanning process
    var _w = require$$0.useState(0.0), scanProgress = _w[0], setScanProgress = _w[1];
    // Also set server side for max successful scans.
    var softMaxUploads = 12;
    // Card detection parameters & metadata
    var _x = require$$0.useState(0.9), threshold = _x[0], setThreshold = _x[1];
    var _y = require$$0.useState(0.01), laplacianThreshold = _y[0], setLaplacianThreshold = _y[1];
    var defaultScanFrequency = 250;
    var _z = require$$0.useState(defaultScanFrequency), scanFreqency = _z[0], setScanFreqency = _z[1];
    // state to save timestamp of last WS ping
    var pingFrequency = 6500;
    var _0 = require$$0.useState(new Date()), lastPing = _0[0], setLastPing = _0[1];
    var _1 = require$$0.useState({}), videoMetadata = _1[0], setVideoMetadata = _1[1];
    // Short lived buffer for storing scan images before upload
    var _2 = useBufferSize(4), bufferSize = _2[0], setBufferSize = _2[1];
    var scanCaptureBuffer = require$$0.useRef([]);
    //debug options
    var _3 = require$$0.useState(0.0), latestScore = _3[0], setLatestScore = _3[1];
    var _4 = require$$0.useState(0.0), latestLaplacian = _4[0], setLatestLaplacian = _4[1];
    var _5 = require$$0.useState(0.0), bestScore = _5[0], setBestScore = _5[1];
    var _6 = require$$0.useState(0.0), bestLaplacian = _6[0], setBestLaplacian = _6[1];
    var debugCanvasBestRef = require$$0.useRef(null);
    var debugCanvasLatestRef = require$$0.useRef(null);
    var _7 = require$$0.useState(""), modelState = _7[0], setModelState = _7[1];
    var _8 = require$$0.useState(""), scanDebugState = _8[0], setScanDebugState = _8[1];
    useVideoSizes(videoRefBg, setShowCurtain, stateMachineState);
    var videoWidth = ((_b = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _b === void 0 ? void 0 : _b.videoWidth)
        ? (_c = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _c === void 0 ? void 0 : _c.videoWidth
        : 500;
    var videoHeight = ((_d = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _d === void 0 ? void 0 : _d.videoHeight)
        ? (_e = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _e === void 0 ? void 0 : _e.videoHeight
        : 500;
    var scale = Math.sqrt(isMobile_1 ? 0.95 : 0.65); // This scales the area to 95% or 65% of the original
    videoWidth *= scale;
    videoHeight *= scale;
    //A card's usual aspect ratio
    //85.60 × 53.98 mm (3.370 × 2.125 in) with an aspect ratio of 1.586
    var CARD_ASPECT_RATIO = 1.58;
    var device_aspect_ratio = videoHeight / videoWidth;
    //if height is much larger than width
    //we fix the dimensions to fit in a regular card's usual aspect ratio
    if (device_aspect_ratio >= CARD_ASPECT_RATIO) {
        videoHeight = videoHeight / device_aspect_ratio;
        videoWidth = videoWidth * CARD_ASPECT_RATIO;
    }
    var videoLayoutHeight = ((_g = (_f = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect()) === null || _g === void 0 ? void 0 : _g.height) || 0;
    videoLayoutHeight =
        videoLayoutHeight > videoHeight ? videoHeight : videoLayoutHeight;
    useLayoutHeight(videoRefBg, stateMachineState.matches("cameraLoading"), videoLayoutHeight);
    useCustomWidget(autoSwitchActiveColor, autoSwitchInactiveColor, progressBarColor, widgetBackgroundColor, messageFontSize, messageTextColor, messageBackgroundColor, cameraOptions);
    var getCardMetadata = require$$0.useCallback(function () {
        var environmentInfo = getEnvironmentInfo();
        var deviceInfo = getDeviceInfo();
        var videoElementInfo = getRefSize(videoRefBg);
        var guideFrameElementInfo = getRefSize(frameDivRef);
        return {
            environmentInfo: environmentInfo,
            deviceInfo: deviceInfo,
            videoElementInfo: videoElementInfo,
            guideFrameElementInfo: guideFrameElementInfo,
            videoMetadata: videoMetadata,
        };
    }, [videoMetadata, frameDivRef, videoRefBg]);
    //This is the main scanning loop and is enabled once the video has loaded.
    //Toggable with loop duration is set via scanFrequency.
    useInterval(function () {
        scanHandler(videoRefBg, frameDivRef, captureCanvasRef, detectionCanvasRef, debugCanvasLatestRef, debugCanvasBestRef, scanCountRef, performanceCountRef, setLatestScore, setLatestLaplacian, setBestScore, setBestLaplacian, setModelState, setScanDebugState, setScanProgress, cameraOptions.flipHorizontal, cameraOptions.flipVertical, scanCaptureBuffer, threshold, laplacianThreshold, onError, scanProgress, softMaxUploads, bufferSize, videoMetadata, cardScanApi, cardIdRef, stateMachineState, stateMachineSend, live ? false : (_internal === null || _internal === void 0 ? void 0 : _internal.debugMenu) || false);
        wsPing(); //this should be moved to a separate interval
    }, stateMachineState.context.scannerRunning ? scanFreqency : null);
    require$$0.useEffect(function () {
        if (isMobile_1 &&
            !isMobileOnLandscape &&
            videoRefBg.current &&
            videoRefBg.current.videoWidth < videoRefBg.current.videoHeight) {
            setIsVideoPortrait(true);
        }
        else {
            setIsVideoPortrait(false);
        }
    }, [
        isMobile_1,
        isMobileOnLandscape,
        (_h = videoRefBg.current) === null || _h === void 0 ? void 0 : _h.videoWidth,
        (_j = videoRefBg.current) === null || _j === void 0 ? void 0 : _j.videoHeight,
    ]);
    require$$0.useEffect(function () {
        webSocketHandler(cardScanApi, cardIdRef, onError, stateMachineState, stateMachineSend, backsideSupport, eligibility ? true : false, onEligibilityError);
    }, [cardScanApi, stateMachineState, stateMachineSend, stateMachineService]);
    //TODO: find a way to reset states more clearly
    require$$0.useEffect(function () {
        var subscription = stateMachineService.subscribe(function (state) {
            var _a, _b;
            GlobalLogger.debug("state machine state: ".concat(state.value, " - ").concat(state.event.type));
            if (state.event.type === "scan.completed") {
                var info = {
                    cardId: state.context.card_id,
                    cardState: state.value,
                    scanCount: scanCountRef.current,
                };
                if (onProgress) {
                    onProgress(info);
                }
            }
            if (state.matches("success")) {
                (_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.getCard(cardIdRef.current).then(function (res) {
                    var card = new Card(res.data);
                    GlobalLogger.log("scanning completed: c:".concat(card.cardId));
                    GlobalLogger.debug("scanned card: ".concat(JSON.stringify(card)), "everything");
                    onSuccess(card);
                }).then(function () {
                    var _a;
                    if (eligibilityIdRef.current && onEligibilitySuccess) {
                        (_a = cardScanApi.current) === null || _a === void 0 ? void 0 : _a.getEligibility(eligibilityIdRef.current).then(function (res) {
                            GlobalLogger.log("eligibility completed: e:".concat(eligibilityIdRef.current));
                            GlobalLogger.debug("eligibility payload: ".concat(JSON.stringify(res.data)), "everything");
                            var eligibility = new Eligibility(res.data);
                            onEligibilitySuccess(eligibility);
                        });
                    }
                }).finally(function () {
                    cleanUp(scanCaptureBuffer, setScanProgress, videoRefBg, cardScanApi);
                });
            }
            //reset before moving to backside
            if (state.matches("backsidePending")) {
                scanCountRef.current = 0;
                scanCaptureBuffer.current = [];
                setScanProgress(0);
                resetCorners();
                GlobalLogger.debug("Flipping to backside scan");
            }
            if (state.matches("eligibilityPending") &&
                state.event.type === "card.completed" &&
                eligibility) {
                (_b = cardScanApi.current) === null || _b === void 0 ? void 0 : _b.createEligibility(eligibility, cardIdRef.current).then(function (response) {
                    eligibilityIdRef.current = response.data.eligibility_id;
                }).catch(function (error) {
                    onEligibilityError === null || onEligibilityError === void 0 ? void 0 : onEligibilityError(error);
                });
            }
            // on toggle
            if (state.context.toggledAutoManual &&
                ["autoCapture", "manualCapture"].some(state.matches)) {
                GlobalLogger.debug("Toggling to manual capture");
                scanCaptureBuffer.current = [];
                setScanProgress(0);
                document.documentElement.style.setProperty("--cardscan-buffer-size", "0");
                setScanFreqency(defaultScanFrequency);
            }
        });
        return subscription.unsubscribe;
    }, [stateMachineService]);
    require$$0.useEffect(function () {
        var _a;
        //de-dupe this or make it lazy.
        //creating and saving card_id.
        if (!isCardCreationInProgress.current &&
            stateMachineState.context.modelState === "warmed") {
            isCardCreationInProgress.current = true;
            var metadata = getCardMetadata();
            (_a = cardScanApi.current) === null || _a === void 0 ? void 0 : _a.createCard(backsideSupport, true, metadata).then(function (response) {
                var _a, _b;
                cardIdRef.current = response.data.card_id;
                GlobalLogger.debug("Card ID: ".concat(cardIdRef.current));
                onScanStart === null || onScanStart === void 0 ? void 0 : onScanStart(cardIdRef.current, false);
                //register socket on card creation
                if (((_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket) &&
                    ((_b = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _b === void 0 ? void 0 : _b.socket.readyState) == 1) {
                    // 1 is open
                    var payload = JSON.stringify({
                        card_id: response.data.card_id,
                        action: "register",
                        source: "startup",
                    });
                    cardScanApi.current.socket.send(payload);
                }
            }).catch(function (error) {
                _handleError(error, stateMachineSend, onError);
                isCardCreationInProgress.current = false;
            });
        }
    }, [
        cardScanApi,
        stateMachineSend,
        onError,
        backsideSupport,
        stateMachineState,
        getCardMetadata,
    ]);
    require$$0.useEffect(function () {
        // Setup popstate event listener
        var popstateHandler = function () {
            cleanUp(scanCaptureBuffer, setScanProgress, videoRefBg, cardScanApi);
        };
        window.addEventListener("popstate", popstateHandler);
        // Cleanup popstate event listener on component unmount
        return function () {
            window.removeEventListener("popstate", popstateHandler);
        };
    }, []);
    require$$0.useEffect(function () {
        if (logging) {
            setModelState(DetectorWrapper.get().modelState);
        }
        if (live) {
            GlobalLogger.setLogLevel(logging === undefined || logging === "off" ? "off" : "normal");
        }
        else {
            GlobalLogger.setLogLevel(logging || "off");
        }
    }, [logging, live, DetectorWrapper]);
    //TODO: move this into cardScanApi w/ own timer and toggle on/off?
    var wsPing = function () {
        var _a;
        var now = new Date();
        var ms = lastPing.getTime();
        if (["success", "error"].some(stateMachineState.matches)) {
            return;
        }
        if (now.getTime() - ms < pingFrequency) {
            return;
        }
        if (((_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket) &&
            cardScanApi.current.socket.readyState == 1) {
            cardScanApi.current.socket.send("ping");
            setLastPing(now);
        }
    };
    //---------------------------------------
    // UI Interaction handlers
    //---------------------------------------
    //TODO: most of this could be reduced to state machine (but need to add retry state -> autocapture)
    var handleRetryButton = function () { return __awaiter(void 0, void 0, void 0, function () {
        var video, metadata;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    //sanity check we're in retry mode.
                    //empty both detection buffer and clear progress UI
                    scanCaptureBuffer.current = [];
                    scanCountRef.current = 0;
                    setScanProgress(0);
                    document.documentElement.style.setProperty("--cardscan-buffer-size", "0");
                    document.documentElement.style.setProperty("--cardscan-corner-height", "0");
                    document.documentElement.style.setProperty("--cardscan-corner-width", "0");
                    video = videoRefBg.current;
                    if (!(video === null || video === void 0 ? void 0 : video.paused)) return [3 /*break*/, 2];
                    return [4 /*yield*/, (video === null || video === void 0 ? void 0 : video.play())];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    //reset state.
                    stateMachineSend("retry_scan");
                    setScanFreqency(defaultScanFrequency);
                    cardIdRef.current = "";
                    if (onRetry) {
                        onRetry();
                    }
                    metadata = getCardMetadata();
                    //de-dupe this
                    (_a = cardScanApi.current) === null || _a === void 0 ? void 0 : _a.createCard(backsideSupport, true, metadata).then(function (response) {
                        var _a;
                        cardIdRef.current = response.data.card_id;
                        onScanStart === null || onScanStart === void 0 ? void 0 : onScanStart(cardIdRef.current, false);
                        //register socket on card creation
                        if ((_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket) {
                            var payload = JSON.stringify({
                                card_id: response.data.card_id,
                                action: "register",
                                source: "retry",
                            });
                            cardScanApi.current.socket.send(payload);
                        }
                        //needs to implement another state coming to "retry"
                        stateMachineSend("retry_scan");
                    }).catch(function (error) {
                        _handleError(error, stateMachineSend, onError);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var onCloseBtn = function () {
        if (onCancel) {
            onCancel();
        }
    };
    var getModelState = function (state) {
        stateMachineSend({
            type: "UPDATE_MODEL_STATE",
            modelState: state,
        });
    };
    require$$0.useEffect(function () {
        if (stateMachineState.value === "cameraLoading") {
            var initialModelState = DetectorWrapper.get().modelState;
            stateMachineSend({
                type: "UPDATE_MODEL_STATE",
                modelState: initialModelState,
            });
            if (initialModelState !== "warmed") {
                DetectorWrapper.get().setModelStatusCallback(getModelState);
            }
        }
    }, [stateMachineState.value]);
    //---------------------------------------
    // Rendering
    //---------------------------------------
    return (jsxRuntime.jsxs(MyGlobalContext.Provider, __assign$2({ value: {
            logging: logging || GlobalLogger.startingLogLevel,
            modelState: modelState,
            scanDebugState: scanDebugState,
            threshold: threshold,
            setThreshold: setThreshold,
            laplacianThreshold: laplacianThreshold,
            setLaplacianThreshold: setLaplacianThreshold,
            scanFreqency: scanFreqency,
            setScanFreqency: setScanFreqency,
            bufferSize: bufferSize,
            setBufferSize: setBufferSize,
            bufferRef: scanCaptureBuffer,
            debugCanvasBestRef: debugCanvasBestRef,
            bestScore: bestScore,
            bestLaplacian: bestLaplacian,
            debugCanvasLatestRef: debugCanvasLatestRef,
            latestScore: latestScore,
            latestLaplacian: latestLaplacian,
            debugMenu: live ? false : (_internal === null || _internal === void 0 ? void 0 : _internal.debugMenu) || false,
            videoMetadata: videoMetadata,
            showCurtain: showCurtain,
            onCloseBtn: onCloseBtn,
            closeButton: closeButton,
            isMobile: isMobile_1,
            isMobileOnLandscape: isMobileOnLandscape,
            stateMachineState: stateMachineState,
            stateMachineSend: stateMachineSend,
            stateMachineService: stateMachineService,
            handleRetryButton: handleRetryButton,
        } }, { children: [jsxRuntime.jsx(CameraPermissionModal, { cameraPermissionModalConfig: cameraPermissionModalConfig, enableModel: showErrorModal &&
                    ((_k = cameraPermissionModalConfig === null || cameraPermissionModalConfig === void 0 ? void 0 : cameraPermissionModalConfig.enabled) !== null && _k !== void 0 ? _k : true) &&
                    (!(webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled) || isMobile_1) }), jsxRuntime.jsx(WebToMobileModal, { enableModel: showErrorModal &&
                    !isMobile_1 &&
                    !((_l = cameraPermissionModalConfig === null || cameraPermissionModalConfig === void 0 ? void 0 : cameraPermissionModalConfig.enabled) !== null && _l !== void 0 ? _l : true) &&
                    (webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled) !== undefined
                    ? webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled
                    : false, cardScanApi: cardScanApi, webToMobileHandoffConfig: webToMobileHandoffConfig, spinnerOptions: spinnerOptions, backsideSupport: backsideSupport }), jsxRuntime.jsxs("div", __assign$2({ "data-cy": "cardscanMainContainer", className: "".concat(styles$1.cardscanMain, " ").concat(isMobile_1 ? styles$1.isMobile : "", " ").concat(isMobileOnLandscape ? styles$1.isLandscape : "") }, { children: [jsxRuntime.jsx(DebugMenu, {}), jsxRuntime.jsx(CardCapture, { children: jsxRuntime.jsxs("div", __assign$2({ className: "".concat(styles$1.cardscanVideoContainer, " ").concat(fullScreen && !isMobile_1 ? styles$1.fullScreenLimit : "", " \n            ").concat(isMobile_1 ? styles$1.mobile : "", "\n            ").concat(isMobileOnLandscape ? styles$1.landscapeMobile : "", "\n            ").concat(isVideoPortrait ? styles$1.portraitView : "") }, { children: [jsxRuntime.jsx(ScanVideoViewer, { videoRef: videoRefBg, setShowErrorModal: setShowErrorModal, stateMachineSend: stateMachineSend, setScanDebugState: setScanDebugState, onError: onError, captureCanvasRef: captureCanvasRef, setVideoMetadata: setVideoMetadata, isMobile: isMobile_1, isVideoPortrait: isVideoPortrait }), stateMachineState.matches("cameraLoading") ? (jsxRuntime.jsx("div", __assign$2({ "data-cy": "cardScanCameraLoading", className: styles$1.spinnerWrapper }, { children: jsxRuntime.jsx(dist, __assign$2({}, spinnerOptions)) }))) : (jsxRuntime.jsx(ScanFrame, { successIndicator: successIndicator, errorIndicator: errorIndicator, handleRetryButton: handleRetryButton, frameDivRef: frameDivRef, spinnerOptions: spinnerOptions, webToMobileHandoffConfig: webToMobileHandoffConfig, cardScanApi: cardScanApi, backsideSupport: backsideSupport })), !showErrorModal && !(webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled) && (jsxRuntime.jsx("img", { "data-cy": "cardscanLogo", alt: "cardscan logo", src: CardScanLogoURL, className: "".concat(styles$1.cardscanLogo, " ").concat(isMobile_1 ? styles$1.cardscanLogoMobile : "") })), !showCurtain && !stateMachineState.matches("cameraLoading") && (jsxRuntime.jsx(jsxRuntime.Fragment, { children: !stateMachineState.context.autoScan &&
                                        !stateMachineState.context.processing &&
                                        !stateMachineState.matches("success") && (jsxRuntime.jsx("img", { "data-cy": "cameraBtn", alt: "button to start the scanning", src: img, className: styles$1.cameraBtn, onClick: function () { return stateMachineSend("MANUAL_BUTTON_CLICK"); }, style: { bottom: 0 } })) }))] })) })] })), jsxRuntime.jsx(ScanCanvas, { captureCanvasRef: captureCanvasRef, detectionCanvasRef: detectionCanvasRef, frameDivDimensions: frameDivRefRect, frameDivRef: frameDivRef, videoRefBg: videoRefBg, videoHeight: videoHeight, videoWidth: videoWidth })] })));
};

var css_248z = ".scanErrorWrapper-module_scanErrorBar__Vz8hg{background:#ffe0e0;border:1px solid #a33a3a;color:#ba3939;margin:10px;padding:10px}.scanErrorWrapper-module_scanViewMainContainerNoFullScreen__6mw-x{aspect-ratio:16/9;height:auto;max-height:100%;max-width:100%;min-width:300px;width:100%}.scanErrorWrapper-module_scanViewMainContainerFullScreen__MUzaQ{height:100vh;left:0;max-width:100%;min-width:300px;position:fixed;top:0;width:100vw}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjYW5FcnJvcldyYXBwZXIubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsNkNBSUUsa0JBQW1CLENBQ25CLHdCQUF5QixDQUZ6QixhQUFjLENBRGQsV0FBWSxDQURaLFlBS0YsQ0FFQSxrRUFHRSxpQkFBa0IsQ0FEbEIsV0FBWSxDQUdaLGVBQWdCLENBRGhCLGNBQWUsQ0FFZixlQUFnQixDQUxoQixVQU1GLENBRUEsZ0VBS0UsWUFBYSxDQUhiLE1BQVMsQ0FJVCxjQUFlLENBQ2YsZUFBZ0IsQ0FOaEIsY0FBZSxDQUVmLEtBQVEsQ0FDUixXQUlGIiwiZmlsZSI6InNjYW5FcnJvcldyYXBwZXIubW9kdWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuc2NhbkVycm9yQmFyIHtcbiAgcGFkZGluZzogMTBweDtcbiAgbWFyZ2luOiAxMHB4O1xuICBjb2xvcjogI2JhMzkzOTtcbiAgYmFja2dyb3VuZDogI2ZmZTBlMDtcbiAgYm9yZGVyOiAxcHggc29saWQgI2EzM2EzYTtcbn1cblxuLnNjYW5WaWV3TWFpbkNvbnRhaW5lck5vRnVsbFNjcmVlbiB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IGF1dG87XG4gIGFzcGVjdC1yYXRpbzogMTYvOTtcbiAgbWF4LXdpZHRoOiAxMDAlO1xuICBtYXgtaGVpZ2h0OiAxMDAlO1xuICBtaW4td2lkdGg6IDMwMHB4O1xufVxuXG4uc2NhblZpZXdNYWluQ29udGFpbmVyRnVsbFNjcmVlbiB7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgbGVmdDogMHB4O1xuICB0b3A6IDBweDtcbiAgd2lkdGg6IDEwMHZ3O1xuICBoZWlnaHQ6IDEwMHZoO1xuICBtYXgtd2lkdGg6IDEwMCU7XG4gIG1pbi13aWR0aDogMzAwcHg7XG59Il19 */";
var styles = {"scanErrorBar":"scanErrorWrapper-module_scanErrorBar__Vz8hg","scanViewMainContainerNoFullScreen":"scanErrorWrapper-module_scanViewMainContainerNoFullScreen__6mw-x","scanViewMainContainerFullScreen":"scanErrorWrapper-module_scanViewMainContainerFullScreen__MUzaQ"};
styleInject(css_248z);

// Check if there is a valid token
var ScanErrorWrapper = function (_a) {
    var sessionToken = _a.sessionToken, children = _a.children, fullScreen = _a.fullScreen;
    useMobileOrientation_1().isLandscape;
    return !sessionToken || sessionToken.length == 0 ? (jsxRuntime.jsx("div", __assign$2({ "data-cy": "scanErrorBar", className: styles.scanErrorBar }, { children: "A Session Token is needed to continue." }))) : (jsxRuntime.jsx("div", __assign$2({ className: fullScreen || isMobile_1
            ? styles.scanViewMainContainerFullScreen
            : styles.scanViewMainContainerNoFullScreen }, { children: children })));
};

var App = function (_a) {
    var logging = _a.logging, _b = _a.live, live = _b === void 0 ? false : _b, sessionToken = _a.sessionToken, onSuccess = _a.onSuccess, onEligibilityError = _a.onEligibilityError, onEligibilitySuccess = _a.onEligibilitySuccess, onCancel = _a.onCancel, onError = _a.onError, onRetry = _a.onRetry, _c = _a.fullScreen, fullScreen = _c === void 0 ? true : _c, onProgress = _a.onProgress, onScanStart = _a.onScanStart, messages = _a.messages, _d = _a.backsideSupport, backsideSupport = _d === void 0 ? false : _d, eligibility = _a.eligibility, _e = _a.indicatorOptions, indicatorOptions = _e === void 0 ? {} : _e, cameraPermissionModalConfig = _a.cameraPermissionModalConfig, closeButton = _a.closeButton, successIndicator = _a.successIndicator, errorIndicator = _a.errorIndicator, autoSwitchActiveColor = _a.autoSwitchActiveColor, autoSwitchInactiveColor = _a.autoSwitchInactiveColor, progressBarColor = _a.progressBarColor, widgetBackgroundColor = _a.widgetBackgroundColor, messageFontSize = _a.messageFontSize, messageTextColor = _a.messageTextColor, messageBackgroundColor = _a.messageBackgroundColor, _f = _a.webToMobileHandoffConfig, webToMobileHandoffConfig = _f === void 0 ? {
        enabled: false,
        urlBase: live
            ? "https://capture.cardscan.ai"
            : "https://sandbox-capture.cardscan.ai",
        companyName: "CardScanHealth",
    } : _f, _internal = _a._internal, cameraOptions = _a.cameraOptions;
    return (jsxRuntime.jsx(ScanErrorWrapper, __assign$2({ sessionToken: sessionToken, fullScreen: fullScreen }, { children: jsxRuntime.jsx(CardScanView, { live: live, logging: logging, sessionToken: sessionToken, cameraPermissionModalConfig: cameraPermissionModalConfig, onSuccess: onSuccess, onEligibilitySuccess: onEligibilitySuccess, onEligibilityError: onEligibilityError, onCancel: onCancel, onError: onError, onRetry: onRetry, onProgress: onProgress, onScanStart: onScanStart, messages: messages, backsideSupport: backsideSupport, eligibility: eligibility, indicatorOptions: indicatorOptions, closeButton: closeButton, successIndicator: successIndicator, errorIndicator: errorIndicator, autoSwitchActiveColor: autoSwitchActiveColor, autoSwitchInactiveColor: autoSwitchInactiveColor, progressBarColor: progressBarColor, widgetBackgroundColor: widgetBackgroundColor, messageFontSize: messageFontSize, messageTextColor: messageTextColor, messageBackgroundColor: messageBackgroundColor, webToMobileHandoffConfig: webToMobileHandoffConfig, _internal: _internal, cameraOptions: cameraOptions }) })));
};
App.propTypes = {
    logging: PropTypes.oneOf([
        "off",
        "normal",
        "verbose",
        "detector",
        "everything",
    ]),
    live: PropTypes.bool,
    sessionToken: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    onError: PropTypes.func,
    onProgress: PropTypes.func,
    onScanStart: PropTypes.func,
    backsideSupport: PropTypes.bool,
    cameraPermissionModalConfig: PropTypes.shape({}),
    webToMobileHandoffConfig: PropTypes.shape({}),
    _internal: PropTypes.shape({}),
};
App.defaultProps = {
    cameraPermissionModalConfig: { enabled: true },
    webToMobileHandoffConfig: {
        enabled: false,
        urlBase: "capture.cardscan.ai",
        companyName: "CardScanHealth",
    },
};

exports.CardScanApi = CardScanApi;
exports.CardScanModel = CardScanModel;
exports.CardScanView = App;
//# sourceMappingURL=index.js.map
